import { defineComponent as Se, openBlock as L, createElementBlock as j, createElementVNode as ae, toDisplayString as $e, createCommentVNode as ce, normalizeClass as pe, renderSlot as me, createBlock as Ce, unref as q, createVNode as Oe, mergeProps as Ee, shallowRef as Hn, watch as Ve, computed as J, toValue as Ke, reactive as Jr, h as Ts, getCurrentInstance as Qr, inject as Zn, resolveComponent as Fa, createPropsRestProxy as ga, resolveDynamicComponent as Xt, withCtx as Ie, ref as we, onMounted as wt, Transition as wn, normalizeProps as At, guardReactiveProps as Rt, createTextVNode as yt, Teleport as ba, useSlots as En, onUpdated as Jl, onUnmounted as Tn, withModifiers as oa, Fragment as Ge, renderList as vt, useModel as Za, mergeModels as sa, useTemplateRef as dt, nextTick as Wa, createSlots as Xa, normalizeStyle as Lt, isRef as Ri, onBeforeUnmount as Ql, provide as ei, withDirectives as Jt, withKeys as ti, vModelCheckbox as eo, vModelDynamic as Fi, readonly as to, vShow as ni, createStaticVNode as As, TransitionGroup as Ls, getCurrentScope as $s, onScopeDispose as Is, shallowReadonly as In, version as Ds, vModelRadio as Ms, toRefs as Ca, onServerPrefetch as Os, onBeforeMount as Rs, vModelText as Fs } from "vue";
import { toArray as Ns, unrefElement as no, tryOnScopeDispose as Bs, refDebounced as Ps, useTransition as zs, TransitionPresets as Vs, useScrollLock as ao, onClickOutside as Ya, onKeyStroke as ro, useEventListener as on, useMediaQuery as Hs, usePreferredReducedMotion as io, useVibrate as lo, useTimeoutFn as ea, useIntervalFn as Us, useDebounceFn as qs, useElementSize as js, useResizeObserver as Zs, usePointerSwipe as Ws } from "@vueuse/core";
import { isNotNestedPath as Xs, cleanupNonNestedPath as Ys, useForm as Gs, useField as Ks } from "vee-validate";
import './index.css';const Js = {
  key: 0,
  class: "lc-count-bubble"
}, zr = /* @__PURE__ */ Se({
  __name: "LcCountBubble",
  props: {
    count: {}
  },
  setup(e) {
    return (t, n) => e.count ? (L(), j("div", Js, [
      ae("span", null, $e(Math.min(e.count, 99)), 1)
    ])) : ce("", !0);
  }
}), Qe = /* @__PURE__ */ Se({
  __name: "LcIcon",
  props: {
    name: {},
    size: { default: "medium" }
  },
  setup(e) {
    return (t, n) => (L(), j("i", {
      "aria-hidden": "true",
      class: pe(["lc-icon", `lc-icon--${e.name}`, `lc-icon--size-${e.size}`]),
      focusable: "false"
    }, null, 2));
  }
}), _1 = ["large", "medium", "small"], S1 = [
  "account-balance",
  "add",
  "alarm",
  "alert-circle",
  "alert-triangle",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-right-small",
  "arrow-up",
  "arrowhead-right",
  "award",
  "bank",
  "bell",
  "bell-off",
  "calendar",
  "camera",
  "camera-scan",
  "card-add-funds",
  "card-expired",
  "card-okay",
  "careers",
  "chat",
  "checkmark",
  "checkmark-circle",
  "checkmark-small",
  "chevron-circle",
  "chevron-close",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "close",
  "close-account",
  "close-large",
  "cloud-upload",
  "copy",
  "data",
  "day-afternoon",
  "day-evening",
  "day-midday",
  "day-morning",
  "deposit-limits",
  "download",
  "dropdown-down",
  "dropdown-left",
  "dropdown-right",
  "dropdown-up",
  "edit",
  "edit-active",
  "email",
  "emoji-bad",
  "emoji-good",
  "emoji-ok",
  "exclamation",
  "external-link",
  "eye",
  "eye-close",
  "eye-off",
  "file",
  "file-text",
  "file-type",
  "filter",
  "fire",
  "flash",
  "flash-plus",
  "game",
  "gift",
  "heart",
  "helpcenter",
  "hero",
  "hit-megahit",
  "hit-powerhit",
  "house",
  "id",
  "info",
  "info-help",
  "keno",
  "language",
  "language-lt",
  "limits",
  "limits-purchase",
  "link",
  "list",
  "loader",
  "location",
  "location-not-allowed",
  "lock",
  "login",
  "logout",
  "map",
  "mark-all-as-read",
  "menu",
  "message-circle",
  "message-square",
  "minus",
  "mobile-phone",
  "more-horizontal",
  "more-vertical",
  "orders",
  "orders-canceled",
  "orders-multiple-filled-xx",
  "orders-multiple-filled-xxx",
  "orders-multiple-xx",
  "orders-multiple-xxx",
  "orders-purchased",
  "orders-waiting-for-purchase",
  "pause",
  "payment-options",
  "phone-call",
  "play",
  "play-filled",
  "plus",
  "plus-small",
  "prepaid",
  "prepaid-participating",
  "pricetag",
  "prize",
  "profile-block",
  "profile-circle",
  "profile-close",
  "profile-customer-id",
  "profile-person",
  "profile-personal-info",
  "profile-self-exclusion",
  "protect",
  "question",
  "quick-pick-settings",
  "reset",
  "retailer",
  "save",
  "scratch-autoreveal",
  "scratch-backside",
  "scratch-demo",
  "scratch-now",
  "scratch-processing",
  "scratch-scratched",
  "scratch-unscratched",
  "scratchcard",
  "search",
  "serial-number",
  "settings",
  "shopping-card-empty",
  "shopping-card-filled",
  "shopping-cart",
  "show-all",
  "shuffle-h",
  "shuffle-numbers",
  "shuffle-v",
  "spades",
  "star",
  "status-of-order",
  "subscription",
  "subscription-deactivated",
  "subscription-paused",
  "swap",
  "sync",
  "tab-lotteries",
  "tab-scratchcards",
  "ticket-processing",
  "time",
  "time-pending",
  "time-sandclock",
  "touch",
  "transaction",
  "transaction-credit-note",
  "transaction-debit-note",
  "transaction-funding",
  "transaction-refund",
  "transactions-chargeback",
  "transactions-old",
  "transactions-payout",
  "transactions-reverse-chargeback",
  "trash-empty",
  "trash-full",
  "unlock",
  "unverified-shield",
  "upload",
  "verify",
  "verify-guard",
  "verify-shield",
  "winning",
  "winning-correction",
  "zoom"
], Qs = { class: "lc-badge" }, C1 = /* @__PURE__ */ Se({
  __name: "LcBadge",
  props: {
    count: {},
    icon: {}
  },
  setup(e) {
    return (t, n) => (L(), j("div", Qs, [
      me(t.$slots, "icon", {}, () => [
        e.icon ? (L(), Ce(q(Qe), {
          key: 0,
          name: e.icon
        }, null, 8, ["name"])) : ce("", !0)
      ]),
      Oe(q(zr), Ee({ count: e.count }, { class: "lc-badge__count" }), null, 16),
      me(t.$slots, "default")
    ]));
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const ec = (e) => e != null;
var oo = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "area[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], Na = /* @__PURE__ */ oo.join(","), so = typeof Element > "u", kn = so ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Ba = !so && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, Pa = function(t, n) {
  var r;
  n === void 0 && (n = !0);
  var s = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = s === "" || s === "true", a = i || n && t && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof t.closest == "function" ? t.closest("[inert]") : Pa(t.parentNode));
  return a;
}, tc = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, co = function(t, n, r) {
  if (Pa(t))
    return [];
  var s = Array.prototype.slice.apply(t.querySelectorAll(Na));
  return n && kn.call(t, Na) && s.unshift(t), s = s.filter(r), s;
}, za = function(t, n, r) {
  for (var s = [], i = Array.from(t); i.length; ) {
    var a = i.shift();
    if (!Pa(a, !1))
      if (a.tagName === "SLOT") {
        var l = a.assignedElements(), o = l.length ? l : a.children, h = za(o, !0, r);
        r.flatten ? s.push.apply(s, h) : s.push({
          scopeParent: a,
          candidates: h
        });
      } else {
        var v = kn.call(a, Na);
        v && r.filter(a) && (n || !t.includes(a)) && s.push(a);
        var u = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), f = !Pa(u, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (u && f) {
          var m = za(u === !0 ? a.children : u.children, !0, r);
          r.flatten ? s.push.apply(s, m) : s.push({
            scopeParent: a,
            candidates: m
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return s;
}, uo = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, pn = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || tc(t)) && !uo(t) ? 0 : t.tabIndex;
}, nc = function(t, n) {
  var r = pn(t);
  return r < 0 && n && !uo(t) ? 0 : r;
}, ac = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, fo = function(t) {
  return t.tagName === "INPUT";
}, rc = function(t) {
  return fo(t) && t.type === "hidden";
}, ic = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, lc = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, oc = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Ba(t), r = function(l) {
    return n.querySelectorAll('input[type="radio"][name="' + l + '"]');
  }, s;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    s = r(window.CSS.escape(t.name));
  else
    try {
      s = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = lc(s, t.form);
  return !i || i === t;
}, sc = function(t) {
  return fo(t) && t.type === "radio";
}, cc = function(t) {
  return sc(t) && !oc(t);
}, uc = function(t) {
  var n, r = t && Ba(t), s = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var a, l, o;
    for (i = !!((a = s) !== null && a !== void 0 && (l = a.ownerDocument) !== null && l !== void 0 && l.contains(s) || t != null && (o = t.ownerDocument) !== null && o !== void 0 && o.contains(t)); !i && s; ) {
      var h, v, u;
      r = Ba(s), s = (h = r) === null || h === void 0 ? void 0 : h.host, i = !!((v = s) !== null && v !== void 0 && (u = v.ownerDocument) !== null && u !== void 0 && u.contains(s));
    }
  }
  return i;
}, Ni = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, s = n.height;
  return r === 0 && s === 0;
}, dc = function(t, n) {
  var r = n.displayCheck, s = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t) {
    var i = t.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !i;
  }
  var a = getComputedStyle(t), l = a.visibility;
  if (l === "hidden" || l === "collapse")
    return !0;
  var o = kn.call(t, "details>summary:first-of-type"), h = o ? t.parentElement : t;
  if (kn.call(h, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  r === "full-native" || r === "legacy-full") {
    if (typeof s == "function") {
      for (var v = t; t; ) {
        var u = t.parentElement, f = Ba(t);
        if (u && !u.shadowRoot && s(u) === !0)
          return Ni(t);
        t.assignedSlot ? t = t.assignedSlot : !u && f !== t.ownerDocument ? t = f.host : t = u;
      }
      t = v;
    }
    if (uc(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return Ni(t);
  return !1;
}, fc = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var s = n.children.item(r);
          if (s.tagName === "LEGEND")
            return kn.call(n, "fieldset[disabled] *") ? !0 : !s.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Va = function(t, n) {
  return !(n.disabled || rc(n) || dc(n, t) || // For a details element with a summary, the summary element gets the focus
  ic(n) || fc(n));
}, Vr = function(t, n) {
  return !(cc(n) || pn(n) < 0 || !Va(t, n));
}, hc = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, ho = function(t) {
  var n = [], r = [];
  return t.forEach(function(s, i) {
    var a = !!s.scopeParent, l = a ? s.scopeParent : s, o = nc(l, a), h = a ? ho(s.candidates) : l;
    o === 0 ? a ? n.push.apply(n, h) : n.push(l) : r.push({
      documentOrder: i,
      tabIndex: o,
      item: s,
      isScope: a,
      content: h
    });
  }), r.sort(ac).reduce(function(s, i) {
    return i.isScope ? s.push.apply(s, i.content) : s.push(i.content), s;
  }, []).concat(n);
}, vc = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = za([t], n.includeContainer, {
    filter: Vr.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: hc
  }) : r = co(t, n.includeContainer, Vr.bind(null, n)), ho(r);
}, mc = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = za([t], n.includeContainer, {
    filter: Va.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = co(t, n.includeContainer, Va.bind(null, n)), r;
}, Dn = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return kn.call(t, Na) === !1 ? !1 : Vr(n, t);
}, gc = /* @__PURE__ */ oo.concat("iframe:not([inert]):not([inert] *)").join(","), br = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return kn.call(t, gc) === !1 ? !1 : Va(n, t);
};
function Hr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function bc(e) {
  if (Array.isArray(e)) return Hr(e);
}
function Bi(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = vo(e)) || t) {
      n && (e = n);
      var r = 0, s = function() {
      };
      return {
        s,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(o) {
          throw o;
        },
        f: s
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, a = !0, l = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var o = n.next();
      return a = o.done, o;
    },
    e: function(o) {
      l = !0, i = o;
    },
    f: function() {
      try {
        a || n.return == null || n.return();
      } finally {
        if (l) throw i;
      }
    }
  };
}
function pc(e, t, n) {
  return (t = _c(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function yc(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function wc() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Pi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function zi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pi(Object(n), !0).forEach(function(r) {
      pc(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pi(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function xc(e) {
  return bc(e) || yc(e) || vo(e) || wc();
}
function kc(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _c(e) {
  var t = kc(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function vo(e, t) {
  if (e) {
    if (typeof e == "string") return Hr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Hr(e, t) : void 0;
  }
}
var Gt = {
  // Returns the trap from the top of the stack.
  getActiveTrap: function(t) {
    return t?.length > 0 ? t[t.length - 1] : null;
  },
  // Pauses the currently active trap, then adds a new trap to the stack.
  activateTrap: function(t, n) {
    var r = Gt.getActiveTrap(t);
    n !== r && Gt.pauseTrap(t);
    var s = t.indexOf(n);
    s === -1 || t.splice(s, 1), t.push(n);
  },
  // Removes the trap from the top of the stack, then unpauses the next trap down.
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), Gt.unpauseTrap(t);
  },
  // Pauses the trap at the top of the stack.
  pauseTrap: function(t) {
    var n = Gt.getActiveTrap(t);
    n?._setPausedState(!0);
  },
  // Unpauses the trap at the top of the stack.
  unpauseTrap: function(t) {
    var n = Gt.getActiveTrap(t);
    n && !n._isManuallyPaused() && n._setPausedState(!1);
  }
}, Sc = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, Cc = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, aa = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, Ec = function(t) {
  return aa(t) && !t.shiftKey;
}, Tc = function(t) {
  return aa(t) && t.shiftKey;
}, Vi = function(t) {
  return setTimeout(t, 0);
}, Yn = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
    r[s - 1] = arguments[s];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, Ea = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Ac = [], Lc = function(t, n) {
  var r = n?.document || document, s = n?.trapStack || Ac, i = zi({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    delayReturnFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: Ec,
    isKeyBackward: Tc
  }, n), a = {
    // containers given to createFocusTrap()
    /** @type {Array<HTMLElement>} */
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    // references to nodes that are siblings to the ancestors of this trap's containers.
    /** @type {Set<HTMLElement>} */
    adjacentElements: /* @__PURE__ */ new Set(),
    // references to nodes that were inert or aria-hidden before the trap was activated.
    /** @type {Set<HTMLElement>} */
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, l, o = function(T, A, z) {
    return T && T[A] !== void 0 ? T[A] : i[z || A];
  }, h = function(T, A) {
    var z = typeof A?.composedPath == "function" ? A.composedPath() : void 0;
    return a.containerGroups.findIndex(function(U) {
      var X = U.container, B = U.tabbableNodes;
      return X.contains(T) || z?.includes(X) || B.find(function(ie) {
        return ie === T;
      });
    });
  }, v = function(T) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, z = A.hasFallback, U = z === void 0 ? !1 : z, X = A.params, B = X === void 0 ? [] : X, ie = i[T];
    if (typeof ie == "function" && (ie = ie.apply(void 0, xc(B))), ie === !0 && (ie = void 0), !ie) {
      if (ie === void 0 || ie === !1)
        return ie;
      throw new Error("`".concat(T, "` was specified but was not a node, or did not return a node"));
    }
    var H = ie;
    if (typeof ie == "string") {
      try {
        H = r.querySelector(ie);
      } catch (ee) {
        throw new Error("`".concat(T, '` appears to be an invalid selector; error="').concat(ee.message, '"'));
      }
      if (!H && !U)
        throw new Error("`".concat(T, "` as selector refers to no known node"));
    }
    return H;
  }, u = function(T) {
    var A = T.activeElement;
    return A ? A.shadowRoot && A.shadowRoot.activeElement !== null ? u(A.shadowRoot) : A : null;
  }, f = function() {
    var T = v("initialFocus", {
      hasFallback: !0
    });
    if (T === !1)
      return !1;
    if (T === void 0 || T && !br(T, i.tabbableOptions)) {
      var A = u(r);
      if (h(A) >= 0)
        T = A;
      else {
        var z = a.tabbableGroups[0], U = z && z.firstTabbableNode;
        T = U || v("fallbackFocus");
      }
    } else T === null && (T = v("fallbackFocus"));
    if (!T)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return T;
  }, m = function() {
    if (a.containerGroups = a.containers.map(function(T) {
      var A = vc(T, i.tabbableOptions), z = mc(T, i.tabbableOptions), U = A.length > 0 ? A[0] : void 0, X = A.length > 0 ? A[A.length - 1] : void 0, B = z.find(function(ee) {
        return Dn(ee);
      }), ie = z.slice().reverse().find(function(ee) {
        return Dn(ee);
      }), H = !!A.find(function(ee) {
        return pn(ee) > 0;
      });
      return {
        container: T,
        tabbableNodes: A,
        focusableNodes: z,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: H,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: U,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: X,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: B,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: ie,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(ue) {
          var ye = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, xe = A.indexOf(ue);
          return xe < 0 ? ye ? z.slice(z.indexOf(ue) + 1).find(function(te) {
            return Dn(te);
          }) : z.slice(0, z.indexOf(ue)).reverse().find(function(te) {
            return Dn(te);
          }) : A[xe + (ye ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(T) {
      return T.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !v("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(T) {
      return T.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, c = function(T) {
    if (T !== !1 && T !== u(document)) {
      if (!T || !T.focus) {
        c(f());
        return;
      }
      T.focus({
        preventScroll: !!i.preventScroll
      }), a.mostRecentlyFocusedNode = T, Sc(T) && T.select();
    }
  }, w = function(T) {
    var A = v("setReturnFocus", {
      params: [T]
    });
    return A || (A === !1 ? !1 : T);
  }, _ = function(T) {
    var A = T.target, z = T.event, U = T.isBackward, X = U === void 0 ? !1 : U;
    A = A || Ea(z), m();
    var B = null;
    if (a.tabbableGroups.length > 0) {
      var ie = h(A, z), H = ie >= 0 ? a.containerGroups[ie] : void 0;
      if (ie < 0)
        X ? B = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : B = a.tabbableGroups[0].firstTabbableNode;
      else if (X) {
        var ee = a.tabbableGroups.findIndex(function(ge) {
          var be = ge.firstTabbableNode;
          return A === be;
        });
        if (ee < 0 && (H.container === A || br(A, i.tabbableOptions) && !Dn(A, i.tabbableOptions) && !H.nextTabbableNode(A, !1)) && (ee = ie), ee >= 0) {
          var ue = ee === 0 ? a.tabbableGroups.length - 1 : ee - 1, ye = a.tabbableGroups[ue];
          B = pn(A) >= 0 ? ye.lastTabbableNode : ye.lastDomTabbableNode;
        } else aa(z) || (B = H.nextTabbableNode(A, !1));
      } else {
        var xe = a.tabbableGroups.findIndex(function(ge) {
          var be = ge.lastTabbableNode;
          return A === be;
        });
        if (xe < 0 && (H.container === A || br(A, i.tabbableOptions) && !Dn(A, i.tabbableOptions) && !H.nextTabbableNode(A)) && (xe = ie), xe >= 0) {
          var te = xe === a.tabbableGroups.length - 1 ? 0 : xe + 1, he = a.tabbableGroups[te];
          B = pn(A) >= 0 ? he.firstTabbableNode : he.firstDomTabbableNode;
        } else aa(z) || (B = H.nextTabbableNode(A));
      }
    } else
      B = v("fallbackFocus");
    return B;
  }, g = function(T) {
    var A = Ea(T);
    if (!(h(A, T) >= 0)) {
      if (Yn(i.clickOutsideDeactivates, T)) {
        l.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      Yn(i.allowOutsideClick, T) || T.preventDefault();
    }
  }, b = function(T) {
    var A = Ea(T), z = h(A, T) >= 0;
    if (z || A instanceof Document)
      z && (a.mostRecentlyFocusedNode = A);
    else {
      T.stopImmediatePropagation();
      var U, X = !0;
      if (a.mostRecentlyFocusedNode)
        if (pn(a.mostRecentlyFocusedNode) > 0) {
          var B = h(a.mostRecentlyFocusedNode), ie = a.containerGroups[B].tabbableNodes;
          if (ie.length > 0) {
            var H = ie.findIndex(function(ee) {
              return ee === a.mostRecentlyFocusedNode;
            });
            H >= 0 && (i.isKeyForward(a.recentNavEvent) ? H + 1 < ie.length && (U = ie[H + 1], X = !1) : H - 1 >= 0 && (U = ie[H - 1], X = !1));
          }
        } else
          a.containerGroups.some(function(ee) {
            return ee.tabbableNodes.some(function(ue) {
              return pn(ue) > 0;
            });
          }) || (X = !1);
      else
        X = !1;
      X && (U = _({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(a.recentNavEvent)
      })), c(U || a.mostRecentlyFocusedNode || f());
    }
    a.recentNavEvent = void 0;
  }, S = function(T) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = T;
    var z = _({
      event: T,
      isBackward: A
    });
    z && (aa(T) && T.preventDefault(), c(z));
  }, E = function(T) {
    (i.isKeyForward(T) || i.isKeyBackward(T)) && S(T, i.isKeyBackward(T));
  }, I = function(T) {
    Cc(T) && Yn(i.escapeDeactivates, T) !== !1 && (T.preventDefault(), l.deactivate());
  }, $ = function(T) {
    var A = Ea(T);
    h(A, T) >= 0 || Yn(i.clickOutsideDeactivates, T) || Yn(i.allowOutsideClick, T) || (T.preventDefault(), T.stopImmediatePropagation());
  }, C = function() {
    if (a.active) {
      Gt.activateTrap(s, l);
      var T;
      return i.delayInitialFocus ? T = new Promise(function(A) {
        a.delayInitialFocusTimer = Vi(function() {
          c(f()), A();
        });
      }) : c(f()), r.addEventListener("focusin", b, !0), r.addEventListener("mousedown", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", $, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", E, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", I), T;
    }
  }, F = function(T) {
    a.active && !a.paused && l._setSubtreeIsolation(!1), a.adjacentElements.clear(), a.alreadySilent.clear();
    var A = /* @__PURE__ */ new Set(), z = /* @__PURE__ */ new Set(), U = Bi(T), X;
    try {
      for (U.s(); !(X = U.n()).done; ) {
        var B = X.value;
        A.add(B);
        for (var ie = typeof ShadowRoot < "u" && B.getRootNode() instanceof ShadowRoot, H = B; H; ) {
          A.add(H);
          var ee = H.parentElement, ue = [];
          ee ? ue = ee.children : !ee && ie && (ue = H.getRootNode().children, ee = H.getRootNode().host, ie = typeof ShadowRoot < "u" && ee.getRootNode() instanceof ShadowRoot);
          var ye = Bi(ue), xe;
          try {
            for (ye.s(); !(xe = ye.n()).done; ) {
              var te = xe.value;
              z.add(te);
            }
          } catch (he) {
            ye.e(he);
          } finally {
            ye.f();
          }
          H = ee;
        }
      }
    } catch (he) {
      U.e(he);
    } finally {
      U.f();
    }
    A.forEach(function(he) {
      z.delete(he);
    }), a.adjacentElements = z;
  }, V = function() {
    if (a.active)
      return r.removeEventListener("focusin", b, !0), r.removeEventListener("mousedown", g, !0), r.removeEventListener("touchstart", g, !0), r.removeEventListener("click", $, !0), r.removeEventListener("keydown", E, !0), r.removeEventListener("keydown", I), l;
  }, K = function(T) {
    var A = a.mostRecentlyFocusedNode;
    if (A) {
      var z = T.some(function(X) {
        var B = Array.from(X.removedNodes);
        return B.some(function(ie) {
          return ie === A || typeof ie.contains == "function" && ie.contains(A);
        });
      });
      if (z && a.containers.some(function(X) {
        return X?.isConnected;
      })) {
        m();
        var U = f();
        c(U);
      }
    }
  }, O = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(K) : void 0, G = function() {
    O && (O.disconnect(), a.active && !a.paused && a.containers.map(function(T) {
      O.observe(T, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return l = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(T) {
      if (a.active)
        return this;
      var A = o(T, "onActivate"), z = o(T, "onPostActivate"), U = o(T, "checkCanFocusTrap"), X = Gt.getActiveTrap(s), B = !1;
      if (X && !X.paused) {
        var ie;
        (ie = X._setSubtreeIsolation) === null || ie === void 0 || ie.call(X, !1), B = !0;
      }
      try {
        U || m(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = u(r), A?.({
          trap: l
        });
        var H = function() {
          U && m();
          var ye = function() {
            l._setSubtreeIsolation(!0), G(), z?.({
              trap: l
            });
          }, xe = C();
          xe ? xe.then(ye) : ye();
        };
        if (U)
          return U(a.containers.concat()).then(H, H), this;
        H();
      } catch (ue) {
        if (X === Gt.getActiveTrap(s) && B) {
          var ee;
          (ee = X._setSubtreeIsolation) === null || ee === void 0 || ee.call(X, !0);
        }
        throw ue;
      }
      return this;
    },
    deactivate: function(T) {
      if (!a.active)
        return this;
      var A = zi({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, T);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, a.paused || l._setSubtreeIsolation(!1), a.alreadySilent.clear(), V(), a.active = !1, a.paused = !1, G(), Gt.deactivateTrap(s, l);
      var z = o(A, "onDeactivate"), U = o(A, "onPostDeactivate"), X = o(A, "checkCanReturnFocus"), B = o(A, "delayReturnFocus"), ie = o(A, "returnFocus", "returnFocusOnDeactivate");
      z?.({
        trap: l
      });
      var H = function() {
        ie && c(w(a.nodeFocusedBeforeActivation)), U?.({
          trap: l
        });
      }, ee = function() {
        B && ie ? Vi(H) : H();
      };
      return ie && X ? (X(w(a.nodeFocusedBeforeActivation)).then(ee, ee), this) : (ee(), this);
    },
    pause: function(T) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, T)) : this;
    },
    unpause: function(T) {
      return a.active ? (a.manuallyPaused = !1, s[s.length - 1] !== this ? this : this._setPausedState(!1, T)) : this;
    },
    updateContainerElements: function(T) {
      var A = [].concat(T).filter(Boolean);
      return a.containers = A.map(function(z) {
        return typeof z == "string" ? r.querySelector(z) : z;
      }), i.isolateSubtrees && F(a.containers), a.active && (m(), a.paused || l._setSubtreeIsolation(!0)), G(), this;
    }
  }, Object.defineProperties(l, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(T, A) {
        if (a.paused === T)
          return this;
        if (a.paused = T, T) {
          var z = o(A, "onPause"), U = o(A, "onPostPause");
          z?.({
            trap: l
          }), V(), l._setSubtreeIsolation(!1), G(), U?.({
            trap: l
          });
        } else {
          var X = o(A, "onUnpause"), B = o(A, "onPostUnpause");
          X?.({
            trap: l
          });
          var ie = function() {
            m();
            var ee = function() {
              l._setSubtreeIsolation(!0), G(), B?.({
                trap: l
              });
            }, ue = C();
            ue ? ue.then(ee) : ee();
          };
          ie();
        }
        return this;
      }
    },
    _setSubtreeIsolation: {
      value: function(T) {
        i.isolateSubtrees && a.adjacentElements.forEach(function(A) {
          var z;
          T ? i.isolateSubtrees === "aria-hidden" ? ((A.ariaHidden === "true" || ((z = A.getAttribute("aria-hidden")) === null || z === void 0 ? void 0 : z.toLowerCase()) === "true") && a.alreadySilent.add(A), A.setAttribute("aria-hidden", "true")) : ((A.inert || A.hasAttribute("inert")) && a.alreadySilent.add(A), A.setAttribute("inert", !0)) : a.alreadySilent.has(A) || (i.isolateSubtrees === "aria-hidden" ? A.removeAttribute("aria-hidden") : A.removeAttribute("inert"));
        });
      }
    }
  }), l.updateContainerElements(t), l;
};
function $c(e, t = {}) {
  let n;
  const { immediate: r, ...s } = t, i = Hn(!1), a = Hn(!1), l = (u) => n && n.activate(u), o = (u) => n && n.deactivate(u), h = () => {
    n && (n.pause(), a.value = !0);
  }, v = () => {
    n && (n.unpause(), a.value = !1);
  };
  return Ve(J(() => Ns(Ke(e)).map((u) => {
    const f = Ke(u);
    return typeof f == "string" ? f : no(f);
  }).filter(ec)), (u) => {
    if (u.length)
      if (!n)
        n = Lc(u, {
          ...s,
          onActivate(f) {
            i.value = !0, t.onActivate && t.onActivate(f);
          },
          onDeactivate(f) {
            i.value = !1, t.onDeactivate && t.onDeactivate(f);
          }
        }), r && l();
      else {
        const f = n?.active;
        n?.updateContainerElements(u), !f && r && l();
      }
  }, { flush: "post" }), Bs(() => o()), {
    hasFocus: i,
    isPaused: a,
    activate: l,
    deactivate: o,
    pause: h,
    unpause: v
  };
}
const mo = /* @__PURE__ */ Se((e, { slots: t }) => {
  const n = Hn(), r = Jr($c(n, e.options));
  return () => {
    if (t.default) return Ts(e.as || "div", { ref: n }, t.default(r));
  };
}, {
  name: "UseFocusTrap",
  props: ["as", "options"]
}), Ic = 864e5, Dc = 6e4, Mc = 36e5, Hi = /* @__PURE__ */ Symbol.for("constructDateFrom");
function Un(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Hi in e ? e[Hi](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Dt(e, t) {
  return Un(e, e);
}
function Oc(e, t, n) {
  const r = Dt(e);
  return isNaN(t) ? Un(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Rc(e, t, n) {
  const r = Dt(e);
  if (isNaN(t)) return Un(e, NaN);
  if (!t)
    return r;
  const s = r.getDate(), i = Un(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const a = i.getDate();
  return s >= a ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    s
  ), r);
}
function Gn(e, t, n) {
  const {
    years: r = 0,
    months: s = 0,
    weeks: i = 0,
    days: a = 0,
    hours: l = 0,
    minutes: o = 0,
    seconds: h = 0
  } = t, v = Dt(e), u = s || r ? Rc(v, s + r * 12) : v, f = a || i ? Oc(u, a + i * 7) : u, m = o + l * 60, w = (h + m * 60) * 1e3;
  return Un(e, +f + w);
}
function Ui(e) {
  const t = Dt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function cn(e, ...t) {
  const n = Un.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function qi(e, t) {
  const n = Dt(e);
  return n.setHours(0, 0, 0, 0), n;
}
function Fc(e, t, n) {
  const [r, s] = cn(
    n?.in,
    e,
    t
  ), i = qi(r), a = qi(s), l = +i - Ui(i), o = +a - Ui(a);
  return Math.round((l - o) / Ic);
}
function ra(e, t) {
  const n = +Dt(e) - +Dt(t);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function Nc(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function ai(e) {
  return !(!Nc(e) && typeof e != "number" || isNaN(+Dt(e)));
}
function Bc(e, t, n) {
  const [r, s] = cn(
    n?.in,
    e,
    t
  ), i = r.getFullYear() - s.getFullYear(), a = r.getMonth() - s.getMonth();
  return i * 12 + a;
}
function Pc(e, t, n) {
  const [r, s] = cn(
    n?.in,
    e,
    t
  );
  return r.getFullYear() - s.getFullYear();
}
function zc(e, t, n) {
  const [r, s] = cn(
    n?.in,
    e,
    t
  ), i = ji(r, s), a = Math.abs(
    Fc(r, s)
  );
  r.setDate(r.getDate() - i * a);
  const l = +(ji(r, s) === -i), o = i * (a - l);
  return o === 0 ? 0 : o;
}
function ji(e, t) {
  const n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function ri(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function Vc(e, t, n) {
  const [r, s] = cn(
    n?.in,
    e,
    t
  ), i = (+r - +s) / Mc;
  return ri(n?.roundingMethod)(i);
}
function go(e, t) {
  return +Dt(e) - +Dt(t);
}
function Hc(e, t, n) {
  const r = go(e, t) / Dc;
  return ri(n?.roundingMethod)(r);
}
function Uc(e, t) {
  const n = Dt(e);
  return n.setHours(23, 59, 59, 999), n;
}
function qc(e, t) {
  const n = Dt(e), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function jc(e, t) {
  const n = Dt(e);
  return +Uc(n) == +qc(n);
}
function Zc(e, t, n) {
  const [r, s, i] = cn(
    n?.in,
    e,
    e,
    t
  ), a = ra(s, i), l = Math.abs(
    Bc(s, i)
  );
  if (l < 1) return 0;
  s.getMonth() === 1 && s.getDate() > 27 && s.setDate(30), s.setMonth(s.getMonth() - a * l);
  let o = ra(s, i) === -a;
  jc(r) && l === 1 && ra(r, i) === 1 && (o = !1);
  const h = a * (l - +o);
  return h === 0 ? 0 : h;
}
function Wc(e, t, n) {
  const r = go(e, t) / 1e3;
  return ri(n?.roundingMethod)(r);
}
function Xc(e, t, n) {
  const [r, s] = cn(
    n?.in,
    e,
    t
  ), i = ra(r, s), a = Math.abs(Pc(r, s));
  r.setFullYear(1584), s.setFullYear(1584);
  const l = ra(r, s) === -i, o = i * (a - +l);
  return o === 0 ? 0 : o;
}
function Yc(e, t) {
  const [n, r] = cn(e, t.start, t.end);
  return { start: n, end: r };
}
function Gc(e, t) {
  const { start: n, end: r } = Yc(t?.in, e), s = {}, i = Xc(r, n);
  i && (s.years = i);
  const a = Gn(n, { years: s.years }), l = Zc(r, a);
  l && (s.months = l);
  const o = Gn(a, { months: s.months }), h = zc(r, o);
  h && (s.days = h);
  const v = Gn(o, { days: s.days }), u = Vc(r, v);
  u && (s.hours = u);
  const f = Gn(v, { hours: s.hours }), m = Hc(r, f);
  m && (s.minutes = m);
  const c = Gn(f, { minutes: s.minutes }), w = Wc(r, c);
  return w && (s.seconds = w), s;
}
function bo(e) {
  return +Dt(e) < Date.now();
}
function Kc(e, t, n) {
  let r = (s) => e(s, ...t);
  return n === void 0 ? r : Object.assign(r, { lazy: n, lazyArgs: t });
}
function Ga(e, t, n) {
  let r = e.length - t.length;
  if (r === 0) return e(...t);
  if (r === 1) return Kc(e, t, n);
  throw Error("Wrong number of arguments");
}
function Zi(...e) {
  return Ga(Jc, e);
}
const Jc = (e, t) => e.length >= t;
function _t(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function Wi(e) {
  if (typeof e != "object" || !e) return !1;
  let t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function Qc(...e) {
  return Ga(po, e);
}
function po(e, t) {
  let n = { ...e, ...t };
  for (let r in t) {
    if (!(r in e)) continue;
    let { [r]: s } = e;
    if (!Wi(s)) continue;
    let { [r]: i } = t;
    Wi(i) && (n[r] = po(s, i));
  }
  return n;
}
function Qt(...e) {
  return Ga(eu, e);
}
function eu(e, t) {
  if (!Zi(t, 1)) return { ...e };
  if (!Zi(t, 2)) {
    let { [t[0]]: r, ...s } = e;
    return s;
  }
  let n = { ...e };
  for (let r of t) delete n[r];
  return n;
}
function tu(...e) {
  return Ga(nu, e);
}
function nu(e, t) {
  let n = {};
  for (let r of t) r in e && (n[r] = e[r]);
  return n;
}
const yo = {
  general: {
    currency: "USD",
    locale: "en-US"
  },
  lcButton: {
    longPressHint: "Press & Hold"
  },
  lcCard: {
    toggleAriaLabel: "Toggle content visibility"
  },
  lcFlyOut: {
    buttonAriaLabel: "Close flyout",
    to: "#lc-fly-outs",
    visibleInSeconds: 4
  },
  lcHeader: {
    flyOutToggleAriaLabel: "Toggle flyout visibility",
    leftButtonAriaLabel: "Go back"
  },
  lcInfoButton: {
    closeButtonAriaLabel: "Close info modal",
    openButtonAriaLabel: "Open info modal"
  },
  lcLotteryCutoffTime: {
    textCutoffTime: "Cutoff time",
    textTimeIsAlmostUp: "Time’s almost up",
    textTimeToCutoff: "Time until cutoff"
  },
  lcLotteryEditorCard: {
    clearLabel: "Clear",
    quickPickLabel: "Quick Pick",
    toggleAriaLabel: "Toggle play visibility"
  },
  lcLotteryRemainingPicks: {
    doneLabel: "Done!"
  },
  lcModal: {
    closeTriggers: [],
    fullScreen: !1,
    fullSize: !1,
    isVisible: !1,
    noFocusTrap: !1,
    spacing: "large",
    to: "#lc-modals"
  },
  lcPasswordInput: {
    toggleAriaLabel: "Toggle password visibility"
  },
  lcToast: {
    closeButtonAriaLabel: "Close toast"
  }
}, je = Jr(yo), E1 = (e) => {
  Object.assign(je, Qc(yo, e));
}, au = /* @__PURE__ */ Symbol(), pa = () => {
  const e = Qr();
  if (!e?.proxy)
    throw new Error("No instance of Vue detected");
  return "$nuxt" in e.proxy ? Zn(au) : null;
}, ru = () => pa() ? Fa("NuxtTime") : "time", wo = /* @__PURE__ */ Se({
  __name: "CommonDateTime",
  props: {
    day: {},
    hour: {},
    minute: {},
    month: {},
    second: {},
    weekday: {},
    year: {},
    datetime: {},
    locale: { default: () => je.general.locale }
  },
  setup(e) {
    const t = ga(e, ["datetime", "locale"]), n = ru(), r = J(() => s.value ? i.value?.toISOString() : void 0), s = J(() => i.value ? ai(i.value) : !1), i = J(() => {
      if (e.datetime)
        return new Date(e.datetime);
    });
    return (a, l) => s.value ? (L(), Ce(Xt(q(n)), Ee({
      key: 0,
      class: "lc-datetime"
    }, { ...t, locale: e.locale }, { datetime: r.value }), {
      default: Ie(() => [
        me(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["datetime"])) : ce("", !0);
  }
}), Wn = (e) => {
  const t = Qr(), n = pa();
  return !(t?.proxy && "$router" in t.proxy) || !e ? "a" : n ? Fa("NuxtLink") : Fa("RouterLink");
}, ii = /* @__PURE__ */ Se({
  __name: "CommonLink",
  props: {
    href: {},
    target: {},
    to: {}
  },
  setup(e) {
    const t = Wn(e.to);
    return (n, r) => (L(), Ce(Xt(q(t)), Ee(n.$attrs, n.$props), {
      default: Ie(() => [
        me(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ca = /* @__PURE__ */ Se({
  __name: "CommonTransition",
  props: {
    mode: {},
    name: { default: "slide-down-sm" }
  },
  setup(e) {
    const t = we(!1), n = Ps(t, 1);
    return wt(() => {
      t.value = !0;
    }), (r, s) => (L(), Ce(wn, At(Rt({ name: e.name, mode: e.mode })), {
      default: Ie(() => [
        q(n) ? me(r.$slots, "default", {}, void 0, void 0, 0) : ce("", !0)
      ]),
      _: 3
    }, 16));
  }
}), iu = {
  key: 0,
  class: "lc-feedback-message__content"
}, An = /* @__PURE__ */ Se({
  __name: "FeedbackMessage",
  props: {
    content: {},
    disabled: { type: Boolean },
    variant: { default: "default" }
  },
  setup(e) {
    const t = J(() => [
      "lc-feedback-message",
      `lc-feedback-message--variant-${e.variant}`,
      {
        "lc-feedback-message--disabled": e.disabled
      }
    ]);
    return (n, r) => (L(), j("div", {
      class: pe(t.value),
      role: "alert"
    }, [
      Oe(q(ca), {
        mode: "out-in",
        name: "slide-fade"
      }, {
        default: Ie(() => [
          e.content ? (L(), j("p", iu, [
            e.variant === "error" ? (L(), Ce(q(Qe), {
              key: 0,
              class: "lc-feedback-message__icon",
              name: "alert-triangle",
              size: "small"
            })) : ce("", !0),
            yt(" " + $e(e.content), 1)
          ])) : ce("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), lu = /* @__PURE__ */ Se({
  __name: "InternalOptionalTeleport",
  props: {
    to: {}
  },
  setup(e) {
    return (t, n) => e.to ? (L(), Ce(ba, {
      key: 0,
      to: e.to
    }, [
      me(t.$slots, "default")
    ], 8, ["to"])) : me(t.$slots, "default", {}, void 0, void 0, 1);
  }
}), ou = ["height", "width"], su = ["r", "stroke-width"], cu = ["r", "stroke-dasharray", "stroke-dashoffset", "stroke-width"], xo = /* @__PURE__ */ Se({
  __name: "ProgressCircle",
  props: {
    progress: { default: 0 },
    progressClass: {},
    radius: { default: 24 },
    strokeWidth: { default: 4 },
    trackClass: {}
  },
  setup(e) {
    const t = J(() => Math.min(100, Math.max(0, e.progress))), n = J(() => e.radius - e.strokeWidth), r = J(() => 2 * Math.PI * n.value), s = J(
      () => r.value - t.value / 100 * r.value
    );
    return (i, a) => (L(), j("svg", {
      class: "lc-progress-circle",
      height: e.radius * 2,
      width: e.radius * 2
    }, [
      ae("circle", {
        class: pe(["lc-progress-circle__track", e.trackClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-width": e.strokeWidth
      }, null, 10, su),
      ae("circle", {
        class: pe(["lc-progress-circle__progress", e.progressClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-dasharray": `${r.value} ${r.value}`,
        "stroke-dashoffset": s.value,
        "stroke-width": e.strokeWidth
      }, null, 10, cu)
    ], 8, ou));
  }
}), uu = { class: "lc-timer-circle" }, du = ["aria-valuenow"], fu = { class: "lc-timer-circle__content" }, hu = /* @__PURE__ */ Se({
  __name: "TimerCircle",
  props: {
    durationInMs: { default: 4e3 }
  },
  setup(e) {
    const t = we(0), n = zs(t, {
      duration: e.durationInMs,
      transition: Vs.linear
    });
    return wt(() => {
      t.value = 100;
    }), (r, s) => (L(), j("div", uu, [
      ae("div", {
        "aria-valuenow": q(n),
        class: "lc-timer-circle__visual",
        role: "progressbar"
      }, [
        Oe(q(xo), Ee({ progress: q(n) }, { class: "lc-timer-circle__progress" }), null, 16)
      ], 8, du),
      ae("div", fu, [
        me(r.$slots, "default")
      ])
    ]));
  }
}), vu = (e, t) => e in t, en = (e, t) => typeof e == "string" && Object.values(t).includes(e), T1 = ["left", "right"], A1 = ["large", "medium", "small"], L1 = ["button", "reset", "submit"], $1 = ["click", "long-press"], I1 = [
  "primary",
  "primary-ghost",
  "secondary",
  "tertiary",
  "filled",
  "raised"
];
var Ur = /* @__PURE__ */ ((e) => (e.Enter = "Enter", e.Space = " ", e))(Ur || {});
const mu = ["aria-valuenow"], gu = { class: "lc-button__content" }, bu = {
  key: 0,
  class: "lc-button__label-bubble"
}, pu = {
  key: 0,
  class: "lc-button__overlay"
}, yu = { class: "lc-button__long-press-hint" }, wu = {
  key: 1,
  class: "lc-button__overlay"
}, xu = {
  key: 0,
  class: "lc-button__loading-text"
}, Xi = 1e3 / 25, St = /* @__PURE__ */ Se({
  __name: "LcButton",
  props: {
    href: {},
    target: {},
    to: {},
    count: {},
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    growAnimationMaxWidth: { default: "100%" },
    icon: {},
    iconPosition: { default: "left" },
    loading: { type: Boolean },
    loadingText: {},
    longPressDelay: { default: 2500 },
    longPressHint: { default: () => je.lcButton.longPressHint },
    longPressHintDelay: { default: 1300 },
    noPadding: { type: Boolean },
    size: { default: "large" },
    title: {},
    trigger: { default: "click" },
    type: { default: "button" },
    variant: { default: "primary" }
  },
  emits: ["longpress"],
  setup(e, { emit: t }) {
    const n = t, r = En(), s = we(!!r.default), i = we(!1), a = we(!1), l = we(!1), o = we(!1), h = we(0), v = we(null);
    let u, f, m;
    const c = J(() => [
      "lc-button",
      `lc-button--icon-${e.iconPosition}`,
      `lc-button--size-${e.size}`,
      `lc-button--variant-${e.variant}`,
      {
        "lc-button--disabled": w.value,
        "lc-button--icon-only": !s.value,
        "lc-button--link": _.value,
        "lc-button--loading": e.loading,
        "lc-button--long-press-active": e.trigger === "long-press" && l.value,
        "lc-button--long-press-done": i.value,
        "lc-button--no-padding": e.noPadding,
        "lc-button--overlay-visible": g.value || e.loading,
        "lc-button--pressed": b.value
      }
    ]), w = J(() => e.disabled || e.loading), _ = J(() => !!(e.href || e.to) && !w.value), g = J(
      () => a.value && !e.loading && e.trigger === "long-press"
    ), b = J(() => o.value || !!v.value), S = J(() => typeof e.to == "string" ? void 0 : e.to?.replace), E = J(() => {
      const U = {
        "--grow-animation-max-width": e.growAnimationMaxWidth
      };
      return e.trigger !== "long-press" ? U : {
        ...U,
        "--progress-transition-duration": `${e.longPressDelay}ms`
      };
    }), I = J(() => _.value ? Wn(e.to) : "button"), $ = () => {
      i.value = !1, l.value = !1, G(), T();
    }, C = (U) => {
      w.value || en(U.key, Ur) && (v.value || (v.value = U.key, V()));
    }, F = (U) => {
      en(U.key, Ur) && U.key === v.value && (G(), !o.value && P());
    }, V = (U = !1) => {
      e.trigger !== "click" && (U && window.addEventListener("pointerup", O), clearTimeout(m), l.value = !0);
    }, K = () => {
      w.value || (o.value = !0, V(!0));
    }, O = () => {
      window.removeEventListener("pointerup", O), T(), !v.value && P();
    }, G = () => {
      v.value = null;
    }, P = () => {
      !l.value && !i.value || (i.value ? a.value = !1 : m = setTimeout(() => {
        a.value = !1;
      }, e.longPressHintDelay), i.value = !1, l.value = !1);
    }, T = () => {
      o.value = !1;
    }, A = () => {
      w.value || V();
    }, z = () => {
      T(), P();
    };
    return Jl(() => {
      s.value = !!r.default;
    }), Tn(() => {
      clearInterval(u), clearTimeout(f), clearTimeout(m);
    }), Ve(l, (U) => {
      if (!w.value) {
        if (!U) {
          clearInterval(u), clearTimeout(f), h.value = 0;
          return;
        }
        a.value = !0, u = setInterval(() => {
          h.value += Xi / e.longPressDelay * 100;
        }, Xi), f = setTimeout(() => {
          clearInterval(u), i.value = !0, n("longpress");
        }, e.longPressDelay);
      }
    }), (U, X) => (L(), Ce(Xt(I.value), Ee(U.$attrs, {
      autofocus: e.autofocus,
      href: e.href,
      target: e.target,
      title: e.title,
      to: e.to,
      type: e.type,
      style: E.value,
      replace: S.value
    }, {
      "aria-busy": e.loading,
      class: c.value,
      disabled: w.value,
      onBlur: $,
      onContextmenu: X[0] || (X[0] = oa(() => {
      }, ["prevent"])),
      onKeydown: C,
      onKeyup: F,
      onPointerdown: K,
      onPointerup: O,
      onTouchend: z,
      onTouchstartPassive: A
    }), {
      default: Ie(() => [
        e.trigger === "long-press" ? (L(), j("div", {
          key: 0,
          "aria-valuenow": h.value,
          class: "lc-button__progress",
          role: "progressbar"
        }, null, 8, mu)) : ce("", !0),
        ae("div", gu, [
          e.icon ? (L(), Ce(q(Qe), {
            key: 0,
            class: "lc-button__icon",
            name: e.icon
          }, null, 8, ["name"])) : ce("", !0),
          Oe(wn, { name: "font-size-fade" }, {
            default: Ie(() => [
              U.$slots.default ? (L(), j("span", bu, [
                me(U.$slots, "default"),
                Oe(q(zr), Ee({ count: e.count }, { class: "lc-button__count-text" }), null, 16)
              ])) : ce("", !0)
            ]),
            _: 3
          }),
          U.$slots.default ? ce("", !0) : (L(), Ce(q(zr), Ee({ key: 1 }, { count: e.count }, { class: "lc-button__count" }), null, 16))
        ]),
        Oe(q(ca), { name: "fade" }, {
          default: Ie(() => [
            g.value ? (L(), j("div", pu, [
              ae("span", yu, $e(e.longPressHint), 1)
            ])) : ce("", !0),
            e.loading ? (L(), j("div", wu, [
              Oe(q(Qe), {
                class: "lc-button__loading-spinner",
                name: "loader"
              }),
              e.loadingText ? (L(), j("span", xu, $e(e.loadingText), 1)) : ce("", !0)
            ])) : ce("", !0)
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 16, ["aria-busy", "class", "disabled"]));
  }
}), li = /* @__PURE__ */ Se({
  __name: "LcSeparator",
  props: {
    variant: { default: "default" }
  },
  setup(e) {
    return (t, n) => (L(), j("hr", {
      class: pe(["lc-separator", `lc-separator--variant-${e.variant}`])
    }, null, 2));
  }
}), D1 = ["dashed", "default"], Ct = (e) => {
  if (e) return `lc-${e}`;
  const t = pa(), n = crypto.randomUUID();
  return t ? `lc-${t.useId() || n}` : `lc-${n}`;
}, oi = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, s] of t)
    n[r] = s;
  return n;
}, ku = {}, _u = { viewBox: "0 0 752 8" }, Su = { id: "perforation" }, Cu = ["cx"];
function Eu(e, t) {
  return L(), j("svg", _u, [
    ae("mask", Su, [
      t[0] || (t[0] = ae("rect", {
        fill: "white",
        height: "8",
        width: "752"
      }, null, -1)),
      (L(!0), j(Ge, null, vt(new Array(21), (n, r) => (L(), j("circle", {
        key: r,
        cx: 28 + r * 34.75,
        cy: "18",
        fill: "black",
        r: "16"
      }, null, 8, Cu))), 128))
    ]),
    t[1] || (t[1] = ae("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const Tu = /* @__PURE__ */ oi(ku, [["render", Eu]]), Au = {}, Lu = { viewBox: "0 0 752 8" }, $u = { id: "perforation" }, Iu = ["points"];
function Du(e, t) {
  return L(), j("svg", Lu, [
    ae("mask", $u, [
      t[0] || (t[0] = ae("rect", {
        fill: "black",
        height: "8",
        width: "752"
      }, null, -1)),
      (L(!0), j(Ge, null, vt(new Array(150), (n, r) => (L(), j("polygon", {
        key: r,
        fill: "white",
        points: `${r * 5},0 ${4 + r * 5},6 ${8 + r * 5},0`
      }, null, 8, Iu))), 128))
    ]),
    t[1] || (t[1] = ae("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const Yi = /* @__PURE__ */ oi(Au, [["render", Du]]), Mu = ["id"], Ou = {
  key: 0,
  class: "lc-card__background"
}, Ru = {
  key: 1,
  class: /* @__PURE__ */ pe(["lc-card__perforation", "lc-card__perforation--top"])
}, Fu = {
  key: 0,
  class: "lc-card__toggle"
}, Nu = {
  key: 3,
  class: "lc-card__body-wrap"
}, Bu = ["id"], ya = /* @__PURE__ */ Se({
  __name: "LcCard",
  props: /* @__PURE__ */ sa({
    bodyClass: {},
    expandable: { type: Boolean },
    footerClass: {},
    headerClass: {},
    headerTo: {},
    id: {},
    modelValue: { type: Boolean },
    onHeaderClick: { type: Function },
    radius: { default: "medium" },
    shadow: { default: "large" },
    showSeparator: { type: Boolean },
    toggleAriaLabel: { default: () => je.lcCard.toggleAriaLabel },
    variant: { default: "default" },
    withWavyBody: { type: Boolean },
    withWavyHeader: { type: Boolean }
  }, {
    modelValue: { default: !1, type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = En(), n = Ct(e.id), r = we(!!t.default), s = Za(e, "modelValue"), i = J(() => [
      "lc-card",
      `lc-card--radius-${e.radius}`,
      `lc-card--shadow-${e.shadow}`,
      `lc-card--variant-${e.variant}`,
      {
        "lc-card--expandable": e.expandable,
        "lc-card--expanded": e.expandable && s.value,
        "lc-card--no-body": !r.value,
        "lc-card--wavy-body": e.withWavyBody,
        "lc-card--wavy-header": e.withWavyHeader
      }
    ]), a = () => {
      e.expandable && (s.value = !s.value);
    };
    return Jl(() => {
      r.value = !!t.default;
    }), (l, o) => (L(), j("article", {
      id: q(n),
      class: pe(i.value)
    }, [
      l.$slots.background ? (L(), j("div", Ou, [
        me(l.$slots, "background")
      ])) : ce("", !0),
      e.variant === "transaction" ? (L(), j("div", Ru, [
        Oe(Yi)
      ])) : ce("", !0),
      l.$slots.header || e.expandable ? (L(), Ce(Xt(e.expandable ? "button" : "div"), {
        key: 2,
        "aria-controls": e.expandable ? `${q(n)}-region` : void 0,
        "aria-expanded": e.expandable ? s.value : void 0,
        "aria-label": e.expandable ? e.toggleAriaLabel : void 0,
        class: "lc-card__header-wrap",
        type: e.expandable ? "button" : void 0,
        onClickPassive: a
      }, {
        default: Ie(() => [
          e.headerTo && !e.expandable ? (L(), Ce(q(ii), {
            key: 0,
            tabindex: "-1",
            to: e.headerTo,
            onClick: e.onHeaderClick
          }, {
            default: Ie(() => [
              ae("header", {
                class: pe(["lc-card__header", e.headerClass])
              }, [
                me(l.$slots, "header")
              ], 2)
            ]),
            _: 3
          }, 8, ["to", "onClick"])) : (L(), j("header", {
            key: 1,
            class: pe(["lc-card__header", e.headerClass])
          }, [
            me(l.$slots, "header"),
            e.expandable ? (L(), j(Ge, { key: 0 }, [
              l.$slots.toggle ? (L(), j("div", Fu, [
                me(l.$slots, "toggle")
              ])) : (L(), Ce(q(Qe), {
                key: 1,
                class: "lc-card__toggle-icon",
                name: "chevron-down"
              }))
            ], 64)) : ce("", !0)
          ], 2))
        ]),
        _: 3
      }, 40, ["aria-controls", "aria-expanded", "aria-label", "type"])) : ce("", !0),
      (l.$slots.default || l.$slots.footer) && (!e.expandable || s.value) ? (L(), j("div", Nu, [
        l.$slots.default ? (L(), j("div", {
          key: 0,
          class: pe(["lc-card__body", e.bodyClass])
        }, [
          me(l.$slots, "default")
        ], 2)) : ce("", !0),
        l.$slots.footer ? (L(), j("footer", {
          key: 1,
          class: pe(["lc-card__footer", e.footerClass])
        }, [
          e.showSeparator ? (L(), Ce(q(li), {
            key: 0,
            variant: "dashed"
          })) : ce("", !0),
          me(l.$slots, "footer")
        ], 2)) : ce("", !0),
        e.variant !== "default" ? (L(), j("div", {
          key: 2,
          id: `${q(n)}-region`,
          class: pe(["lc-card__perforation", "lc-card__perforation--bottom"])
        }, [
          e.variant == "order" ? (L(), Ce(Tu, { key: 0 })) : (L(), Ce(Yi, { key: 1 }))
        ], 8, Bu)) : ce("", !0)
      ])) : ce("", !0)
    ], 10, Mu));
  }
}), M1 = ["large", "medium", "none"], O1 = ["large", "none", "small"], R1 = ["default", "order", "transaction"], Pu = { class: "lc-modal__card-header-wrap" }, zu = { class: "lc-modal__card-header-actions" }, ko = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcModal",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    backgroundClass: {},
    closeTriggers: { default: () => je.lcModal.closeTriggers },
    containerClass: {},
    fullScreen: { type: Boolean },
    fullSize: { type: Boolean },
    isVisible: { type: Boolean, default: () => je.lcModal.isVisible },
    noFocusTrap: { type: Boolean, default: () => je.lcModal.noFocusTrap },
    spacing: { default: () => je.lcModal.spacing },
    to: { default: () => je.lcModal.to },
    transition: {},
    wrapAttrs: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = t, r = we(), s = ao(() => document.documentElement), i = J(() => h("close-button")), o = {
      allowOutsideClick: (f) => {
        const m = f.target;
        return m ? Ke(e.ignoreOutsideClickOn).some((c) => (typeof c == "string" ? document.querySelector(c) : no(c))?.contains(m) ?? !1) : !1;
      },
      fallbackFocus: (() => {
        const f = document.createElement("button");
        return f.id = "lc-modal-fallback-focus", f.hidden = !0, f;
      })(),
      immediate: !0
    }, h = (f) => e.closeTriggers.includes(f), v = (f) => {
      h(f) && n("close");
    }, u = (f) => {
      r.value = f;
    };
    return Ya(r, () => v("click-outside"), {
      ignore: e.ignoreOutsideClickOn
    }), ro("Escape", () => v("escape")), Ve(
      () => e.isVisible,
      (f) => {
        s.value = f;
      },
      { immediate: !0 }
    ), (f, m) => e.isVisible ? (L(), Ce(ba, {
      key: 0,
      class: "lc-modal",
      to: e.to
    }, [
      Oe(q(ca), { name: "fade" }, {
        default: Ie(() => [
          ae("div", {
            class: pe([
              "lc-modal__bg",
              {
                "lc-modal__bg--full-screen": e.fullScreen,
                "lc-modal__bg--full-size": e.fullSize
              },
              e.backgroundClass
            ])
          }, [
            Oe(q(ca), Ee(e.wrapAttrs, {
              class: ["lc-modal__wrap", e.containerClass],
              name: e.transition
            }), {
              default: Ie(() => [
                (L(), Ce(Xt(e.noFocusTrap ? "div" : q(mo)), {
                  options: e.noFocusTrap ? null : o
                }, {
                  default: Ie(() => [
                    me(f.$slots, "modal", At(Rt({ setRef: u })), () => [
                      Oe(q(ya), {
                        ref_key: "modalRef",
                        ref: r,
                        "body-class": "lc-modal__body",
                        class: pe([
                          "lc-modal__card",
                          `lc-modal__card--${e.spacing}`,
                          {
                            "lc-modal__card--full-size": e.fullSize
                          }
                        ]),
                        role: "dialog"
                      }, {
                        default: Ie(() => [
                          f.$slots.header || i.value ? (L(), j("header", {
                            key: 0,
                            class: pe(["lc-modal__card-header", {
                              "lc-modal__card-header--close-button": i.value || e.fullSize
                            }])
                          }, [
                            ae("div", Pu, [
                              me(f.$slots, "header")
                            ]),
                            ae("div", zu, [
                              me(f.$slots, "actions"),
                              i.value ? (L(), Ce(q(St), {
                                key: 0,
                                class: "lc-modal__card-header-close",
                                icon: "close",
                                size: "small",
                                variant: "tertiary",
                                onClickPassive: m[0] || (m[0] = (c) => v("close-button"))
                              })) : ce("", !0)
                            ])
                          ], 2)) : ce("", !0),
                          me(f.$slots, "default")
                        ]),
                        _: 3
                      }, 8, ["class"])
                    ])
                  ]),
                  _: 3
                }, 8, ["options"]))
              ]),
              _: 3
            }, 16, ["class", "name"])
          ], 2)
        ]),
        _: 3
      })
    ], 8, ["to"])) : ce("", !0);
  }
}), F1 = ["click-outside", "close-button", "escape"], N1 = ["large", "medium", "small"], Vu = 30, Hu = 0.3, Gi = (e) => {
  const t = e.match(/^([\d.]+)(px|dvh|vh|svh|lvh)$/);
  if (t) {
    const s = parseFloat(t[1]);
    return t[2] === "px" ? s : s / 100 * window.innerHeight;
  }
  const n = document.createElement("div");
  n.style.cssText = `height:${e};position:absolute;visibility:hidden`, document.body.appendChild(n);
  const r = n.getBoundingClientRect().height;
  return n.remove(), r;
}, Uu = ({
  dragAreaRef: e,
  snapHeights: t,
  onClose: n,
  canClose: r
}) => {
  const s = we(0), i = we(0), a = we(!1), l = we(0), o = we(0), h = we(0), v = we(0), u = J(
    () => Ke(t)[l.value] ?? Ke(t)[0]
  ), f = J(() => l.value < Ke(t).length - 1), m = () => {
    i.value = 0, s.value = 0, a.value = !1;
  }, c = () => {
    l.value = 0;
  }, w = (S, E) => (E > 0 ? S / E : 0) > Hu || S > Vu, _ = () => {
    if (!a.value) return;
    const S = v.value - h.value, E = Date.now() - o.value, I = Math.abs(S), $ = S > 0 ? "down" : "up", C = Ke(t);
    if ($ === "up" && f.value && w(I, E)) {
      const V = Gi(C[l.value]) + I;
      let K = l.value + 1, O = 1 / 0;
      for (let G = l.value + 1; G < C.length; G++) {
        const P = Math.abs(Gi(C[G]) - V);
        P < O && (O = P, K = G);
      }
      l.value = K, m();
      return;
    }
    if ($ === "down" && w(I, E) && r()) {
      a.value = !1, n();
      return;
    }
    m();
  }, g = (S) => {
    if (S.target.closest('button, a, [role="button"]')) return;
    S.currentTarget.setPointerCapture(S.pointerId), h.value = S.clientY, v.value = S.clientY, o.value = Date.now(), a.value = !0;
  }, b = (S) => {
    if (!a.value) return;
    v.value = S.clientY;
    const E = v.value - h.value;
    E < 0 && f.value ? (i.value = -E, s.value = 0) : (i.value = 0, s.value = Math.max(0, E));
  };
  return on(e, "pointerdown", g), on(e, "pointermove", b), on(e, "pointerup", _), on(e, "pointercancel", _), on(e, "lostpointercapture", _), {
    currentSnapHeight: u,
    currentSnapIndex: l,
    dismissOffset: s,
    isDragging: a,
    resetDrag: m,
    resetSnapIndex: c,
    snapTransitionOffset: i
  };
}, qu = { class: "lc-bottom-sheet-modal__header" }, ju = { class: "lc-bottom-sheet-modal__header-actions" }, Zu = { class: "lc-bottom-sheet" }, Wu = ["aria-labelledby"], Xu = { class: "lc-bottom-sheet__header-actions" }, Ta = 300, Ki = "lc-bottom-sheet__drag-area", Yu = "(width < 496px)", B1 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcBottomSheet",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    closeTriggers: { default: () => ["swipe-down", "click-outside", "escape", "close-button"] },
    modalClass: {},
    modelValue: { type: Boolean, default: !1 },
    snapHeights: { default: () => ["50dvh"] },
    to: { default: () => je.lcModal.to }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = {
      allowOutsideClick: !0,
      fallbackFocus: () => document.querySelector(`.${Ki}`) ?? document.body,
      immediate: !0
    }, r = ["click-outside", "escape", "close-button"], s = t;
    let i;
    const l = `${Ct()}-header`, o = dt("dragArea"), h = we(!1), v = we(!1), u = we(!0), f = Hs(Yu), m = ao(() => document.documentElement), {
      currentSnapHeight: c,
      dismissOffset: w,
      isDragging: _,
      resetDrag: g,
      resetSnapIndex: b,
      snapTransitionOffset: S
    } = Uu({
      dragAreaRef: o,
      snapHeights: J(() => e.snapHeights),
      onClose: () => $(),
      canClose: () => F("swipe-down")
    }), E = J(
      () => e.closeTriggers.filter(
        (K) => r.includes(K)
      )
    ), I = J(() => {
      if (_.value) {
        const O = S.value !== 0;
        return {
          height: O ? `calc(${c.value} + ${S.value}px)` : c.value,
          transform: O ? "translateY(0)" : `translateY(${Math.max(0, w.value)}px)`,
          transition: "none"
        };
      }
      if (h.value)
        return {
          height: c.value,
          transform: "translateY(100%)",
          transition: `transform ${Ta}ms ease`
        };
      const K = u.value;
      return {
        height: c.value,
        transform: K ? "translateY(100%)" : "translateY(0)",
        transition: u.value ? "none" : `height ${Ta}ms ease, transform ${Ta}ms ease`
      };
    }), $ = () => {
      h.value || (h.value = !0, i = setTimeout(() => {
        h.value = !1, g(), b(), s("update:modelValue", !1);
      }, Ta));
    }, C = () => {
      F("click-outside") && $();
    }, F = (K) => e.closeTriggers.includes(K), V = (K) => {
      const O = K.target;
      v.value = O.scrollTop > 0;
    };
    return Ve(
      () => e.modelValue,
      async (K) => {
        if (!K) return m.value = !1;
        clearTimeout(i), h.value = !1, g(), v.value = !1, u.value = !0, m.value = !0, await Wa(), requestAnimationFrame(() => {
          u.value = !1;
        });
      },
      { immediate: !0 }
    ), ro("Escape", () => {
      F("escape") && $();
    }), Tn(() => {
      clearTimeout(i), m.value = !1;
    }), (K, O) => q(f) ? e.modelValue ? (L(), Ce(ba, {
      key: 1,
      to: e.to
    }, [
      ae("div", Zu, [
        ae("div", {
          class: pe(["lc-bottom-sheet__overlay", { "lc-bottom-sheet__overlay--closing": h.value }]),
          role: "presentation",
          onClick: C
        }, null, 2),
        Oe(q(mo), { options: n }, {
          default: Ie(() => [
            ae("div", {
              "aria-labelledby": K.$slots.title ? l : void 0,
              "aria-modal": "true",
              class: "lc-bottom-sheet__sheet",
              role: "dialog",
              style: Lt(I.value)
            }, [
              ae("div", {
                ref: "dragArea",
                class: pe([
                  Ki,
                  { "lc-bottom-sheet__drag-area--scrolled": v.value }
                ])
              }, [
                O[1] || (O[1] = ae("div", { class: "lc-bottom-sheet__handle" }, [
                  ae("div", { class: "lc-bottom-sheet__handle-pill" })
                ], -1)),
                K.$slots.title || F("close-button") ? (L(), j("div", {
                  key: 0,
                  id: l,
                  class: "lc-bottom-sheet__header"
                }, [
                  me(K.$slots, "title"),
                  ae("div", Xu, [
                    me(K.$slots, "actions"),
                    F("close-button") ? (L(), Ce(q(St), {
                      key: 0,
                      class: "lc-modal__card-header-close",
                      icon: "close",
                      size: "small",
                      variant: "tertiary",
                      onClick: $
                    })) : ce("", !0)
                  ])
                ])) : ce("", !0)
              ], 2),
              ae("div", {
                ref: "contentArea",
                class: "lc-bottom-sheet__content",
                onScroll: V
              }, [
                me(K.$slots, "default")
              ], 544)
            ], 12, Wu)
          ]),
          _: 3
        })
      ])
    ], 8, ["to"])) : ce("", !0) : (L(), Ce(q(ko), Ee({ key: 0 }, { to: e.to, ignoreOutsideClickOn: e.ignoreOutsideClickOn }, {
      "background-class": `lc-bottom-sheet-modal lc-bottom-sheet-modal--${v.value ? "scrolled" : "default"}`,
      "is-visible": e.modelValue,
      "container-class": e.modalClass,
      "close-triggers": E.value,
      spacing: "small",
      onClose: O[0] || (O[0] = (G) => s("update:modelValue", !1))
    }), Xa({
      default: Ie(() => [
        ae("div", {
          class: pe(["lc-bottom-sheet-modal__content", { "lc-bottom-sheet-modal__content--scrolled": v.value }]),
          onScroll: V
        }, [
          me(K.$slots, "default")
        ], 34)
      ]),
      _: 2
    }, [
      K.$slots.title ? {
        name: "header",
        fn: Ie(() => [
          ae("div", qu, [
            me(K.$slots, "title")
          ])
        ]),
        key: "0"
      } : void 0,
      K.$slots.actions ? {
        name: "actions",
        fn: Ie(() => [
          ae("div", ju, [
            me(K.$slots, "actions")
          ])
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["background-class", "is-visible", "container-class", "close-triggers"]));
  }
}), P1 = ["swipe-down", "click-outside", "escape"];
function _o(e = {}) {
  let t, n = [];
  const r = ["select", "slideFocus"];
  function s(h) {
    t = h;
    const {
      options: {
        axis: v
      },
      slideRects: u
    } = t.internalEngine();
    v !== "y" && (n = u.map((f) => f.height), r.forEach((f) => t.on(f, l)), l());
  }
  function i() {
    r.forEach((v) => t.off(v, l));
    const h = t.containerNode();
    h.style.height = "", h.getAttribute("style") || h.removeAttribute("style");
  }
  function a() {
    const {
      slideRegistry: h
    } = t.internalEngine(), v = h[t.selectedScrollSnap()];
    return v ? v.map((u) => n[u]).reduce((u, f) => Math.max(u, f), 0) : null;
  }
  function l() {
    a() !== null && (t.containerNode().style.height = `${a()}px`);
  }
  return {
    name: "autoHeight",
    options: e,
    init: s,
    destroy: i
  };
}
_o.globalOptions = void 0;
const Gu = {
  active: !0,
  breakpoints: {},
  snapped: "is-snapped",
  inView: "is-in-view",
  draggable: "is-draggable",
  dragging: "is-dragging",
  loop: "is-loop"
};
function Kn(e) {
  return (Array.isArray(e) ? e : [e]).filter(Boolean);
}
function Jn(e, t) {
  !e || !t.length || e.classList.remove(...t);
}
function Aa(e, t) {
  !e || !t.length || e.classList.add(...t);
}
function Ka(e = {}) {
  let t, n, r, s, i = [], a = [];
  const l = ["select"], o = ["pointerDown", "pointerUp"], h = ["slidesInView"], v = {
    snapped: [],
    inView: [],
    draggable: [],
    dragging: [],
    loop: []
  };
  function u(b, S) {
    n = b;
    const {
      mergeOptions: E,
      optionsAtMedia: I
    } = S, $ = E(Gu, Ka.globalOptions), C = E($, e);
    t = I(C), r = n.rootNode(), s = n.slideNodes();
    const {
      watchDrag: F,
      loop: V
    } = n.internalEngine().options, K = !!F;
    t.loop && V && (v.loop = Kn(t.loop), Aa(r, v.loop)), t.draggable && K && (v.draggable = Kn(t.draggable), Aa(r, v.draggable)), t.dragging && (v.dragging = Kn(t.dragging), o.forEach((O) => n.on(O, m))), t.snapped && (v.snapped = Kn(t.snapped), l.forEach((O) => n.on(O, w)), w()), t.inView && (v.inView = Kn(t.inView), h.forEach((O) => n.on(O, _)), _());
  }
  function f() {
    o.forEach((b) => n.off(b, m)), l.forEach((b) => n.off(b, w)), h.forEach((b) => n.off(b, _)), Jn(r, v.loop), Jn(r, v.draggable), Jn(r, v.dragging), c([], i, v.snapped), c([], a, v.inView), Object.keys(v).forEach((b) => {
      const S = b;
      v[S] = [];
    });
  }
  function m(b, S) {
    (S === "pointerDown" ? Aa : Jn)(r, v.dragging);
  }
  function c(b = [], S = [], E) {
    const I = S.map((C) => s[C]), $ = b.map((C) => s[C]);
    return I.forEach((C) => Jn(C, E)), $.forEach((C) => Aa(C, E)), b;
  }
  function w() {
    const {
      slideRegistry: b
    } = n.internalEngine(), S = b[n.selectedScrollSnap()];
    i = c(S, i, v.snapped);
  }
  function _() {
    const b = n.slidesInView();
    a = c(b, a, v.inView);
  }
  return {
    name: "classNames",
    options: e,
    init: u,
    destroy: f
  };
}
Ka.globalOptions = void 0;
function Ku(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Ji(e) {
  return Ku(e) || Array.isArray(e);
}
function Ju() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function si(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  const s = JSON.stringify(Object.keys(e.breakpoints || {})), i = JSON.stringify(Object.keys(t.breakpoints || {}));
  return s !== i ? !1 : n.every((a) => {
    const l = e[a], o = t[a];
    return typeof l == "function" ? `${l}` == `${o}` : !Ji(l) || !Ji(o) ? l === o : si(l, o);
  });
}
function Qi(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function Qu(e, t) {
  if (e.length !== t.length) return !1;
  const n = Qi(e), r = Qi(t);
  return n.every((s, i) => {
    const a = r[i];
    return si(s, a);
  });
}
function ci(e) {
  return typeof e == "number";
}
function qr(e) {
  return typeof e == "string";
}
function Ja(e) {
  return typeof e == "boolean";
}
function el(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function at(e) {
  return Math.abs(e);
}
function ui(e) {
  return Math.sign(e);
}
function ia(e, t) {
  return at(e - t);
}
function ed(e, t) {
  if (e === 0 || t === 0 || at(e) <= at(t)) return 0;
  const n = ia(at(e), at(t));
  return at(n / e);
}
function td(e) {
  return Math.round(e * 100) / 100;
}
function ua(e) {
  return da(e).map(Number);
}
function Ht(e) {
  return e[wa(e)];
}
function wa(e) {
  return Math.max(0, e.length - 1);
}
function di(e, t) {
  return t === wa(e);
}
function tl(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function da(e) {
  return Object.keys(e);
}
function So(e, t) {
  return [e, t].reduce((n, r) => (da(r).forEach((s) => {
    const i = n[s], a = r[s], l = el(i) && el(a);
    n[s] = l ? So(i, a) : a;
  }), n), {});
}
function jr(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function nd(e, t) {
  const n = {
    start: r,
    center: s,
    end: i
  };
  function r() {
    return 0;
  }
  function s(o) {
    return i(o) / 2;
  }
  function i(o) {
    return t - o;
  }
  function a(o, h) {
    return qr(e) ? n[e](o) : e(t, o, h);
  }
  return {
    measure: a
  };
}
function fa() {
  let e = [];
  function t(s, i, a, l = {
    passive: !0
  }) {
    let o;
    if ("addEventListener" in s)
      s.addEventListener(i, a, l), o = () => s.removeEventListener(i, a, l);
    else {
      const h = s;
      h.addListener(a), o = () => h.removeListener(a);
    }
    return e.push(o), r;
  }
  function n() {
    e = e.filter((s) => s());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function ad(e, t, n, r) {
  const s = fa(), i = 1e3 / 60;
  let a = null, l = 0, o = 0;
  function h() {
    s.add(e, "visibilitychange", () => {
      e.hidden && c();
    });
  }
  function v() {
    m(), s.clear();
  }
  function u(_) {
    if (!o) return;
    a || (a = _, n(), n());
    const g = _ - a;
    for (a = _, l += g; l >= i; )
      n(), l -= i;
    const b = l / i;
    r(b), o && (o = t.requestAnimationFrame(u));
  }
  function f() {
    o || (o = t.requestAnimationFrame(u));
  }
  function m() {
    t.cancelAnimationFrame(o), a = null, l = 0, o = 0;
  }
  function c() {
    a = null, l = 0;
  }
  return {
    init: h,
    destroy: v,
    start: f,
    stop: m,
    update: n,
    render: r
  };
}
function rd(e, t) {
  const n = t === "rtl", r = e === "y", s = r ? "y" : "x", i = r ? "x" : "y", a = !r && n ? -1 : 1, l = v(), o = u();
  function h(c) {
    const {
      height: w,
      width: _
    } = c;
    return r ? w : _;
  }
  function v() {
    return r ? "top" : n ? "right" : "left";
  }
  function u() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function f(c) {
    return c * a;
  }
  return {
    scroll: s,
    cross: i,
    startEdge: l,
    endEdge: o,
    measureSize: h,
    direction: f
  };
}
function _n(e = 0, t = 0) {
  const n = at(e - t);
  function r(h) {
    return h < e;
  }
  function s(h) {
    return h > t;
  }
  function i(h) {
    return r(h) || s(h);
  }
  function a(h) {
    return i(h) ? r(h) ? e : t : h;
  }
  function l(h) {
    return n ? h - n * Math.ceil((h - t) / n) : h;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: a,
    reachedAny: i,
    reachedMax: s,
    reachedMin: r,
    removeOffset: l
  };
}
function Co(e, t, n) {
  const {
    constrain: r
  } = _n(0, e), s = e + 1;
  let i = a(t);
  function a(f) {
    return n ? at((s + f) % s) : r(f);
  }
  function l() {
    return i;
  }
  function o(f) {
    return i = a(f), u;
  }
  function h(f) {
    return v().set(l() + f);
  }
  function v() {
    return Co(e, l(), n);
  }
  const u = {
    get: l,
    set: o,
    add: h,
    clone: v
  };
  return u;
}
function id(e, t, n, r, s, i, a, l, o, h, v, u, f, m, c, w, _, g, b) {
  const {
    cross: S,
    direction: E
  } = e, I = ["INPUT", "SELECT", "TEXTAREA"], $ = {
    passive: !1
  }, C = fa(), F = fa(), V = _n(50, 225).constrain(m.measure(20)), K = {
    mouse: 300,
    touch: 400
  }, O = {
    mouse: 500,
    touch: 600
  }, G = c ? 43 : 25;
  let P = !1, T = 0, A = 0, z = !1, U = !1, X = !1, B = !1;
  function ie(de) {
    if (!b) return;
    function Re(Ze) {
      (Ja(b) || b(de, Ze)) && te(Ze);
    }
    const He = t;
    C.add(He, "dragstart", (Ze) => Ze.preventDefault(), $).add(He, "touchmove", () => {
    }, $).add(He, "touchend", () => {
    }).add(He, "touchstart", Re).add(He, "mousedown", Re).add(He, "touchcancel", ge).add(He, "contextmenu", ge).add(He, "click", be, !0);
  }
  function H() {
    C.clear(), F.clear();
  }
  function ee() {
    const de = B ? n : t;
    F.add(de, "touchmove", he, $).add(de, "touchend", ge).add(de, "mousemove", he, $).add(de, "mouseup", ge);
  }
  function ue(de) {
    const Re = de.nodeName || "";
    return I.includes(Re);
  }
  function ye() {
    return (c ? O : K)[B ? "mouse" : "touch"];
  }
  function xe(de, Re) {
    const He = u.add(ui(de) * -1), Ze = v.byDistance(de, !c).distance;
    return c || at(de) < V ? Ze : _ && Re ? Ze * 0.5 : v.byIndex(He.get(), 0).distance;
  }
  function te(de) {
    const Re = jr(de, r);
    B = Re, X = c && Re && !de.buttons && P, P = ia(s.get(), a.get()) >= 2, !(Re && de.button !== 0) && (ue(de.target) || (z = !0, i.pointerDown(de), h.useFriction(0).useDuration(0), s.set(a), ee(), T = i.readPoint(de), A = i.readPoint(de, S), f.emit("pointerDown")));
  }
  function he(de) {
    if (!jr(de, r) && de.touches.length >= 2) return ge(de);
    const He = i.readPoint(de), Ze = i.readPoint(de, S), We = ia(He, T), Be = ia(Ze, A);
    if (!U && !B && (!de.cancelable || (U = We > Be, !U)))
      return ge(de);
    const Fe = i.pointerMove(de);
    We > w && (X = !0), h.useFriction(0.3).useDuration(0.75), l.start(), s.add(E(Fe)), de.preventDefault();
  }
  function ge(de) {
    const He = v.byDistance(0, !1).index !== u.get(), Ze = i.pointerUp(de) * ye(), We = xe(E(Ze), He), Be = ed(Ze, We), Fe = G - 10 * Be, Ye = g + Be / 50;
    U = !1, z = !1, F.clear(), h.useDuration(Fe).useFriction(Ye), o.distance(We, !c), B = !1, f.emit("pointerUp");
  }
  function be(de) {
    X && (de.stopPropagation(), de.preventDefault(), X = !1);
  }
  function Pe() {
    return z;
  }
  return {
    init: ie,
    destroy: H,
    pointerDown: Pe
  };
}
function ld(e, t) {
  let r, s;
  function i(u) {
    return u.timeStamp;
  }
  function a(u, f) {
    const c = `client${(f || e.scroll) === "x" ? "X" : "Y"}`;
    return (jr(u, t) ? u : u.touches[0])[c];
  }
  function l(u) {
    return r = u, s = u, a(u);
  }
  function o(u) {
    const f = a(u) - a(s), m = i(u) - i(r) > 170;
    return s = u, m && (r = u), f;
  }
  function h(u) {
    if (!r || !s) return 0;
    const f = a(s) - a(r), m = i(u) - i(r), c = i(u) - i(s) > 170, w = f / m;
    return m && !c && at(w) > 0.1 ? w : 0;
  }
  return {
    pointerDown: l,
    pointerMove: o,
    pointerUp: h,
    readPoint: a
  };
}
function od() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: s,
      offsetWidth: i,
      offsetHeight: a
    } = n;
    return {
      top: r,
      right: s + i,
      bottom: r + a,
      left: s,
      width: i,
      height: a
    };
  }
  return {
    measure: e
  };
}
function sd(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function cd(e, t, n, r, s, i, a) {
  const l = [e].concat(r);
  let o, h, v = [], u = !1;
  function f(_) {
    return s.measureSize(a.measure(_));
  }
  function m(_) {
    if (!i) return;
    h = f(e), v = r.map(f);
    function g(b) {
      for (const S of b) {
        if (u) return;
        const E = S.target === e, I = r.indexOf(S.target), $ = E ? h : v[I], C = f(E ? e : r[I]);
        if (at(C - $) >= 0.5) {
          _.reInit(), t.emit("resize");
          break;
        }
      }
    }
    o = new ResizeObserver((b) => {
      (Ja(i) || i(_, b)) && g(b);
    }), n.requestAnimationFrame(() => {
      l.forEach((b) => o.observe(b));
    });
  }
  function c() {
    u = !0, o && o.disconnect();
  }
  return {
    init: m,
    destroy: c
  };
}
function ud(e, t, n, r, s, i) {
  let a = 0, l = 0, o = s, h = i, v = e.get(), u = 0;
  function f() {
    const $ = r.get() - e.get(), C = !o;
    let F = 0;
    return C ? (a = 0, n.set(r), e.set(r), F = $) : (n.set(e), a += $ / o, a *= h, v += a, e.add(a), F = v - u), l = ui(F), u = v, I;
  }
  function m() {
    const $ = r.get() - t.get();
    return at($) < 1e-3;
  }
  function c() {
    return o;
  }
  function w() {
    return l;
  }
  function _() {
    return a;
  }
  function g() {
    return S(s);
  }
  function b() {
    return E(i);
  }
  function S($) {
    return o = $, I;
  }
  function E($) {
    return h = $, I;
  }
  const I = {
    direction: w,
    duration: c,
    velocity: _,
    seek: f,
    settled: m,
    useBaseFriction: b,
    useBaseDuration: g,
    useFriction: E,
    useDuration: S
  };
  return I;
}
function dd(e, t, n, r, s) {
  const i = s.measure(10), a = s.measure(50), l = _n(0.1, 0.99);
  let o = !1;
  function h() {
    return !(o || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function v(m) {
    if (!h()) return;
    const c = e.reachedMin(t.get()) ? "min" : "max", w = at(e[c] - t.get()), _ = n.get() - t.get(), g = l.constrain(w / a);
    n.subtract(_ * g), !m && at(_) < i && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function u(m) {
    o = !m;
  }
  return {
    shouldConstrain: h,
    constrain: v,
    toggleActive: u
  };
}
function fd(e, t, n, r, s) {
  const i = _n(-t + e, 0), a = u(), l = v(), o = f();
  function h(c, w) {
    return ia(c, w) <= 1;
  }
  function v() {
    const c = a[0], w = Ht(a), _ = a.lastIndexOf(c), g = a.indexOf(w) + 1;
    return _n(_, g);
  }
  function u() {
    return n.map((c, w) => {
      const {
        min: _,
        max: g
      } = i, b = i.constrain(c), S = !w, E = di(n, w);
      return S ? g : E || h(_, b) ? _ : h(g, b) ? g : b;
    }).map((c) => parseFloat(c.toFixed(3)));
  }
  function f() {
    if (t <= e + s) return [i.max];
    if (r === "keepSnaps") return a;
    const {
      min: c,
      max: w
    } = l;
    return a.slice(c, w);
  }
  return {
    snapsContained: o,
    scrollContainLimit: l
  };
}
function hd(e, t, n) {
  const r = t[0], s = n ? r - e : Ht(t);
  return {
    limit: _n(s, r)
  };
}
function vd(e, t, n, r) {
  const i = t.min + 0.1, a = t.max + 0.1, {
    reachedMin: l,
    reachedMax: o
  } = _n(i, a);
  function h(f) {
    return f === 1 ? o(n.get()) : f === -1 ? l(n.get()) : !1;
  }
  function v(f) {
    if (!h(f)) return;
    const m = e * (f * -1);
    r.forEach((c) => c.add(m));
  }
  return {
    loop: v
  };
}
function md(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(i) {
    const a = i - t;
    return n ? a / -n : 0;
  }
  return {
    get: r
  };
}
function gd(e, t, n, r, s) {
  const {
    startEdge: i,
    endEdge: a
  } = e, {
    groupSlides: l
  } = s, o = u().map(t.measure), h = f(), v = m();
  function u() {
    return l(r).map((w) => Ht(w)[a] - w[0][i]).map(at);
  }
  function f() {
    return r.map((w) => n[i] - w[i]).map((w) => -at(w));
  }
  function m() {
    return l(h).map((w) => w[0]).map((w, _) => w + o[_]);
  }
  return {
    snaps: h,
    snapsAligned: v
  };
}
function bd(e, t, n, r, s, i) {
  const {
    groupSlides: a
  } = s, {
    min: l,
    max: o
  } = r, h = v();
  function v() {
    const f = a(i), m = !e || t === "keepSnaps";
    return n.length === 1 ? [i] : m ? f : f.slice(l, o).map((c, w, _) => {
      const g = !w, b = di(_, w);
      if (g) {
        const S = Ht(_[0]) + 1;
        return tl(S);
      }
      if (b) {
        const S = wa(i) - Ht(_)[0] + 1;
        return tl(S, Ht(_)[0]);
      }
      return c;
    });
  }
  return {
    slideRegistry: h
  };
}
function pd(e, t, n, r, s) {
  const {
    reachedAny: i,
    removeOffset: a,
    constrain: l
  } = r;
  function o(c) {
    return c.concat().sort((w, _) => at(w) - at(_))[0];
  }
  function h(c) {
    const w = e ? a(c) : l(c), _ = t.map((b, S) => ({
      diff: v(b - w, 0),
      index: S
    })).sort((b, S) => at(b.diff) - at(S.diff)), {
      index: g
    } = _[0];
    return {
      index: g,
      distance: w
    };
  }
  function v(c, w) {
    const _ = [c, c + n, c - n];
    if (!e) return c;
    if (!w) return o(_);
    const g = _.filter((b) => ui(b) === w);
    return g.length ? o(g) : Ht(_) - n;
  }
  function u(c, w) {
    const _ = t[c] - s.get(), g = v(_, w);
    return {
      index: c,
      distance: g
    };
  }
  function f(c, w) {
    const _ = s.get() + c, {
      index: g,
      distance: b
    } = h(_), S = !e && i(_);
    if (!w || S) return {
      index: g,
      distance: c
    };
    const E = t[g] - b, I = c + v(E, 0);
    return {
      index: g,
      distance: I
    };
  }
  return {
    byDistance: f,
    byIndex: u,
    shortcut: v
  };
}
function yd(e, t, n, r, s, i, a) {
  function l(u) {
    const f = u.distance, m = u.index !== t.get();
    i.add(f), f && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), m && (n.set(t.get()), t.set(u.index), a.emit("select"));
  }
  function o(u, f) {
    const m = s.byDistance(u, f);
    l(m);
  }
  function h(u, f) {
    const m = t.clone().set(u), c = s.byIndex(m.get(), f);
    l(c);
  }
  return {
    distance: o,
    index: h
  };
}
function wd(e, t, n, r, s, i, a, l) {
  const o = {
    passive: !0,
    capture: !0
  };
  let h = 0;
  function v(m) {
    if (!l) return;
    function c(w) {
      if ((/* @__PURE__ */ new Date()).getTime() - h > 10) return;
      a.emit("slideFocusStart"), e.scrollLeft = 0;
      const b = n.findIndex((S) => S.includes(w));
      ci(b) && (s.useDuration(0), r.index(b, 0), a.emit("slideFocus"));
    }
    i.add(document, "keydown", u, !1), t.forEach((w, _) => {
      i.add(w, "focus", (g) => {
        (Ja(l) || l(m, g)) && c(_);
      }, o);
    });
  }
  function u(m) {
    m.code === "Tab" && (h = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: v
  };
}
function ta(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(o) {
    t = a(o);
  }
  function s(o) {
    t += a(o);
  }
  function i(o) {
    t -= a(o);
  }
  function a(o) {
    return ci(o) ? o : o.get();
  }
  return {
    get: n,
    set: r,
    add: s,
    subtract: i
  };
}
function Eo(e, t) {
  const n = e.scroll === "x" ? a : l, r = t.style;
  let s = null, i = !1;
  function a(f) {
    return `translate3d(${f}px,0px,0px)`;
  }
  function l(f) {
    return `translate3d(0px,${f}px,0px)`;
  }
  function o(f) {
    if (i) return;
    const m = td(e.direction(f));
    m !== s && (r.transform = n(m), s = m);
  }
  function h(f) {
    i = !f;
  }
  function v() {
    i || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: v,
    to: o,
    toggleActive: h
  };
}
function xd(e, t, n, r, s, i, a, l, o) {
  const v = ua(s), u = ua(s).reverse(), f = g().concat(b());
  function m(C, F) {
    return C.reduce((V, K) => V - s[K], F);
  }
  function c(C, F) {
    return C.reduce((V, K) => m(V, F) > 0 ? V.concat([K]) : V, []);
  }
  function w(C) {
    return i.map((F, V) => ({
      start: F - r[V] + 0.5 + C,
      end: F + t - 0.5 + C
    }));
  }
  function _(C, F, V) {
    const K = w(F);
    return C.map((O) => {
      const G = V ? 0 : -n, P = V ? n : 0, T = V ? "end" : "start", A = K[O][T];
      return {
        index: O,
        loopPoint: A,
        slideLocation: ta(-1),
        translate: Eo(e, o[O]),
        target: () => l.get() > A ? G : P
      };
    });
  }
  function g() {
    const C = a[0], F = c(u, C);
    return _(F, n, !1);
  }
  function b() {
    const C = t - a[0] - 1, F = c(v, C);
    return _(F, -n, !0);
  }
  function S() {
    return f.every(({
      index: C
    }) => {
      const F = v.filter((V) => V !== C);
      return m(F, t) <= 0.1;
    });
  }
  function E() {
    f.forEach((C) => {
      const {
        target: F,
        translate: V,
        slideLocation: K
      } = C, O = F();
      O !== K.get() && (V.to(O), K.set(O));
    });
  }
  function I() {
    f.forEach((C) => C.translate.clear());
  }
  return {
    canLoop: S,
    clear: I,
    loop: E,
    loopPoints: f
  };
}
function kd(e, t, n) {
  let r, s = !1;
  function i(o) {
    if (!n) return;
    function h(v) {
      for (const u of v)
        if (u.type === "childList") {
          o.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((v) => {
      s || (Ja(n) || n(o, v)) && h(v);
    }), r.observe(e, {
      childList: !0
    });
  }
  function a() {
    r && r.disconnect(), s = !0;
  }
  return {
    init: i,
    destroy: a
  };
}
function _d(e, t, n, r) {
  const s = {};
  let i = null, a = null, l, o = !1;
  function h() {
    l = new IntersectionObserver((c) => {
      o || (c.forEach((w) => {
        const _ = t.indexOf(w.target);
        s[_] = w;
      }), i = null, a = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((c) => l.observe(c));
  }
  function v() {
    l && l.disconnect(), o = !0;
  }
  function u(c) {
    return da(s).reduce((w, _) => {
      const g = parseInt(_), {
        isIntersecting: b
      } = s[g];
      return (c && b || !c && !b) && w.push(g), w;
    }, []);
  }
  function f(c = !0) {
    if (c && i) return i;
    if (!c && a) return a;
    const w = u(c);
    return c && (i = w), c || (a = w), w;
  }
  return {
    init: h,
    destroy: v,
    get: f
  };
}
function Sd(e, t, n, r, s, i) {
  const {
    measureSize: a,
    startEdge: l,
    endEdge: o
  } = e, h = n[0] && s, v = c(), u = w(), f = n.map(a), m = _();
  function c() {
    if (!h) return 0;
    const b = n[0];
    return at(t[l] - b[l]);
  }
  function w() {
    if (!h) return 0;
    const b = i.getComputedStyle(Ht(r));
    return parseFloat(b.getPropertyValue(`margin-${o}`));
  }
  function _() {
    return n.map((b, S, E) => {
      const I = !S, $ = di(E, S);
      return I ? f[S] + v : $ ? f[S] + u : E[S + 1][l] - b[l];
    }).map(at);
  }
  return {
    slideSizes: f,
    slideSizesWithGaps: m,
    startGap: v,
    endGap: u
  };
}
function Cd(e, t, n, r, s, i, a, l, o) {
  const {
    startEdge: h,
    endEdge: v,
    direction: u
  } = e, f = ci(n);
  function m(g, b) {
    return ua(g).filter((S) => S % b === 0).map((S) => g.slice(S, S + b));
  }
  function c(g) {
    return g.length ? ua(g).reduce((b, S, E) => {
      const I = Ht(b) || 0, $ = I === 0, C = S === wa(g), F = s[h] - i[I][h], V = s[h] - i[S][v], K = !r && $ ? u(a) : 0, O = !r && C ? u(l) : 0, G = at(V - O - (F + K));
      return E && G > t + o && b.push(S), C && b.push(g.length), b;
    }, []).map((b, S, E) => {
      const I = Math.max(E[S - 1] || 0);
      return g.slice(I, b);
    }) : [];
  }
  function w(g) {
    return f ? m(g, n) : c(g);
  }
  return {
    groupSlides: w
  };
}
function Ed(e, t, n, r, s, i, a) {
  const {
    align: l,
    axis: o,
    direction: h,
    startIndex: v,
    loop: u,
    duration: f,
    dragFree: m,
    dragThreshold: c,
    inViewThreshold: w,
    slidesToScroll: _,
    skipSnaps: g,
    containScroll: b,
    watchResize: S,
    watchSlides: E,
    watchDrag: I,
    watchFocus: $
  } = i, C = 2, F = od(), V = F.measure(t), K = n.map(F.measure), O = rd(o, h), G = O.measureSize(V), P = sd(G), T = nd(l, G), A = !u && !!b, z = u || !!b, {
    slideSizes: U,
    slideSizesWithGaps: X,
    startGap: B,
    endGap: ie
  } = Sd(O, V, K, n, z, s), H = Cd(O, G, _, u, V, K, B, ie, C), {
    snaps: ee,
    snapsAligned: ue
  } = gd(O, T, V, K, H), ye = -Ht(ee) + Ht(X), {
    snapsContained: xe,
    scrollContainLimit: te
  } = fd(G, ye, ue, b, C), he = A ? xe : ue, {
    limit: ge
  } = hd(ye, he, u), be = Co(wa(he), v, u), Pe = be.clone(), Ne = ua(n), de = ({
    dragHandler: k,
    scrollBody: y,
    scrollBounds: Y,
    options: {
      loop: W
    }
  }) => {
    W || Y.constrain(k.pointerDown()), y.seek();
  }, Re = ({
    scrollBody: k,
    translate: y,
    location: Y,
    offsetLocation: W,
    previousLocation: se,
    scrollLooper: R,
    slideLooper: le,
    dragHandler: p,
    animation: fe,
    eventHandler: Le,
    scrollBounds: d,
    options: {
      loop: re
    }
  }, ne) => {
    const x = k.settled(), N = !d.shouldConstrain(), Q = re ? x : x && N, De = Q && !p.pointerDown();
    De && fe.stop();
    const ke = Y.get() * ne + se.get() * (1 - ne);
    W.set(ke), re && (R.loop(k.direction()), le.loop()), y.to(W.get()), De && Le.emit("settle"), Q || Le.emit("scroll");
  }, He = ad(r, s, () => de(D), (k) => Re(D, k)), Ze = 0.68, We = he[be.get()], Be = ta(We), Fe = ta(We), Ye = ta(We), st = ta(We), mt = ud(Be, Ye, Fe, st, f, Ze), gt = pd(u, he, ye, ge, st), Ft = yd(He, be, Pe, mt, gt, st, a), Mt = md(ge), xt = fa(), Ut = _d(t, n, a, w), {
    slideRegistry: $t
  } = bd(A, b, he, te, H, Ne), ct = wd(e, n, $t, Ft, mt, xt, a, $), D = {
    ownerDocument: r,
    ownerWindow: s,
    eventHandler: a,
    containerRect: V,
    slideRects: K,
    animation: He,
    axis: O,
    dragHandler: id(O, e, r, s, st, ld(O, s), Be, He, Ft, mt, gt, be, a, P, m, c, g, Ze, I),
    eventStore: xt,
    percentOfView: P,
    index: be,
    indexPrevious: Pe,
    limit: ge,
    location: Be,
    offsetLocation: Ye,
    previousLocation: Fe,
    options: i,
    resizeHandler: cd(t, a, s, n, O, S, F),
    scrollBody: mt,
    scrollBounds: dd(ge, Ye, st, mt, P),
    scrollLooper: vd(ye, ge, Ye, [Be, Ye, Fe, st]),
    scrollProgress: Mt,
    scrollSnapList: he.map(Mt.get),
    scrollSnaps: he,
    scrollTarget: gt,
    scrollTo: Ft,
    slideLooper: xd(O, G, ye, U, X, ee, he, Ye, n),
    slideFocus: ct,
    slidesHandler: kd(t, a, E),
    slidesInView: Ut,
    slideIndexes: Ne,
    slideRegistry: $t,
    slidesToScroll: H,
    target: st,
    translate: Eo(O, t)
  };
  return D;
}
function Td() {
  let e = {}, t;
  function n(h) {
    t = h;
  }
  function r(h) {
    return e[h] || [];
  }
  function s(h) {
    return r(h).forEach((v) => v(t, h)), o;
  }
  function i(h, v) {
    return e[h] = r(h).concat([v]), o;
  }
  function a(h, v) {
    return e[h] = r(h).filter((u) => u !== v), o;
  }
  function l() {
    e = {};
  }
  const o = {
    init: n,
    emit: s,
    off: a,
    on: i,
    clear: l
  };
  return o;
}
const Ad = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Ld(e) {
  function t(i, a) {
    return So(i, a || {});
  }
  function n(i) {
    const a = i.breakpoints || {}, l = da(a).filter((o) => e.matchMedia(o).matches).map((o) => a[o]).reduce((o, h) => t(o, h), {});
    return t(i, l);
  }
  function r(i) {
    return i.map((a) => da(a.breakpoints || {})).reduce((a, l) => a.concat(l), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function $d(e) {
  let t = [];
  function n(i, a) {
    return t = a.filter(({
      options: l
    }) => e.optionsAtMedia(l).active !== !1), t.forEach((l) => l.init(i, e)), a.reduce((l, o) => Object.assign(l, {
      [o.name]: o
    }), {});
  }
  function r() {
    t = t.filter((i) => i.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function Ha(e, t, n) {
  const r = e.ownerDocument, s = r.defaultView, i = Ld(s), a = $d(i), l = fa(), o = Td(), {
    mergeOptions: h,
    optionsAtMedia: v,
    optionsMediaQueries: u
  } = i, {
    on: f,
    off: m,
    emit: c
  } = o, w = O;
  let _ = !1, g, b = h(Ad, Ha.globalOptions), S = h(b), E = [], I, $, C;
  function F() {
    const {
      container: Ne,
      slides: de
    } = S;
    $ = (qr(Ne) ? e.querySelector(Ne) : Ne) || e.children[0];
    const He = qr(de) ? $.querySelectorAll(de) : de;
    C = [].slice.call(He || $.children);
  }
  function V(Ne) {
    const de = Ed(e, $, C, r, s, Ne, o);
    if (Ne.loop && !de.slideLooper.canLoop()) {
      const Re = Object.assign({}, Ne, {
        loop: !1
      });
      return V(Re);
    }
    return de;
  }
  function K(Ne, de) {
    _ || (b = h(b, Ne), S = v(b), E = de || E, F(), g = V(S), u([b, ...E.map(({
      options: Re
    }) => Re)]).forEach((Re) => l.add(Re, "change", O)), S.active && (g.translate.to(g.location.get()), g.animation.init(), g.slidesInView.init(), g.slideFocus.init(Pe), g.eventHandler.init(Pe), g.resizeHandler.init(Pe), g.slidesHandler.init(Pe), g.options.loop && g.slideLooper.loop(), $.offsetParent && C.length && g.dragHandler.init(Pe), I = a.init(Pe, E)));
  }
  function O(Ne, de) {
    const Re = H();
    G(), K(h({
      startIndex: Re
    }, Ne), de), o.emit("reInit");
  }
  function G() {
    g.dragHandler.destroy(), g.eventStore.clear(), g.translate.clear(), g.slideLooper.clear(), g.resizeHandler.destroy(), g.slidesHandler.destroy(), g.slidesInView.destroy(), g.animation.destroy(), a.destroy(), l.clear();
  }
  function P() {
    _ || (_ = !0, l.clear(), G(), o.emit("destroy"), o.clear());
  }
  function T(Ne, de, Re) {
    !S.active || _ || (g.scrollBody.useBaseFriction().useDuration(de === !0 ? 0 : S.duration), g.scrollTo.index(Ne, Re || 0));
  }
  function A(Ne) {
    const de = g.index.add(1).get();
    T(de, Ne, -1);
  }
  function z(Ne) {
    const de = g.index.add(-1).get();
    T(de, Ne, 1);
  }
  function U() {
    return g.index.add(1).get() !== H();
  }
  function X() {
    return g.index.add(-1).get() !== H();
  }
  function B() {
    return g.scrollSnapList;
  }
  function ie() {
    return g.scrollProgress.get(g.offsetLocation.get());
  }
  function H() {
    return g.index.get();
  }
  function ee() {
    return g.indexPrevious.get();
  }
  function ue() {
    return g.slidesInView.get();
  }
  function ye() {
    return g.slidesInView.get(!1);
  }
  function xe() {
    return I;
  }
  function te() {
    return g;
  }
  function he() {
    return e;
  }
  function ge() {
    return $;
  }
  function be() {
    return C;
  }
  const Pe = {
    canScrollNext: U,
    canScrollPrev: X,
    containerNode: ge,
    internalEngine: te,
    destroy: P,
    off: m,
    on: f,
    emit: c,
    plugins: xe,
    previousScrollSnap: ee,
    reInit: w,
    rootNode: he,
    scrollNext: A,
    scrollPrev: z,
    scrollProgress: ie,
    scrollSnapList: B,
    scrollTo: T,
    selectedScrollSnap: H,
    slideNodes: be,
    slidesInView: ue,
    slidesNotInView: ye
  };
  return K(t, n), setTimeout(() => o.emit("init"), 0), Pe;
}
Ha.globalOptions = void 0;
function Qa(e = {}, t = []) {
  const n = Ri(e), r = Ri(t);
  let s = n ? e.value : e, i = r ? t.value : t;
  const a = Hn(), l = Hn();
  function o() {
    l.value && l.value.reInit(s, i);
  }
  return wt(() => {
    !Ju() || !a.value || (Ha.globalOptions = Qa.globalOptions, l.value = Ha(a.value, s, i));
  }), Ql(() => {
    l.value && l.value.destroy();
  }), n && Ve(e, (h) => {
    si(s, h) || (s = h, o());
  }), r && Ve(t, (h) => {
    Qu(i, h) || (i = h, o());
  }), [a, l];
}
Qa.globalOptions = void 0;
const z1 = ["default", "highlight"], V1 = ["click", "keyboard"], Zr = /* @__PURE__ */ Symbol();
var Ma = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e))(Ma || {});
const Id = ["tabindex"], nl = 1.08, Dd = /* @__PURE__ */ Se({
  __name: "LcCarousel",
  props: {
    duration: { default: 25 },
    loop: { type: Boolean },
    skipSnaps: { type: Boolean },
    adaptiveHeight: { type: Boolean },
    defaultIndex: { default: 0 },
    disableSwipe: { type: Boolean },
    id: {},
    keyExtractor: { type: Function },
    keyProp: {},
    moveTriggers: { default: () => [] },
    renderOnlyVisible: { type: Boolean },
    slides: {},
    variant: { default: "default" },
    visibleSlideBuffer: { default: 0 }
  },
  emits: ["ready", "changed"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = {
      align: "start",
      containScroll: "trimSnaps"
    }, i = {
      align: "center",
      containScroll: !1,
      loop: !1,
      skipSnaps: !0
    }, a = {
      duration: e.duration,
      inViewThreshold: 2 / 100,
      loop: e.loop,
      skipSnaps: e.skipSnaps,
      watchDrag: !e.disableSwipe,
      watchResize: ({ containerNode: te, emit: he, reInit: ge }, be) => {
        if (!e.adaptiveHeight) return !0;
        for (const Pe of be) {
          if (te() === Pe.target) return !0;
          requestAnimationFrame(() => {
            ge(), he("resize");
          });
          break;
        }
        return !1;
      },
      ...e.variant === "highlight" ? i : s
    }, l = [
      ...e.adaptiveHeight ? [_o()] : [],
      Ka({
        draggable: "",
        dragging: "lc-carousel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-carousel__slide--snapped"
      })
    ], [o, h] = Qa(
      {
        ...a,
        startIndex: e.defaultIndex
      },
      l
    ), v = Zn(Zr, () => null, !0), u = io(), f = we(0), m = we(e.disableSwipe), c = we(!1), w = we(!1), _ = we(
      new Set(
        e.slides.slice(e.defaultIndex - e.visibleSlideBuffer, e.defaultIndex + e.visibleSlideBuffer).map((te, he) => he)
      )
    );
    let g, b, S;
    const E = J(() => [
      "lc-carousel",
      `lc-carousel--variant-${e.variant}`,
      {
        "lc-carousel--adaptive-height": e.adaptiveHeight,
        "lc-carousel--draggable": !m.value,
        "lc-carousel--keyboard-enabled": U("keyboard"),
        "lc-carousel--swipe-hint": w.value
      }
    ]), I = () => {
      e.disableSwipe || (h.value?.reInit({
        ...a,
        watchDrag: !1
      }), m.value = !0);
    }, $ = () => {
      e.disableSwipe || (h.value?.reInit({
        ...a,
        watchDrag: !0
      }), m.value = !1);
    }, C = (te, he) => e.keyExtractor ? e.keyExtractor(te, he) : e.keyProp && vu(e.keyProp, te) ? String(te[e.keyProp]) : String(he), F = (te) => {
      const he = {
        "aria-roledescription": "slide",
        role: "group"
      };
      return X(te) ? he : {
        ...he,
        "aria-hidden": "true",
        inert: "true"
      };
    }, V = ({ clientX: te }) => {
      if (!h.value || !U("click") || m.value) return;
      const ge = h.value.slideNodes().map((be) => be.getBoundingClientRect());
      for (const [be, { left: Pe, right: Ne }] of ge.entries())
        if (!(te < Pe || te > Ne)) {
          ie(be);
          break;
        }
    }, K = () => {
      c.value = !0, ye(), xe(), r("ready");
    }, O = (te) => {
      if (!(!en(te.key, Ma) || !U("keyboard") || m.value))
        switch (te.preventDefault(), te.stopPropagation(), te.key) {
          case Ma.ArrowLeft:
            ee();
            break;
          case Ma.ArrowRight:
            H();
            break;
        }
    }, G = () => {
      v?.disable();
    }, P = () => {
      v?.enable();
    }, T = () => {
      ye(), xe();
    }, A = () => {
      const te = h.value?.selectedScrollSnap() ?? 0;
      r("changed", te);
    }, z = () => {
      clearTimeout(b), b = setTimeout(() => h.value?.reInit(), 50);
    }, U = (te) => e.moveTriggers.includes(te), X = (te) => _.value.has(te), B = (te) => !te || u.value === "reduce", ie = (te, he = !0) => {
      h.value?.scrollTo(te, B(he));
    }, H = (te = !0) => {
      h.value?.scrollNext(B(te));
    }, ee = (te = !0) => {
      h.value?.scrollPrev(B(te));
    }, ue = async () => {
      w.value || (w.value = !0, await new Promise((te) => {
        S = setTimeout(() => {
          w.value = !1, te();
        }, 1800);
      }));
    }, ye = () => {
      if (!h.value || e.variant !== "highlight") return;
      const { rootNode: te, slideNodes: he } = h.value, ge = he(), Pe = te().getBoundingClientRect(), Ne = Pe.left + Pe.width / 2;
      let de = ge[0], Re = 1 / 0;
      ge.forEach((Be) => {
        const Fe = Be.getBoundingClientRect(), Ye = Fe.left + Fe.width / 2, st = Math.abs(Ye - Ne);
        st < Re && (de = Be, Re = st);
      });
      const We = de.offsetWidth * (nl - 1) / 2;
      ge.forEach((Be, Fe) => {
        if (Be === de) {
          f.value = Fe, Be.style.transform = `scale(${nl.toString()}) translateX(0px)`, Be.style.zIndex = "1";
          return;
        }
        const Ye = Be.getBoundingClientRect(), mt = Ye.left + Ye.width / 2 < Ne ? -1 : 1;
        Be.style.transform = `scale(1) translateX(${(mt * We).toString()}px)`, Be.style.zIndex = "0";
      });
    }, xe = () => {
      if (!h.value) return;
      const te = h.value.slidesInView();
      if (!te.length) return;
      const he = e.slides.length, ge = /* @__PURE__ */ new Set();
      te.forEach((be) => {
        for (let Pe = -e.visibleSlideBuffer; Pe <= e.visibleSlideBuffer; Pe++) {
          const Ne = (be + Pe + he) % he;
          ge.add(Ne);
        }
      }), _.value = ge;
    };
    return wt(() => {
      h.value && (h.value.on("init", K).on("pointerDown", G).on("pointerUp", P).on("reInit", T).on("resize", xe).on("scroll", ye).on("select", A).on("slidesChanged", ye).on("slidesInView", xe), e.adaptiveHeight && (g = new ResizeObserver(z), h.value.slideNodes().forEach((te) => g?.observe(te))));
    }), Tn(() => {
      clearTimeout(S), clearTimeout(b), g?.disconnect();
    }), Ve(
      [() => e.disableSwipe, () => e.loop, () => e.skipSnaps, () => e.variant],
      ([te, he, ge, be]) => {
        m.value = te, h.value?.reInit({
          ...a,
          loop: he,
          skipSnaps: ge,
          watchDrag: !te,
          ...be === "highlight" ? i : s
        });
      }
    ), t({
      disable: I,
      enable: $,
      moveToIndex: ie,
      next: H,
      prev: ee,
      showSwipeHint: ue
    }), ei(Zr, {
      disable: I,
      enable: $
    }), (te, he) => (L(), j("div", {
      class: pe(E.value),
      tabindex: U("keyboard") ? 0 : void 0,
      onClickPassive: V,
      onKeydown: O
    }, [
      ae("div", {
        ref_key: "emblaRef",
        ref: o,
        class: "lc-carousel__container"
      }, [
        ae("div", Ee({ id: e.id }, { class: "lc-carousel__wrap" }), [
          (L(!0), j(Ge, null, vt(e.slides, (ge, be) => me(te.$slots, "slide", Ee({ ref_for: !0 }, { slide: ge, index: be }, {
            key: C(ge, be),
            attributes: F(be),
            isHighlighted: f.value === be,
            isVisible: X(be)
          }))), 128))
        ], 16)
      ], 512)
    ], 42, Id));
  }
}), Md = ["for"], Od = { class: "lc-checkbox__control" }, Rd = ["id", "data-click-name"], Fd = ["id"], H1 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcCheckbox",
  props: {
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "checkbox" },
    noFeedback: { type: Boolean },
    value: { type: Boolean }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = Ct(e.id), { vibrate: s } = lo(), i = J(() => [
      "lc-checkbox",
      {
        "lc-checkbox--checked": e.value,
        "lc-checkbox--disabled": e.disabled,
        "lc-checkbox--error": !!e.errorMessage
      }
    ]), a = J({
      get: () => e.value,
      set: (l) => {
        n("update:value", l), s();
      }
    });
    return (l, o) => (L(), j("div", {
      class: pe([i.value, l.$attrs.class])
    }, [
      ae("label", {
        class: "lc-checkbox__wrap",
        for: q(r)
      }, [
        ae("div", Od, [
          Jt(ae("input", Ee({ id: q(r) }, {
            ...Qt(l.$attrs, ["class"]),
            disabled: e.disabled,
            name: e.name
          }, {
            "onUpdate:modelValue": o[0] || (o[0] = (h) => a.value = h),
            class: "lc-checkbox__input",
            "data-click-listener": "blur,focus",
            "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_checkbox`,
            type: "checkbox",
            onKeydown: o[1] || (o[1] = ti((h) => a.value = !a.value, ["enter"]))
          }), null, 16, Rd), [
            [eo, a.value]
          ]),
          Oe(q(Qe), {
            class: "lc-checkbox__icon",
            name: "checkmark"
          })
        ]),
        e.label ? (L(), j("span", {
          key: 0,
          id: `${q(r)}-label`,
          class: "lc-checkbox__label"
        }, $e(e.label), 9, Fd)) : ce("", !0)
      ], 8, Md),
      e.noFeedback ? ce("", !0) : (L(), Ce(q(An), Ee({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), Nd = () => typeof window > "u";
function To(e, t) {
  const n = pa(), r = typeof e == "string" ? e : void 0, s = typeof e == "function" ? e : t;
  if (n)
    return r ? n.useState(r, s) : n.useState(s);
  const i = s ? Ke(s()) : void 0;
  return we(i);
}
const fi = {
  drawingShort: {
    hour: "numeric",
    minute: "numeric",
    weekday: "short"
  }
}, Ao = (e, t) => Gc({
  end: new Date(t),
  start: new Date(e)
}), Lo = ({ date: e, format: t, locale: n, timeZone: r }) => new Intl.DateTimeFormat(n ?? "en-US", {
  ...fi[t],
  timeZone: r
}).format(new Date(e)), pr = (e) => typeof e != "number" ? "" : e <= 0 ? "00" : e < 10 ? `0${e}` : String(e), Bd = /* @__PURE__ */ Se({
  __name: "LcCountdown",
  props: {
    expiresAt: {},
    variant: { default: "default" }
  },
  emits: ["expired", "update"],
  setup(e, { emit: t }) {
    const n = {
      hours: 0,
      minutes: 0,
      seconds: 0
    }, r = t, s = Nd(), i = To(() => /* @__PURE__ */ new Date()), a = we(!1);
    let l;
    const o = J(() => {
      if (a.value) return n;
      const { hours: g, minutes: b, seconds: S } = Ao(i.value, f.value);
      return {
        ...n,
        hours: g || 0,
        minutes: b || 0,
        seconds: S || 0
      };
    }), h = J(() => v.value ? f.value.toISOString() : void 0), v = J(() => ai(f.value)), u = J(() => {
      const { hours: g, minutes: b, seconds: S } = o.value, E = `${pr(b)}:${pr(S)}`;
      return e.variant === "without-hours" ? E : `${pr(g)}:${E}`;
    }), f = J(() => new Date(e.expiresAt)), m = () => {
      a.value = !0, r("expired"), clearInterval(l);
    }, c = () => {
      i.value = /* @__PURE__ */ new Date(), r("update");
    }, w = () => bo(f.value), _ = () => {
      l && clearInterval(l), l = setInterval(() => {
        w() ? m() : c();
      }, 1e3);
    };
    return Ql(() => {
      clearInterval(l);
    }), Ve(
      h,
      () => {
        s || (a.value = !1, _());
      },
      {
        immediate: !0
      }
    ), (g, b) => v.value ? (L(), j("time", Ee({ key: 0 }, { datetime: h.value }, { class: "lc-countdown" }), $e(u.value), 17)) : ce("", !0);
  }
}), U1 = ["default", "without-hours"], Pd = { class: "lc-data-list" }, q1 = /* @__PURE__ */ Se({
  __name: "LcDataList",
  setup(e) {
    return (t, n) => (L(), j("ul", Pd, [
      me(t.$slots, "default")
    ]));
  }
}), zd = { class: "lc-data-list-item" }, Vd = { class: "lc-data-list-item__content" }, Hd = {
  key: 0,
  class: "lc-data-list-item__headline"
}, Ud = {
  key: 0,
  class: "lc-data-list-item__text"
}, qd = { key: 0 }, jd = {
  key: 0,
  class: "lc-data-list-item__underneath"
}, j1 = /* @__PURE__ */ Se({
  __name: "LcDataListItem",
  props: {
    headline: {},
    text: {}
  },
  setup(e) {
    return (t, n) => (L(), j("li", zd, [
      ae("div", Vd, [
        ae("section", null, [
          e.headline ? (L(), j("span", Hd, $e(e.headline), 1)) : ce("", !0),
          me(t.$slots, "default", {}, () => [
            e.text ? (L(), j("p", Ud, $e(e.text), 1)) : ce("", !0)
          ])
        ]),
        t.$slots.suffix ? (L(), j("aside", qd, [
          me(t.$slots, "suffix")
        ])) : ce("", !0)
      ]),
      t.$slots.underneath ? (L(), j("div", jd, [
        me(t.$slots, "underneath")
      ])) : ce("", !0)
    ]));
  }
});
var Zd = Object.defineProperty, Wd = (e, t, n) => t in e ? Zd(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, la = (e, t, n) => Wd(e, typeof t != "symbol" ? t + "" : t, n);
const al = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, rl = (e, t, n) => e.replaceAll(t, "").replace(n, ".").replace("..", ".").replace(/[^.\d]/g, ""), il = (e, t, n) => {
  var r;
  return new Intl.NumberFormat(((r = n.number) == null ? void 0 : r.locale) ?? "en", {
    minimumFractionDigits: e,
    maximumFractionDigits: t,
    roundingMode: "trunc"
  });
}, Xd = (e, t = !0, n) => {
  var r, s, i, a;
  const l = ((r = n.number) == null ? void 0 : r.unsigned) !== !0 && e.startsWith("-") ? "-" : "", o = ((s = n.number) == null ? void 0 : s.fraction) ?? 0;
  let h = il(0, o, n);
  const v = h.formatToParts(1000.12), u = ((i = v.find((_) => _.type === "group")) == null ? void 0 : i.value) ?? " ", f = ((a = v.find((_) => _.type === "decimal")) == null ? void 0 : a.value) ?? ".", m = rl(e, u, f);
  if (Number.isNaN(parseFloat(m))) return l;
  const c = m.split(".");
  if (c[1] != null && c[1].length >= 1) {
    const _ = c[1].length <= o ? c[1].length : o;
    h = il(_, o, n);
  }
  let w = h.format(parseFloat(m));
  return t ? o > 0 && m.endsWith(".") && !m.slice(0, -1).includes(".") && (w += f) : w = rl(w, u, f), l + w;
}, $o = (e) => JSON.parse(e.replaceAll("'", '"')), Yd = (e, t = {}) => {
  const n = { ...t };
  e.dataset.maska != null && e.dataset.maska !== "" && (n.mask = Gd(e.dataset.maska)), e.dataset.maskaEager != null && (n.eager = La(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (n.reversed = La(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (n.tokensReplace = La(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (n.tokens = Kd(e.dataset.maskaTokens));
  const r = {};
  return e.dataset.maskaNumberLocale != null && (r.locale = e.dataset.maskaNumberLocale), e.dataset.maskaNumberFraction != null && (r.fraction = parseInt(e.dataset.maskaNumberFraction)), e.dataset.maskaNumberUnsigned != null && (r.unsigned = La(e.dataset.maskaNumberUnsigned)), (e.dataset.maskaNumber != null || Object.values(r).length > 0) && (n.number = r), n;
}, La = (e) => e !== "" ? !!JSON.parse(e) : !0, Gd = (e) => e.startsWith("[") && e.endsWith("]") ? $o(e) : e, Kd = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return $o(e);
  const t = {};
  return e.split("|").forEach((n) => {
    const r = n.split(":");
    t[r[0]] = {
      pattern: Io() ? new RegExp(r[1], "u") : new RegExp(r[1]),
      optional: r[2] === "optional",
      multiple: r[2] === "multiple",
      repeated: r[2] === "repeated"
    };
  }), t;
}, Io = () => {
  try {
    return new RegExp("\\p{L}", "u"), !0;
  } catch {
    return !1;
  }
};
class Jd {
  constructor(t = {}) {
    la(this, "opts", {}), la(this, "memo", /* @__PURE__ */ new Map());
    const n = { ...t };
    if (n.tokens != null) {
      n.tokens = n.tokensReplace ? { ...n.tokens } : { ...al, ...n.tokens };
      for (const r of Object.values(n.tokens))
        typeof r.pattern == "string" && (r.pattern = Io() ? new RegExp(r.pattern, "u") : new RegExp(r.pattern));
    } else
      n.tokens = al;
    Array.isArray(n.mask) && (n.mask.length > 1 ? n.mask = [...n.mask].sort((r, s) => r.length - s.length) : n.mask = n.mask[0] ?? ""), n.mask === "" && (n.mask = null), this.opts = n;
  }
  masked(t) {
    return this.process(String(t), this.findMask(String(t)));
  }
  unmasked(t) {
    return this.process(String(t), this.findMask(String(t)), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(t) {
    const n = this.findMask(String(t));
    if (this.opts.mask == null || n == null) return !1;
    const r = this.process(String(t), n).length;
    return typeof this.opts.mask == "string" ? r >= this.opts.mask.length : r >= n.length;
  }
  findMask(t) {
    const n = this.opts.mask;
    if (n == null)
      return null;
    if (typeof n == "string")
      return n;
    if (typeof n == "function")
      return n(t);
    const r = this.process(t, n.slice(-1).pop() ?? "", !1);
    return n.find((s) => this.process(t, s, !1).length >= r.length) ?? "";
  }
  escapeMask(t) {
    const n = [], r = [];
    return t.split("").forEach((s, i) => {
      s === "!" && t[i - 1] !== "!" ? r.push(i - r.length) : n.push(s);
    }), { mask: n.join(""), escaped: r };
  }
  process(t, n, r = !0) {
    if (this.opts.number != null) return Xd(t, r, this.opts);
    if (n == null) return t;
    const s = `v=${t},mr=${n},m=${r ? 1 : 0}`;
    if (this.memo.has(s)) return this.memo.get(s);
    const { mask: i, escaped: a } = this.escapeMask(n), l = [], o = this.opts.tokens != null ? this.opts.tokens : {}, h = this.isReversed() ? -1 : 1, v = this.isReversed() ? "unshift" : "push", u = this.isReversed() ? 0 : i.length - 1, f = this.isReversed() ? () => _ > -1 && g > -1 : () => _ < i.length && g < t.length, m = (S) => !this.isReversed() && S <= u || this.isReversed() && S >= u;
    let c, w = -1, _ = this.isReversed() ? i.length - 1 : 0, g = this.isReversed() ? t.length - 1 : 0, b = !1;
    for (; f(); ) {
      const S = i.charAt(_), E = o[S], I = E?.transform != null ? E.transform(t.charAt(g)) : t.charAt(g);
      if (!a.includes(_) && E != null ? (I.match(E.pattern) != null ? (l[v](I), E.repeated ? (w === -1 ? w = _ : _ === u && _ !== w && (_ = w - h), u === w && (_ -= h)) : E.multiple && (b = !0, _ -= h), _ += h) : E.multiple ? b && (_ += h, g -= h, b = !1) : I === c ? c = void 0 : E.optional && (_ += h, g -= h), g += h) : (r && !this.isEager() && l[v](S), I === S && !this.isEager() ? g += h : c = S, this.isEager() || (_ += h)), this.isEager())
        for (; m(_) && (o[i.charAt(_)] == null || a.includes(_)); ) {
          if (r) {
            if (l[v](i.charAt(_)), t.charAt(g) === i.charAt(_)) {
              _ += h, g += h;
              continue;
            }
          } else i.charAt(_) === t.charAt(g) && (g += h);
          _ += h;
        }
    }
    return this.memo.set(s, l.join("")), this.memo.get(s);
  }
}
class Qd {
  constructor(t, n = {}) {
    la(this, "items", /* @__PURE__ */ new Map()), la(this, "eventAbortController"), la(this, "onInput", (r) => {
      if (r instanceof CustomEvent && r.type === "input" && !r.isTrusted && !r.bubbles)
        return;
      const s = r.target, i = this.items.get(s);
      if (i === void 0) return;
      const a = "inputType" in r && r.inputType.startsWith("delete"), l = i.isEager(), o = a && l && i.unmasked(s.value) === "" ? "" : s.value;
      this.fixCursor(s, a, () => this.setValue(s, o));
    }), this.options = n, this.eventAbortController = new AbortController(), this.init(this.getInputs(t));
  }
  update(t = {}) {
    this.options = { ...t }, this.init(Array.from(this.items.keys()));
  }
  updateValue(t) {
    var n;
    t.value !== "" && t.value !== ((n = this.processInput(t)) == null ? void 0 : n.masked) && this.setValue(t, t.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(t) {
    const n = this.getOptions(this.options);
    for (const r of t) {
      if (!this.items.has(r)) {
        const { signal: i } = this.eventAbortController;
        r.addEventListener("input", this.onInput, { capture: !0, signal: i });
      }
      const s = new Jd(Yd(r, n));
      this.items.set(r, s), queueMicrotask(() => this.updateValue(r)), r.selectionStart === null && s.isEager() && console.warn("Maska: input of `%s` type is not supported", r.type);
    }
  }
  getInputs(t) {
    return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [t];
  }
  getOptions(t) {
    const { onMaska: n, preProcess: r, postProcess: s, ...i } = t;
    return i;
  }
  fixCursor(t, n, r) {
    var s, i;
    const a = t.selectionStart, l = t.value;
    if (r(), a === null || a === l.length && !n) return;
    const o = t.value, h = l.slice(0, a), v = o.slice(0, a), u = (s = this.processInput(t, h)) == null ? void 0 : s.unmasked, f = (i = this.processInput(t, v)) == null ? void 0 : i.unmasked;
    if (u === void 0 || f === void 0) return;
    let m = a;
    h !== v && (m += n ? o.length - l.length : u.length - f.length), t.setSelectionRange(m, m);
  }
  setValue(t, n) {
    const r = this.processInput(t, n);
    r !== void 0 && (t.value = r.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((s) => s(r)) : this.options.onMaska(r)), t.dispatchEvent(new CustomEvent("maska", { detail: r })), t.dispatchEvent(new CustomEvent("input", { detail: r.masked })));
  }
  processInput(t, n) {
    const r = this.items.get(t);
    if (r === void 0) return;
    let s = n ?? t.value;
    this.options.preProcess != null && (s = this.options.preProcess(s));
    let i = r.masked(s);
    return this.options.postProcess != null && (i = this.options.postProcess(i)), {
      masked: i,
      unmasked: r.unmasked(s),
      completed: r.completed(s)
    };
  }
}
const yr = /* @__PURE__ */ new WeakMap(), ef = (e, t) => {
  if (e.arg == null || e.instance == null) return;
  const n = "setup" in e.instance.$.type;
  e.arg in e.instance ? e.instance[e.arg] = t : n && console.warn("Maska: please expose `%s` using defineExpose", e.arg);
}, tf = (e, t) => {
  var n;
  const r = e instanceof HTMLInputElement ? e : e.querySelector("input");
  if (r == null || r?.type === "file") return;
  let s = {};
  if (t.value != null && (s = typeof t.value == "string" ? { mask: t.value } : { ...t.value }), t.arg != null) {
    const i = (a) => {
      const l = t.modifiers.unmasked ? a.unmasked : t.modifiers.completed ? a.completed : a.masked;
      ef(t, l);
    };
    s.onMaska = s.onMaska == null ? i : Array.isArray(s.onMaska) ? [...s.onMaska, i] : [s.onMaska, i];
  }
  yr.has(r) ? (n = yr.get(r)) == null || n.update(s) : yr.set(r, new Qd(r, s));
}, nf = ["for"], af = ["id"], rf = { class: "lc-input__input-wrap" }, lf = ["data-testid"], of = ["data-testid"], er = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: { default: "input" },
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean, default: !0 },
    suffixClass: {},
    type: { default: "text" },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = { Z: { pattern: "[1-9]" } }, s = n, i = dt("input"), a = Ct(e.id), l = we(!1), o = J(() => [
      "lc-input",
      {
        "lc-input--disabled": e.disabled,
        "lc-input--error": !!e.errorMessage,
        "lc-input--has-label": !!e.label
      }
    ]), h = J(() => ({
      "aria-labelledby": e.label ? `${a}-label` : void 0,
      autocomplete: e.autocomplete,
      class: "lc-input__input",
      "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_input`,
      disabled: e.disabled,
      id: a,
      inputmode: e.inputmode,
      name: e.name,
      onFocusin: () => l.value = !0,
      onFocusout: () => l.value = !1,
      pattern: e.pattern,
      placeholder: e.placeholder,
      spellcheck: e.spellcheck,
      type: e.type
    })), v = J(() => [
      "lc-input__label",
      {
        "lc-input__label--floating": l.value || !!e.value || typeof e.value == "number"
      }
    ]), u = J(() => e.mask ? m(e.mask) ? { ...e.mask, tokens: { ...r, ...e.mask.tokens } } : { mask: e.mask, tokens: r } : {}), f = J({
      get: () => e.value,
      set: (c) => {
        s("update:value", c);
      }
    }), m = (c) => c.mask !== void 0;
    return wt(() => {
      e.autofocus && i.value?.focus(), e.value && s("update:value", e.value);
    }), t({ ref: i }), (c, w) => (L(), j("div", {
      class: pe([o.value, c.$attrs.class])
    }, [
      ae("label", {
        class: "lc-input__wrap",
        for: q(a)
      }, [
        e.label ? (L(), j("span", {
          key: 0,
          id: `${q(a)}-label`,
          class: pe(v.value)
        }, $e(e.label), 11, af)) : ce("", !0),
        ae("div", rf, [
          c.$slots.prefix ? (L(), j("div", {
            key: 0,
            class: pe(["lc-input__prefix", e.prefixClass])
          }, [
            me(c.$slots, "prefix")
          ], 2)) : ce("", !0),
          e.mask ? Jt((L(), j("input", Ee({
            key: 1,
            ref: "input"
          }, {
            ...Qt(c.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": w[0] || (w[0] = (_) => f.value = _),
            "data-testid": c.$attrs["data-testid"] ?? "lc-input-with-mask"
          }), null, 16, lf)), [
            [Fi, f.value],
            [q(tf), u.value]
          ]) : Jt((L(), j("input", Ee({
            key: 2,
            ref: "input"
          }, {
            ...Qt(c.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": w[1] || (w[1] = (_) => f.value = _),
            "data-testid": c.$attrs["data-testid"] ?? "lc-input-without-mask"
          }), null, 16, of)), [
            [Fi, f.value]
          ]),
          c.$slots.suffix ? (L(), j("div", {
            key: 3,
            class: pe(["lc-input__suffix", e.suffixClass])
          }, [
            me(c.$slots, "suffix")
          ], 2)) : ce("", !0)
        ])
      ], 8, nf),
      e.noFeedback ? ce("", !0) : (L(), Ce(q(An), Ee({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), Z1 = [
  "decimal",
  "email",
  "none",
  "numeric",
  "search",
  "tel",
  "text",
  "url"
], W1 = [
  "email",
  "number",
  "password",
  "search",
  "tel",
  "text",
  "url"
], X1 = /* @__PURE__ */ Se({
  __name: "LcDateInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null], default: "##/##/####" },
    name: {},
    noFeedback: { type: Boolean },
    placeholder: { default: "MM/DD/YYYY" },
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {}
  },
  setup(e) {
    const t = ga(e, ["mask", "placeholder"]);
    return (n, r) => (L(), Ce(q(er), Ee({ ...n.$attrs, ...t, mask: e.mask, placeholder: e.placeholder }, {
      class: "lc-date-input",
      inputmode: "numeric",
      pattern: "[0-9]*"
    }), null, 16));
  }
}), sf = { class: "lc-description-list" }, Y1 = /* @__PURE__ */ Se({
  __name: "LcDescriptionList",
  setup(e) {
    return (t, n) => (L(), j("dl", sf, [
      me(t.$slots, "default")
    ]));
  }
}), Do = /* @__PURE__ */ Symbol();
var rn = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.Backspace = "Backspace", e.Dead = "Dead", e.Delete = "Delete", e.Eight = "8", e.Five = "5", e.Four = "4", e.Nine = "9", e.One = "1", e.Seven = "7", e.Six = "6", e.Three = "3", e.Two = "2", e.Zero = "0", e))(rn || {});
const G1 = /* @__PURE__ */ Se({
  __name: "LcDigitInput",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    type: {},
    index: { default: 0 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = ga(e, ["index"]), i = dt("input"), a = Zn(Do, () => null, !0), l = J(() => Ke(a?.config)), o = J(() => s.disabled || !!Ke(a?.disabled)), h = J(() => o.value ? "*" : "#"), v = J({
      get: () => o.value ? "X" : f.value,
      set: (c) => {
        if (o.value || c === "X") return;
        const w = typeof c == "number" ? c : null;
        r("update:value", w), a?.updateValue(e.index, w);
      }
    }), u = J(() => a ? `${Ke(a.name)}_input_${e.index}` : s.name), f = J(() => a ? Ke(a.value)?.[e.index] : s.value), m = (c) => {
      if (en(c.key, rn))
        switch (c.key !== rn.Dead && c.preventDefault(), c.key) {
          case rn.ArrowLeft:
            a?.focusPrevious(e.index);
            break;
          case rn.ArrowRight:
            a?.focusNext(e.index);
            break;
          case rn.Backspace:
          case rn.Delete:
            v.value = null;
            break;
          case rn.Dead: {
            const w = c.target;
            w?.blur(), setTimeout(() => w?.focus(), 1);
            break;
          }
          default: {
            const w = parseInt(c.key);
            v.value = w, a?.focusNext(e.index);
          }
        }
    };
    return t({
      disabled: o,
      index: e.index,
      inputRef: i
    }), (c, w) => (L(), Ce(q(er), Ee({ ref: "input" }, { ...c.$attrs, ...s, ...l.value, disabled: o.value, mask: h.value, name: u.value }, {
      autocomplete: "off",
      class: "lc-digit-input",
      inputmode: "numeric",
      pattern: "[0-9]*",
      tabindex: o.value ? -1 : 0,
      value: v.value,
      onKeydown: m
    }), null, 16, ["tabindex", "value"]));
  }
}), cf = ["id"], uf = ["id"], df = ["aria-labelledby"], K1 = /* @__PURE__ */ Se({
  __name: "LcDigitInputGroup",
  props: {
    disabled: { type: Boolean },
    errorMessage: {},
    feedbackMessageClass: {},
    helpMessage: {},
    id: {},
    legendClass: {},
    name: { default: "digit-input-group" },
    noFeedback: { type: Boolean },
    value: {},
    wrapperClass: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = we([]), i = Ct(e.id), a = (f, m) => {
      const c = [...e.value ?? []];
      c[f] = m, r("update:value", c);
    }, l = () => {
      const f = s.value.findIndex((m) => !m.disabled);
      s.value[f]?.inputRef?.ref?.focus();
    }, o = (f) => {
      if (f < 0 || f >= s.value.length) return;
      const m = s.value[f];
      m.disabled || m.inputRef?.ref?.focus();
    }, h = (f, m) => {
      if (a(f, m), m !== null) {
        v(f);
        return;
      }
      if (f <= 0 || typeof e.value?.[f] == "number") return;
      const w = s.value.slice(0, f).reverse().find(({ disabled: _ }) => !_)?.index;
      typeof w == "number" && (o(w), a(w, null));
    }, v = (f, m = !0) => {
      const c = m ? f + 1 : f - 1;
      if (c < 0 || c >= s.value.length) return;
      const w = s.value[c];
      if (w.disabled) {
        v(c, m);
        return;
      }
      w.inputRef?.ref?.focus();
    }, u = (f) => {
      const m = f;
      m?.inputRef?.ref && (s.value[m.index] = m);
    };
    return wt(l), t({ focusFirstEnabledInput: l, focusInputByIndex: o }), ei(Do, {
      config: to(
        J(() => ({
          errorMessage: e.errorMessage,
          noFeedback: !0
        }))
      ),
      disabled: () => e.disabled,
      focusNext: (f) => v(f),
      focusPrevious: (f) => v(f, !1),
      name: () => e.name,
      updateValue: h,
      value: () => e.value
    }), (f, m) => (L(), j("fieldset", Ee(f.$attrs, {
      id: q(i),
      class: "lc-digit-input-group"
    }), [
      f.$slots.legend ? (L(), j("legend", {
        key: 0,
        id: `${q(i)}-label`,
        class: pe(["lc-digit-input-group__label", e.legendClass])
      }, [
        me(f.$slots, "legend")
      ], 10, uf)) : ce("", !0),
      ae("div", {
        "aria-labelledby": f.$slots.legend ? `${q(i)}-label` : void 0,
        class: pe(["lc-digit-input-group__wrap", e.wrapperClass]),
        role: "group"
      }, [
        me(f.$slots, "default", At(Rt({ setRef: u })))
      ], 10, df),
      e.noFeedback ? ce("", !0) : (L(), Ce(q(An), Ee({ key: 1 }, { disabled: e.disabled }, {
        class: e.feedbackMessageClass,
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["class", "content", "variant"]))
    ], 16, cf));
  }
}), ff = ["id"], hf = ["aria-controls", "aria-expanded"], vf = ["id"], mf = /* @__PURE__ */ Se({
  __name: "LcExpandable",
  props: /* @__PURE__ */ sa({
    contentClass: {},
    disabled: { type: Boolean },
    headerClass: {},
    id: {},
    modelValue: { type: Boolean }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ct(e.id), n = Za(e, "modelValue"), r = J(() => [
      "lc-expandable",
      {
        "lc-expandable--disabled": e.disabled,
        "lc-expandable--expanded": n.value
      }
    ]), s = () => {
      n.value = !n.value;
    };
    return (i, a) => (L(), j("article", Ee(i.$attrs, {
      id: q(t),
      class: r.value
    }), [
      ae("button", Ee({
        "aria-controls": `${q(t)}-region`
      }, { disabled: e.disabled }, {
        "aria-expanded": n.value,
        class: ["lc-expandable__header", e.headerClass],
        type: "button",
        onClickPassive: s
      }), [
        me(i.$slots, "header"),
        e.disabled ? ce("", !0) : (L(), Ce(q(Qe), {
          key: 0,
          class: "lc-expandable__header-icon",
          name: "chevron-down"
        }))
      ], 16, hf),
      Jt(ae("section", {
        id: `${q(t)}-region`,
        class: pe(["lc-expandable__content", e.contentClass]),
        role: "region"
      }, [
        me(i.$slots, "default")
      ], 10, vf), [
        [ni, n.value]
      ])
    ], 16, ff));
  }
}), gf = { class: "lc-expandable-list" }, J1 = /* @__PURE__ */ Se({
  __name: "LcExpandableList",
  setup(e) {
    return (t, n) => (L(), j("div", gf, [
      me(t.$slots, "default")
    ]));
  }
}), bf = () => {
  const e = we(!1);
  return wt(() => {
    e.value = !0;
  }), Tn(() => {
    e.value = !1;
  }), e;
}, pf = {
  key: 0,
  class: "lc-fly-out__illustration"
}, yf = { class: "lc-fly-out__message" }, Q1 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcFlyOut",
  props: {
    buttonAriaLabel: { default: () => je.lcFlyOut.buttonAriaLabel },
    isVisible: { type: Boolean },
    message: {},
    to: { default: () => je.lcFlyOut.to },
    visibleInSeconds: { default: () => je.lcFlyOut.visibleInSeconds }
  },
  emits: ["update:isVisible"],
  setup(e, { emit: t }) {
    const n = t, r = bf(), s = J(() => e.visibleInSeconds * 1e3), { start: i, stop: a } = ea(
      () => {
        n("update:isVisible", !1);
      },
      s,
      { immediate: !1 }
    );
    return Tn(a), Ve(
      () => e.isVisible,
      (l) => {
        l ? i() : a();
      },
      { immediate: !0 }
    ), (l, o) => q(r) ? (L(), Ce(ba, {
      key: 0,
      class: "lc-fly-out",
      to: e.to
    }, [
      Oe(q(ca), { name: "slide-down-lg" }, {
        default: Ie(() => [
          e.isVisible ? (L(), j("div", Ee({ key: 0 }, l.$attrs, { class: "lc-fly-out__container" }), [
            Oe(q(hu), {
              class: "lc-fly-out__timer",
              "duration-in-ms": s.value
            }, {
              default: Ie(() => [
                Oe(q(St), {
                  "aria-label": e.buttonAriaLabel,
                  icon: "close",
                  variant: "tertiary",
                  onClick: o[0] || (o[0] = (h) => l.$emit("update:isVisible", !1))
                }, null, 8, ["aria-label"])
              ]),
              _: 1
            }, 8, ["duration-in-ms"]),
            l.$slots.default ? (L(), j("div", pf, [
              me(l.$slots, "default")
            ])) : ce("", !0),
            ae("p", yf, $e(e.message), 1)
          ], 16)) : ce("", !0)
        ]),
        _: 3
      })
    ], 8, ["to"])) : ce("", !0);
  }
});
const ha = (e) => e !== null && !!e && typeof e == "object" && !Array.isArray(e);
function ll(e) {
  return Number(e) >= 0;
}
function wf(e) {
  return typeof e == "object" && e !== null;
}
function xf(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
function ol(e) {
  if (!wf(e) || xf(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Mo(e, t) {
  return Object.keys(t).forEach((n) => {
    if (ol(t[n]) && ol(e[n])) {
      e[n] || (e[n] = {}), Mo(e[n], t[n]);
      return;
    }
    e[n] = t[n];
  }), e;
}
function kf(e, t = { abortEarly: !1 }) {
  return {
    __type: "VVTypedSchema",
    async parse(r) {
      var s;
      try {
        return {
          value: await e.validate(r, Object.assign({}, t)),
          errors: []
        };
      } catch (i) {
        const a = i;
        if (a.name !== "ValidationError")
          throw i;
        if (!(!((s = a.inner) === null || s === void 0) && s.length) && a.errors.length)
          return { errors: [{ path: a.path, errors: a.errors }] };
        const l = a.inner.reduce((o, h) => {
          const v = h.path || "";
          return o[v] || (o[v] = { errors: [], path: v }), o[v].errors.push(...h.errors), o;
        }, {});
        return { errors: Object.values(l) };
      }
    },
    cast(r) {
      try {
        return e.cast(r);
      } catch {
        const i = e.getDefault();
        return ha(i) && ha(r) ? Mo(i, r) : r;
      }
    },
    describe(r) {
      try {
        if (!r)
          return sl(e.spec);
        const s = _f(r, e);
        return s ? sl(s) : {
          required: !1,
          exists: !1
        };
      } catch {
        return process.env.NODE_ENV !== "production" && console.warn(`Failed to describe path ${r} on the schema, returning a default description.`), {
          required: !1,
          exists: !1
        };
      }
    }
  };
}
function sl(e) {
  return {
    required: !e.optional,
    exists: !0
  };
}
function _f(e, t) {
  if (!cl(t))
    return null;
  if (Xs(e)) {
    const s = t.fields[Ys(e)];
    return s?.spec || null;
  }
  const n = (e || "").split(/\.|\[(\d+)\]/).filter(Boolean);
  let r = t;
  for (let s = 0; s < n.length; s++) {
    const i = n[s];
    if (cl(r) && i in r.fields ? r = r.fields[i] : Sf(r) && ll(i) ? r = r.spec.types[Number(i)] : ll(i) && Cf(r) && (r = r.innerType), s === n.length - 1)
      return r.spec;
  }
  return null;
}
function Sf(e) {
  return ha(e) && e.type === "tuple";
}
function cl(e) {
  return ha(e) && e.type === "object";
}
function Cf(e) {
  return ha(e) && e.type === "array";
}
const eg = /* @__PURE__ */ Se({
  __name: "LcForm",
  props: {
    initialValues: {},
    onSubmit: { type: Function },
    resetOnSubmit: { type: Boolean },
    validateOnMount: { type: Boolean },
    validationSchema: {}
  },
  setup(e, { expose: t }) {
    const n = e, { isFieldValid: r, isSubmitting: s, meta: i, resetField: a, resetForm: l, setErrors: o, validate: h, values: v } = Gs({
      initialValues: n.initialValues,
      validateOnMount: n.validateOnMount,
      validationSchema: n.validationSchema ? kf(n.validationSchema) : void 0
    }), u = async (f) => {
      f.preventDefault();
      try {
        s.value = !0;
        const { valid: m, values: c } = await h();
        m && n.onSubmit && await n.onSubmit(c), m && n.resetOnSubmit && l();
      } finally {
        s.value = !1;
      }
    };
    return t({
      isFieldValid: r,
      isSubmitting: s,
      meta: i,
      resetField: a,
      resetForm: l,
      setErrors: o,
      validate: h,
      values: v
    }), (f, m) => (L(), j("form", {
      class: "lc-form",
      novalidate: "",
      onSubmit: u
    }, [
      me(f.$slots, "default", At(Rt({ isSubmitting: q(s), meta: q(i), values: q(v) })))
    ], 32));
  }
}), tg = [
  "aggressive",
  "blur",
  "eager",
  "lazy",
  "passive"
];
var Oo = /* @__PURE__ */ ((e) => (e.InputEnd = "lottocom_form_input_end", e))(Oo || {});
const Nt = {
  Blur: "onBlur",
  Change: "onChange",
  Update: "onUpdate:value"
}, Ef = { class: "lc-form-field" }, ng = /* @__PURE__ */ Se({
  __name: "LcFormField",
  props: {
    mode: { default: "aggressive" },
    name: {}
  },
  setup(e, { expose: t }) {
    const n = {
      aggressive: () => [Nt.Blur, Nt.Update],
      blur: ({ errorMessage: f }) => f.value ? [Nt.Update] : [Nt.Blur],
      eager: ({ errorMessage: f }) => f.value ? [Nt.Update] : [Nt.Change],
      lazy: () => [Nt.Change],
      passive: () => []
    }, {
      errorMessage: r,
      handleBlur: s,
      handleChange: i,
      meta: a,
      value: l
    } = Ks(() => e.name, {}, { validateOnValueUpdate: !1 }), o = {
      [Nt.Blur]: (f) => u(f, !0),
      [Nt.Change]: (f) => i(f, !0),
      [Nt.Update]: (f) => i(f, !0)
    }, h = J(() => ({
      errorMessage: r.value,
      name: e.name,
      value: l.value,
      ...v.value
    })), v = J(() => {
      const f = {
        [Nt.Blur]: (m) => u(m, !1),
        [Nt.Update]: (m) => i(m, !1)
      };
      return n[e.mode]({
        errorMessage: r,
        meta: a
      }).forEach((m) => {
        f[m] = o[m];
      }), f;
    }), u = async (f, m) => {
      if (s(f, m), await Wa(), !f) return;
      const c = new CustomEvent(Oo.InputEnd, {
        detail: {
          _value: f
        }
      });
      window.dispatchEvent(c);
    };
    return t({ field: h }), (f, m) => (L(), j("div", Ef, [
      me(f.$slots, "default", At(Rt({ field: h.value })))
    ]));
  }
}), Tf = ["id"], Af = { ref: "wrapper" }, Lf = { class: "lc-header__wrap" }, $f = { class: "lc-header__left-button-wrap" }, If = { class: "lc-header__headline-wrap" }, Df = {
  key: 0,
  class: "lc-header__fly-out-toggle-wrap"
}, Mf = ["id", "aria-labelledby"], Of = { class: "lc-header__fly-out-content-container" }, ag = /* @__PURE__ */ Se({
  __name: "LcHeader",
  props: {
    href: {},
    target: {},
    to: {},
    ignoreOutsideClickOn: { default: () => [je.lcModal.to] },
    closeFlyOutOnOutsideClick: { type: Boolean, default: !0 },
    flyOutContentClass: {},
    flyOutToggleAriaLabel: { default: () => je.lcHeader.flyOutToggleAriaLabel },
    flyOutToggleClass: {},
    headlineClass: {},
    id: {},
    leftButtonAriaLabel: { default: () => je.lcHeader.leftButtonAriaLabel },
    leftButtonIcon: { default: "arrow-left" },
    withFlyOut: { type: Boolean }
  },
  emits: ["left-button-click"],
  setup(e) {
    const t = dt("wrapper"), n = Ct(e.id), r = we(!1), s = J(() => [
      "lc-header",
      {
        "lc-header--active": r.value,
        "lc-header--with-fly-out": e.withFlyOut
      }
    ]), i = () => {
      r.value = !r.value;
    };
    return Ya(
      t,
      () => {
        !e.closeFlyOutOnOutsideClick || !r.value || (r.value = !1);
      },
      { ignore: [...Ke(e.ignoreOutsideClickOn)] }
    ), (a, l) => (L(), j("header", {
      id: q(n),
      class: pe(s.value)
    }, [
      ae("div", Af, [
        ae("div", Lf, [
          ae("div", $f, [
            Oe(q(St), Ee({ href: e.href, target: e.target, to: e.to }, {
              "aria-label": e.leftButtonAriaLabel,
              icon: e.leftButtonIcon,
              size: "small",
              variant: "tertiary",
              onClick: l[0] || (l[0] = (o) => a.$emit("left-button-click"))
            }), null, 16, ["aria-label", "icon"])
          ]),
          ae("div", If, [
            ae("h1", {
              class: pe(["lc-header__headline", e.headlineClass])
            }, [
              me(a.$slots, "headline")
            ], 2)
          ]),
          me(a.$slots, "right", {}, () => [
            e.withFlyOut ? (L(), j("div", Df, [
              Oe(q(St), {
                id: `${q(n)}-toggle`,
                "aria-controls": `${q(n)}-region`,
                "aria-expanded": r.value,
                "aria-label": e.flyOutToggleAriaLabel,
                class: pe(["lc-header__fly-out-toggle", e.flyOutToggleClass]),
                icon: "chevron-down",
                "icon-position": "right",
                "no-padding": "",
                size: "small",
                variant: "tertiary",
                onClickPassive: i
              }, {
                default: Ie(() => [
                  me(a.$slots, "fly-out-toggle")
                ]),
                _: 3
              }, 8, ["id", "aria-controls", "aria-expanded", "aria-label", "class"])
            ])) : ce("", !0)
          ])
        ]),
        e.withFlyOut && r.value ? (L(), j("div", {
          key: 0,
          id: `${q(n)}-region`,
          "aria-labelledby": `${q(n)}-toggle`,
          class: "lc-header__fly-out",
          role: "region"
        }, [
          ae("div", Of, [
            ae("div", {
              class: pe(["lc-header__fly-out-content", e.flyOutContentClass])
            }, [
              me(a.$slots, "fly-out-content")
            ], 2)
          ])
        ], 8, Mf)) : ce("", !0)
      ], 512),
      me(a.$slots, "default")
    ], 10, Tf));
  }
}), Rf = /* @__PURE__ */ Se({
  __name: "LcHighFrequencyBall",
  props: {
    content: {},
    opacity: { default: 1 },
    size: { default: "medium" }
  },
  setup(e) {
    const t = J(() => ["lc-high-frequency-ball", `lc-high-frequency-ball--size-${e.size}`]);
    return (n, r) => (L(), j("div", {
      class: pe(t.value),
      style: Lt({
        "--ball-opacity": e.opacity
      })
    }, $e(e.content), 7));
  }
}), Ff = { class: "lc-high-frequency-ball-background" }, Ro = /* @__PURE__ */ Se({
  __name: "LcHighFrequencyBallBackground",
  props: {
    ballConfig: {},
    gradientClass: {}
  },
  setup(e) {
    return (t, n) => (L(), j("div", Ff, [
      (L(!0), j(Ge, null, vt(e.ballConfig, (r, s) => (L(), Ce(Rf, {
        key: s,
        class: "lc-high-frequency-ball-background__ball",
        content: r.content,
        opacity: r.opacity,
        size: r.size,
        style: Lt({
          "--ball-position-top": r.top,
          "--ball-position-left": r.left
        })
      }, null, 8, ["content", "opacity", "size", "style"]))), 128)),
      ae("div", {
        class: pe(["lc-high-frequency-ball-background__gradient", e.gradientClass])
      }, null, 2)
    ]));
  }
}), Nf = {
  key: 0,
  class: "lc-lottery-jackpot__placeholder"
}, Bf = { class: "lc-lottery-jackpot__value" }, Pf = { class: "lc-lottery-jackpot__currency" }, zf = {
  key: 0,
  class: "lc-lottery-jackpot__numeral"
}, ul = 10 ** 9, dl = 10 ** 6, Vf = "mil millones", Hf = "mil M", Fo = /* @__PURE__ */ Se({
  __name: "LcLotteryJackpot",
  props: {
    currency: { default: () => je.general.currency },
    locale: { default: () => je.general.locale },
    noShadow: { type: Boolean },
    placeholder: {},
    size: { default: "medium" },
    value: {}
  },
  setup(e) {
    const t = ul * 100, n = dl * 100, r = J(() => {
      let a;
      const l = e.value >= t, o = e.value >= n;
      switch (!0) {
        case l:
          a = Math.floor(e.value / ul) / 100;
          break;
        case o:
          a = Math.floor(e.value / dl) / 100;
          break;
        default:
          a = e.value / 100;
          break;
      }
      const [h, v] = a.toFixed(2).split("."), u = v.replace(/0+$/, ""), f = o || l;
      let m = u;
      !f && u.length >= 1 ? m = v : f && h.length >= 3 ? m = "" : f && u.length > 1 && (m = u.slice(0, 1));
      const c = m.length > 0 ? [h, m].join(".") : h, w = m.length;
      return new Intl.NumberFormat(e.locale, {
        maximumFractionDigits: w,
        minimumFractionDigits: w
      }).format(Number(c));
    }), s = J(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: a }) => a === "currency")?.value ?? e.currency
    ), i = J(() => {
      if (e.value < n) return null;
      const a = new Intl.NumberFormat(e.locale, {
        compactDisplay: "long",
        maximumFractionDigits: 12,
        minimumFractionDigits: 2,
        notation: "compact"
      }).format(e.value / 100).split(" ").slice(1).join(" ");
      return a === Vf ? Hf : a;
    });
    return (a, l) => (L(), j("div", {
      class: pe([
        "lc-lottery-jackpot",
        `lc-lottery-jackpot--size-${e.size}`,
        { "lc-lottery-jackpot--no-shadow": e.noShadow }
      ])
    }, [
      e.placeholder ? (L(), j("span", Nf, $e(e.placeholder), 1)) : (L(), j(Ge, { key: 1 }, [
        ae("span", Bf, [
          ae("span", Pf, $e(s.value), 1),
          ae("span", null, $e(r.value), 1)
        ]),
        i.value ? (L(), j("span", zf, $e(i.value), 1)) : ce("", !0)
      ], 64))
    ], 2));
  }
}), rg = ["large", "medium", "small"], No = () => typeof window < "u", Uf = { class: "lc-info-button__modal" }, qf = { class: "lc-info-button__modal-header" }, jf = { class: "lc-info-button__modal-headline" }, Zf = { class: "lc-info-button__modal-text" }, Bo = /* @__PURE__ */ Se({
  __name: "LcInfoButton",
  props: {
    to: {},
    closeButtonAriaLabel: { default: () => je.lcInfoButton.closeButtonAriaLabel },
    disabled: { type: Boolean, default: !1 },
    headline: {},
    openButtonAriaLabel: { default: () => je.lcInfoButton.openButtonAriaLabel },
    text: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = No(), n = we(!1), r = () => {
      n.value = !1;
    }, s = () => {
      e.disabled || (n.value = !0);
    };
    return (i, a) => (L(), j("div", {
      class: pe(["lc-info-button", `lc-info-button--variant-${e.variant}`])
    }, [
      Oe(q(St), Ee({ disabled: e.disabled }, {
        "aria-label": e.openButtonAriaLabel,
        class: "lc-info-button__button-open",
        icon: "info",
        size: "small",
        variant: "tertiary",
        onClickPassive: s
      }), null, 16, ["aria-label"]),
      q(t) && n.value ? (L(), Ce(q(ko), Ee({ key: 0 }, { to: e.to, isVisible: n.value }, {
        "close-triggers": ["escape", "click-outside"],
        spacing: "small",
        onClosePassive: r
      }), {
        default: Ie(() => [
          ae("div", Uf, [
            ae("header", qf, [
              ae("span", jf, $e(e.headline), 1),
              Oe(q(St), {
                "aria-label": e.closeButtonAriaLabel,
                icon: "close",
                size: "small",
                variant: "tertiary",
                onClick: r
              }, null, 8, ["aria-label"])
            ]),
            me(i.$slots, "default", {}, () => [
              ae("p", Zf, $e(e.text), 1)
            ])
          ])
        ]),
        _: 3
      }, 16)) : ce("", !0)
    ], 2));
  }
}), ig = ["default", "prominent"], Wf = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='11.9999'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M19.4149%2015.1688C18.8733%2019.0325%2016.1778%2021.4239%2011.7967%2021.4239C7.80659%2021.4239%204.34435%2017.7274%205.29956%2014.3591C6.14178%2011.3891%208.79864%2011.1375%209.58553%207.65315C11.2998%209.28806%2010.8823%2010.6768%2010.5907%2012.0319C10.34%2013.1974%2010.7651%2014.5391%2011.7967%2014.5391C13.0342%2014.5391%2013.5051%2013.1541%2013.0342%2011.7364C12.2699%209.43549%2010.4881%206.2479%2012.2267%203.90869C13.3913%206.00993%2014.7039%206.89025%2016.4607%208.40282C18.7036%2010.3339%2019.7843%2012.5328%2019.4149%2015.1688Z'%20fill='%23000860'/%3e%3cpath%20d='M7.99905%203.70487C9.59553%207.89517%205.86485%209.98417%205.86485%209.98417C5.07622%206.82574%206.57056%206.64536%207.99905%203.70487Z'%20fill='%23000860'/%3e%3c/svg%3e", Xf = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='56'%20height='55'%20fill='none'%3e%3cg%20filter='url(%23a)'%3e%3cpath%20fill='%2300C572'%20d='M24.064%204.19A1%201%200%200%201%2025.427%204L27.1%205.192a1%201%200%200%200%201.185-.016l1.638-1.24a1%201%200%200%201%201.368.153l1.323%201.572a1%201%200%200%200%201.151.279l1.895-.794a1%201%200%200%201%201.288.49l.89%201.85a1%201%200%200%200%201.046.557l2.033-.297a1%201%200%200%201%201.125.794l.402%202.014a1%201%200%200%200%20.875.799l2.042.218a1%201%200%200%201%20.893%201.048l-.112%202.052a1%201%200%200%200%20.649.99l1.924.72a1%201%200%200%201%20.604%201.237l-.618%201.96a1%201%200%200%200%20.381%201.12l1.685%201.176a1%201%200%200%201%20.277%201.349l-1.086%201.744a1%201%200%200%200%20.091%201.18l1.34%201.558a1%201%200%200%201-.067%201.375l-1.485%201.419a1%201%200%200%200-.206%201.166l.91%201.842a1%201%200%200%201-.407%201.315l-1.791%201.005a1%201%200%200%200-.49%201.079l.424%202.01a1%201%200%200%201-.721%201.173l-1.986.528a1%201%200%200%200-.742.923l-.089%202.052a1%201%200%200%201-.99.957l-2.055.017a1%201%200%200%200-.948.71l-.597%201.965a1%201%200%200%201-1.197.68l-1.994-.493a1%201%200%200%200-1.095.45l-1.067%201.756a1%201%200%200%201-1.33.361l-1.808-.974a1%201%200%200%200-1.172.165l-1.47%201.435a1%201%200%200%201-1.377.02l-1.51-1.394a1%201%200%200%200-1.177-.132l-1.78%201.024a1%201%200%200%201-1.339-.324l-1.115-1.725a1%201%200%200%200-1.108-.42l-1.98.55a1%201%200%200%201-1.215-.647l-.651-1.949a1%201%200%200%200-.968-.682l-2.054.04a1%201%200%200%201-1.017-.929l-.146-2.05a1%201%200%200%200-.768-.901l-2-.472a1%201%200%200%201-.753-1.153l.367-2.02a1%201%200%200%200-.519-1.065l-1.819-.955a1%201%200%200%201-.444-1.303l.86-1.866a1%201%200%200%200-.239-1.16L4.738%2029.73a1%201%200%200%201-.105-1.373l1.296-1.593a1%201%200%200%200%20.058-1.183l-1.135-1.713a1%201%200%200%201%20.24-1.356l1.651-1.222a1%201%200%200%200%20.35-1.131l-.672-1.942a1%201%200%200%201%20.569-1.254l1.903-.772a1%201%200%200%200%20.62-1.009l-.168-2.047a1%201%200%200%201%20.863-1.073l2.036-.275a1%201%200%200%200%20.852-.823l.345-2.025a1%201%200%200%201%201.103-.825l2.04.24a1%201%200%200%200%201.03-.585l.838-1.875a1%201%200%200%201%201.274-.525l1.916.74a1%201%200%200%200%201.143-.31z'/%3e%3cpath%20fill='%23fff'%20d='M12.886%2035.433a.42.42%200%200%201-.32-.075.41.41%200%200%201-.16-.286l-1.538-10.943a.41.41%200%200%201%20.075-.32.41.41%200%200%201%20.286-.16l1.532-.215q.254-.036.387.066.135.101.178.163l5.481%206.389-.97-6.902a.41.41%200%200%201%20.075-.32.4.4%200%200%201%20.27-.158l1.717-.242a.41.41%200%200%201%20.32.076q.135.101.16.286l1.538%2010.943a.45.45%200%200%201-.075.32.41.41%200%200%201-.287.16l-1.549.217q-.252.036-.386-.065-.12-.12-.178-.164l-5.434-6.172.94%206.683a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.176-1.57a.42.42%200%200%201-.32-.076.41.41%200%200%201-.16-.286l-1.538-10.943a.42.42%200%200%201%20.076-.32.41.41%200%200%201%20.286-.16l7.626-1.072a.41.41%200%200%201%20.32.076q.135.101.16.286l.19%201.347a.4.4%200%200%201-.078.303.42.42%200%200%201-.287.16l-5.454.767.372%202.643%205.084-.715a.42.42%200%200%201%20.32.075q.133.102.16.287l.175%201.246a.4.4%200%200%201-.078.302.42.42%200%200%201-.287.16l-5.084.715.384%202.727%205.589-.785a.42.42%200%200%201%20.32.075q.133.102.16.287l.187%201.33a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.278-1.586a.64.64%200%200%201-.459-.09.66.66%200%200%201-.237-.344l-3.436-10.521a.15.15%200%200%201-.026-.065l-.007-.05a.33.33%200%200%201%20.067-.25.32.32%200%200%201%20.236-.154l1.768-.248q.438-.061.538.285l2.263%206.943.742-4.619q.03-.142.128-.31.096-.167.366-.206l1.06-.149q.27-.038.409.097a.8.8%200%200%201%20.192.265l2%204.217.247-7.28q0-.36.456-.424l1.767-.248a.32.32%200%200%201%20.27.082.33.33%200%200%201%20.133.222l.008.05a.15.15%200%200%201-.008.07l-.403%2011.06a.62.62%200%200%201-.15.4q-.13.172-.399.21l-1.364.192q-.27.038-.44-.076a.9.9%200%200%201-.227-.277l-2.535-4.966-1.05%205.47a.8.8%200%200%201-.16.331q-.117.154-.402.194z'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='a'%20width='54.296'%20height='56.295'%20x='.852'%20y='.102'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='2'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20values='0%200%200%200%200%200%200%200%200%200.0313726%200%200%200%200%200.376471%200%200%200%200.06%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_11660_18282'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_11660_18282'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", Yf = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12.0001'%20cy='12.9417'%20r='11'%20fill='white'/%3e%3ccircle%20cx='12'%20cy='12.9417'%20r='9.21486'%20transform='rotate(-11.3509%2012%2012.9417)'%20fill='%23000860'/%3e%3cpath%20d='M10.5288%205.61047C9.30234%205.85667%208.15728%206.40664%207.19846%207.21001C6.23963%208.01338%205.49769%209.04448%205.04059%2010.2089L12.0003%2012.941L10.5288%205.61047Z'%20fill='white'/%3e%3c/svg%3e", Gf = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M11.7802%2013.8032L14.3303%2012.5401L14.5266%2012.7531C16.3077%2014.6859%2017.2575%2017.2414%2017.1712%2019.8683C17.1679%2019.9693%2017.1041%2020.0585%2017.0095%2020.0942L13.4144%2021.4522C13.2796%2021.5031%2013.1355%2021.4035%2013.1355%2021.2594L13.1356%2020.3255C13.1356%2018.0815%2012.6742%2015.8615%2011.7802%2013.8032Z'%20fill='%23000860'/%3e%3cpath%20d='M11.0112%209.27934C11.0323%209.19513%2011.1291%209.15558%2011.2031%209.20086L17.6251%2012.5888C17.715%2012.6438%2017.7043%2012.7778%2017.6066%2012.8177L9.86212%2016.2293C9.76448%2016.2693%209.66293%2016.1812%209.6886%2016.0789L11.0112%209.27934Z'%20fill='%23000860'/%3e%3cpath%20d='M5.25467%200.422462C5.25301%200.280381%205.41499%200.19807%205.52878%200.283175L8.27821%202.33962C8.3234%202.37342%208.38232%202.38282%208.43577%202.36475L11.6885%201.26567C11.8231%201.22018%2011.9515%201.3488%2011.9057%201.48331L10.7995%204.73366C10.7813%204.78707%2010.7906%204.84601%2010.8243%204.89127L12.8748%207.64518C12.9596%207.75915%2012.8769%207.92095%2012.7349%207.91898L9.30178%207.87136C9.24536%207.87057%209.19217%207.8976%209.15954%207.94364L7.17404%2010.7447C7.09187%2010.8607%206.91245%2010.832%206.87042%2010.6963L5.85482%207.41653C5.83813%207.36263%205.79599%207.32039%205.74213%207.30359L2.46457%206.28085C2.32893%206.23852%202.3007%206.05904%202.41681%205.97712L5.22222%203.99773C5.26833%203.9652%205.29547%203.91207%205.29481%203.85565L5.25467%200.422462Z'%20fill='%23000860'/%3e%3c/svg%3e", Kf = {
  key: 0,
  fill: "none",
  height: "32",
  viewBox: "0 0 21 32",
  width: "21",
  xmlns: "http://www.w3.org/2000/svg"
}, Jf = ["src"], Qf = {
  key: 2,
  class: "lc-teaser-badge__text"
}, e0 = ["src"], t0 = 8, an = 10, n0 = 20, a0 = /* @__PURE__ */ Se({
  __name: "LcTeaserBadge",
  props: {
    infoHeadline: {},
    infoText: {},
    title: {},
    variant: {}
  },
  setup(e) {
    const t = J(() => [
      "lc-teaser-badge",
      `lc-teaser-badge--variant-${e.variant}`,
      {
        "lc-teaser-badge--multiple-lines": n.value
      }
    ]), n = J(() => s.value.length > 1), r = J(() => {
      switch (e.variant) {
        case "fire":
          return Wf;
        case "pie":
          return Yf;
        case "star":
          return Gf;
        default:
          return null;
      }
    }), s = J(() => {
      if (!e.title) return [];
      const i = e.title.substring(0, n0);
      if (i.length <= t0) return [i];
      const l = i.split(" ").filter(Boolean);
      if (l.length === 1)
        return [
          i.slice(0, an),
          i.slice(an)
        ];
      let o = "";
      const h = [];
      return l.forEach((v) => {
        if (o.length + v.length + (o.length ? 1 : 0) <= an) {
          o.length > 0 && (o += " "), o += v;
          return;
        }
        if (v.length > an) {
          if (o.length > 0) {
            let u = 0;
            o.length < an && (o += " ", u = an - o.length, o += v.slice(0, u)), h.push(o), h.push(v.slice(u)), o = "";
            return;
          }
          h.push(v.slice(0, an)), o = v.slice(an);
          return;
        }
        h.push(o), o = v;
      }), o.length > 0 && h.push(o), h.length > 2 ? [h[0], h.slice(1).join(" ")] : h;
    });
    return (i, a) => (L(), j("div", {
      class: pe(t.value)
    }, [
      e.variant === "price-tag" ? (L(), j("svg", Kf, [...a[0] || (a[0] = [
        ae("path", {
          d: "M20.4593 2C20.4593 0.895431 19.5638 0 18.4593 0H16.9403C16.602 0 16.2693 0.0858105 15.9732 0.249404L1.49209 8.24989C0.854856 8.60195 0.459259 9.27247 0.459259 10.0005V21.9995C0.459259 22.7275 0.854856 23.398 1.49209 23.7501L15.9732 31.7506C16.2693 31.9142 16.602 32 16.9403 32H18.4593C19.5638 32 20.4593 31.1046 20.4593 30V2Z",
          fill: "currentColor"
        }, null, -1)
      ])])) : ce("", !0),
      r.value ? (L(), j("img", {
        key: 1,
        alt: "",
        height: "24",
        src: r.value,
        width: "24"
      }, null, 8, Jf)) : ce("", !0),
      e.variant !== "new" ? (L(), j("span", Qf, $e(s.value.join(`
`)), 1)) : (L(), j("img", {
        key: 3,
        alt: "New",
        height: "48",
        src: q(Xf),
        width: "48"
      }, null, 8, e0)),
      e.variant !== "new" && e.variant !== "floating" && e.infoHeadline && e.infoText ? (L(), Ce(q(Bo), {
        key: 4,
        headline: e.infoHeadline,
        "open-button-aria-label": `${q(je).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : ce("", !0)
    ], 2));
  }
}), lg = ["fire", "lightning", "money", "star"], og = [
  "fire",
  "floating",
  "new",
  "pie",
  "price-tag",
  "star",
  "text"
], sg = ["bottom-m", "bottom-xl", "top-m", "top-xl"], Po = ["badge", "default", "hero"];
var zo = /* @__PURE__ */ ((e) => (e.Blue = "#a8e2ff", e.Green = "#84f9c1", e.YellowBright = "#ffec8d", e.YellowDark = "#f2c219", e))(zo || {});
const r0 = { class: "lc-teaser-hero-badge__text-wrap" }, i0 = /* @__PURE__ */ Se({
  __name: "LcTeaserHeroBadge",
  props: {
    color: { default: () => zo.YellowBright },
    infoHeadline: {},
    infoText: {},
    subtitle: {},
    title: {},
    variant: {}
  },
  setup(e) {
    return (t, n) => (L(), j("div", {
      class: pe(["lc-teaser-hero-badge", `lc-teaser-hero-badge--variant-${e.variant}`]),
      style: Lt({
        "--teaser-badge-color": e.color
      })
    }, [
      ae("div", r0, [
        ae("span", null, $e(e.title), 1),
        ae("span", null, $e(e.subtitle), 1)
      ]),
      e.infoHeadline && e.infoText ? (L(), Ce(q(Bo), {
        key: 0,
        headline: e.infoHeadline,
        "open-button-aria-label": `${q(je).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : ce("", !0)
    ], 6));
  }
}), l0 = (e) => !!e.title && !!e.subtitle, o0 = { class: "lc-teaser__background" }, tr = /* @__PURE__ */ Se({
  __name: "LcTeaser",
  props: {
    bodyClass: {},
    footerClass: {},
    headerClass: {},
    headerTo: {},
    onHeaderClick: { type: Function },
    backgroundPattern: {},
    badge: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = En(), n = J(() => [
      ["lc-teaser", `lc-teaser--variant-${e.variant}`],
      {
        [`lc-teaser--background-pattern-${String(e.backgroundPattern)}`]: e.variant === "hero" && !!e.backgroundPattern,
        [`lc-teaser--variant-badge-${String(e.badge?.variant)}`]: !!e.badge,
        "lc-teaser--has-background": !!t.background
      }
    ]);
    return (r, s) => (L(), Ce(q(ya), Ee({ headerTo: e.headerTo }, {
      "body-class": ["lc-teaser__body", e.bodyClass],
      class: n.value,
      "footer-class": ["lc-teaser__footer", e.footerClass],
      "header-class": ["lc-teaser__header", e.headerClass],
      radius: "large",
      onHeaderClick: e.onHeaderClick
    }), Xa({
      default: Ie(() => [
        me(r.$slots, "default"),
        e.badge ? (L(), j(Ge, { key: 0 }, [
          q(l0)(e.badge) ? (L(), Ce(i0, At(Ee({ key: 0 }, e.badge)), null, 16)) : (L(), Ce(a0, At(Ee({ key: 1 }, e.badge)), null, 16))
        ], 64)) : ce("", !0)
      ]),
      _: 2
    }, [
      r.$slots.background ? {
        name: "background",
        fn: Ie(() => [
          ae("div", o0, [
            me(r.$slots, "background")
          ])
        ]),
        key: "0"
      } : void 0,
      r.$slots.header ? {
        name: "header",
        fn: Ie(() => [
          me(r.$slots, "header")
        ]),
        key: "1"
      } : void 0,
      r.$slots.footer ? {
        name: "footer",
        fn: Ie(() => [
          me(r.$slots, "footer")
        ]),
        key: "2"
      } : void 0
    ]), 1040, ["body-class", "class", "footer-class", "header-class", "onHeaderClick"]));
  }
}), s0 = { class: "lc-high-frequency-teaser__background" }, c0 = { class: "lc-high-frequency-teaser__jackpot-section" }, u0 = {
  key: 0,
  class: "lc-high-frequency-teaser__jackpot-headline"
}, d0 = { class: "lc-high-frequency-teaser__button-container" }, f0 = { class: "lc-high-frequency-teaser__button-wrap" }, h0 = { class: "lc-high-frequency-teaser__hint-container" }, v0 = {
  key: 0,
  class: "lc-high-frequency-teaser__hint-text"
}, cg = /* @__PURE__ */ Se({
  __name: "LcHighFrequencyTeaser",
  props: {
    backgroundPattern: {},
    badge: {},
    headline: {},
    jackpot: {},
    locale: {},
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" },
    ballConfig: {},
    hint: {}
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    En();
    const t = J(() => [
      "lc-high-frequency-teaser",
      `lc-high-frequency-teaser--variant-${e.variant}`
    ]), n = J(
      () => e.primaryButtonProps.to ? Wn(e.primaryButtonProps.to) : "div"
    );
    return (r, s) => (L(), Ce(q(tr), Ee({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-high-frequency-teaser__body",
      class: t.value,
      "footer-class": "lc-high-frequency-teaser__footer",
      "header-to": e.primaryButtonProps.to,
      onHeaderClick: e.onTeaserClick
    }), {
      background: Ie(() => [
        ae("div", s0, [
          Oe(q(Ro), At(Rt({ ballConfig: e.ballConfig })), null, 16)
        ])
      ]),
      header: Ie(() => [
        me(r.$slots, "lottery-logo")
      ]),
      default: Ie(() => [
        ae("section", c0, [
          (L(), Ce(Xt(n.value), {
            class: "lc-high-frequency-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: Ie(() => [
              e.headline ? (L(), j("strong", u0, $e(e.headline), 1)) : ce("", !0),
              Oe(q(Fo), Ee(e.jackpot, {
                "no-shadow": "",
                size: "small"
              }), null, 16)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ae("section", d0, [
          ae("div", f0, [
            me(r.$slots, "primary-button", {}, () => [
              Oe(q(St), Ee(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-high-frequency-teaser__button",
                "no-padding": "",
                onClick: s[0] || (s[0] = (i) => r.$emit("primary-button-click"))
              }), {
                default: Ie(() => [
                  yt($e(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])
            ])
          ])
        ]),
        ae("section", h0, [
          e.hint ? (L(), j("p", v0, [
            me(r.$slots, "hint", {}, () => [
              yt($e(e.hint), 1)
            ])
          ])) : ce("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class", "header-to", "onHeaderClick"]));
  }
}), m0 = {
  width: "47",
  height: "47",
  viewBox: "0 0 47 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, g0 = ["stroke"], b0 = ["stroke"], fl = "lc-high-frequency-teaser-watch-arrows-gradient-1", hl = "lc-high-frequency-teaser-watch-arrows-gradient-2", p0 = /* @__PURE__ */ Se({
  __name: "ArrowsIcon",
  setup(e) {
    return (t, n) => (L(), j("svg", m0, [
      ae("path", {
        d: "M6.29812 18.431C7.41552 14.3207 9.97378 10.7492 13.5059 8.36858C17.0381 5.98793 21.3086 4.95686 25.5378 5.46358C29.7671 5.9703 33.6731 7.98101 36.5429 11.1287C39.4127 14.2764 41.0549 18.3511 41.1696 22.6091",
        stroke: `url(#${fl})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, g0),
      n[2] || (n[2] = ae("path", {
        d: "M38.1073 20.6755L41.1265 22.9697C41.2144 23.0366 41.3399 23.0195 41.4067 22.9315L43.7009 19.9123",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ae("path", {
        d: "M40.5545 28.3175C39.3918 32.4153 36.7942 35.9583 33.236 38.2998C29.6778 40.6413 25.3962 41.6251 21.1727 41.0717C16.9493 40.5183 13.0657 38.4646 10.2309 35.2854C7.39604 32.1062 5.79899 28.0136 5.73126 23.7546",
        stroke: `url(#${hl})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, b0),
      n[3] || (n[3] = ae("path", {
        d: "M8.73274 25.8842L5.71355 23.5899C5.6256 23.5231 5.50013 23.5402 5.4333 23.6282L3.1391 26.6474",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ae("defs", null, [
        ae("linearGradient", {
          id: fl,
          x1: "35.7167",
          y1: "6.28729",
          x2: "7.80661",
          y2: "13.8312",
          gradientUnits: "userSpaceOnUse"
        }, [...n[0] || (n[0] = [
          ae("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ae("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])]),
        ae("linearGradient", {
          id: hl,
          x1: "11.0036",
          y1: "40.1356",
          x2: "38.9953",
          y2: "32.9005",
          gradientUnits: "userSpaceOnUse"
        }, [...n[1] || (n[1] = [
          ae("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ae("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), y0 = {}, w0 = {
  viewBox: "0 0 45 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function x0(e, t) {
  return L(), j("svg", w0, [...t[0] || (t[0] = [
    As('<path class="star star-1" fill-rule="evenodd" clip-rule="evenodd" d="M5.25845 10.7151C4.91385 10.5772 4.91385 10.0894 5.25845 9.95156C6.48681 9.46014 7.46014 8.48681 7.95157 7.25845C8.08943 6.91385 8.57723 6.91385 8.7151 7.25845C9.20653 8.48681 10.1799 9.46014 11.4082 9.95156C11.7528 10.0894 11.7528 10.5772 11.4082 10.7151C10.1799 11.2065 9.20653 12.1798 8.7151 13.4082C8.57723 13.7528 8.08943 13.7528 7.95157 13.4082C7.46014 12.1798 6.48681 11.2065 5.25845 10.7151Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-2" fill-rule="evenodd" clip-rule="evenodd" d="M0.155071 19.2291C-0.0516903 19.1463 -0.0516903 18.8537 0.155071 18.7709C0.892087 18.4761 1.47608 17.8921 1.77094 17.1551C1.85366 16.9483 2.14634 16.9483 2.22906 17.1551C2.52392 17.8921 3.10791 18.4761 3.84493 18.7709C4.05169 18.8537 4.05169 19.1463 3.84493 19.2291C3.10791 19.5239 2.52392 20.1079 2.22906 20.8449C2.14634 21.0517 1.85366 21.0517 1.77094 20.8449C1.47608 20.1079 0.892087 19.5239 0.155071 19.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-3" fill-rule="evenodd" clip-rule="evenodd" d="M41.1551 18.2291C40.9483 18.1463 40.9483 17.8537 41.1551 17.7709C41.8921 17.4761 42.4761 16.8921 42.7709 16.1551C42.8537 15.9483 43.1463 15.9483 43.2291 16.1551C43.5239 16.8921 44.1079 17.4761 44.8449 17.7709C45.0517 17.8537 45.0517 18.1463 44.8449 18.2291C44.1079 18.5239 43.5239 19.1079 43.2291 19.8449C43.1463 20.0517 42.8537 20.0517 42.7709 19.8449C42.4761 19.1079 41.8921 18.5239 41.1551 18.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-4" fill-rule="evenodd" clip-rule="evenodd" d="M32.2068 21.9721C31.9311 21.8618 31.9311 21.4715 32.2068 21.3613C33.1894 20.9681 33.9681 20.1894 34.3613 19.2068C34.4715 18.9311 34.8618 18.9311 34.9721 19.2068C35.3652 20.1894 36.1439 20.9681 37.1266 21.3613C37.4023 21.4715 37.4023 21.8618 37.1266 21.9721C36.1439 22.3652 35.3652 23.1439 34.9721 24.1266C34.8618 24.4022 34.4715 24.4022 34.3613 24.1266C33.9681 23.1439 33.1894 22.3652 32.2068 21.9721Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-5" fill-rule="evenodd" clip-rule="evenodd" d="M31.2068 2.97208C30.9311 2.86179 30.9311 2.47154 31.2068 2.36125C32.1894 1.96811 32.9681 1.18945 33.3613 0.206761C33.4715 -0.0689204 33.8618 -0.0689204 33.9721 0.206761C34.3652 1.18945 35.1439 1.96811 36.1266 2.36125C36.4023 2.47154 36.4023 2.86179 36.1266 2.97208C35.1439 3.36522 34.3652 4.14388 33.9721 5.12657C33.8618 5.40225 33.4715 5.40225 33.3613 5.12657C32.9681 4.14388 32.1894 3.36522 31.2068 2.97208Z" fill="currentColor" data-v-0c679bcf></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2651 4.74748C19.6333 4.10999 20.4491 3.89126 21.0867 4.2592L32.6479 10.935C33.2856 11.3032 33.5044 12.1189 33.1362 12.7566C32.7679 13.3941 31.9522 13.6129 31.3146 13.2449L31.144 13.1459L30.5047 14.2553C29.6757 15.6906 28.226 16.6584 26.5828 16.8751L24.0815 17.2045L25.0464 19.5352C25.6807 21.067 25.5666 22.8078 24.7378 24.2436L24.101 25.3464L24.2469 25.4311C24.8843 25.7994 25.102 26.6151 24.7339 27.2527C24.3657 27.89 23.5511 28.1087 22.9135 27.741L11.351 21.0652C10.7137 20.6969 10.496 19.8811 10.8641 19.2436C11.2324 18.6065 12.0469 18.3886 12.6844 18.7566L12.8354 18.8438L13.4734 17.7397C14.3024 16.3041 15.7518 15.3352 17.3953 15.1186L19.8966 14.7878L18.9318 12.4571C18.2977 10.9256 18.4117 9.18694 19.2404 7.75138L19.8797 6.64201L19.7534 6.56909C19.1157 6.20089 18.8969 5.38518 19.2651 4.74748ZM17.7443 17.7618C16.9225 17.87 16.1965 18.3552 15.782 19.073L15.1492 20.1694L21.7951 24.0066L22.4292 22.9102C22.8434 22.1925 22.901 21.3218 22.5841 20.5561L21.2365 17.3009L17.7443 17.7618ZM21.549 9.08472C21.135 9.80227 21.0773 10.6721 21.394 11.4376L22.7417 14.6928L26.2339 14.2319C27.0556 14.1236 27.7816 13.6396 28.1961 12.922L28.8289 11.8243L22.1831 7.98706L21.549 9.08472Z" fill="currentColor" data-v-0c679bcf></path>', 6)
  ])]);
}
const k0 = /* @__PURE__ */ oi(y0, [["render", x0], ["__scopeId", "data-v-0c679bcf"]]), _0 = {
  width: "48",
  height: "54",
  viewBox: "16 6 48 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, S0 = ["fill"], vl = "lc-high-frequency-teaser-watch-play-button-gradient", C0 = /* @__PURE__ */ Se({
  __name: "PlayButtonIcon",
  setup(e) {
    return (t, n) => (L(), j("svg", _0, [
      n[1] || (n[1] = ae("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        transform: "translate(2.4, 2.4)",
        fill: "var(--play-button-icon-shadow-color, #D3A700)"
      }, null, -1)),
      ae("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        fill: `url(#${vl})`
      }, null, 8, S0),
      ae("defs", null, [
        ae("radialGradient", {
          id: vl,
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(30.339 18.8727) rotate(103.105) scale(31.1141 42.8816)"
        }, [...n[0] || (n[0] = [
          ae("stop", { "stop-color": "var(--play-button-icon-color-start, #FFF5C9)" }, null, -1),
          ae("stop", {
            offset: "1",
            "stop-color": "var(--play-button-icon-color-end, #FBCD0C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), Qn = {
  SPIN_DELAY: 50,
  PAUSE_DELAY: 2550,
  LABEL_DELAY: 3350,
  IDLE_DELAY: 13350,
  IDLE_SPIN_INTERVAL: 1e4
}, E0 = { class: "lc-high-frequency-teaser-watch__background-wrapper" }, T0 = { class: "lc-high-frequency-teaser-watch__header-wrapper" }, A0 = { class: "lc-high-frequency-teaser-watch__game-badge" }, L0 = { class: "lc-high-frequency-teaser-watch__game-label" }, $0 = { class: "lc-high-frequency-teaser-watch__game-number" }, I0 = { class: "lc-high-frequency-teaser-watch__game-icon" }, D0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__pause-icon"
}, M0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__icon-area"
}, O0 = { class: "lc-high-frequency-teaser-watch__timer-value" }, R0 = { class: "lc-high-frequency-teaser-watch__timer-unit" }, F0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__new-game-label"
}, N0 = { class: "lc-high-frequency-teaser-watch__main" }, B0 = { class: "lc-high-frequency-teaser-watch__title" }, ug = /* @__PURE__ */ Se({
  __name: "LcHighFrequencyTeaserWatch",
  props: {
    ballConfig: {},
    gameLabel: {},
    gameNumber: {},
    timerValueLabel: {},
    timerUnitLabel: {},
    isOperational: { type: Boolean, default: !0 },
    title: {},
    to: {}
  },
  setup(e) {
    const t = we("idle"), n = we(e.gameNumber), r = we(!1), s = we(0), i = J(() => e.to ? Wn(e.to) : "div"), a = J(() => String(n.value).split("")), l = J(() => t.value === "spinning"), o = J(() => t.value === "idle" || l.value), h = J(() => ({
      "lc-high-frequency-teaser-watch__timer-icon--spinning": l.value
    })), v = J(() => ({
      "lc-high-frequency-teaser-watch__timer-text--hidden": l.value
    })), u = J(() => ({
      "lc-high-frequency-teaser-watch__arrows--spinning": l.value,
      "lc-high-frequency-teaser-watch__arrows--idle-spin": s.value > 0 && t.value === "idle"
    })), f = J(() => ({
      "lc-high-frequency-teaser-watch__play-button--heartbeat": r.value
    })), { pause: m, resume: c } = Us(
      () => {
        t.value === "idle" && e.isOperational && s.value++;
      },
      Qn.IDLE_SPIN_INTERVAL,
      { immediate: e.isOperational }
    ), { start: w, stop: _ } = ea(
      () => {
        t.value = "spinning";
      },
      Qn.SPIN_DELAY,
      { immediate: !1 }
    ), { start: g, stop: b } = ea(
      () => t.value = "paused",
      Qn.PAUSE_DELAY,
      { immediate: !1 }
    ), S = we(e.gameNumber), { start: E, stop: I } = ea(
      () => {
        t.value = "label", n.value = S.value, r.value = !1, requestAnimationFrame(() => {
          r.value = !0;
        });
      },
      Qn.LABEL_DELAY,
      { immediate: !1 }
    ), { start: $, stop: C } = ea(
      () => {
        t.value = "idle", r.value = !1, c();
      },
      Qn.IDLE_DELAY,
      { immediate: !1 }
    ), F = () => {
      _(), b(), I(), C();
    };
    return Ve(
      () => e.isOperational,
      (V) => {
        V ? c() : (F(), m(), t.value = "idle", r.value = !1);
      }
    ), Ve(
      () => e.gameNumber,
      (V, K) => {
        if (V === K || !e.isOperational) {
          n.value = V;
          return;
        }
        F(), m(), S.value = V, t.value = "idle", w(), g(), E(), $();
      }
    ), (V, K) => (L(), Ce(Xt(i.value), At(Rt({ to: e.to })), {
      default: Ie(() => [
        Oe(q(tr), {
          class: "lc-high-frequency-teaser-watch",
          "body-class": "lc-high-frequency-teaser-watch__body",
          "footer-class": "lc-high-frequency-teaser-watch__footer"
        }, {
          background: Ie(() => [
            ae("div", E0, [
              Oe(q(Ro), Ee({
                class: "lc-high-frequency-teaser-watch__background",
                "gradient-class": "lc-high-frequency-teaser-watch__gradient"
              }, { ballConfig: e.ballConfig }), null, 16)
            ])
          ]),
          header: Ie(() => [
            ae("div", T0, [
              ae("div", A0, [
                ae("span", L0, $e(e.gameLabel), 1),
                ae("span", $0, [
                  (L(!0), j(Ge, null, vt(a.value, (O, G) => (L(), j("span", {
                    key: `pos-${G}`,
                    class: "lc-high-frequency-teaser-watch__digit-slot"
                  }, [
                    Oe(Ls, { name: "lc-high-frequency-teaser-watch-digit" }, {
                      default: Ie(() => [
                        (L(), j("span", {
                          key: O,
                          class: "lc-high-frequency-teaser-watch__digit",
                          style: Lt({ transitionDelay: `${G * 35}ms` })
                        }, $e(O), 5))
                      ]),
                      _: 2
                    }, 1024)
                  ]))), 128))
                ])
              ]),
              ae("div", I0, [
                Oe(wn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                  default: Ie(() => [
                    e.isOperational ? ce("", !0) : (L(), j("div", D0, [
                      Oe(k0)
                    ]))
                  ]),
                  _: 1
                }),
                e.isOperational ? (L(), j("div", M0, [
                  Oe(wn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                    default: Ie(() => [
                      o.value ? (L(), j("div", {
                        key: 0,
                        class: pe(["lc-high-frequency-teaser-watch__timer-icon", h.value])
                      }, [
                        ae("span", {
                          class: pe(["lc-high-frequency-teaser-watch__timer-text", v.value])
                        }, [
                          ae("span", O0, $e(e.timerValueLabel), 1),
                          ae("span", R0, $e(e.timerUnitLabel), 1)
                        ], 2),
                        (L(), j("div", {
                          key: `arrows-${s.value}`,
                          class: pe(["lc-high-frequency-teaser-watch__arrows", u.value])
                        }, [
                          Oe(p0)
                        ], 2))
                      ], 2)) : ce("", !0)
                    ]),
                    _: 1
                  }),
                  Oe(wn, { name: "lc-high-frequency-teaser-watch-label" }, {
                    default: Ie(() => [
                      t.value === "label" ? (L(), j("div", F0, [
                        me(V.$slots, "new-game-label")
                      ])) : ce("", !0)
                    ]),
                    _: 3
                  })
                ])) : ce("", !0)
              ])
            ])
          ]),
          footer: Ie(() => [
            me(V.$slots, "message")
          ]),
          default: Ie(() => [
            ae("div", N0, [
              ae("div", {
                class: pe(["lc-high-frequency-teaser-watch__play-button", f.value])
              }, [
                Oe(C0)
              ], 2),
              ae("span", B0, $e(e.title), 1)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
});
var Fn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", P0 = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var $a = 0; $a < Fn.length; $a++)
  P0[Fn.charCodeAt($a)] = $a;
var z0 = function(e) {
  var t = new Uint8Array(e), n, r = t.length, s = "";
  for (n = 0; n < r; n += 3)
    s += Fn[t[n] >> 2], s += Fn[(t[n] & 3) << 4 | t[n + 1] >> 4], s += Fn[(t[n + 1] & 15) << 2 | t[n + 2] >> 6], s += Fn[t[n + 2] & 63];
  return r % 3 === 2 ? s = s.substring(0, s.length - 1) + "=" : r % 3 === 1 && (s = s.substring(0, s.length - 2) + "=="), s;
}, V0 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "#", "$", "%", "*", "+", ",", "-", ".", ":", ";", "=", "?", "@", "[", "]", "^", "_", "{", "|", "}", "~"], na = (e) => {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    let r = e[n], s = V0.indexOf(r);
    t = t * 83 + s;
  }
  return t;
}, wr = (e) => {
  let t = e / 255;
  return t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}, xr = (e) => {
  let t = Math.max(0, Math.min(1, e));
  return t <= 31308e-7 ? Math.trunc(t * 12.92 * 255 + 0.5) : Math.trunc((1.055 * Math.pow(t, 0.4166666666666667) - 0.055) * 255 + 0.5);
}, H0 = (e) => e < 0 ? -1 : 1, kr = (e, t) => H0(e) * Math.pow(Math.abs(e), t), ml = class extends Error {
  constructor(t) {
    super(t), this.name = "ValidationError", this.message = t;
  }
}, U0 = (e) => {
  if (!e || e.length < 6) throw new ml("The blurhash string must be at least 6 characters");
  let t = na(e[0]), n = Math.floor(t / 9) + 1, r = t % 9 + 1;
  if (e.length !== 4 + 2 * r * n) throw new ml(`blurhash length mismatch: length is ${e.length} but it should be ${4 + 2 * r * n}`);
}, q0 = (e) => {
  let t = e >> 16, n = e >> 8 & 255, r = e & 255;
  return [wr(t), wr(n), wr(r)];
}, j0 = (e, t) => {
  let n = Math.floor(e / 361), r = Math.floor(e / 19) % 19, s = e % 19;
  return [kr((n - 9) / 9, 2) * t, kr((r - 9) / 9, 2) * t, kr((s - 9) / 9, 2) * t];
}, Z0 = (e, t, n, r) => {
  U0(e), r = r | 1;
  let s = na(e[0]), i = Math.floor(s / 9) + 1, a = s % 9 + 1, l = (na(e[1]) + 1) / 166, o = new Array(a * i);
  for (let u = 0; u < o.length; u++) if (u === 0) {
    let f = na(e.substring(2, 6));
    o[u] = q0(f);
  } else {
    let f = na(e.substring(4 + u * 2, 6 + u * 2));
    o[u] = j0(f, l * r);
  }
  let h = t * 4, v = new Uint8ClampedArray(h * n);
  for (let u = 0; u < n; u++) for (let f = 0; f < t; f++) {
    let m = 0, c = 0, w = 0;
    for (let S = 0; S < i; S++) for (let E = 0; E < a; E++) {
      let I = Math.cos(Math.PI * f * E / t) * Math.cos(Math.PI * u * S / n), $ = o[E + S * a];
      m += $[0] * I, c += $[1] * I, w += $[2] * I;
    }
    let _ = xr(m), g = xr(c), b = xr(w);
    v[4 * f + 0 + u * h] = _, v[4 * f + 1 + u * h] = g, v[4 * f + 2 + u * h] = b, v[4 * f + 3 + u * h] = 255;
  }
  return v;
}, W0 = Z0;
function X0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Y0(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var _r = { exports: {} }, Sr = {}, gl;
function un() {
  return gl || (gl = 1, (function(e) {
    var t = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
    function n(i, a) {
      return Object.prototype.hasOwnProperty.call(i, a);
    }
    e.assign = function(i) {
      for (var a = Array.prototype.slice.call(arguments, 1); a.length; ) {
        var l = a.shift();
        if (l) {
          if (typeof l != "object")
            throw new TypeError(l + "must be non-object");
          for (var o in l)
            n(l, o) && (i[o] = l[o]);
        }
      }
      return i;
    }, e.shrinkBuf = function(i, a) {
      return i.length === a ? i : i.subarray ? i.subarray(0, a) : (i.length = a, i);
    };
    var r = {
      arraySet: function(i, a, l, o, h) {
        if (a.subarray && i.subarray) {
          i.set(a.subarray(l, l + o), h);
          return;
        }
        for (var v = 0; v < o; v++)
          i[h + v] = a[l + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        var a, l, o, h, v, u;
        for (o = 0, a = 0, l = i.length; a < l; a++)
          o += i[a].length;
        for (u = new Uint8Array(o), h = 0, a = 0, l = i.length; a < l; a++)
          v = i[a], u.set(v, h), h += v.length;
        return u;
      }
    }, s = {
      arraySet: function(i, a, l, o, h) {
        for (var v = 0; v < o; v++)
          i[h + v] = a[l + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        return [].concat.apply([], i);
      }
    };
    e.setTyped = function(i) {
      i ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, r)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, s));
    }, e.setTyped(t);
  })(Sr)), Sr;
}
var Mn = {}, zt = {}, mn = {}, bl;
function G0() {
  if (bl) return mn;
  bl = 1;
  var e = un(), t = 4, n = 0, r = 1, s = 2;
  function i(y) {
    for (var Y = y.length; --Y >= 0; )
      y[Y] = 0;
  }
  var a = 0, l = 1, o = 2, h = 3, v = 258, u = 29, f = 256, m = f + 1 + u, c = 30, w = 19, _ = 2 * m + 1, g = 15, b = 16, S = 7, E = 256, I = 16, $ = 17, C = 18, F = (
    /* extra bits for each length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
  ), V = (
    /* extra bits for each distance code */
    [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
  ), K = (
    /* extra bits for each bit length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
  ), O = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], G = 512, P = new Array((m + 2) * 2);
  i(P);
  var T = new Array(c * 2);
  i(T);
  var A = new Array(G);
  i(A);
  var z = new Array(v - h + 1);
  i(z);
  var U = new Array(u);
  i(U);
  var X = new Array(c);
  i(X);
  function B(y, Y, W, se, R) {
    this.static_tree = y, this.extra_bits = Y, this.extra_base = W, this.elems = se, this.max_length = R, this.has_stree = y && y.length;
  }
  var ie, H, ee;
  function ue(y, Y) {
    this.dyn_tree = y, this.max_code = 0, this.stat_desc = Y;
  }
  function ye(y) {
    return y < 256 ? A[y] : A[256 + (y >>> 7)];
  }
  function xe(y, Y) {
    y.pending_buf[y.pending++] = Y & 255, y.pending_buf[y.pending++] = Y >>> 8 & 255;
  }
  function te(y, Y, W) {
    y.bi_valid > b - W ? (y.bi_buf |= Y << y.bi_valid & 65535, xe(y, y.bi_buf), y.bi_buf = Y >> b - y.bi_valid, y.bi_valid += W - b) : (y.bi_buf |= Y << y.bi_valid & 65535, y.bi_valid += W);
  }
  function he(y, Y, W) {
    te(
      y,
      W[Y * 2],
      W[Y * 2 + 1]
      /*.Len*/
    );
  }
  function ge(y, Y) {
    var W = 0;
    do
      W |= y & 1, y >>>= 1, W <<= 1;
    while (--Y > 0);
    return W >>> 1;
  }
  function be(y) {
    y.bi_valid === 16 ? (xe(y, y.bi_buf), y.bi_buf = 0, y.bi_valid = 0) : y.bi_valid >= 8 && (y.pending_buf[y.pending++] = y.bi_buf & 255, y.bi_buf >>= 8, y.bi_valid -= 8);
  }
  function Pe(y, Y) {
    var W = Y.dyn_tree, se = Y.max_code, R = Y.stat_desc.static_tree, le = Y.stat_desc.has_stree, p = Y.stat_desc.extra_bits, fe = Y.stat_desc.extra_base, Le = Y.stat_desc.max_length, d, re, ne, x, N, Q, De = 0;
    for (x = 0; x <= g; x++)
      y.bl_count[x] = 0;
    for (W[y.heap[y.heap_max] * 2 + 1] = 0, d = y.heap_max + 1; d < _; d++)
      re = y.heap[d], x = W[W[re * 2 + 1] * 2 + 1] + 1, x > Le && (x = Le, De++), W[re * 2 + 1] = x, !(re > se) && (y.bl_count[x]++, N = 0, re >= fe && (N = p[re - fe]), Q = W[re * 2], y.opt_len += Q * (x + N), le && (y.static_len += Q * (R[re * 2 + 1] + N)));
    if (De !== 0) {
      do {
        for (x = Le - 1; y.bl_count[x] === 0; )
          x--;
        y.bl_count[x]--, y.bl_count[x + 1] += 2, y.bl_count[Le]--, De -= 2;
      } while (De > 0);
      for (x = Le; x !== 0; x--)
        for (re = y.bl_count[x]; re !== 0; )
          ne = y.heap[--d], !(ne > se) && (W[ne * 2 + 1] !== x && (y.opt_len += (x - W[ne * 2 + 1]) * W[ne * 2], W[ne * 2 + 1] = x), re--);
    }
  }
  function Ne(y, Y, W) {
    var se = new Array(g + 1), R = 0, le, p;
    for (le = 1; le <= g; le++)
      se[le] = R = R + W[le - 1] << 1;
    for (p = 0; p <= Y; p++) {
      var fe = y[p * 2 + 1];
      fe !== 0 && (y[p * 2] = ge(se[fe]++, fe));
    }
  }
  function de() {
    var y, Y, W, se, R, le = new Array(g + 1);
    for (W = 0, se = 0; se < u - 1; se++)
      for (U[se] = W, y = 0; y < 1 << F[se]; y++)
        z[W++] = se;
    for (z[W - 1] = se, R = 0, se = 0; se < 16; se++)
      for (X[se] = R, y = 0; y < 1 << V[se]; y++)
        A[R++] = se;
    for (R >>= 7; se < c; se++)
      for (X[se] = R << 7, y = 0; y < 1 << V[se] - 7; y++)
        A[256 + R++] = se;
    for (Y = 0; Y <= g; Y++)
      le[Y] = 0;
    for (y = 0; y <= 143; )
      P[y * 2 + 1] = 8, y++, le[8]++;
    for (; y <= 255; )
      P[y * 2 + 1] = 9, y++, le[9]++;
    for (; y <= 279; )
      P[y * 2 + 1] = 7, y++, le[7]++;
    for (; y <= 287; )
      P[y * 2 + 1] = 8, y++, le[8]++;
    for (Ne(P, m + 1, le), y = 0; y < c; y++)
      T[y * 2 + 1] = 5, T[y * 2] = ge(y, 5);
    ie = new B(P, F, f + 1, m, g), H = new B(T, V, 0, c, g), ee = new B(new Array(0), K, 0, w, S);
  }
  function Re(y) {
    var Y;
    for (Y = 0; Y < m; Y++)
      y.dyn_ltree[Y * 2] = 0;
    for (Y = 0; Y < c; Y++)
      y.dyn_dtree[Y * 2] = 0;
    for (Y = 0; Y < w; Y++)
      y.bl_tree[Y * 2] = 0;
    y.dyn_ltree[E * 2] = 1, y.opt_len = y.static_len = 0, y.last_lit = y.matches = 0;
  }
  function He(y) {
    y.bi_valid > 8 ? xe(y, y.bi_buf) : y.bi_valid > 0 && (y.pending_buf[y.pending++] = y.bi_buf), y.bi_buf = 0, y.bi_valid = 0;
  }
  function Ze(y, Y, W, se) {
    He(y), xe(y, W), xe(y, ~W), e.arraySet(y.pending_buf, y.window, Y, W, y.pending), y.pending += W;
  }
  function We(y, Y, W, se) {
    var R = Y * 2, le = W * 2;
    return y[R] < y[le] || y[R] === y[le] && se[Y] <= se[W];
  }
  function Be(y, Y, W) {
    for (var se = y.heap[W], R = W << 1; R <= y.heap_len && (R < y.heap_len && We(Y, y.heap[R + 1], y.heap[R], y.depth) && R++, !We(Y, se, y.heap[R], y.depth)); )
      y.heap[W] = y.heap[R], W = R, R <<= 1;
    y.heap[W] = se;
  }
  function Fe(y, Y, W) {
    var se, R, le = 0, p, fe;
    if (y.last_lit !== 0)
      do
        se = y.pending_buf[y.d_buf + le * 2] << 8 | y.pending_buf[y.d_buf + le * 2 + 1], R = y.pending_buf[y.l_buf + le], le++, se === 0 ? he(y, R, Y) : (p = z[R], he(y, p + f + 1, Y), fe = F[p], fe !== 0 && (R -= U[p], te(y, R, fe)), se--, p = ye(se), he(y, p, W), fe = V[p], fe !== 0 && (se -= X[p], te(y, se, fe)));
      while (le < y.last_lit);
    he(y, E, Y);
  }
  function Ye(y, Y) {
    var W = Y.dyn_tree, se = Y.stat_desc.static_tree, R = Y.stat_desc.has_stree, le = Y.stat_desc.elems, p, fe, Le = -1, d;
    for (y.heap_len = 0, y.heap_max = _, p = 0; p < le; p++)
      W[p * 2] !== 0 ? (y.heap[++y.heap_len] = Le = p, y.depth[p] = 0) : W[p * 2 + 1] = 0;
    for (; y.heap_len < 2; )
      d = y.heap[++y.heap_len] = Le < 2 ? ++Le : 0, W[d * 2] = 1, y.depth[d] = 0, y.opt_len--, R && (y.static_len -= se[d * 2 + 1]);
    for (Y.max_code = Le, p = y.heap_len >> 1; p >= 1; p--)
      Be(y, W, p);
    d = le;
    do
      p = y.heap[
        1
        /*SMALLEST*/
      ], y.heap[
        1
        /*SMALLEST*/
      ] = y.heap[y.heap_len--], Be(
        y,
        W,
        1
        /*SMALLEST*/
      ), fe = y.heap[
        1
        /*SMALLEST*/
      ], y.heap[--y.heap_max] = p, y.heap[--y.heap_max] = fe, W[d * 2] = W[p * 2] + W[fe * 2], y.depth[d] = (y.depth[p] >= y.depth[fe] ? y.depth[p] : y.depth[fe]) + 1, W[p * 2 + 1] = W[fe * 2 + 1] = d, y.heap[
        1
        /*SMALLEST*/
      ] = d++, Be(
        y,
        W,
        1
        /*SMALLEST*/
      );
    while (y.heap_len >= 2);
    y.heap[--y.heap_max] = y.heap[
      1
      /*SMALLEST*/
    ], Pe(y, Y), Ne(W, Le, y.bl_count);
  }
  function st(y, Y, W) {
    var se, R = -1, le, p = Y[1], fe = 0, Le = 7, d = 4;
    for (p === 0 && (Le = 138, d = 3), Y[(W + 1) * 2 + 1] = 65535, se = 0; se <= W; se++)
      le = p, p = Y[(se + 1) * 2 + 1], !(++fe < Le && le === p) && (fe < d ? y.bl_tree[le * 2] += fe : le !== 0 ? (le !== R && y.bl_tree[le * 2]++, y.bl_tree[I * 2]++) : fe <= 10 ? y.bl_tree[$ * 2]++ : y.bl_tree[C * 2]++, fe = 0, R = le, p === 0 ? (Le = 138, d = 3) : le === p ? (Le = 6, d = 3) : (Le = 7, d = 4));
  }
  function mt(y, Y, W) {
    var se, R = -1, le, p = Y[1], fe = 0, Le = 7, d = 4;
    for (p === 0 && (Le = 138, d = 3), se = 0; se <= W; se++)
      if (le = p, p = Y[(se + 1) * 2 + 1], !(++fe < Le && le === p)) {
        if (fe < d)
          do
            he(y, le, y.bl_tree);
          while (--fe !== 0);
        else le !== 0 ? (le !== R && (he(y, le, y.bl_tree), fe--), he(y, I, y.bl_tree), te(y, fe - 3, 2)) : fe <= 10 ? (he(y, $, y.bl_tree), te(y, fe - 3, 3)) : (he(y, C, y.bl_tree), te(y, fe - 11, 7));
        fe = 0, R = le, p === 0 ? (Le = 138, d = 3) : le === p ? (Le = 6, d = 3) : (Le = 7, d = 4);
      }
  }
  function gt(y) {
    var Y;
    for (st(y, y.dyn_ltree, y.l_desc.max_code), st(y, y.dyn_dtree, y.d_desc.max_code), Ye(y, y.bl_desc), Y = w - 1; Y >= 3 && y.bl_tree[O[Y] * 2 + 1] === 0; Y--)
      ;
    return y.opt_len += 3 * (Y + 1) + 5 + 5 + 4, Y;
  }
  function Ft(y, Y, W, se) {
    var R;
    for (te(y, Y - 257, 5), te(y, W - 1, 5), te(y, se - 4, 4), R = 0; R < se; R++)
      te(y, y.bl_tree[O[R] * 2 + 1], 3);
    mt(y, y.dyn_ltree, Y - 1), mt(y, y.dyn_dtree, W - 1);
  }
  function Mt(y) {
    var Y = 4093624447, W;
    for (W = 0; W <= 31; W++, Y >>>= 1)
      if (Y & 1 && y.dyn_ltree[W * 2] !== 0)
        return n;
    if (y.dyn_ltree[18] !== 0 || y.dyn_ltree[20] !== 0 || y.dyn_ltree[26] !== 0)
      return r;
    for (W = 32; W < f; W++)
      if (y.dyn_ltree[W * 2] !== 0)
        return r;
    return n;
  }
  var xt = !1;
  function Ut(y) {
    xt || (de(), xt = !0), y.l_desc = new ue(y.dyn_ltree, ie), y.d_desc = new ue(y.dyn_dtree, H), y.bl_desc = new ue(y.bl_tree, ee), y.bi_buf = 0, y.bi_valid = 0, Re(y);
  }
  function $t(y, Y, W, se) {
    te(y, (a << 1) + (se ? 1 : 0), 3), Ze(y, Y, W);
  }
  function ct(y) {
    te(y, l << 1, 3), he(y, E, P), be(y);
  }
  function D(y, Y, W, se) {
    var R, le, p = 0;
    y.level > 0 ? (y.strm.data_type === s && (y.strm.data_type = Mt(y)), Ye(y, y.l_desc), Ye(y, y.d_desc), p = gt(y), R = y.opt_len + 3 + 7 >>> 3, le = y.static_len + 3 + 7 >>> 3, le <= R && (R = le)) : R = le = W + 5, W + 4 <= R && Y !== -1 ? $t(y, Y, W, se) : y.strategy === t || le === R ? (te(y, (l << 1) + (se ? 1 : 0), 3), Fe(y, P, T)) : (te(y, (o << 1) + (se ? 1 : 0), 3), Ft(y, y.l_desc.max_code + 1, y.d_desc.max_code + 1, p + 1), Fe(y, y.dyn_ltree, y.dyn_dtree)), Re(y), se && He(y);
  }
  function k(y, Y, W) {
    return y.pending_buf[y.d_buf + y.last_lit * 2] = Y >>> 8 & 255, y.pending_buf[y.d_buf + y.last_lit * 2 + 1] = Y & 255, y.pending_buf[y.l_buf + y.last_lit] = W & 255, y.last_lit++, Y === 0 ? y.dyn_ltree[W * 2]++ : (y.matches++, Y--, y.dyn_ltree[(z[W] + f + 1) * 2]++, y.dyn_dtree[ye(Y) * 2]++), y.last_lit === y.lit_bufsize - 1;
  }
  return mn._tr_init = Ut, mn._tr_stored_block = $t, mn._tr_flush_block = D, mn._tr_tally = k, mn._tr_align = ct, mn;
}
var Cr, pl;
function Vo() {
  if (pl) return Cr;
  pl = 1;
  function e(t, n, r, s) {
    for (var i = t & 65535 | 0, a = t >>> 16 & 65535 | 0, l = 0; r !== 0; ) {
      l = r > 2e3 ? 2e3 : r, r -= l;
      do
        i = i + n[s++] | 0, a = a + i | 0;
      while (--l);
      i %= 65521, a %= 65521;
    }
    return i | a << 16 | 0;
  }
  return Cr = e, Cr;
}
var Er, yl;
function Ho() {
  if (yl) return Er;
  yl = 1;
  function e() {
    for (var r, s = [], i = 0; i < 256; i++) {
      r = i;
      for (var a = 0; a < 8; a++)
        r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
      s[i] = r;
    }
    return s;
  }
  var t = e();
  function n(r, s, i, a) {
    var l = t, o = a + i;
    r ^= -1;
    for (var h = a; h < o; h++)
      r = r >>> 8 ^ l[(r ^ s[h]) & 255];
    return r ^ -1;
  }
  return Er = n, Er;
}
var Tr, wl;
function hi() {
  return wl || (wl = 1, Tr = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */
    1: "stream end",
    /* Z_STREAM_END      1  */
    0: "",
    /* Z_OK              0  */
    "-1": "file error",
    /* Z_ERRNO         (-1) */
    "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */
    "-3": "data error",
    /* Z_DATA_ERROR    (-3) */
    "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */
    "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */
    "-6": "incompatible version"
    /* Z_VERSION_ERROR (-6) */
  }), Tr;
}
var xl;
function K0() {
  if (xl) return zt;
  xl = 1;
  var e = un(), t = G0(), n = Vo(), r = Ho(), s = hi(), i = 0, a = 1, l = 3, o = 4, h = 5, v = 0, u = 1, f = -2, m = -3, c = -5, w = -1, _ = 1, g = 2, b = 3, S = 4, E = 0, I = 2, $ = 8, C = 9, F = 15, V = 8, K = 29, O = 256, G = O + 1 + K, P = 30, T = 19, A = 2 * G + 1, z = 15, U = 3, X = 258, B = X + U + 1, ie = 32, H = 42, ee = 69, ue = 73, ye = 91, xe = 103, te = 113, he = 666, ge = 1, be = 2, Pe = 3, Ne = 4, de = 3;
  function Re(d, re) {
    return d.msg = s[re], re;
  }
  function He(d) {
    return (d << 1) - (d > 4 ? 9 : 0);
  }
  function Ze(d) {
    for (var re = d.length; --re >= 0; )
      d[re] = 0;
  }
  function We(d) {
    var re = d.state, ne = re.pending;
    ne > d.avail_out && (ne = d.avail_out), ne !== 0 && (e.arraySet(d.output, re.pending_buf, re.pending_out, ne, d.next_out), d.next_out += ne, re.pending_out += ne, d.total_out += ne, d.avail_out -= ne, re.pending -= ne, re.pending === 0 && (re.pending_out = 0));
  }
  function Be(d, re) {
    t._tr_flush_block(d, d.block_start >= 0 ? d.block_start : -1, d.strstart - d.block_start, re), d.block_start = d.strstart, We(d.strm);
  }
  function Fe(d, re) {
    d.pending_buf[d.pending++] = re;
  }
  function Ye(d, re) {
    d.pending_buf[d.pending++] = re >>> 8 & 255, d.pending_buf[d.pending++] = re & 255;
  }
  function st(d, re, ne, x) {
    var N = d.avail_in;
    return N > x && (N = x), N === 0 ? 0 : (d.avail_in -= N, e.arraySet(re, d.input, d.next_in, N, ne), d.state.wrap === 1 ? d.adler = n(d.adler, re, N, ne) : d.state.wrap === 2 && (d.adler = r(d.adler, re, N, ne)), d.next_in += N, d.total_in += N, N);
  }
  function mt(d, re) {
    var ne = d.max_chain_length, x = d.strstart, N, Q, De = d.prev_length, ke = d.nice_match, Te = d.strstart > d.w_size - B ? d.strstart - (d.w_size - B) : 0, Ue = d.window, ft = d.w_mask, et = d.prev, qe = d.strstart + X, it = Ue[x + De - 1], bt = Ue[x + De];
    d.prev_length >= d.good_match && (ne >>= 2), ke > d.lookahead && (ke = d.lookahead);
    do
      if (N = re, !(Ue[N + De] !== bt || Ue[N + De - 1] !== it || Ue[N] !== Ue[x] || Ue[++N] !== Ue[x + 1])) {
        x += 2, N++;
        do
          ;
        while (Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && x < qe);
        if (Q = X - (qe - x), x = qe - X, Q > De) {
          if (d.match_start = re, De = Q, Q >= ke)
            break;
          it = Ue[x + De - 1], bt = Ue[x + De];
        }
      }
    while ((re = et[re & ft]) > Te && --ne !== 0);
    return De <= d.lookahead ? De : d.lookahead;
  }
  function gt(d) {
    var re = d.w_size, ne, x, N, Q, De;
    do {
      if (Q = d.window_size - d.lookahead - d.strstart, d.strstart >= re + (re - B)) {
        e.arraySet(d.window, d.window, re, re, 0), d.match_start -= re, d.strstart -= re, d.block_start -= re, x = d.hash_size, ne = x;
        do
          N = d.head[--ne], d.head[ne] = N >= re ? N - re : 0;
        while (--x);
        x = re, ne = x;
        do
          N = d.prev[--ne], d.prev[ne] = N >= re ? N - re : 0;
        while (--x);
        Q += re;
      }
      if (d.strm.avail_in === 0)
        break;
      if (x = st(d.strm, d.window, d.strstart + d.lookahead, Q), d.lookahead += x, d.lookahead + d.insert >= U)
        for (De = d.strstart - d.insert, d.ins_h = d.window[De], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[De + 1]) & d.hash_mask; d.insert && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[De + U - 1]) & d.hash_mask, d.prev[De & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = De, De++, d.insert--, !(d.lookahead + d.insert < U)); )
          ;
    } while (d.lookahead < B && d.strm.avail_in !== 0);
  }
  function Ft(d, re) {
    var ne = 65535;
    for (ne > d.pending_buf_size - 5 && (ne = d.pending_buf_size - 5); ; ) {
      if (d.lookahead <= 1) {
        if (gt(d), d.lookahead === 0 && re === i)
          return ge;
        if (d.lookahead === 0)
          break;
      }
      d.strstart += d.lookahead, d.lookahead = 0;
      var x = d.block_start + ne;
      if ((d.strstart === 0 || d.strstart >= x) && (d.lookahead = d.strstart - x, d.strstart = x, Be(d, !1), d.strm.avail_out === 0) || d.strstart - d.block_start >= d.w_size - B && (Be(d, !1), d.strm.avail_out === 0))
        return ge;
    }
    return d.insert = 0, re === o ? (Be(d, !0), d.strm.avail_out === 0 ? Pe : Ne) : (d.strstart > d.block_start && (Be(d, !1), d.strm.avail_out === 0), ge);
  }
  function Mt(d, re) {
    for (var ne, x; ; ) {
      if (d.lookahead < B) {
        if (gt(d), d.lookahead < B && re === i)
          return ge;
        if (d.lookahead === 0)
          break;
      }
      if (ne = 0, d.lookahead >= U && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + U - 1]) & d.hash_mask, ne = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), ne !== 0 && d.strstart - ne <= d.w_size - B && (d.match_length = mt(d, ne)), d.match_length >= U)
        if (x = t._tr_tally(d, d.strstart - d.match_start, d.match_length - U), d.lookahead -= d.match_length, d.match_length <= d.max_lazy_match && d.lookahead >= U) {
          d.match_length--;
          do
            d.strstart++, d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + U - 1]) & d.hash_mask, ne = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart;
          while (--d.match_length !== 0);
          d.strstart++;
        } else
          d.strstart += d.match_length, d.match_length = 0, d.ins_h = d.window[d.strstart], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + 1]) & d.hash_mask;
      else
        x = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++;
      if (x && (Be(d, !1), d.strm.avail_out === 0))
        return ge;
    }
    return d.insert = d.strstart < U - 1 ? d.strstart : U - 1, re === o ? (Be(d, !0), d.strm.avail_out === 0 ? Pe : Ne) : d.last_lit && (Be(d, !1), d.strm.avail_out === 0) ? ge : be;
  }
  function xt(d, re) {
    for (var ne, x, N; ; ) {
      if (d.lookahead < B) {
        if (gt(d), d.lookahead < B && re === i)
          return ge;
        if (d.lookahead === 0)
          break;
      }
      if (ne = 0, d.lookahead >= U && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + U - 1]) & d.hash_mask, ne = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), d.prev_length = d.match_length, d.prev_match = d.match_start, d.match_length = U - 1, ne !== 0 && d.prev_length < d.max_lazy_match && d.strstart - ne <= d.w_size - B && (d.match_length = mt(d, ne), d.match_length <= 5 && (d.strategy === _ || d.match_length === U && d.strstart - d.match_start > 4096) && (d.match_length = U - 1)), d.prev_length >= U && d.match_length <= d.prev_length) {
        N = d.strstart + d.lookahead - U, x = t._tr_tally(d, d.strstart - 1 - d.prev_match, d.prev_length - U), d.lookahead -= d.prev_length - 1, d.prev_length -= 2;
        do
          ++d.strstart <= N && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + U - 1]) & d.hash_mask, ne = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart);
        while (--d.prev_length !== 0);
        if (d.match_available = 0, d.match_length = U - 1, d.strstart++, x && (Be(d, !1), d.strm.avail_out === 0))
          return ge;
      } else if (d.match_available) {
        if (x = t._tr_tally(d, 0, d.window[d.strstart - 1]), x && Be(d, !1), d.strstart++, d.lookahead--, d.strm.avail_out === 0)
          return ge;
      } else
        d.match_available = 1, d.strstart++, d.lookahead--;
    }
    return d.match_available && (x = t._tr_tally(d, 0, d.window[d.strstart - 1]), d.match_available = 0), d.insert = d.strstart < U - 1 ? d.strstart : U - 1, re === o ? (Be(d, !0), d.strm.avail_out === 0 ? Pe : Ne) : d.last_lit && (Be(d, !1), d.strm.avail_out === 0) ? ge : be;
  }
  function Ut(d, re) {
    for (var ne, x, N, Q, De = d.window; ; ) {
      if (d.lookahead <= X) {
        if (gt(d), d.lookahead <= X && re === i)
          return ge;
        if (d.lookahead === 0)
          break;
      }
      if (d.match_length = 0, d.lookahead >= U && d.strstart > 0 && (N = d.strstart - 1, x = De[N], x === De[++N] && x === De[++N] && x === De[++N])) {
        Q = d.strstart + X;
        do
          ;
        while (x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && N < Q);
        d.match_length = X - (Q - N), d.match_length > d.lookahead && (d.match_length = d.lookahead);
      }
      if (d.match_length >= U ? (ne = t._tr_tally(d, 1, d.match_length - U), d.lookahead -= d.match_length, d.strstart += d.match_length, d.match_length = 0) : (ne = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++), ne && (Be(d, !1), d.strm.avail_out === 0))
        return ge;
    }
    return d.insert = 0, re === o ? (Be(d, !0), d.strm.avail_out === 0 ? Pe : Ne) : d.last_lit && (Be(d, !1), d.strm.avail_out === 0) ? ge : be;
  }
  function $t(d, re) {
    for (var ne; ; ) {
      if (d.lookahead === 0 && (gt(d), d.lookahead === 0)) {
        if (re === i)
          return ge;
        break;
      }
      if (d.match_length = 0, ne = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++, ne && (Be(d, !1), d.strm.avail_out === 0))
        return ge;
    }
    return d.insert = 0, re === o ? (Be(d, !0), d.strm.avail_out === 0 ? Pe : Ne) : d.last_lit && (Be(d, !1), d.strm.avail_out === 0) ? ge : be;
  }
  function ct(d, re, ne, x, N) {
    this.good_length = d, this.max_lazy = re, this.nice_length = ne, this.max_chain = x, this.func = N;
  }
  var D;
  D = [
    /*      good lazy nice chain */
    new ct(0, 0, 0, 0, Ft),
    /* 0 store only */
    new ct(4, 4, 8, 4, Mt),
    /* 1 max speed, no lazy matches */
    new ct(4, 5, 16, 8, Mt),
    /* 2 */
    new ct(4, 6, 32, 32, Mt),
    /* 3 */
    new ct(4, 4, 16, 16, xt),
    /* 4 lazy matches */
    new ct(8, 16, 32, 32, xt),
    /* 5 */
    new ct(8, 16, 128, 128, xt),
    /* 6 */
    new ct(8, 32, 128, 256, xt),
    /* 7 */
    new ct(32, 128, 258, 1024, xt),
    /* 8 */
    new ct(32, 258, 258, 4096, xt)
    /* 9 max compression */
  ];
  function k(d) {
    d.window_size = 2 * d.w_size, Ze(d.head), d.max_lazy_match = D[d.level].max_lazy, d.good_match = D[d.level].good_length, d.nice_match = D[d.level].nice_length, d.max_chain_length = D[d.level].max_chain, d.strstart = 0, d.block_start = 0, d.lookahead = 0, d.insert = 0, d.match_length = d.prev_length = U - 1, d.match_available = 0, d.ins_h = 0;
  }
  function y() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = $, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new e.Buf16(A * 2), this.dyn_dtree = new e.Buf16((2 * P + 1) * 2), this.bl_tree = new e.Buf16((2 * T + 1) * 2), Ze(this.dyn_ltree), Ze(this.dyn_dtree), Ze(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new e.Buf16(z + 1), this.heap = new e.Buf16(2 * G + 1), Ze(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new e.Buf16(2 * G + 1), Ze(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function Y(d) {
    var re;
    return !d || !d.state ? Re(d, f) : (d.total_in = d.total_out = 0, d.data_type = I, re = d.state, re.pending = 0, re.pending_out = 0, re.wrap < 0 && (re.wrap = -re.wrap), re.status = re.wrap ? H : te, d.adler = re.wrap === 2 ? 0 : 1, re.last_flush = i, t._tr_init(re), v);
  }
  function W(d) {
    var re = Y(d);
    return re === v && k(d.state), re;
  }
  function se(d, re) {
    return !d || !d.state || d.state.wrap !== 2 ? f : (d.state.gzhead = re, v);
  }
  function R(d, re, ne, x, N, Q) {
    if (!d)
      return f;
    var De = 1;
    if (re === w && (re = 6), x < 0 ? (De = 0, x = -x) : x > 15 && (De = 2, x -= 16), N < 1 || N > C || ne !== $ || x < 8 || x > 15 || re < 0 || re > 9 || Q < 0 || Q > S)
      return Re(d, f);
    x === 8 && (x = 9);
    var ke = new y();
    return d.state = ke, ke.strm = d, ke.wrap = De, ke.gzhead = null, ke.w_bits = x, ke.w_size = 1 << ke.w_bits, ke.w_mask = ke.w_size - 1, ke.hash_bits = N + 7, ke.hash_size = 1 << ke.hash_bits, ke.hash_mask = ke.hash_size - 1, ke.hash_shift = ~~((ke.hash_bits + U - 1) / U), ke.window = new e.Buf8(ke.w_size * 2), ke.head = new e.Buf16(ke.hash_size), ke.prev = new e.Buf16(ke.w_size), ke.lit_bufsize = 1 << N + 6, ke.pending_buf_size = ke.lit_bufsize * 4, ke.pending_buf = new e.Buf8(ke.pending_buf_size), ke.d_buf = 1 * ke.lit_bufsize, ke.l_buf = 3 * ke.lit_bufsize, ke.level = re, ke.strategy = Q, ke.method = ne, W(d);
  }
  function le(d, re) {
    return R(d, re, $, F, V, E);
  }
  function p(d, re) {
    var ne, x, N, Q;
    if (!d || !d.state || re > h || re < 0)
      return d ? Re(d, f) : f;
    if (x = d.state, !d.output || !d.input && d.avail_in !== 0 || x.status === he && re !== o)
      return Re(d, d.avail_out === 0 ? c : f);
    if (x.strm = d, ne = x.last_flush, x.last_flush = re, x.status === H)
      if (x.wrap === 2)
        d.adler = 0, Fe(x, 31), Fe(x, 139), Fe(x, 8), x.gzhead ? (Fe(
          x,
          (x.gzhead.text ? 1 : 0) + (x.gzhead.hcrc ? 2 : 0) + (x.gzhead.extra ? 4 : 0) + (x.gzhead.name ? 8 : 0) + (x.gzhead.comment ? 16 : 0)
        ), Fe(x, x.gzhead.time & 255), Fe(x, x.gzhead.time >> 8 & 255), Fe(x, x.gzhead.time >> 16 & 255), Fe(x, x.gzhead.time >> 24 & 255), Fe(x, x.level === 9 ? 2 : x.strategy >= g || x.level < 2 ? 4 : 0), Fe(x, x.gzhead.os & 255), x.gzhead.extra && x.gzhead.extra.length && (Fe(x, x.gzhead.extra.length & 255), Fe(x, x.gzhead.extra.length >> 8 & 255)), x.gzhead.hcrc && (d.adler = r(d.adler, x.pending_buf, x.pending, 0)), x.gzindex = 0, x.status = ee) : (Fe(x, 0), Fe(x, 0), Fe(x, 0), Fe(x, 0), Fe(x, 0), Fe(x, x.level === 9 ? 2 : x.strategy >= g || x.level < 2 ? 4 : 0), Fe(x, de), x.status = te);
      else {
        var De = $ + (x.w_bits - 8 << 4) << 8, ke = -1;
        x.strategy >= g || x.level < 2 ? ke = 0 : x.level < 6 ? ke = 1 : x.level === 6 ? ke = 2 : ke = 3, De |= ke << 6, x.strstart !== 0 && (De |= ie), De += 31 - De % 31, x.status = te, Ye(x, De), x.strstart !== 0 && (Ye(x, d.adler >>> 16), Ye(x, d.adler & 65535)), d.adler = 1;
      }
    if (x.status === ee)
      if (x.gzhead.extra) {
        for (N = x.pending; x.gzindex < (x.gzhead.extra.length & 65535) && !(x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), We(d), N = x.pending, x.pending === x.pending_buf_size)); )
          Fe(x, x.gzhead.extra[x.gzindex] & 255), x.gzindex++;
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), x.gzindex === x.gzhead.extra.length && (x.gzindex = 0, x.status = ue);
      } else
        x.status = ue;
    if (x.status === ue)
      if (x.gzhead.name) {
        N = x.pending;
        do {
          if (x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), We(d), N = x.pending, x.pending === x.pending_buf_size)) {
            Q = 1;
            break;
          }
          x.gzindex < x.gzhead.name.length ? Q = x.gzhead.name.charCodeAt(x.gzindex++) & 255 : Q = 0, Fe(x, Q);
        } while (Q !== 0);
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), Q === 0 && (x.gzindex = 0, x.status = ye);
      } else
        x.status = ye;
    if (x.status === ye)
      if (x.gzhead.comment) {
        N = x.pending;
        do {
          if (x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), We(d), N = x.pending, x.pending === x.pending_buf_size)) {
            Q = 1;
            break;
          }
          x.gzindex < x.gzhead.comment.length ? Q = x.gzhead.comment.charCodeAt(x.gzindex++) & 255 : Q = 0, Fe(x, Q);
        } while (Q !== 0);
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), Q === 0 && (x.status = xe);
      } else
        x.status = xe;
    if (x.status === xe && (x.gzhead.hcrc ? (x.pending + 2 > x.pending_buf_size && We(d), x.pending + 2 <= x.pending_buf_size && (Fe(x, d.adler & 255), Fe(x, d.adler >> 8 & 255), d.adler = 0, x.status = te)) : x.status = te), x.pending !== 0) {
      if (We(d), d.avail_out === 0)
        return x.last_flush = -1, v;
    } else if (d.avail_in === 0 && He(re) <= He(ne) && re !== o)
      return Re(d, c);
    if (x.status === he && d.avail_in !== 0)
      return Re(d, c);
    if (d.avail_in !== 0 || x.lookahead !== 0 || re !== i && x.status !== he) {
      var Te = x.strategy === g ? $t(x, re) : x.strategy === b ? Ut(x, re) : D[x.level].func(x, re);
      if ((Te === Pe || Te === Ne) && (x.status = he), Te === ge || Te === Pe)
        return d.avail_out === 0 && (x.last_flush = -1), v;
      if (Te === be && (re === a ? t._tr_align(x) : re !== h && (t._tr_stored_block(x, 0, 0, !1), re === l && (Ze(x.head), x.lookahead === 0 && (x.strstart = 0, x.block_start = 0, x.insert = 0))), We(d), d.avail_out === 0))
        return x.last_flush = -1, v;
    }
    return re !== o ? v : x.wrap <= 0 ? u : (x.wrap === 2 ? (Fe(x, d.adler & 255), Fe(x, d.adler >> 8 & 255), Fe(x, d.adler >> 16 & 255), Fe(x, d.adler >> 24 & 255), Fe(x, d.total_in & 255), Fe(x, d.total_in >> 8 & 255), Fe(x, d.total_in >> 16 & 255), Fe(x, d.total_in >> 24 & 255)) : (Ye(x, d.adler >>> 16), Ye(x, d.adler & 65535)), We(d), x.wrap > 0 && (x.wrap = -x.wrap), x.pending !== 0 ? v : u);
  }
  function fe(d) {
    var re;
    return !d || !d.state ? f : (re = d.state.status, re !== H && re !== ee && re !== ue && re !== ye && re !== xe && re !== te && re !== he ? Re(d, f) : (d.state = null, re === te ? Re(d, m) : v));
  }
  function Le(d, re) {
    var ne = re.length, x, N, Q, De, ke, Te, Ue, ft;
    if (!d || !d.state || (x = d.state, De = x.wrap, De === 2 || De === 1 && x.status !== H || x.lookahead))
      return f;
    for (De === 1 && (d.adler = n(d.adler, re, ne, 0)), x.wrap = 0, ne >= x.w_size && (De === 0 && (Ze(x.head), x.strstart = 0, x.block_start = 0, x.insert = 0), ft = new e.Buf8(x.w_size), e.arraySet(ft, re, ne - x.w_size, x.w_size, 0), re = ft, ne = x.w_size), ke = d.avail_in, Te = d.next_in, Ue = d.input, d.avail_in = ne, d.next_in = 0, d.input = re, gt(x); x.lookahead >= U; ) {
      N = x.strstart, Q = x.lookahead - (U - 1);
      do
        x.ins_h = (x.ins_h << x.hash_shift ^ x.window[N + U - 1]) & x.hash_mask, x.prev[N & x.w_mask] = x.head[x.ins_h], x.head[x.ins_h] = N, N++;
      while (--Q);
      x.strstart = N, x.lookahead = U - 1, gt(x);
    }
    return x.strstart += x.lookahead, x.block_start = x.strstart, x.insert = x.lookahead, x.lookahead = 0, x.match_length = x.prev_length = U - 1, x.match_available = 0, d.next_in = Te, d.input = Ue, d.avail_in = ke, x.wrap = De, v;
  }
  return zt.deflateInit = le, zt.deflateInit2 = R, zt.deflateReset = W, zt.deflateResetKeep = Y, zt.deflateSetHeader = se, zt.deflate = p, zt.deflateEnd = fe, zt.deflateSetDictionary = Le, zt.deflateInfo = "pako deflate (from Nodeca project)", zt;
}
var gn = {}, kl;
function Uo() {
  if (kl) return gn;
  kl = 1;
  var e = un(), t = !0, n = !0;
  try {
    String.fromCharCode.apply(null, [0]);
  } catch {
    t = !1;
  }
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    n = !1;
  }
  for (var r = new e.Buf8(256), s = 0; s < 256; s++)
    r[s] = s >= 252 ? 6 : s >= 248 ? 5 : s >= 240 ? 4 : s >= 224 ? 3 : s >= 192 ? 2 : 1;
  r[254] = r[254] = 1, gn.string2buf = function(a) {
    var l, o, h, v, u, f = a.length, m = 0;
    for (v = 0; v < f; v++)
      o = a.charCodeAt(v), (o & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (o = 65536 + (o - 55296 << 10) + (h - 56320), v++)), m += o < 128 ? 1 : o < 2048 ? 2 : o < 65536 ? 3 : 4;
    for (l = new e.Buf8(m), u = 0, v = 0; u < m; v++)
      o = a.charCodeAt(v), (o & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (o = 65536 + (o - 55296 << 10) + (h - 56320), v++)), o < 128 ? l[u++] = o : o < 2048 ? (l[u++] = 192 | o >>> 6, l[u++] = 128 | o & 63) : o < 65536 ? (l[u++] = 224 | o >>> 12, l[u++] = 128 | o >>> 6 & 63, l[u++] = 128 | o & 63) : (l[u++] = 240 | o >>> 18, l[u++] = 128 | o >>> 12 & 63, l[u++] = 128 | o >>> 6 & 63, l[u++] = 128 | o & 63);
    return l;
  };
  function i(a, l) {
    if (l < 65534 && (a.subarray && n || !a.subarray && t))
      return String.fromCharCode.apply(null, e.shrinkBuf(a, l));
    for (var o = "", h = 0; h < l; h++)
      o += String.fromCharCode(a[h]);
    return o;
  }
  return gn.buf2binstring = function(a) {
    return i(a, a.length);
  }, gn.binstring2buf = function(a) {
    for (var l = new e.Buf8(a.length), o = 0, h = l.length; o < h; o++)
      l[o] = a.charCodeAt(o);
    return l;
  }, gn.buf2string = function(a, l) {
    var o, h, v, u, f = l || a.length, m = new Array(f * 2);
    for (h = 0, o = 0; o < f; ) {
      if (v = a[o++], v < 128) {
        m[h++] = v;
        continue;
      }
      if (u = r[v], u > 4) {
        m[h++] = 65533, o += u - 1;
        continue;
      }
      for (v &= u === 2 ? 31 : u === 3 ? 15 : 7; u > 1 && o < f; )
        v = v << 6 | a[o++] & 63, u--;
      if (u > 1) {
        m[h++] = 65533;
        continue;
      }
      v < 65536 ? m[h++] = v : (v -= 65536, m[h++] = 55296 | v >> 10 & 1023, m[h++] = 56320 | v & 1023);
    }
    return i(m, h);
  }, gn.utf8border = function(a, l) {
    var o;
    for (l = l || a.length, l > a.length && (l = a.length), o = l - 1; o >= 0 && (a[o] & 192) === 128; )
      o--;
    return o < 0 || o === 0 ? l : o + r[a[o]] > l ? o : l;
  }, gn;
}
var Ar, _l;
function qo() {
  if (_l) return Ar;
  _l = 1;
  function e() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return Ar = e, Ar;
}
var Sl;
function J0() {
  if (Sl) return Mn;
  Sl = 1;
  var e = K0(), t = un(), n = Uo(), r = hi(), s = qo(), i = Object.prototype.toString, a = 0, l = 4, o = 0, h = 1, v = 2, u = -1, f = 0, m = 8;
  function c(b) {
    if (!(this instanceof c)) return new c(b);
    this.options = t.assign({
      level: u,
      method: m,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: f,
      to: ""
    }, b || {});
    var S = this.options;
    S.raw && S.windowBits > 0 ? S.windowBits = -S.windowBits : S.gzip && S.windowBits > 0 && S.windowBits < 16 && (S.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
    var E = e.deflateInit2(
      this.strm,
      S.level,
      S.method,
      S.windowBits,
      S.memLevel,
      S.strategy
    );
    if (E !== o)
      throw new Error(r[E]);
    if (S.header && e.deflateSetHeader(this.strm, S.header), S.dictionary) {
      var I;
      if (typeof S.dictionary == "string" ? I = n.string2buf(S.dictionary) : i.call(S.dictionary) === "[object ArrayBuffer]" ? I = new Uint8Array(S.dictionary) : I = S.dictionary, E = e.deflateSetDictionary(this.strm, I), E !== o)
        throw new Error(r[E]);
      this._dict_set = !0;
    }
  }
  c.prototype.push = function(b, S) {
    var E = this.strm, I = this.options.chunkSize, $, C;
    if (this.ended)
      return !1;
    C = S === ~~S ? S : S === !0 ? l : a, typeof b == "string" ? E.input = n.string2buf(b) : i.call(b) === "[object ArrayBuffer]" ? E.input = new Uint8Array(b) : E.input = b, E.next_in = 0, E.avail_in = E.input.length;
    do {
      if (E.avail_out === 0 && (E.output = new t.Buf8(I), E.next_out = 0, E.avail_out = I), $ = e.deflate(E, C), $ !== h && $ !== o)
        return this.onEnd($), this.ended = !0, !1;
      (E.avail_out === 0 || E.avail_in === 0 && (C === l || C === v)) && (this.options.to === "string" ? this.onData(n.buf2binstring(t.shrinkBuf(E.output, E.next_out))) : this.onData(t.shrinkBuf(E.output, E.next_out)));
    } while ((E.avail_in > 0 || E.avail_out === 0) && $ !== h);
    return C === l ? ($ = e.deflateEnd(this.strm), this.onEnd($), this.ended = !0, $ === o) : (C === v && (this.onEnd(o), E.avail_out = 0), !0);
  }, c.prototype.onData = function(b) {
    this.chunks.push(b);
  }, c.prototype.onEnd = function(b) {
    b === o && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = b, this.msg = this.strm.msg;
  };
  function w(b, S) {
    var E = new c(S);
    if (E.push(b, !0), E.err)
      throw E.msg || r[E.err];
    return E.result;
  }
  function _(b, S) {
    return S = S || {}, S.raw = !0, w(b, S);
  }
  function g(b, S) {
    return S = S || {}, S.gzip = !0, w(b, S);
  }
  return Mn.Deflate = c, Mn.deflate = w, Mn.deflateRaw = _, Mn.gzip = g, Mn;
}
var On = {}, Bt = {}, Lr, Cl;
function Q0() {
  if (Cl) return Lr;
  Cl = 1;
  var e = 30, t = 12;
  return Lr = function(r, s) {
    var i, a, l, o, h, v, u, f, m, c, w, _, g, b, S, E, I, $, C, F, V, K, O, G, P;
    i = r.state, a = r.next_in, G = r.input, l = a + (r.avail_in - 5), o = r.next_out, P = r.output, h = o - (s - r.avail_out), v = o + (r.avail_out - 257), u = i.dmax, f = i.wsize, m = i.whave, c = i.wnext, w = i.window, _ = i.hold, g = i.bits, b = i.lencode, S = i.distcode, E = (1 << i.lenbits) - 1, I = (1 << i.distbits) - 1;
    e:
      do {
        g < 15 && (_ += G[a++] << g, g += 8, _ += G[a++] << g, g += 8), $ = b[_ & E];
        t:
          for (; ; ) {
            if (C = $ >>> 24, _ >>>= C, g -= C, C = $ >>> 16 & 255, C === 0)
              P[o++] = $ & 65535;
            else if (C & 16) {
              F = $ & 65535, C &= 15, C && (g < C && (_ += G[a++] << g, g += 8), F += _ & (1 << C) - 1, _ >>>= C, g -= C), g < 15 && (_ += G[a++] << g, g += 8, _ += G[a++] << g, g += 8), $ = S[_ & I];
              n:
                for (; ; ) {
                  if (C = $ >>> 24, _ >>>= C, g -= C, C = $ >>> 16 & 255, C & 16) {
                    if (V = $ & 65535, C &= 15, g < C && (_ += G[a++] << g, g += 8, g < C && (_ += G[a++] << g, g += 8)), V += _ & (1 << C) - 1, V > u) {
                      r.msg = "invalid distance too far back", i.mode = e;
                      break e;
                    }
                    if (_ >>>= C, g -= C, C = o - h, V > C) {
                      if (C = V - C, C > m && i.sane) {
                        r.msg = "invalid distance too far back", i.mode = e;
                        break e;
                      }
                      if (K = 0, O = w, c === 0) {
                        if (K += f - C, C < F) {
                          F -= C;
                          do
                            P[o++] = w[K++];
                          while (--C);
                          K = o - V, O = P;
                        }
                      } else if (c < C) {
                        if (K += f + c - C, C -= c, C < F) {
                          F -= C;
                          do
                            P[o++] = w[K++];
                          while (--C);
                          if (K = 0, c < F) {
                            C = c, F -= C;
                            do
                              P[o++] = w[K++];
                            while (--C);
                            K = o - V, O = P;
                          }
                        }
                      } else if (K += c - C, C < F) {
                        F -= C;
                        do
                          P[o++] = w[K++];
                        while (--C);
                        K = o - V, O = P;
                      }
                      for (; F > 2; )
                        P[o++] = O[K++], P[o++] = O[K++], P[o++] = O[K++], F -= 3;
                      F && (P[o++] = O[K++], F > 1 && (P[o++] = O[K++]));
                    } else {
                      K = o - V;
                      do
                        P[o++] = P[K++], P[o++] = P[K++], P[o++] = P[K++], F -= 3;
                      while (F > 2);
                      F && (P[o++] = P[K++], F > 1 && (P[o++] = P[K++]));
                    }
                  } else if ((C & 64) === 0) {
                    $ = S[($ & 65535) + (_ & (1 << C) - 1)];
                    continue n;
                  } else {
                    r.msg = "invalid distance code", i.mode = e;
                    break e;
                  }
                  break;
                }
            } else if ((C & 64) === 0) {
              $ = b[($ & 65535) + (_ & (1 << C) - 1)];
              continue t;
            } else if (C & 32) {
              i.mode = t;
              break e;
            } else {
              r.msg = "invalid literal/length code", i.mode = e;
              break e;
            }
            break;
          }
      } while (a < l && o < v);
    F = g >> 3, a -= F, g -= F << 3, _ &= (1 << g) - 1, r.next_in = a, r.next_out = o, r.avail_in = a < l ? 5 + (l - a) : 5 - (a - l), r.avail_out = o < v ? 257 + (v - o) : 257 - (o - v), i.hold = _, i.bits = g;
  }, Lr;
}
var $r, El;
function eh() {
  if (El) return $r;
  El = 1;
  var e = un(), t = 15, n = 852, r = 592, s = 0, i = 1, a = 2, l = [
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ], o = [
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ], h = [
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ], v = [
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ];
  return $r = function(f, m, c, w, _, g, b, S) {
    var E = S.bits, I = 0, $ = 0, C = 0, F = 0, V = 0, K = 0, O = 0, G = 0, P = 0, T = 0, A, z, U, X, B, ie = null, H = 0, ee, ue = new e.Buf16(t + 1), ye = new e.Buf16(t + 1), xe = null, te = 0, he, ge, be;
    for (I = 0; I <= t; I++)
      ue[I] = 0;
    for ($ = 0; $ < w; $++)
      ue[m[c + $]]++;
    for (V = E, F = t; F >= 1 && ue[F] === 0; F--)
      ;
    if (V > F && (V = F), F === 0)
      return _[g++] = 1 << 24 | 64 << 16 | 0, _[g++] = 1 << 24 | 64 << 16 | 0, S.bits = 1, 0;
    for (C = 1; C < F && ue[C] === 0; C++)
      ;
    for (V < C && (V = C), G = 1, I = 1; I <= t; I++)
      if (G <<= 1, G -= ue[I], G < 0)
        return -1;
    if (G > 0 && (f === s || F !== 1))
      return -1;
    for (ye[1] = 0, I = 1; I < t; I++)
      ye[I + 1] = ye[I] + ue[I];
    for ($ = 0; $ < w; $++)
      m[c + $] !== 0 && (b[ye[m[c + $]]++] = $);
    if (f === s ? (ie = xe = b, ee = 19) : f === i ? (ie = l, H -= 257, xe = o, te -= 257, ee = 256) : (ie = h, xe = v, ee = -1), T = 0, $ = 0, I = C, B = g, K = V, O = 0, U = -1, P = 1 << V, X = P - 1, f === i && P > n || f === a && P > r)
      return 1;
    for (; ; ) {
      he = I - O, b[$] < ee ? (ge = 0, be = b[$]) : b[$] > ee ? (ge = xe[te + b[$]], be = ie[H + b[$]]) : (ge = 96, be = 0), A = 1 << I - O, z = 1 << K, C = z;
      do
        z -= A, _[B + (T >> O) + z] = he << 24 | ge << 16 | be | 0;
      while (z !== 0);
      for (A = 1 << I - 1; T & A; )
        A >>= 1;
      if (A !== 0 ? (T &= A - 1, T += A) : T = 0, $++, --ue[I] === 0) {
        if (I === F)
          break;
        I = m[c + b[$]];
      }
      if (I > V && (T & X) !== U) {
        for (O === 0 && (O = V), B += C, K = I - O, G = 1 << K; K + O < F && (G -= ue[K + O], !(G <= 0)); )
          K++, G <<= 1;
        if (P += 1 << K, f === i && P > n || f === a && P > r)
          return 1;
        U = T & X, _[U] = V << 24 | K << 16 | B - g | 0;
      }
    }
    return T !== 0 && (_[B + T] = I - O << 24 | 64 << 16 | 0), S.bits = V, 0;
  }, $r;
}
var Tl;
function th() {
  if (Tl) return Bt;
  Tl = 1;
  var e = un(), t = Vo(), n = Ho(), r = Q0(), s = eh(), i = 0, a = 1, l = 2, o = 4, h = 5, v = 6, u = 0, f = 1, m = 2, c = -2, w = -3, _ = -4, g = -5, b = 8, S = 1, E = 2, I = 3, $ = 4, C = 5, F = 6, V = 7, K = 8, O = 9, G = 10, P = 11, T = 12, A = 13, z = 14, U = 15, X = 16, B = 17, ie = 18, H = 19, ee = 20, ue = 21, ye = 22, xe = 23, te = 24, he = 25, ge = 26, be = 27, Pe = 28, Ne = 29, de = 30, Re = 31, He = 32, Ze = 852, We = 592, Be = 15, Fe = Be;
  function Ye(R) {
    return (R >>> 24 & 255) + (R >>> 8 & 65280) + ((R & 65280) << 8) + ((R & 255) << 24);
  }
  function st() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new e.Buf16(320), this.work = new e.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function mt(R) {
    var le;
    return !R || !R.state ? c : (le = R.state, R.total_in = R.total_out = le.total = 0, R.msg = "", le.wrap && (R.adler = le.wrap & 1), le.mode = S, le.last = 0, le.havedict = 0, le.dmax = 32768, le.head = null, le.hold = 0, le.bits = 0, le.lencode = le.lendyn = new e.Buf32(Ze), le.distcode = le.distdyn = new e.Buf32(We), le.sane = 1, le.back = -1, u);
  }
  function gt(R) {
    var le;
    return !R || !R.state ? c : (le = R.state, le.wsize = 0, le.whave = 0, le.wnext = 0, mt(R));
  }
  function Ft(R, le) {
    var p, fe;
    return !R || !R.state || (fe = R.state, le < 0 ? (p = 0, le = -le) : (p = (le >> 4) + 1, le < 48 && (le &= 15)), le && (le < 8 || le > 15)) ? c : (fe.window !== null && fe.wbits !== le && (fe.window = null), fe.wrap = p, fe.wbits = le, gt(R));
  }
  function Mt(R, le) {
    var p, fe;
    return R ? (fe = new st(), R.state = fe, fe.window = null, p = Ft(R, le), p !== u && (R.state = null), p) : c;
  }
  function xt(R) {
    return Mt(R, Fe);
  }
  var Ut = !0, $t, ct;
  function D(R) {
    if (Ut) {
      var le;
      for ($t = new e.Buf32(512), ct = new e.Buf32(32), le = 0; le < 144; )
        R.lens[le++] = 8;
      for (; le < 256; )
        R.lens[le++] = 9;
      for (; le < 280; )
        R.lens[le++] = 7;
      for (; le < 288; )
        R.lens[le++] = 8;
      for (s(a, R.lens, 0, 288, $t, 0, R.work, { bits: 9 }), le = 0; le < 32; )
        R.lens[le++] = 5;
      s(l, R.lens, 0, 32, ct, 0, R.work, { bits: 5 }), Ut = !1;
    }
    R.lencode = $t, R.lenbits = 9, R.distcode = ct, R.distbits = 5;
  }
  function k(R, le, p, fe) {
    var Le, d = R.state;
    return d.window === null && (d.wsize = 1 << d.wbits, d.wnext = 0, d.whave = 0, d.window = new e.Buf8(d.wsize)), fe >= d.wsize ? (e.arraySet(d.window, le, p - d.wsize, d.wsize, 0), d.wnext = 0, d.whave = d.wsize) : (Le = d.wsize - d.wnext, Le > fe && (Le = fe), e.arraySet(d.window, le, p - fe, Le, d.wnext), fe -= Le, fe ? (e.arraySet(d.window, le, p - fe, fe, 0), d.wnext = fe, d.whave = d.wsize) : (d.wnext += Le, d.wnext === d.wsize && (d.wnext = 0), d.whave < d.wsize && (d.whave += Le))), 0;
  }
  function y(R, le) {
    var p, fe, Le, d, re, ne, x, N, Q, De, ke, Te, Ue, ft, et = 0, qe, it, bt, kt, fn, nn, tt, Et, ht = new e.Buf8(4), Pt, Ot, xa = (
      /* permutation of code lengths */
      [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
    );
    if (!R || !R.state || !R.output || !R.input && R.avail_in !== 0)
      return c;
    p = R.state, p.mode === T && (p.mode = A), re = R.next_out, Le = R.output, x = R.avail_out, d = R.next_in, fe = R.input, ne = R.avail_in, N = p.hold, Q = p.bits, De = ne, ke = x, Et = u;
    e:
      for (; ; )
        switch (p.mode) {
          case S:
            if (p.wrap === 0) {
              p.mode = A;
              break;
            }
            for (; Q < 16; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            if (p.wrap & 2 && N === 35615) {
              p.check = 0, ht[0] = N & 255, ht[1] = N >>> 8 & 255, p.check = n(p.check, ht, 2, 0), N = 0, Q = 0, p.mode = E;
              break;
            }
            if (p.flags = 0, p.head && (p.head.done = !1), !(p.wrap & 1) || /* check if zlib header allowed */
            (((N & 255) << 8) + (N >> 8)) % 31) {
              R.msg = "incorrect header check", p.mode = de;
              break;
            }
            if ((N & 15) !== b) {
              R.msg = "unknown compression method", p.mode = de;
              break;
            }
            if (N >>>= 4, Q -= 4, tt = (N & 15) + 8, p.wbits === 0)
              p.wbits = tt;
            else if (tt > p.wbits) {
              R.msg = "invalid window size", p.mode = de;
              break;
            }
            p.dmax = 1 << tt, R.adler = p.check = 1, p.mode = N & 512 ? G : T, N = 0, Q = 0;
            break;
          case E:
            for (; Q < 16; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            if (p.flags = N, (p.flags & 255) !== b) {
              R.msg = "unknown compression method", p.mode = de;
              break;
            }
            if (p.flags & 57344) {
              R.msg = "unknown header flags set", p.mode = de;
              break;
            }
            p.head && (p.head.text = N >> 8 & 1), p.flags & 512 && (ht[0] = N & 255, ht[1] = N >>> 8 & 255, p.check = n(p.check, ht, 2, 0)), N = 0, Q = 0, p.mode = I;
          /* falls through */
          case I:
            for (; Q < 32; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            p.head && (p.head.time = N), p.flags & 512 && (ht[0] = N & 255, ht[1] = N >>> 8 & 255, ht[2] = N >>> 16 & 255, ht[3] = N >>> 24 & 255, p.check = n(p.check, ht, 4, 0)), N = 0, Q = 0, p.mode = $;
          /* falls through */
          case $:
            for (; Q < 16; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            p.head && (p.head.xflags = N & 255, p.head.os = N >> 8), p.flags & 512 && (ht[0] = N & 255, ht[1] = N >>> 8 & 255, p.check = n(p.check, ht, 2, 0)), N = 0, Q = 0, p.mode = C;
          /* falls through */
          case C:
            if (p.flags & 1024) {
              for (; Q < 16; ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              p.length = N, p.head && (p.head.extra_len = N), p.flags & 512 && (ht[0] = N & 255, ht[1] = N >>> 8 & 255, p.check = n(p.check, ht, 2, 0)), N = 0, Q = 0;
            } else p.head && (p.head.extra = null);
            p.mode = F;
          /* falls through */
          case F:
            if (p.flags & 1024 && (Te = p.length, Te > ne && (Te = ne), Te && (p.head && (tt = p.head.extra_len - p.length, p.head.extra || (p.head.extra = new Array(p.head.extra_len)), e.arraySet(
              p.head.extra,
              fe,
              d,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              Te,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              tt
            )), p.flags & 512 && (p.check = n(p.check, fe, Te, d)), ne -= Te, d += Te, p.length -= Te), p.length))
              break e;
            p.length = 0, p.mode = V;
          /* falls through */
          case V:
            if (p.flags & 2048) {
              if (ne === 0)
                break e;
              Te = 0;
              do
                tt = fe[d + Te++], p.head && tt && p.length < 65536 && (p.head.name += String.fromCharCode(tt));
              while (tt && Te < ne);
              if (p.flags & 512 && (p.check = n(p.check, fe, Te, d)), ne -= Te, d += Te, tt)
                break e;
            } else p.head && (p.head.name = null);
            p.length = 0, p.mode = K;
          /* falls through */
          case K:
            if (p.flags & 4096) {
              if (ne === 0)
                break e;
              Te = 0;
              do
                tt = fe[d + Te++], p.head && tt && p.length < 65536 && (p.head.comment += String.fromCharCode(tt));
              while (tt && Te < ne);
              if (p.flags & 512 && (p.check = n(p.check, fe, Te, d)), ne -= Te, d += Te, tt)
                break e;
            } else p.head && (p.head.comment = null);
            p.mode = O;
          /* falls through */
          case O:
            if (p.flags & 512) {
              for (; Q < 16; ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              if (N !== (p.check & 65535)) {
                R.msg = "header crc mismatch", p.mode = de;
                break;
              }
              N = 0, Q = 0;
            }
            p.head && (p.head.hcrc = p.flags >> 9 & 1, p.head.done = !0), R.adler = p.check = 0, p.mode = T;
            break;
          case G:
            for (; Q < 32; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            R.adler = p.check = Ye(N), N = 0, Q = 0, p.mode = P;
          /* falls through */
          case P:
            if (p.havedict === 0)
              return R.next_out = re, R.avail_out = x, R.next_in = d, R.avail_in = ne, p.hold = N, p.bits = Q, m;
            R.adler = p.check = 1, p.mode = T;
          /* falls through */
          case T:
            if (le === h || le === v)
              break e;
          /* falls through */
          case A:
            if (p.last) {
              N >>>= Q & 7, Q -= Q & 7, p.mode = be;
              break;
            }
            for (; Q < 3; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            switch (p.last = N & 1, N >>>= 1, Q -= 1, N & 3) {
              case 0:
                p.mode = z;
                break;
              case 1:
                if (D(p), p.mode = ee, le === v) {
                  N >>>= 2, Q -= 2;
                  break e;
                }
                break;
              case 2:
                p.mode = B;
                break;
              case 3:
                R.msg = "invalid block type", p.mode = de;
            }
            N >>>= 2, Q -= 2;
            break;
          case z:
            for (N >>>= Q & 7, Q -= Q & 7; Q < 32; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            if ((N & 65535) !== (N >>> 16 ^ 65535)) {
              R.msg = "invalid stored block lengths", p.mode = de;
              break;
            }
            if (p.length = N & 65535, N = 0, Q = 0, p.mode = U, le === v)
              break e;
          /* falls through */
          case U:
            p.mode = X;
          /* falls through */
          case X:
            if (Te = p.length, Te) {
              if (Te > ne && (Te = ne), Te > x && (Te = x), Te === 0)
                break e;
              e.arraySet(Le, fe, d, Te, re), ne -= Te, d += Te, x -= Te, re += Te, p.length -= Te;
              break;
            }
            p.mode = T;
            break;
          case B:
            for (; Q < 14; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            if (p.nlen = (N & 31) + 257, N >>>= 5, Q -= 5, p.ndist = (N & 31) + 1, N >>>= 5, Q -= 5, p.ncode = (N & 15) + 4, N >>>= 4, Q -= 4, p.nlen > 286 || p.ndist > 30) {
              R.msg = "too many length or distance symbols", p.mode = de;
              break;
            }
            p.have = 0, p.mode = ie;
          /* falls through */
          case ie:
            for (; p.have < p.ncode; ) {
              for (; Q < 3; ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              p.lens[xa[p.have++]] = N & 7, N >>>= 3, Q -= 3;
            }
            for (; p.have < 19; )
              p.lens[xa[p.have++]] = 0;
            if (p.lencode = p.lendyn, p.lenbits = 7, Pt = { bits: p.lenbits }, Et = s(i, p.lens, 0, 19, p.lencode, 0, p.work, Pt), p.lenbits = Pt.bits, Et) {
              R.msg = "invalid code lengths set", p.mode = de;
              break;
            }
            p.have = 0, p.mode = H;
          /* falls through */
          case H:
            for (; p.have < p.nlen + p.ndist; ) {
              for (; et = p.lencode[N & (1 << p.lenbits) - 1], qe = et >>> 24, it = et >>> 16 & 255, bt = et & 65535, !(qe <= Q); ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              if (bt < 16)
                N >>>= qe, Q -= qe, p.lens[p.have++] = bt;
              else {
                if (bt === 16) {
                  for (Ot = qe + 2; Q < Ot; ) {
                    if (ne === 0)
                      break e;
                    ne--, N += fe[d++] << Q, Q += 8;
                  }
                  if (N >>>= qe, Q -= qe, p.have === 0) {
                    R.msg = "invalid bit length repeat", p.mode = de;
                    break;
                  }
                  tt = p.lens[p.have - 1], Te = 3 + (N & 3), N >>>= 2, Q -= 2;
                } else if (bt === 17) {
                  for (Ot = qe + 3; Q < Ot; ) {
                    if (ne === 0)
                      break e;
                    ne--, N += fe[d++] << Q, Q += 8;
                  }
                  N >>>= qe, Q -= qe, tt = 0, Te = 3 + (N & 7), N >>>= 3, Q -= 3;
                } else {
                  for (Ot = qe + 7; Q < Ot; ) {
                    if (ne === 0)
                      break e;
                    ne--, N += fe[d++] << Q, Q += 8;
                  }
                  N >>>= qe, Q -= qe, tt = 0, Te = 11 + (N & 127), N >>>= 7, Q -= 7;
                }
                if (p.have + Te > p.nlen + p.ndist) {
                  R.msg = "invalid bit length repeat", p.mode = de;
                  break;
                }
                for (; Te--; )
                  p.lens[p.have++] = tt;
              }
            }
            if (p.mode === de)
              break;
            if (p.lens[256] === 0) {
              R.msg = "invalid code -- missing end-of-block", p.mode = de;
              break;
            }
            if (p.lenbits = 9, Pt = { bits: p.lenbits }, Et = s(a, p.lens, 0, p.nlen, p.lencode, 0, p.work, Pt), p.lenbits = Pt.bits, Et) {
              R.msg = "invalid literal/lengths set", p.mode = de;
              break;
            }
            if (p.distbits = 6, p.distcode = p.distdyn, Pt = { bits: p.distbits }, Et = s(l, p.lens, p.nlen, p.ndist, p.distcode, 0, p.work, Pt), p.distbits = Pt.bits, Et) {
              R.msg = "invalid distances set", p.mode = de;
              break;
            }
            if (p.mode = ee, le === v)
              break e;
          /* falls through */
          case ee:
            p.mode = ue;
          /* falls through */
          case ue:
            if (ne >= 6 && x >= 258) {
              R.next_out = re, R.avail_out = x, R.next_in = d, R.avail_in = ne, p.hold = N, p.bits = Q, r(R, ke), re = R.next_out, Le = R.output, x = R.avail_out, d = R.next_in, fe = R.input, ne = R.avail_in, N = p.hold, Q = p.bits, p.mode === T && (p.back = -1);
              break;
            }
            for (p.back = 0; et = p.lencode[N & (1 << p.lenbits) - 1], qe = et >>> 24, it = et >>> 16 & 255, bt = et & 65535, !(qe <= Q); ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            if (it && (it & 240) === 0) {
              for (kt = qe, fn = it, nn = bt; et = p.lencode[nn + ((N & (1 << kt + fn) - 1) >> kt)], qe = et >>> 24, it = et >>> 16 & 255, bt = et & 65535, !(kt + qe <= Q); ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              N >>>= kt, Q -= kt, p.back += kt;
            }
            if (N >>>= qe, Q -= qe, p.back += qe, p.length = bt, it === 0) {
              p.mode = ge;
              break;
            }
            if (it & 32) {
              p.back = -1, p.mode = T;
              break;
            }
            if (it & 64) {
              R.msg = "invalid literal/length code", p.mode = de;
              break;
            }
            p.extra = it & 15, p.mode = ye;
          /* falls through */
          case ye:
            if (p.extra) {
              for (Ot = p.extra; Q < Ot; ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              p.length += N & (1 << p.extra) - 1, N >>>= p.extra, Q -= p.extra, p.back += p.extra;
            }
            p.was = p.length, p.mode = xe;
          /* falls through */
          case xe:
            for (; et = p.distcode[N & (1 << p.distbits) - 1], qe = et >>> 24, it = et >>> 16 & 255, bt = et & 65535, !(qe <= Q); ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            if ((it & 240) === 0) {
              for (kt = qe, fn = it, nn = bt; et = p.distcode[nn + ((N & (1 << kt + fn) - 1) >> kt)], qe = et >>> 24, it = et >>> 16 & 255, bt = et & 65535, !(kt + qe <= Q); ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              N >>>= kt, Q -= kt, p.back += kt;
            }
            if (N >>>= qe, Q -= qe, p.back += qe, it & 64) {
              R.msg = "invalid distance code", p.mode = de;
              break;
            }
            p.offset = bt, p.extra = it & 15, p.mode = te;
          /* falls through */
          case te:
            if (p.extra) {
              for (Ot = p.extra; Q < Ot; ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              p.offset += N & (1 << p.extra) - 1, N >>>= p.extra, Q -= p.extra, p.back += p.extra;
            }
            if (p.offset > p.dmax) {
              R.msg = "invalid distance too far back", p.mode = de;
              break;
            }
            p.mode = he;
          /* falls through */
          case he:
            if (x === 0)
              break e;
            if (Te = ke - x, p.offset > Te) {
              if (Te = p.offset - Te, Te > p.whave && p.sane) {
                R.msg = "invalid distance too far back", p.mode = de;
                break;
              }
              Te > p.wnext ? (Te -= p.wnext, Ue = p.wsize - Te) : Ue = p.wnext - Te, Te > p.length && (Te = p.length), ft = p.window;
            } else
              ft = Le, Ue = re - p.offset, Te = p.length;
            Te > x && (Te = x), x -= Te, p.length -= Te;
            do
              Le[re++] = ft[Ue++];
            while (--Te);
            p.length === 0 && (p.mode = ue);
            break;
          case ge:
            if (x === 0)
              break e;
            Le[re++] = p.length, x--, p.mode = ue;
            break;
          case be:
            if (p.wrap) {
              for (; Q < 32; ) {
                if (ne === 0)
                  break e;
                ne--, N |= fe[d++] << Q, Q += 8;
              }
              if (ke -= x, R.total_out += ke, p.total += ke, ke && (R.adler = p.check = /*UPDATE(state.check, put - _out, _out);*/
              p.flags ? n(p.check, Le, ke, re - ke) : t(p.check, Le, ke, re - ke)), ke = x, (p.flags ? N : Ye(N)) !== p.check) {
                R.msg = "incorrect data check", p.mode = de;
                break;
              }
              N = 0, Q = 0;
            }
            p.mode = Pe;
          /* falls through */
          case Pe:
            if (p.wrap && p.flags) {
              for (; Q < 32; ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              if (N !== (p.total & 4294967295)) {
                R.msg = "incorrect length check", p.mode = de;
                break;
              }
              N = 0, Q = 0;
            }
            p.mode = Ne;
          /* falls through */
          case Ne:
            Et = f;
            break e;
          case de:
            Et = w;
            break e;
          case Re:
            return _;
          case He:
          /* falls through */
          default:
            return c;
        }
    return R.next_out = re, R.avail_out = x, R.next_in = d, R.avail_in = ne, p.hold = N, p.bits = Q, (p.wsize || ke !== R.avail_out && p.mode < de && (p.mode < be || le !== o)) && k(R, R.output, R.next_out, ke - R.avail_out), De -= R.avail_in, ke -= R.avail_out, R.total_in += De, R.total_out += ke, p.total += ke, p.wrap && ke && (R.adler = p.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
    p.flags ? n(p.check, Le, ke, R.next_out - ke) : t(p.check, Le, ke, R.next_out - ke)), R.data_type = p.bits + (p.last ? 64 : 0) + (p.mode === T ? 128 : 0) + (p.mode === ee || p.mode === U ? 256 : 0), (De === 0 && ke === 0 || le === o) && Et === u && (Et = g), Et;
  }
  function Y(R) {
    if (!R || !R.state)
      return c;
    var le = R.state;
    return le.window && (le.window = null), R.state = null, u;
  }
  function W(R, le) {
    var p;
    return !R || !R.state || (p = R.state, (p.wrap & 2) === 0) ? c : (p.head = le, le.done = !1, u);
  }
  function se(R, le) {
    var p = le.length, fe, Le, d;
    return !R || !R.state || (fe = R.state, fe.wrap !== 0 && fe.mode !== P) ? c : fe.mode === P && (Le = 1, Le = t(Le, le, p, 0), Le !== fe.check) ? w : (d = k(R, le, p, p), d ? (fe.mode = Re, _) : (fe.havedict = 1, u));
  }
  return Bt.inflateReset = gt, Bt.inflateReset2 = Ft, Bt.inflateResetKeep = mt, Bt.inflateInit = xt, Bt.inflateInit2 = Mt, Bt.inflate = y, Bt.inflateEnd = Y, Bt.inflateGetHeader = W, Bt.inflateSetDictionary = se, Bt.inflateInfo = "pako inflate (from Nodeca project)", Bt;
}
var Ir, Al;
function jo() {
  return Al || (Al = 1, Ir = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */
    Z_DEFLATED: 8
    //Z_NULL:                 null // Use -1 or null inline, depending on var type
  }), Ir;
}
var Dr, Ll;
function nh() {
  if (Ll) return Dr;
  Ll = 1;
  function e() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  }
  return Dr = e, Dr;
}
var $l;
function ah() {
  if ($l) return On;
  $l = 1;
  var e = th(), t = un(), n = Uo(), r = jo(), s = hi(), i = qo(), a = nh(), l = Object.prototype.toString;
  function o(u) {
    if (!(this instanceof o)) return new o(u);
    this.options = t.assign({
      chunkSize: 16384,
      windowBits: 0,
      to: ""
    }, u || {});
    var f = this.options;
    f.raw && f.windowBits >= 0 && f.windowBits < 16 && (f.windowBits = -f.windowBits, f.windowBits === 0 && (f.windowBits = -15)), f.windowBits >= 0 && f.windowBits < 16 && !(u && u.windowBits) && (f.windowBits += 32), f.windowBits > 15 && f.windowBits < 48 && (f.windowBits & 15) === 0 && (f.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
    var m = e.inflateInit2(
      this.strm,
      f.windowBits
    );
    if (m !== r.Z_OK)
      throw new Error(s[m]);
    if (this.header = new a(), e.inflateGetHeader(this.strm, this.header), f.dictionary && (typeof f.dictionary == "string" ? f.dictionary = n.string2buf(f.dictionary) : l.call(f.dictionary) === "[object ArrayBuffer]" && (f.dictionary = new Uint8Array(f.dictionary)), f.raw && (m = e.inflateSetDictionary(this.strm, f.dictionary), m !== r.Z_OK)))
      throw new Error(s[m]);
  }
  o.prototype.push = function(u, f) {
    var m = this.strm, c = this.options.chunkSize, w = this.options.dictionary, _, g, b, S, E, I = !1;
    if (this.ended)
      return !1;
    g = f === ~~f ? f : f === !0 ? r.Z_FINISH : r.Z_NO_FLUSH, typeof u == "string" ? m.input = n.binstring2buf(u) : l.call(u) === "[object ArrayBuffer]" ? m.input = new Uint8Array(u) : m.input = u, m.next_in = 0, m.avail_in = m.input.length;
    do {
      if (m.avail_out === 0 && (m.output = new t.Buf8(c), m.next_out = 0, m.avail_out = c), _ = e.inflate(m, r.Z_NO_FLUSH), _ === r.Z_NEED_DICT && w && (_ = e.inflateSetDictionary(this.strm, w)), _ === r.Z_BUF_ERROR && I === !0 && (_ = r.Z_OK, I = !1), _ !== r.Z_STREAM_END && _ !== r.Z_OK)
        return this.onEnd(_), this.ended = !0, !1;
      m.next_out && (m.avail_out === 0 || _ === r.Z_STREAM_END || m.avail_in === 0 && (g === r.Z_FINISH || g === r.Z_SYNC_FLUSH)) && (this.options.to === "string" ? (b = n.utf8border(m.output, m.next_out), S = m.next_out - b, E = n.buf2string(m.output, b), m.next_out = S, m.avail_out = c - S, S && t.arraySet(m.output, m.output, b, S, 0), this.onData(E)) : this.onData(t.shrinkBuf(m.output, m.next_out))), m.avail_in === 0 && m.avail_out === 0 && (I = !0);
    } while ((m.avail_in > 0 || m.avail_out === 0) && _ !== r.Z_STREAM_END);
    return _ === r.Z_STREAM_END && (g = r.Z_FINISH), g === r.Z_FINISH ? (_ = e.inflateEnd(this.strm), this.onEnd(_), this.ended = !0, _ === r.Z_OK) : (g === r.Z_SYNC_FLUSH && (this.onEnd(r.Z_OK), m.avail_out = 0), !0);
  }, o.prototype.onData = function(u) {
    this.chunks.push(u);
  }, o.prototype.onEnd = function(u) {
    u === r.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = u, this.msg = this.strm.msg;
  };
  function h(u, f) {
    var m = new o(f);
    if (m.push(u, !0), m.err)
      throw m.msg || s[m.err];
    return m.result;
  }
  function v(u, f) {
    return f = f || {}, f.raw = !0, h(u, f);
  }
  return On.Inflate = o, On.inflate = h, On.inflateRaw = v, On.ungzip = h, On;
}
var Mr, Il;
function rh() {
  if (Il) return Mr;
  Il = 1;
  var e = un().assign, t = J0(), n = ah(), r = jo(), s = {};
  return e(s, t, n, r), Mr = s, Mr;
}
var Dl;
function ih() {
  return Dl || (Dl = 1, (function(e) {
    (function() {
      var t = {}, n;
      e.exports = t, typeof Y0 == "function" ? n = rh() : n = window.pako, (function(r, s) {
        r.toRGBA8 = function(i) {
          var a = i.width, l = i.height;
          if (i.tabs.acTL == null) return [r.toRGBA8.decodeImage(i.data, a, l, i).buffer];
          var o = [];
          i.frames[0].data == null && (i.frames[0].data = i.data);
          for (var h, v = new Uint8Array(a * l * 4), u = 0; u < i.frames.length; u++) {
            var f = i.frames[u], m = f.rect.x, c = f.rect.y, w = f.rect.width, _ = f.rect.height, g = r.toRGBA8.decodeImage(f.data, w, _, i);
            if (u == 0 ? h = g : f.blend == 0 ? r._copyTile(g, w, _, h, a, l, m, c, 0) : f.blend == 1 && r._copyTile(g, w, _, h, a, l, m, c, 1), o.push(h.buffer), h = h.slice(0), f.dispose != 0) {
              if (f.dispose == 1) r._copyTile(v, w, _, h, a, l, m, c, 0);
              else if (f.dispose == 2) {
                for (var b = u - 1; i.frames[b].dispose == 2; ) b--;
                h = new Uint8Array(o[b]).slice(0);
              }
            }
          }
          return o;
        }, r.toRGBA8.decodeImage = function(i, a, l, o) {
          var h = a * l, v = r.decode._getBPP(o), u = Math.ceil(a * v / 8), f = new Uint8Array(h * 4), m = new Uint32Array(f.buffer), c = o.ctype, w = o.depth, _ = r._bin.readUshort;
          if (c == 6) {
            var g = h << 2;
            if (w == 8) for (var b = 0; b < g; b++)
              f[b] = i[b];
            if (w == 16) for (var b = 0; b < g; b++)
              f[b] = i[b << 1];
          } else if (c == 2) {
            var S = o.tabs.tRNS, E = -1, I = -1, $ = -1;
            if (S && (E = S[0], I = S[1], $ = S[2]), w == 8) for (var b = 0; b < h; b++) {
              var C = b << 2, F = b * 3;
              f[C] = i[F], f[C + 1] = i[F + 1], f[C + 2] = i[F + 2], f[C + 3] = 255, E != -1 && i[F] == E && i[F + 1] == I && i[F + 2] == $ && (f[C + 3] = 0);
            }
            if (w == 16) for (var b = 0; b < h; b++) {
              var C = b << 2, F = b * 6;
              f[C] = i[F], f[C + 1] = i[F + 2], f[C + 2] = i[F + 4], f[C + 3] = 255, E != -1 && _(i, F) == E && _(i, F + 2) == I && _(i, F + 4) == $ && (f[C + 3] = 0);
            }
          } else if (c == 3) {
            var V = o.tabs.PLTE, K = o.tabs.tRNS, O = K ? K.length : 0;
            if (w == 1) for (var G = 0; G < l; G++)
              for (var P = G * u, T = G * a, b = 0; b < a; b++) {
                var C = T + b << 2, A = i[P + (b >> 3)] >> 7 - ((b & 7) << 0) & 1, z = 3 * A;
                f[C] = V[z], f[C + 1] = V[z + 1], f[C + 2] = V[z + 2], f[C + 3] = A < O ? K[A] : 255;
              }
            if (w == 2) for (var G = 0; G < l; G++)
              for (var P = G * u, T = G * a, b = 0; b < a; b++) {
                var C = T + b << 2, A = i[P + (b >> 2)] >> 6 - ((b & 3) << 1) & 3, z = 3 * A;
                f[C] = V[z], f[C + 1] = V[z + 1], f[C + 2] = V[z + 2], f[C + 3] = A < O ? K[A] : 255;
              }
            if (w == 4) for (var G = 0; G < l; G++)
              for (var P = G * u, T = G * a, b = 0; b < a; b++) {
                var C = T + b << 2, A = i[P + (b >> 1)] >> 4 - ((b & 1) << 2) & 15, z = 3 * A;
                f[C] = V[z], f[C + 1] = V[z + 1], f[C + 2] = V[z + 2], f[C + 3] = A < O ? K[A] : 255;
              }
            if (w == 8) for (var b = 0; b < h; b++) {
              var C = b << 2, A = i[b], z = 3 * A;
              f[C] = V[z], f[C + 1] = V[z + 1], f[C + 2] = V[z + 2], f[C + 3] = A < O ? K[A] : 255;
            }
          } else if (c == 4) {
            if (w == 8) for (var b = 0; b < h; b++) {
              var C = b << 2, U = b << 1, X = i[U];
              f[C] = X, f[C + 1] = X, f[C + 2] = X, f[C + 3] = i[U + 1];
            }
            if (w == 16) for (var b = 0; b < h; b++) {
              var C = b << 2, U = b << 2, X = i[U];
              f[C] = X, f[C + 1] = X, f[C + 2] = X, f[C + 3] = i[U + 2];
            }
          } else if (c == 0) {
            var E = o.tabs.tRNS ? o.tabs.tRNS : -1;
            if (w == 1) for (var b = 0; b < h; b++) {
              var X = 255 * (i[b >> 3] >> 7 - (b & 7) & 1), B = X == E * 255 ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
            if (w == 2) for (var b = 0; b < h; b++) {
              var X = 85 * (i[b >> 2] >> 6 - ((b & 3) << 1) & 3), B = X == E * 85 ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
            if (w == 4) for (var b = 0; b < h; b++) {
              var X = 17 * (i[b >> 1] >> 4 - ((b & 1) << 2) & 15), B = X == E * 17 ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
            if (w == 8) for (var b = 0; b < h; b++) {
              var X = i[b], B = X == E ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
            if (w == 16) for (var b = 0; b < h; b++) {
              var X = i[b << 1], B = _(i, b << 1) == E ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
          }
          return f;
        }, r.decode = function(i) {
          for (var a = new Uint8Array(i), l = 8, o = r._bin, h = o.readUshort, v = o.readUint, u = { tabs: {}, frames: [] }, f = new Uint8Array(a.length), m = 0, c, w = 0, _ = [137, 80, 78, 71, 13, 10, 26, 10], g = 0; g < 8; g++) if (a[g] != _[g]) throw "The input is not a PNG file!";
          for (; l < a.length; ) {
            var b = o.readUint(a, l);
            l += 4;
            var S = o.readASCII(a, l, 4);
            if (l += 4, S == "IHDR")
              r.decode._IHDR(a, l, u);
            else if (S == "IDAT") {
              for (var g = 0; g < b; g++) f[m + g] = a[l + g];
              m += b;
            } else if (S == "acTL")
              u.tabs[S] = { num_frames: v(a, l), num_plays: v(a, l + 4) }, c = new Uint8Array(a.length);
            else if (S == "fcTL") {
              if (w != 0) {
                var E = u.frames[u.frames.length - 1];
                E.data = r.decode._decompress(u, c.slice(0, w), E.rect.width, E.rect.height), w = 0;
              }
              var I = { x: v(a, l + 12), y: v(a, l + 16), width: v(a, l + 4), height: v(a, l + 8) }, $ = h(a, l + 22);
              $ = h(a, l + 20) / ($ == 0 ? 100 : $);
              var C = { rect: I, delay: Math.round($ * 1e3), dispose: a[l + 24], blend: a[l + 25] };
              u.frames.push(C);
            } else if (S == "fdAT") {
              for (var g = 0; g < b - 4; g++) c[w + g] = a[l + g + 4];
              w += b - 4;
            } else if (S == "pHYs")
              u.tabs[S] = [o.readUint(a, l), o.readUint(a, l + 4), a[l + 8]];
            else if (S == "cHRM") {
              u.tabs[S] = [];
              for (var g = 0; g < 8; g++) u.tabs[S].push(o.readUint(a, l + g * 4));
            } else if (S == "tEXt") {
              u.tabs[S] == null && (u.tabs[S] = {});
              var F = o.nextZero(a, l), V = o.readASCII(a, l, F - l), K = o.readASCII(a, F + 1, l + b - F - 1);
              u.tabs[S][V] = K;
            } else if (S == "iTXt") {
              u.tabs[S] == null && (u.tabs[S] = {});
              var F = 0, O = l;
              F = o.nextZero(a, O);
              var V = o.readASCII(a, O, F - O);
              O = F + 1, a[O], a[O + 1], O += 2, F = o.nextZero(a, O), o.readASCII(a, O, F - O), O = F + 1, F = o.nextZero(a, O), o.readUTF8(a, O, F - O), O = F + 1;
              var K = o.readUTF8(a, O, b - (O - l));
              u.tabs[S][V] = K;
            } else if (S == "PLTE")
              u.tabs[S] = o.readBytes(a, l, b);
            else if (S == "hIST") {
              var G = u.tabs.PLTE.length / 3;
              u.tabs[S] = [];
              for (var g = 0; g < G; g++) u.tabs[S].push(h(a, l + g * 2));
            } else if (S == "tRNS")
              u.ctype == 3 ? u.tabs[S] = o.readBytes(a, l, b) : u.ctype == 0 ? u.tabs[S] = h(a, l) : u.ctype == 2 && (u.tabs[S] = [h(a, l), h(a, l + 2), h(a, l + 4)]);
            else if (S == "gAMA") u.tabs[S] = o.readUint(a, l) / 1e5;
            else if (S == "sRGB") u.tabs[S] = a[l];
            else if (S == "bKGD")
              u.ctype == 0 || u.ctype == 4 ? u.tabs[S] = [h(a, l)] : u.ctype == 2 || u.ctype == 6 ? u.tabs[S] = [h(a, l), h(a, l + 2), h(a, l + 4)] : u.ctype == 3 && (u.tabs[S] = a[l]);
            else if (S == "IEND") {
              if (w != 0) {
                var E = u.frames[u.frames.length - 1];
                E.data = r.decode._decompress(u, c.slice(0, w), E.rect.width, E.rect.height), w = 0;
              }
              u.data = r.decode._decompress(u, f, u.width, u.height);
              break;
            }
            l += b, o.readUint(a, l), l += 4;
          }
          return delete u.compress, delete u.interlace, delete u.filter, u;
        }, r.decode._decompress = function(i, a, l, o) {
          return i.compress == 0 && (a = r.decode._inflate(a)), i.interlace == 0 ? a = r.decode._filterZero(a, i, 0, l, o) : i.interlace == 1 && (a = r.decode._readInterlace(a, i)), a;
        }, r.decode._inflate = function(i) {
          return s.inflate(i);
        }, r.decode._readInterlace = function(i, a) {
          for (var l = a.width, o = a.height, h = r.decode._getBPP(a), v = h >> 3, u = Math.ceil(l * h / 8), f = new Uint8Array(o * u), m = 0, c = [0, 0, 4, 0, 2, 0, 1], w = [0, 4, 0, 2, 0, 1, 0], _ = [8, 8, 8, 4, 4, 2, 2], g = [8, 8, 4, 4, 2, 2, 1], b = 0; b < 7; ) {
            for (var S = _[b], E = g[b], I = 0, $ = 0, C = c[b]; C < o; )
              C += S, $++;
            for (var F = w[b]; F < l; )
              F += E, I++;
            var V = Math.ceil(I * h / 8);
            r.decode._filterZero(i, a, m, I, $);
            for (var K = 0, O = c[b]; O < o; ) {
              for (var G = w[b], P = m + K * V << 3; G < l; ) {
                if (h == 1) {
                  var T = i[P >> 3];
                  T = T >> 7 - (P & 7) & 1, f[O * u + (G >> 3)] |= T << 7 - ((G & 3) << 0);
                }
                if (h == 2) {
                  var T = i[P >> 3];
                  T = T >> 6 - (P & 7) & 3, f[O * u + (G >> 2)] |= T << 6 - ((G & 3) << 1);
                }
                if (h == 4) {
                  var T = i[P >> 3];
                  T = T >> 4 - (P & 7) & 15, f[O * u + (G >> 1)] |= T << 4 - ((G & 1) << 2);
                }
                if (h >= 8)
                  for (var A = O * u + G * v, z = 0; z < v; z++) f[A + z] = i[(P >> 3) + z];
                P += h, G += E;
              }
              K++, O += S;
            }
            I * $ != 0 && (m += $ * (1 + V)), b = b + 1;
          }
          return f;
        }, r.decode._getBPP = function(i) {
          var a = [1, null, 3, 1, 2, null, 4][i.ctype];
          return a * i.depth;
        }, r.decode._filterZero = function(i, a, l, o, h) {
          var v = r.decode._getBPP(a), u = Math.ceil(o * v / 8), f = r.decode._paeth;
          v = Math.ceil(v / 8);
          for (var m = 0; m < h; m++) {
            var c = l + m * u, w = c + m + 1, _ = i[w - 1];
            if (_ == 0) for (var g = 0; g < u; g++) i[c + g] = i[w + g];
            else if (_ == 1) {
              for (var g = 0; g < v; g++) i[c + g] = i[w + g];
              for (var g = v; g < u; g++) i[c + g] = i[w + g] + i[c + g - v] & 255;
            } else if (m == 0) {
              for (var g = 0; g < v; g++) i[c + g] = i[w + g];
              if (_ == 2) for (var g = v; g < u; g++) i[c + g] = i[w + g] & 255;
              if (_ == 3) for (var g = v; g < u; g++) i[c + g] = i[w + g] + (i[c + g - v] >> 1) & 255;
              if (_ == 4) for (var g = v; g < u; g++) i[c + g] = i[w + g] + f(i[c + g - v], 0, 0) & 255;
            } else {
              if (_ == 2)
                for (var g = 0; g < u; g++) i[c + g] = i[w + g] + i[c + g - u] & 255;
              if (_ == 3) {
                for (var g = 0; g < v; g++) i[c + g] = i[w + g] + (i[c + g - u] >> 1) & 255;
                for (var g = v; g < u; g++) i[c + g] = i[w + g] + (i[c + g - u] + i[c + g - v] >> 1) & 255;
              }
              if (_ == 4) {
                for (var g = 0; g < v; g++) i[c + g] = i[w + g] + f(0, i[c + g - u], 0) & 255;
                for (var g = v; g < u; g++) i[c + g] = i[w + g] + f(i[c + g - v], i[c + g - u], i[c + g - v - u]) & 255;
              }
            }
          }
          return i;
        }, r.decode._paeth = function(i, a, l) {
          var o = i + a - l, h = Math.abs(o - i), v = Math.abs(o - a), u = Math.abs(o - l);
          return h <= v && h <= u ? i : v <= u ? a : l;
        }, r.decode._IHDR = function(i, a, l) {
          var o = r._bin;
          l.width = o.readUint(i, a), a += 4, l.height = o.readUint(i, a), a += 4, l.depth = i[a], a++, l.ctype = i[a], a++, l.compress = i[a], a++, l.filter = i[a], a++, l.interlace = i[a], a++;
        }, r._bin = {
          nextZero: function(i, a) {
            for (; i[a] != 0; ) a++;
            return a;
          },
          readUshort: function(i, a) {
            return i[a] << 8 | i[a + 1];
          },
          writeUshort: function(i, a, l) {
            i[a] = l >> 8 & 255, i[a + 1] = l & 255;
          },
          readUint: function(i, a) {
            return i[a] * (256 * 256 * 256) + (i[a + 1] << 16 | i[a + 2] << 8 | i[a + 3]);
          },
          writeUint: function(i, a, l) {
            i[a] = l >> 24 & 255, i[a + 1] = l >> 16 & 255, i[a + 2] = l >> 8 & 255, i[a + 3] = l & 255;
          },
          readASCII: function(i, a, l) {
            for (var o = "", h = 0; h < l; h++) o += String.fromCharCode(i[a + h]);
            return o;
          },
          writeASCII: function(i, a, l) {
            for (var o = 0; o < l.length; o++) i[a + o] = l.charCodeAt(o);
          },
          readBytes: function(i, a, l) {
            for (var o = [], h = 0; h < l; h++) o.push(i[a + h]);
            return o;
          },
          pad: function(i) {
            return i.length < 2 ? "0" + i : i;
          },
          readUTF8: function(i, a, l) {
            for (var o = "", h, v = 0; v < l; v++) o += "%" + r._bin.pad(i[a + v].toString(16));
            try {
              h = decodeURIComponent(o);
            } catch {
              return r._bin.readASCII(i, a, l);
            }
            return h;
          }
        }, r._copyTile = function(i, a, l, o, h, v, u, f, m) {
          for (var c = Math.min(a, h), w = Math.min(l, v), _ = 0, g = 0, b = 0; b < w; b++)
            for (var S = 0; S < c; S++)
              if (u >= 0 && f >= 0 ? (_ = b * a + S << 2, g = (f + b) * h + u + S << 2) : (_ = (-f + b) * a - u + S << 2, g = b * h + S << 2), m == 0)
                o[g] = i[_], o[g + 1] = i[_ + 1], o[g + 2] = i[_ + 2], o[g + 3] = i[_ + 3];
              else if (m == 1) {
                var E = i[_ + 3] * 0.00392156862745098, I = i[_] * E, $ = i[_ + 1] * E, C = i[_ + 2] * E, F = o[g + 3] * (1 / 255), V = o[g] * F, K = o[g + 1] * F, O = o[g + 2] * F, G = 1 - E, P = E + F * G, T = P == 0 ? 0 : 1 / P;
                o[g + 3] = 255 * P, o[g + 0] = (I + V * G) * T, o[g + 1] = ($ + K * G) * T, o[g + 2] = (C + O * G) * T;
              } else if (m == 2) {
                var E = i[_ + 3], I = i[_], $ = i[_ + 1], C = i[_ + 2], F = o[g + 3], V = o[g], K = o[g + 1], O = o[g + 2];
                E == F && I == V && $ == K && C == O ? (o[g] = 0, o[g + 1] = 0, o[g + 2] = 0, o[g + 3] = 0) : (o[g] = I, o[g + 1] = $, o[g + 2] = C, o[g + 3] = E);
              } else if (m == 3) {
                var E = i[_ + 3], I = i[_], $ = i[_ + 1], C = i[_ + 2], F = o[g + 3], V = o[g], K = o[g + 1], O = o[g + 2];
                if (E == F && I == V && $ == K && C == O) continue;
                if (E < 220 && F > 20) return !1;
              }
          return !0;
        }, r.encode = function(i, a, l, o, h, v) {
          o == null && (o = 0), v == null && (v = !1);
          for (var u = new Uint8Array(i[0].byteLength * i.length + 100), f = [137, 80, 78, 71, 13, 10, 26, 10], m = 0; m < 8; m++) u[m] = f[m];
          var c = 8, w = r._bin, _ = r.crc.crc, g = w.writeUint, b = w.writeUshort, S = w.writeASCII, E = r.encode.compressPNG(i, a, l, o, v);
          g(u, c, 13), c += 4, S(u, c, "IHDR"), c += 4, g(u, c, a), c += 4, g(u, c, l), c += 4, u[c] = E.depth, c++, u[c] = E.ctype, c++, u[c] = 0, c++, u[c] = 0, c++, u[c] = 0, c++, g(u, c, _(u, c - 17, 17)), c += 4, g(u, c, 1), c += 4, S(u, c, "sRGB"), c += 4, u[c] = 1, c++, g(u, c, _(u, c - 5, 5)), c += 4;
          var I = i.length > 1;
          if (I && (g(u, c, 8), c += 4, S(u, c, "acTL"), c += 4, g(u, c, i.length), c += 4, g(u, c, 0), c += 4, g(u, c, _(u, c - 12, 12)), c += 4), E.ctype == 3) {
            var $ = E.plte.length;
            g(u, c, $ * 3), c += 4, S(u, c, "PLTE"), c += 4;
            for (var m = 0; m < $; m++) {
              var C = m * 3, F = E.plte[m], V = F & 255, K = F >> 8 & 255, O = F >> 16 & 255;
              u[c + C + 0] = V, u[c + C + 1] = K, u[c + C + 2] = O;
            }
            if (c += $ * 3, g(u, c, _(u, c - $ * 3 - 4, $ * 3 + 4)), c += 4, E.gotAlpha) {
              g(u, c, $), c += 4, S(u, c, "tRNS"), c += 4;
              for (var m = 0; m < $; m++) u[c + m] = E.plte[m] >> 24 & 255;
              c += $, g(u, c, _(u, c - $ - 4, $ + 4)), c += 4;
            }
          }
          for (var G = 0, P = 0; P < E.frames.length; P++) {
            var T = E.frames[P];
            I && (g(u, c, 26), c += 4, S(u, c, "fcTL"), c += 4, g(u, c, G++), c += 4, g(u, c, T.rect.width), c += 4, g(u, c, T.rect.height), c += 4, g(u, c, T.rect.x), c += 4, g(u, c, T.rect.y), c += 4, b(u, c, h[P]), c += 2, b(u, c, 1e3), c += 2, u[c] = T.dispose, c++, u[c] = T.blend, c++, g(u, c, _(u, c - 30, 30)), c += 4);
            var A = T.cimg, $ = A.length;
            g(u, c, $ + (P == 0 ? 0 : 4)), c += 4;
            var z = c;
            S(u, c, P == 0 ? "IDAT" : "fdAT"), c += 4, P != 0 && (g(u, c, G++), c += 4);
            for (var m = 0; m < $; m++) u[c + m] = A[m];
            c += $, g(u, c, _(u, z, c - z)), c += 4;
          }
          return g(u, c, 0), c += 4, S(u, c, "IEND"), c += 4, g(u, c, _(u, c - 4, 4)), c += 4, u.buffer.slice(0, c);
        }, r.encode.compressPNG = function(i, a, l, o, h) {
          for (var v = r.encode.compress(i, a, l, o, !1, h), u = 0; u < i.length; u++) {
            var f = v.frames[u];
            f.rect.width;
            var m = f.rect.height, c = f.bpl, w = f.bpp, _ = new Uint8Array(m * c + m);
            f.cimg = r.encode._filterZero(f.img, m, w, c, _);
          }
          return v;
        }, r.encode.compress = function(i, a, l, o, h, v) {
          v == null && (v = !1);
          for (var u = 6, f = 8, m = 4, c = 255, w = 0; w < i.length; w++)
            for (var _ = new Uint8Array(i[w]), g = _.length, b = 0; b < g; b += 4) c &= _[b + 3];
          var S = c != 255, E = {}, I = [];
          if (i.length != 0 && (E[0] = 0, I.push(0), o != 0 && o--), o != 0) {
            var $ = r.quantize(i, o, h);
            i = $.bufs;
            for (var b = 0; b < $.plte.length; b++) {
              var C = $.plte[b].est.rgba;
              E[C] == null && (E[C] = I.length, I.push(C));
            }
          } else
            for (var w = 0; w < i.length; w++)
              for (var F = new Uint32Array(i[w]), g = F.length, b = 0; b < g; b++) {
                var C = F[b];
                if ((b < a || C != F[b - 1] && C != F[b - a]) && E[C] == null && (E[C] = I.length, I.push(C), I.length >= 300))
                  break;
              }
          var V = S ? h : !1, K = I.length;
          K <= 256 && v == !1 && (K <= 2 ? f = 1 : K <= 4 ? f = 2 : K <= 16 ? f = 4 : f = 8, h && (f = 8), S = !0);
          for (var O = [], w = 0; w < i.length; w++) {
            var G = new Uint8Array(i[w]), P = new Uint32Array(G.buffer), T = 0, A = 0, z = a, U = l, X = 0;
            if (w != 0 && !V) {
              for (var B = h || w == 1 || O[O.length - 2].dispose == 2 ? 1 : 2, ie = 0, H = 1e9, ee = 0; ee < B; ee++) {
                for (var Ne = new Uint8Array(i[w - 1 - ee]), ue = new Uint32Array(i[w - 1 - ee]), ye = a, xe = l, te = -1, he = -1, ge = 0; ge < l; ge++) for (var be = 0; be < a; be++) {
                  var b = ge * a + be;
                  P[b] != ue[b] && (be < ye && (ye = be), be > te && (te = be), ge < xe && (xe = ge), ge > he && (he = ge));
                }
                var Pe = te == -1 ? 1 : (te - ye + 1) * (he - xe + 1);
                Pe < H && (H = Pe, ie = ee, te == -1 ? (T = A = 0, z = U = 1) : (T = ye, A = xe, z = te - ye + 1, U = he - xe + 1));
              }
              var Ne = new Uint8Array(i[w - 1 - ie]);
              ie == 1 && (O[O.length - 1].dispose = 2);
              var de = new Uint8Array(z * U * 4);
              new Uint32Array(de.buffer), r._copyTile(Ne, a, l, de, z, U, -T, -A, 0), r._copyTile(G, a, l, de, z, U, -T, -A, 3) ? (r._copyTile(G, a, l, de, z, U, -T, -A, 2), X = 1) : (r._copyTile(G, a, l, de, z, U, -T, -A, 0), X = 0), G = de, P = new Uint32Array(G.buffer);
            }
            var Re = 4 * z;
            if (K <= 256 && v == !1) {
              Re = Math.ceil(f * z / 8);
              for (var de = new Uint8Array(Re * U), ge = 0; ge < U; ge++) {
                var b = ge * Re, He = ge * z;
                if (f == 8) for (var be = 0; be < z; be++) de[b + be] = E[P[He + be]];
                else if (f == 4) for (var be = 0; be < z; be++) de[b + (be >> 1)] |= E[P[He + be]] << 4 - (be & 1) * 4;
                else if (f == 2) for (var be = 0; be < z; be++) de[b + (be >> 2)] |= E[P[He + be]] << 6 - (be & 3) * 2;
                else if (f == 1) for (var be = 0; be < z; be++) de[b + (be >> 3)] |= E[P[He + be]] << 7 - (be & 7) * 1;
              }
              G = de, u = 3, m = 1;
            } else if (S == !1 && i.length == 1) {
              for (var de = new Uint8Array(z * U * 3), Ze = z * U, b = 0; b < Ze; b++) {
                var We = b * 3, Be = b * 4;
                de[We] = G[Be], de[We + 1] = G[Be + 1], de[We + 2] = G[Be + 2];
              }
              G = de, u = 2, m = 3, Re = 3 * z;
            }
            O.push({ rect: { x: T, y: A, width: z, height: U }, img: G, bpl: Re, bpp: m, blend: X, dispose: V ? 1 : 0 });
          }
          return { ctype: u, depth: f, plte: I, gotAlpha: S, frames: O };
        }, r.encode._filterZero = function(i, a, l, o, h) {
          for (var v = [], u = 0; u < 5; u++)
            if (!(a * o > 5e5 && (u == 2 || u == 3 || u == 4))) {
              for (var f = 0; f < a; f++) r.encode._filterLine(h, i, f, o, l, u);
              if (v.push(s.deflate(h)), l == 1) break;
            }
          for (var m, c = 1e9, w = 0; w < v.length; w++) v[w].length < c && (m = w, c = v[w].length);
          return v[m];
        }, r.encode._filterLine = function(i, a, l, o, h, v) {
          var u = l * o, f = u + l, m = r.decode._paeth;
          if (i[f] = v, f++, v == 0) for (var c = 0; c < o; c++) i[f + c] = a[u + c];
          else if (v == 1) {
            for (var c = 0; c < h; c++) i[f + c] = a[u + c];
            for (var c = h; c < o; c++) i[f + c] = a[u + c] - a[u + c - h] + 256 & 255;
          } else if (l == 0) {
            for (var c = 0; c < h; c++) i[f + c] = a[u + c];
            if (v == 2) for (var c = h; c < o; c++) i[f + c] = a[u + c];
            if (v == 3) for (var c = h; c < o; c++) i[f + c] = a[u + c] - (a[u + c - h] >> 1) + 256 & 255;
            if (v == 4) for (var c = h; c < o; c++) i[f + c] = a[u + c] - m(a[u + c - h], 0, 0) + 256 & 255;
          } else {
            if (v == 2)
              for (var c = 0; c < o; c++) i[f + c] = a[u + c] + 256 - a[u + c - o] & 255;
            if (v == 3) {
              for (var c = 0; c < h; c++) i[f + c] = a[u + c] + 256 - (a[u + c - o] >> 1) & 255;
              for (var c = h; c < o; c++) i[f + c] = a[u + c] + 256 - (a[u + c - o] + a[u + c - h] >> 1) & 255;
            }
            if (v == 4) {
              for (var c = 0; c < h; c++) i[f + c] = a[u + c] + 256 - m(0, a[u + c - o], 0) & 255;
              for (var c = h; c < o; c++) i[f + c] = a[u + c] + 256 - m(a[u + c - h], a[u + c - o], a[u + c - h - o]) & 255;
            }
          }
        }, r.crc = {
          table: (function() {
            for (var i = new Uint32Array(256), a = 0; a < 256; a++) {
              for (var l = a, o = 0; o < 8; o++)
                l & 1 ? l = 3988292384 ^ l >>> 1 : l = l >>> 1;
              i[a] = l;
            }
            return i;
          })(),
          update: function(i, a, l, o) {
            for (var h = 0; h < o; h++) i = r.crc.table[(i ^ a[l + h]) & 255] ^ i >>> 8;
            return i;
          },
          crc: function(i, a, l) {
            return r.crc.update(4294967295, i, a, l) ^ 4294967295;
          }
        }, r.quantize = function(i, a, l) {
          for (var o = [], h = 0, v = 0; v < i.length; v++)
            o.push(r.encode.alphaMul(new Uint8Array(i[v]), l)), h += i[v].byteLength;
          for (var u = new Uint8Array(h), f = new Uint32Array(u.buffer), m = 0, v = 0; v < o.length; v++) {
            for (var c = o[v], w = c.length, _ = 0; _ < w; _++) u[m + _] = c[_];
            m += w;
          }
          var g = { i0: 0, i1: u.length, bst: null, est: null, tdst: 0, left: null, right: null };
          g.bst = r.quantize.stats(u, g.i0, g.i1), g.est = r.quantize.estats(g.bst);
          for (var b = [g]; b.length < a; ) {
            for (var S = 0, E = 0, v = 0; v < b.length; v++) b[v].est.L > S && (S = b[v].est.L, E = v);
            if (S < 1e-3) break;
            var I = b[E], $ = r.quantize.splitPixels(u, f, I.i0, I.i1, I.est.e, I.est.eMq255), C = { i0: I.i0, i1: $, bst: null, est: null, tdst: 0, left: null, right: null };
            C.bst = r.quantize.stats(u, C.i0, C.i1), C.est = r.quantize.estats(C.bst);
            var F = { i0: $, i1: I.i1, bst: null, est: null, tdst: 0, left: null, right: null };
            F.bst = { R: [], m: [], N: I.bst.N - C.bst.N };
            for (var v = 0; v < 16; v++) F.bst.R[v] = I.bst.R[v] - C.bst.R[v];
            for (var v = 0; v < 4; v++) F.bst.m[v] = I.bst.m[v] - C.bst.m[v];
            F.est = r.quantize.estats(F.bst), I.left = C, I.right = F, b[E] = C, b.push(F);
          }
          b.sort(function(B, ie) {
            return ie.bst.N - B.bst.N;
          });
          for (var V = 0; V < o.length; V++) {
            for (var K = r.quantize.planeDst, O = new Uint8Array(o[V].buffer), G = new Uint32Array(o[V].buffer), P = O.length, v = 0; v < P; v += 4) {
              for (var T = O[v] * 0.00392156862745098, A = O[v + 1] * (1 / 255), z = O[v + 2] * (1 / 255), U = O[v + 3] * (1 / 255), X = g; X.left; ) X = K(X.est, T, A, z, U) <= 0 ? X.left : X.right;
              G[v >> 2] = X.est.rgba;
            }
            o[V] = G.buffer;
          }
          return { bufs: o, plte: b };
        }, r.quantize.getNearest = function(i, a, l, o, h) {
          if (i.left == null)
            return i.tdst = r.quantize.dist(i.est.q, a, l, o, h), i;
          var v = r.quantize.planeDst(i.est, a, l, o, h), u = i.left, f = i.right;
          v > 0 && (u = i.right, f = i.left);
          var m = r.quantize.getNearest(u, a, l, o, h);
          if (m.tdst <= v * v) return m;
          var c = r.quantize.getNearest(f, a, l, o, h);
          return c.tdst < m.tdst ? c : m;
        }, r.quantize.planeDst = function(i, a, l, o, h) {
          var v = i.e;
          return v[0] * a + v[1] * l + v[2] * o + v[3] * h - i.eMq;
        }, r.quantize.dist = function(i, a, l, o, h) {
          var v = a - i[0], u = l - i[1], f = o - i[2], m = h - i[3];
          return v * v + u * u + f * f + m * m;
        }, r.quantize.splitPixels = function(i, a, l, o, h, v) {
          var u = r.quantize.vecDot;
          for (o -= 4; l < o; ) {
            for (; u(i, l, h) <= v; ) l += 4;
            for (; u(i, o, h) > v; ) o -= 4;
            if (l >= o) break;
            var f = a[l >> 2];
            a[l >> 2] = a[o >> 2], a[o >> 2] = f, l += 4, o -= 4;
          }
          for (; u(i, l, h) > v; ) l -= 4;
          return l + 4;
        }, r.quantize.vecDot = function(i, a, l) {
          return i[a] * l[0] + i[a + 1] * l[1] + i[a + 2] * l[2] + i[a + 3] * l[3];
        }, r.quantize.stats = function(i, a, l) {
          for (var o = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], h = [0, 0, 0, 0], v = l - a >> 2, u = a; u < l; u += 4) {
            var f = i[u] * 0.00392156862745098, m = i[u + 1] * (1 / 255), c = i[u + 2] * (1 / 255), w = i[u + 3] * (1 / 255);
            h[0] += f, h[1] += m, h[2] += c, h[3] += w, o[0] += f * f, o[1] += f * m, o[2] += f * c, o[3] += f * w, o[5] += m * m, o[6] += m * c, o[7] += m * w, o[10] += c * c, o[11] += c * w, o[15] += w * w;
          }
          return o[4] = o[1], o[8] = o[2], o[12] = o[3], o[9] = o[6], o[13] = o[7], o[14] = o[11], { R: o, m: h, N: v };
        }, r.quantize.estats = function(i) {
          var a = i.R, l = i.m, o = i.N, h = l[0], v = l[1], u = l[2], f = l[3], m = o == 0 ? 0 : 1 / o, c = [
            a[0] - h * h * m,
            a[1] - h * v * m,
            a[2] - h * u * m,
            a[3] - h * f * m,
            a[4] - v * h * m,
            a[5] - v * v * m,
            a[6] - v * u * m,
            a[7] - v * f * m,
            a[8] - u * h * m,
            a[9] - u * v * m,
            a[10] - u * u * m,
            a[11] - u * f * m,
            a[12] - f * h * m,
            a[13] - f * v * m,
            a[14] - f * u * m,
            a[15] - f * f * m
          ], w = c, _ = r.M4, g = [0.5, 0.5, 0.5, 0.5], b = 0, S = 0;
          if (o != 0)
            for (var E = 0; E < 10 && (g = _.multVec(w, g), S = Math.sqrt(_.dot(g, g)), g = _.sml(1 / S, g), !(Math.abs(S - b) < 1e-9)); E++)
              b = S;
          var I = [h * m, v * m, u * m, f * m], $ = _.dot(_.sml(255, I), g), C = I[3] < 1e-3 ? 0 : 1 / I[3];
          return {
            Cov: c,
            q: I,
            e: g,
            L: b,
            eMq255: $,
            eMq: _.dot(g, I),
            rgba: (Math.round(255 * I[3]) << 24 | Math.round(255 * I[2] * C) << 16 | Math.round(255 * I[1] * C) << 8 | Math.round(255 * I[0] * C) << 0) >>> 0
          };
        }, r.M4 = {
          multVec: function(i, a) {
            return [
              i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3],
              i[4] * a[0] + i[5] * a[1] + i[6] * a[2] + i[7] * a[3],
              i[8] * a[0] + i[9] * a[1] + i[10] * a[2] + i[11] * a[3],
              i[12] * a[0] + i[13] * a[1] + i[14] * a[2] + i[15] * a[3]
            ];
          },
          dot: function(i, a) {
            return i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3];
          },
          sml: function(i, a) {
            return [i * a[0], i * a[1], i * a[2], i * a[3]];
          }
        }, r.encode.alphaMul = function(i, a) {
          for (var l = new Uint8Array(i.length), o = i.length >> 2, h = 0; h < o; h++) {
            var v = h << 2, u = i[v + 3];
            a && (u = u < 128 ? 0 : 255);
            var f = u * (1 / 255);
            l[v + 0] = i[v + 0] * f, l[v + 1] = i[v + 1] * f, l[v + 2] = i[v + 2] * f, l[v + 3] = u;
          }
          return l;
        };
      })(t, n);
    })();
  })(_r)), _r.exports;
}
var lh = ih();
const oh = /* @__PURE__ */ X0(lh), sh = () => pa() ? Fa("NuxtImg") : "img", ch = ["alt", "src"], fg = /* @__PURE__ */ Se({
  __name: "LcImage",
  props: {
    alt: {},
    aspectRatio: {},
    blurHash: {},
    densities: {},
    fetchpriority: { default: "low" },
    height: {},
    loading: { type: Boolean },
    preload: { type: Boolean },
    src: {},
    width: {}
  },
  emits: ["error", "load"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = dt("wrapper"), i = sh(), a = we(!0), l = J(
      () => typeof e.aspectRatio == "number" ? e.aspectRatio : (Math.round(e.width) / Math.round(e.height)).toFixed(2)
    ), o = J(() => s.value?.clientHeight ?? 0), h = J(() => s.value?.clientWidth ?? 0), v = J(() => e.loading || a.value), u = J(() => {
      if (!e.blurHash) return;
      const m = W0(e.blurHash, 32, 32), c = new Uint8Array(m), w = oh.encode([c.buffer], 32, 32, 256);
      return "data:image/png;base64," + z0(w);
    }), f = () => {
      a.value = !1, r("load");
    };
    return t({
      clientHeight: o,
      clientWidth: h
    }), (m, c) => (L(), j("div", {
      ref: "wrapper",
      class: "lc-image",
      style: Lt({ "--image-aspect-ratio": l.value })
    }, [
      (L(), Ce(Xt(q(i)), Ee({ key: "image" }, {
        alt: e.alt,
        densities: e.densities,
        fetchpriority: e.fetchpriority,
        height: e.height,
        preload: e.preload,
        src: e.src,
        width: e.width
      }, {
        class: "lc-image__image",
        loading: e.fetchpriority === "high" ? void 0 : "lazy",
        onError: c[0] || (c[0] = (w) => m.$emit("error")),
        onLoad: f
      }), null, 16, ["loading"])),
      u.value ? (L(), Ce(wn, {
        key: 0,
        name: "lc-image__transition"
      }, {
        default: Ie(() => [
          Jt(ae("img", Ee({ key: "placeholder" }, { height: e.height, width: e.width }, {
            alt: e.alt,
            class: "lc-image__placeholder",
            src: u.value
          }), null, 16, ch), [
            [ni, v.value]
          ])
        ]),
        _: 1
      })) : ce("", !0)
    ], 4));
  }
}), uh = {
  key: 1,
  class: "lc-info-text__content"
}, dh = {
  key: 0,
  class: "lc-info-text__text"
}, hg = /* @__PURE__ */ Se({
  __name: "LcInfoText",
  props: {
    headline: {},
    icon: { default: "info" },
    iconAlignment: { default: "top" },
    iconSize: { default: "medium" },
    size: { default: "medium" },
    text: {}
  },
  setup(e) {
    const t = En(), n = J(() => [
      "lc-info-text",
      {
        [`lc-info-text--icon-align-${e.iconAlignment}`]: !0,
        [`lc-info-text--size-${e.size}`]: !0
      }
    ]), r = J(() => [
      "lc-info-text__headline",
      {
        "lc-info-text__headline--with-margin": !!e.text || !!t.default
      }
    ]);
    return (s, i) => (L(), j("article", {
      class: pe(n.value)
    }, [
      Oe(q(Qe), {
        name: e.icon,
        size: e.iconSize
      }, null, 8, ["name", "size"]),
      ae("section", null, [
        e.headline ? (L(), j("span", {
          key: 0,
          class: pe(r.value)
        }, $e(e.headline), 3)) : ce("", !0),
        e.text || s.$slots.default ? (L(), j("div", uh, [
          me(s.$slots, "default", {}, () => [
            e.text ? (L(), j("p", dh, $e(e.text), 1)) : ce("", !0)
          ])
        ])) : ce("", !0)
      ])
    ], 2));
  }
}), vg = ["center", "top"], mg = ["medium", "small"], fh = { class: "lc-link-list" }, gg = /* @__PURE__ */ Se({
  __name: "LcLinkList",
  setup(e) {
    return (t, n) => (L(), j("ul", fh, [
      me(t.$slots, "default")
    ]));
  }
}), hh = { key: 0 }, vh = { class: "lc-link-list-item__headline" }, mh = {
  key: 0,
  class: "lc-link-list-item__text"
}, bg = /* @__PURE__ */ Se({
  __name: "LcLinkListItem",
  props: {
    href: {},
    target: {},
    to: {},
    headline: {},
    icon: {},
    text: {}
  },
  setup(e) {
    const t = J(() => [
      "lc-link-list-item",
      {
        "lc-link-list-item--headline-only": !e.text
      }
    ]);
    return (n, r) => (L(), j("li", {
      class: pe(t.value)
    }, [
      Oe(q(ii), Ee({ href: e.href, target: e.target, to: e.to }, { class: "lc-link-list-item__link" }), {
        default: Ie(() => [
          n.$slots.default ? (L(), j("div", hh, [
            me(n.$slots, "default")
          ])) : (L(), j(Ge, { key: 1 }, [
            e.icon ? (L(), Ce(q(Qe), {
              key: 0,
              name: e.icon
            }, null, 8, ["name"])) : ce("", !0),
            ae("div", null, [
              ae("span", vh, $e(e.headline), 1),
              e.text ? (L(), j("p", mh, $e(e.text), 1)) : ce("", !0)
            ])
          ], 64))
        ]),
        _: 3
      }, 16)
    ], 2));
  }
}), gh = "data:image/svg+xml,%3csvg%20id='eSvZIJXzBLn1'%20width='16'%20height='16'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%2016%2016'%20shape-rendering='geometricPrecision'%20text-rendering='geometricPrecision'%3e%3cstyle%3e%3c![CDATA[%23eSvZIJXzBLn2_to%20{animation:%20eSvZIJXzBLn2_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_to__to%20{%200%25%20{transform:%20translate(7.980026px,1.350002px)}%2024%25%20{transform:%20translate(7.980026px,1.350002px)}%2025%25%20{transform:%20translate(7.980026px,2.07px)}%2028%25%20{transform:%20translate(7.980026px,1px)}%2032%25%20{transform:%20translate(9.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20translate(5.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20translate(8.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20translate(6.980026px,1px)}%2044%25%20{transform:%20translate(7.999896px,1.175001px)}%2048%25%20{transform:%20translate(7.980026px,1.350002px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2052%25%20{transform:%20translate(7.980026px,1.35px)}%20100%25%20{transform:%20translate(7.980026px,1.35px)}}%20%23eSvZIJXzBLn2_tr%20{animation:%20eSvZIJXzBLn2_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2028%25%20{transform:%20rotate(0deg)}%2032%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20rotate(-8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20rotate(-8deg)}%2044%25%20{transform:%20rotate(0deg)}%20100%25%20{transform:%20rotate(0deg)}}%20%23eSvZIJXzBLn3_to%20{animation:%20eSvZIJXzBLn3_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn3_tr%20{animation:%20eSvZIJXzBLn3_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn6_to%20{animation:%20eSvZIJXzBLn6_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn6_tr%20{animation:%20eSvZIJXzBLn6_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%206%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn9_to%20{animation:%20eSvZIJXzBLn9_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn9_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000025px,9.6px);animation-timing-function:%20cubic-bezier(0.42,0,1,1)}%2044%25%20{transform:%20translate(8.000025px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}]]%3e%3c/style%3e%3cg%20id='eSvZIJXzBLn2_to'%20transform='translate(7.980026,1.350002)'%3e%3cg%20id='eSvZIJXzBLn2_tr'%20transform='rotate(0)'%3e%3cpath%20d='M6.06888,2.13247c.8-.2,1.4-.26667,1.93333-.26667s1.13333.06667,1.86667.26667c.33332.13333.73332-.13333.80002-.46667.1333-.33333-.1334-.733329-.4667-.799996-.77705-.253981-1.07173-.333333-2.19999-.333333-.73333,0-1.40328.079352-2.26667.333333-.33333.066667-.53333.399996-.46666.799996.06666.33334.46666.53334.8.46667Z'%20transform='translate(-7.980026,-1.350002)'%20fill='%23394e8e'/%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn3_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn3_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='4.09313'%20rx='0.638'%20ry='0.638'%20transform='translate(7.36206%205.73901)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn6_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn6_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='3.48663'%20rx='0.638'%20ry='0.638'%20transform='matrix(0-1%201%200%205.14111%209.83799)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn9_to'%20transform='translate(8.000025,9.2)'%3e%3cpath%20d='M8.00005,14.2C10.7615,14.2,13,11.9614,13,9.2s-2.2385-5-4.99995-5-5,2.23858-5,5s2.23858,5,5,5Zm0,1.2C11.4242,15.4,14.2,12.6242,14.2,9.2s-2.7758-6.2-6.19995-6.2-6.2,2.77583-6.2,6.2s2.77583,6.2,6.2,6.2Z'%20transform='translate(-8.000025,-9.2)'%20clip-rule='evenodd'%20fill='%23394e8e'%20fill-rule='evenodd'/%3e%3c/g%3e%3c/svg%3e", bh = { class: "lc-lottery-cutoff-time__headline" }, ph = ["src"], yh = { class: "lc-lottery-cutoff-time__time-to-cutoff" }, wh = { class: "lc-lottery-cutoff-time__time-is-almost-up" }, xh = {
  key: 0,
  class: "lc-lottery-cutoff-time__divider"
}, kh = { class: "lc-lottery-cutoff-time__countdown-wrapper" }, Ml = /* @__PURE__ */ Se({
  __name: "LcLotteryCutoffTime",
  props: {
    countdownVariant: { default: "default" },
    cutoffTime: {},
    locale: { default: () => je.general.locale },
    nextCutoffTime: {},
    singleLine: { type: Boolean },
    startAnimationTime: { default: 90 },
    textCutoffTime: { default: () => je.lcLotteryCutoffTime.textCutoffTime },
    textTimeIsAlmostUp: { default: () => je.lcLotteryCutoffTime.textTimeIsAlmostUp },
    textTimeToCutoff: { default: () => je.lcLotteryCutoffTime.textTimeToCutoff },
    variant: { default: "default" }
  },
  emits: ["cutoff-time-reached"],
  setup(e, { emit: t }) {
    const n = t, r = we(), s = To(() => /* @__PURE__ */ new Date()), i = J(() => [
      "lc-lottery-cutoff-time",
      `lc-lottery-cutoff-time--variant-${e.variant}`,
      {
        "lc-lottery-cutoff-time--animated": h.value,
        "lc-lottery-cutoff-time--single-line": e.singleLine
      }
    ]), a = J(() => new Date(e.cutoffTime)), l = J(
      () => Lo({
        date: v.value,
        format: "drawingShort",
        locale: e.locale
      })
    ), o = J(() => u("days") === 0), h = J(() => {
      const m = u("minutes");
      return o.value && m ? m < e.startAnimationTime : !1;
    }), v = J({
      get: () => r.value ?? new Date(e.cutoffTime),
      set: (m) => {
        r.value = m;
      }
    }), u = (m) => {
      if (!ai(a.value)) return null;
      const { days: c = 0, hours: w = 0, minutes: _ = 0 } = Ao(s.value, a.value);
      switch (m) {
        case "days":
          return c;
        case "minutes":
          return c * 24 + w * 60 + _;
      }
    }, f = () => {
      n("cutoff-time-reached"), bo(a.value) && e.nextCutoffTime && (v.value = new Date(e.nextCutoffTime));
    };
    return (m, c) => (L(), j("div", {
      class: pe(i.value)
    }, [
      ae("span", bh, [
        h.value ? (L(), j("img", {
          key: 0,
          alt: "",
          height: "16",
          src: q(gh),
          width: "16"
        }, null, 8, ph)) : (L(), Ce(q(Qe), {
          key: 1,
          name: o.value ? "alarm" : "time",
          size: "small"
        }, null, 8, ["name"])),
        me(m.$slots, "title", {}, () => [
          ae("span", yh, $e(o.value ? e.textTimeToCutoff : e.textCutoffTime), 1),
          ae("span", wh, $e(e.textTimeIsAlmostUp), 1)
        ])
      ]),
      e.variant === "default" && e.singleLine ? (L(), j("span", xh, " : ")) : ce("", !0),
      ae("div", kh, [
        o.value ? (L(), Ce(q(Bd), {
          key: 0,
          class: "lc-lottery-cutoff-time__countdown",
          "expires-at": v.value,
          variant: e.countdownVariant,
          onExpired: f,
          onUpdate: c[0] || (c[0] = (w) => s.value = /* @__PURE__ */ new Date())
        }, null, 8, ["expires-at", "variant"])) : (L(), Ce(q(wo), Ee({
          key: 1,
          class: "lc-lottery-cutoff-time__date-time"
        }, { locale: e.locale, ...q(fi).drawingShort }, { datetime: v.value }), {
          default: Ie(() => [
            yt($e(l.value), 1)
          ]),
          _: 1
        }, 16, ["datetime"]))
      ])
    ], 2));
  }
}), pg = ["default", "expressive"], _h = {
  key: 0,
  class: "lc-lottery-numbers__icon-wrap"
}, Sh = {
  key: 0,
  class: "lc-lottery-numbers__field-divider"
}, Ch = "extra", Eh = /* @__PURE__ */ Se({
  __name: "LcLotteryNumbers",
  props: {
    fields: {},
    listClass: {},
    numberClass: { type: Function },
    rows: {},
    size: { default: "medium" },
    spacing: { default: "medium" }
  },
  setup(e) {
    const t = J(() => [
      "lc-lottery-numbers",
      `lc-lottery-numbers--size-${e.size}`,
      `lc-lottery-numbers--spacing-${e.spacing}`,
      {
        "lc-lottery-numbers--multiple-rows": e.rows
      }
    ]), n = J(() => s.value.flat().length), r = J(() => e.rows ? Math.ceil(n.value / e.rows) : n.value), s = J(
      () => e.fields.map(
        ({ name: i, numbers: a }) => a.map(({ icon: l, ignored: o, matching: h, value: v }) => ({
          empty: !l && !o && (v === void 0 || v === ""),
          icon: l,
          ignored: o,
          matching: h,
          name: i.toLowerCase().replace("_", "-"),
          number: v
        }))
      ).filter((i) => !!i.length)
    );
    return (i, a) => (L(), j("article", {
      class: pe(t.value),
      style: Lt({ "--items-per-row": r.value })
    }, [
      ae("ol", {
        class: pe(["lc-lottery-numbers__list", e.listClass])
      }, [
        (L(!0), j(Ge, null, vt(s.value, (l, o) => (L(), j(Ge, { key: o }, [
          (L(!0), j(Ge, null, vt(l, ({ empty: h, icon: v, ignored: u, matching: f, name: m, number: c }, w) => (L(), j(Ge, {
            key: `${o}-${w}`
          }, [
            ae("li", {
              class: "lc-lottery-numbers__list-item",
              style: Lt({
                "--number-bg": `var(--lottery-numbers-${m}-bg)`,
                "--number-border": `var(--lottery-numbers-${m}-border)`,
                "--number-color": `var(--lottery-numbers-${m}-color)`,
                "--number-font-size": `var(--lottery-numbers-${m}-font-size)`,
                "--number-font-weight": `var(--lottery-numbers-${m}-font-weight)`
              })
            }, [
              me(i.$slots, `highlight-${m}`),
              ae("div", {
                class: pe(["lc-lottery-numbers__number", [
                  {
                    "lc-lottery-numbers__number--empty": h,
                    "lc-lottery-numbers__number--empty-extra": h && m === Ch,
                    "lc-lottery-numbers__number--ignored": u
                  },
                  e.numberClass ? e.numberClass(c, m) : ""
                ]])
              }, [
                f ? (L(), j("div", _h, [
                  Oe(q(Qe), {
                    class: "lc-lottery-numbers__icon",
                    name: "checkmark-small"
                  })
                ])) : ce("", !0),
                me(i.$slots, `number-${m}`, Ee({ ref_for: !0 }, { icon: v, number: c }), () => [
                  v ? (L(), Ce(q(Qe), {
                    key: 0,
                    name: v
                  }, null, 8, ["name"])) : (L(), j(Ge, { key: 1 }, [
                    yt($e(u ? "X" : c), 1)
                  ], 64))
                ])
              ], 2)
            ], 4),
            o < s.value.length - 1 && w === l.length - 1 && i.$slots["field-divider"] ? (L(), j("li", Sh, [
              me(i.$slots, "field-divider")
            ])) : ce("", !0)
          ], 64))), 128))
        ], 64))), 128))
      ], 2)
    ], 6));
  }
}), yg = ["large", "medium", "small"], wg = ["medium", "small"], xg = [
  "custom-cell",
  "default",
  "high-frequency",
  "round"
];
var qt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Home = "Home", e))(qt || {});
const Th = ["id"], Ah = { class: "lc-lottery-number-selector__label" }, Lh = ["for"], $h = ["id", "checked", "disabled", "tabindex", "onChange", "onFocusin", "onKeydown"], kg = /* @__PURE__ */ Se({
  __name: "LcLotteryNumberSelector",
  props: {
    allNumbersToggled: { type: Boolean },
    disabled: { type: Boolean },
    fixedColumns: {},
    id: {},
    label: {},
    max: {},
    min: { default: 1 },
    selectableNumbers: {},
    selectableMax: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["complete", "update:value"],
  setup(e, { emit: t }) {
    const n = t, r = No(), s = dt("numberInputs"), i = Ct(e.id), a = we(e.fixedColumns ?? 0), l = we(0), o = J(() => E(l.value)), h = J(
      () => u.value ? c.value : f.value
    ), v = J(() => $(l.value)), u = J(() => e.value.length >= e.selectableMax), f = J(() => {
      const B = Array.from({ length: b.value }, () => []);
      return m.value.map((ie, H) => {
        B[$(H)].push(H);
      }), T(B);
    }), m = J(() => {
      if (e.selectableNumbers?.length)
        return [...e.selectableNumbers];
      if (e.max === void 0)
        throw Error('LcLotteryNumberSelector: provide "max" or "selectableNumbers".');
      if (e.min < 0)
        throw Error('LcLotteryNumberSelector: "min" must be >= 0.');
      if (e.min >= e.max)
        throw Error('LcLotteryNumberSelector: "max" must be greater than "min".');
      return Array.from({ length: e.max - e.min + 1 }, (B, ie) => e.min + ie);
    }), c = J(
      () => f.value.map(
        (B) => B.map(
          (ie) => w.value.includes(ie) ? ie : -1
        )
      )
    ), w = J(() => e.value.map((B) => m.value.indexOf(B))), _ = J(() => Math.min(g.value, a.value)), g = J(() => m.value.length), b = J(() => Math.ceil(g.value / _.value)), S = (B) => {
      const ie = h.value.length, H = h.value[0].length;
      let ee = v.value, ue = o.value;
      do
        switch (B) {
          case "down":
            ee = (ee + 1) % ie, ee === 0 && (ue = (ue + 1) % H);
            break;
          case "left":
            ue = (ue - 1 + H) % H, ue === H - 1 && (ee = (ee - 1 + ie) % ie);
            break;
          case "right":
            ue = (ue + 1) % H, ue === 0 && (ee = (ee + 1) % ie);
            break;
          case "up":
            ee = (ee - 1 + ie) % ie, ee === ie - 1 && (ue = (ue - 1 + H) % H);
            break;
        }
      while (h.value[ee][ue] === -1);
      return h.value[ee][ue];
    }, E = (B) => B % _.value, I = (B) => ({
      "lc-lottery-number-selector__number": !0,
      "lc-lottery-number-selector__number--all-checked": e.allNumbersToggled,
      "lc-lottery-number-selector__number--checked": A(B),
      "lc-lottery-number-selector__number--disabled": z(B)
    }), $ = (B) => Math.floor(B / _.value), C = () => {
      if (u.value) {
        const H = f.value[v.value].filter(
          (ee) => ee > l.value && w.value.includes(ee)
        ).reverse();
        if (!H.length) return;
        l.value = H[0];
        return;
      }
      const B = f.value[v.value];
      l.value = B.at(-1) ?? 0;
    }, F = () => {
      if (u.value) {
        const H = f.value[v.value].filter(
          (ee) => ee < l.value && w.value.includes(ee)
        );
        if (!H.length) return;
        l.value = H[0];
        return;
      }
      const B = f.value[v.value];
      l.value = B[0];
    }, V = () => {
      l.value = u.value ? w.value[0] : 0;
    }, K = () => {
      const B = w.value.at(-1) ?? 0;
      l.value = u.value ? B : g.value - 1;
    }, O = (B) => {
      en(B.key, qt) && (B.preventDefault(), B.stopPropagation(), B.ctrlKey ? G(B.key) : P(B.key));
    }, G = (B) => {
      switch (B) {
        case qt.End:
          K();
          break;
        case qt.Home:
          V();
          break;
      }
    }, P = (B) => {
      switch (B) {
        case qt.ArrowDown:
          l.value = S("down");
          break;
        case qt.ArrowLeft:
          l.value = S("left");
          break;
        case qt.ArrowRight:
          l.value = S("right");
          break;
        case qt.ArrowUp:
          l.value = S("up");
          break;
        case qt.End:
          C();
          break;
        case qt.Home:
          F();
          break;
      }
    }, T = (B) => {
      const ie = Math.max(...B.map((H) => H.length));
      return B.map((H) => {
        const ee = [...H];
        for (; ee.length < ie; )
          ee.push(-1);
        return ee;
      });
    }, A = (B) => e.value.includes(B), z = (B) => e.disabled || !A(B) && u.value || e.allNumbersToggled, U = (B) => {
      const ie = [...e.value], H = ie.indexOf(B);
      H > -1 ? ie.splice(H, 1) : u.value || (ie.push(B), ie.sort((ee, ue) => ee - ue)), n("update:value", ie);
    };
    Ve(
      () => e.allNumbersToggled,
      () => {
        const B = e.allNumbersToggled ? m.value : [];
        n("update:value", B);
      }
    ), Ve(l, (B) => {
      s.value?.[B].focus();
    }), Ve(u, (B) => {
      B && n("complete");
    });
    const X = qs(() => {
      if (e.fixedColumns && e.fixedColumns >= 0) {
        a.value = e.fixedColumns;
        return;
      }
      const B = s.value;
      if (!r || !B?.length) return;
      const ie = B[0].getBoundingClientRect().top;
      let H = 0;
      for (const ee of B) {
        if (ee.getBoundingClientRect().top !== ie) break;
        H++;
      }
      a.value = H;
    }, 100);
    return Ve(() => e.fixedColumns, X), wt(X), on(window, "resize", X), (B, ie) => (L(), j("fieldset", Ee(B.$attrs, {
      id: q(i),
      class: [
        "lc-lottery-number-selector",
        `lc-lottery-number-selector--${e.variant}`,
        {
          "lc-lottery-number-selector--fixed-columns": e.fixedColumns && e.fixedColumns >= 0
        }
      ],
      style: {
        "--fixed-columns": e.fixedColumns,
        "--hfg-number-background": "var(--lottery-numbers-extra-bg)",
        "--number-bg": "var(--lottery-numbers-extra-bg)",
        "--round-number-bg": `var(--lottery-number-rounded-${e.id}-bg)`,
        "--round-number-color": `var(--lottery-number-rounded-${e.id}-color)`
      }
    }), [
      ae("legend", Ah, $e(e.label), 1),
      (L(!0), j(Ge, null, vt(m.value, (H, ee) => (L(), j("label", {
        key: H,
        class: pe(I(H)),
        for: `gridcell-${E(ee)}-${$(ee)}-${q(i)}`
      }, [
        ae("input", {
          id: `gridcell-${E(ee)}-${$(ee)}-${q(i)}`,
          ref_for: !0,
          ref: "numberInputs",
          checked: A(H),
          class: "lc-lottery-number-selector__input",
          disabled: z(H),
          tabindex: l.value === ee || A(H) ? 0 : -1,
          type: "checkbox",
          onChange: () => U(H),
          onFocusin: (ue) => l.value = ee,
          onKeydown: [
            O,
            ti(() => U(H), ["enter"])
          ]
        }, null, 40, $h),
        me(B.$slots, "cell", Ee({ ref_for: !0 }, {
          checked: A(H),
          disabled: z(H),
          number: H
        }), () => [
          yt($e(H), 1)
        ])
      ], 10, Lh))), 128))
    ], 16, Th));
  }
}), Ih = { class: "w-full" }, Dh = {
  key: 0,
  class: "lc-lottery-teaser__jackpot-text"
}, Mh = {
  key: 1,
  class: "lc-lottery-teaser__jackpot-text"
}, Oh = { class: "lc-lottery-teaser__button-container" }, Rh = { class: "lc-lottery-teaser__button-wrap" }, Fh = {
  key: 0,
  class: "lc-lottery-teaser__button-wrap"
}, Nh = {
  key: 0,
  class: "lc-lottery-teaser__draw-date"
}, Bh = { class: "lc-lottery-teaser__draw-date-headline" }, _g = /* @__PURE__ */ Se({
  __name: "LcLotteryTeaser",
  props: {
    cutoffTime: {},
    nextCutoffTime: {},
    backgroundPattern: {},
    badge: {},
    comingSoon: { type: Boolean },
    drawDate: {},
    drawDateHeadline: {},
    headline: {},
    jackpot: {},
    locale: { default: () => je.general.locale },
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" }
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    const t = En(), n = J(() => [
      "lc-lottery-teaser",
      `lc-lottery-teaser--variant-${e.variant}`,
      {
        "lc-lottery-teaser--two-buttons": s.value
      }
    ]), r = J(
      () => Lo({
        date: e.drawDate,
        format: "drawingShort",
        locale: e.locale
      })
    ), s = J(
      () => e.variant !== "expressive" && !!(e.secondaryButtonProps?.text || t["secondary-button"])
    ), i = J(
      () => e.primaryButtonProps.to ? Wn(e.primaryButtonProps.to) : "div"
    );
    return (a, l) => (L(), Ce(q(tr), Ee({ badge: e.badge, backgroundPattern: e.backgroundPattern }, {
      "body-class": "lc-lottery-teaser__body",
      class: n.value,
      "footer-class": "lc-lottery-teaser__footer",
      "header-class": "lc-lottery-teaser__header",
      "header-to": e.primaryButtonProps.to,
      style: {
        "--teaser-frame-color": "var(--lottery-teaser-frame-color)"
      },
      variant: e.variant === "expressive" ? "default" : e.variant,
      onHeaderClick: e.onTeaserClick
    }), Xa({
      header: Ie(() => [
        me(a.$slots, "lottery-logo")
      ]),
      default: Ie(() => [
        e.variant === "expressive" ? (L(), Ce(q(Ml), Ee({ key: 0 }, { cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
          class: "lc-lottery-teaser__cutoff-time",
          variant: "expressive",
          onCutoffTimeReached: l[0] || (l[0] = (o) => a.$emit("outdated"))
        }), null, 16)) : ce("", !0),
        ae("section", Ih, [
          (L(), Ce(Xt(i.value), {
            class: "lc-lottery-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: Ie(() => [
              e.headline ? (L(), j("strong", Dh, $e(e.headline), 1)) : ce("", !0),
              Oe(q(Fo), Ee(e.jackpot, { size: "small" }), null, 16),
              e.subline ? (L(), j("strong", Mh, $e(e.subline), 1)) : ce("", !0)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ae("section", Oh, [
          ae("div", Rh, [
            me(a.$slots, "primary-button", {}, () => [
              Oe(q(St), Ee(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                variant: s.value ? "primary-ghost" : "primary",
                onClick: l[1] || (l[1] = (o) => a.$emit("primary-button-click"))
              }), {
                default: Ie(() => [
                  yt($e(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label", "variant"])
            ])
          ]),
          s.value ? (L(), j("div", Fh, [
            me(a.$slots, "secondary-button", {}, () => [
              e.secondaryButtonProps ? (L(), Ce(q(St), Ee({ key: 0 }, e.secondaryButtonProps, {
                "aria-label": e.secondaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                onClick: l[2] || (l[2] = (o) => a.$emit("secondary-button-click"))
              }), {
                default: Ie(() => [
                  yt($e(e.secondaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])) : ce("", !0)
            ])
          ])) : ce("", !0)
        ])
      ]),
      _: 2
    }, [
      e.variant !== "expressive" ? {
        name: "footer",
        fn: Ie(() => [
          ["default", "badge"].includes(e.variant) ? (L(), j("div", Nh, [
            ae("div", Bh, [
              Oe(q(Qe), {
                name: "calendar",
                size: "small"
              }),
              ae("span", null, $e(e.drawDateHeadline), 1)
            ]),
            Oe(q(wo), Ee({ locale: e.locale, ...q(fi).drawingShort }, { datetime: e.drawDate }), {
              default: Ie(() => [
                yt($e(r.value), 1)
              ]),
              _: 1
            }, 16, ["datetime"])
          ])) : ce("", !0),
          Oe(q(Ml), Ee({ cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
            "single-line": e.variant === "hero",
            variant: e.variant === "hero" ? "expressive" : "default",
            onCutoffTimeReached: l[3] || (l[3] = (o) => a.$emit("outdated"))
          }), null, 16, ["single-line", "variant"])
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["class", "header-to", "variant", "onHeaderClick"]));
  }
}), Sg = [...Po, "expressive"], Ph = { class: "lc-masked-value-display" }, Cg = /* @__PURE__ */ Se({
  __name: "LcMaskedValueDisplay",
  props: {
    masksPerPart: { default: 4 },
    parts: { default: 1 }
  },
  setup(e) {
    return (t, n) => (L(), j("span", Ph, [
      (L(!0), j(Ge, null, vt(e.parts, (r) => (L(), j("span", {
        key: r,
        class: "lc-masked-value-display__part"
      }, [
        (L(!0), j(Ge, null, vt(e.masksPerPart, (s) => (L(), j("span", {
          key: s,
          class: "lc-masked-value-display__mask"
        }))), 128))
      ]))), 128)),
      me(t.$slots, "default")
    ]));
  }
}), Wr = Math.min, Nn = Math.max, Ua = Math.round, Ia = Math.floor, Kt = (e) => ({
  x: e,
  y: e
}), zh = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function vi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function qn(e) {
  return e.split("-")[0];
}
function nr(e) {
  return e.split("-")[1];
}
function Vh(e) {
  return e === "x" ? "y" : "x";
}
function Zo(e) {
  return e === "y" ? "height" : "width";
}
function yn(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function Wo(e) {
  return Vh(yn(e));
}
function Hh(e, t, n) {
  n === void 0 && (n = !1);
  const r = nr(e), s = Wo(e), i = Zo(s);
  let a = s === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = qa(a)), [a, qa(a)];
}
function Uh(e) {
  const t = qa(e);
  return [Xr(e), t, Xr(t)];
}
function Xr(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Ol = ["left", "right"], Rl = ["right", "left"], qh = ["top", "bottom"], jh = ["bottom", "top"];
function Zh(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Rl : Ol : t ? Ol : Rl;
    case "left":
    case "right":
      return t ? qh : jh;
    default:
      return [];
  }
}
function Wh(e, t, n, r) {
  const s = nr(e);
  let i = Zh(qn(e), n === "start", r);
  return s && (i = i.map((a) => a + "-" + s), t && (i = i.concat(i.map(Xr)))), i;
}
function qa(e) {
  const t = qn(e);
  return zh[t] + e.slice(t.length);
}
function Xh(e) {
  var t, n, r, s;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (r = e.bottom) != null ? r : 0,
    left: (s = e.left) != null ? s : 0
  };
}
function Yh(e) {
  return typeof e != "number" ? Xh(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ja(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: s
  } = e;
  return {
    width: r,
    height: s,
    top: n,
    left: t,
    right: t + r,
    bottom: n + s,
    x: t,
    y: n
  };
}
function Fl(e, t, n) {
  let {
    reference: r,
    floating: s
  } = e;
  const i = yn(t), a = Wo(t), l = Zo(a), o = qn(t), h = i === "y", v = r.x + r.width / 2 - s.width / 2, u = r.y + r.height / 2 - s.height / 2, f = r[l] / 2 - s[l] / 2;
  let m;
  switch (o) {
    case "top":
      m = {
        x: v,
        y: r.y - s.height
      };
      break;
    case "bottom":
      m = {
        x: v,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      m = {
        x: r.x - s.width,
        y: u
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  const c = nr(t);
  return c && (m[a] += f * (c === "end" ? 1 : -1) * (n && h ? -1 : 1)), m;
}
async function Gh(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: s,
    platform: i,
    rects: a,
    elements: l,
    strategy: o
  } = e, {
    boundary: h = "clippingAncestors",
    rootBoundary: v = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = vi(t, e), c = Yh(m), _ = l[f ? u === "floating" ? "reference" : "floating" : u], g = ja(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(_))) == null || n ? _ : _.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: h,
    rootBoundary: v,
    strategy: o
  })), b = u === "floating" ? {
    x: r,
    y: s,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, S = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), E = await (i.isElement == null ? void 0 : i.isElement(S)) && await (i.getScale == null ? void 0 : i.getScale(S)) || {
    x: 1,
    y: 1
  }, I = ja(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: b,
    offsetParent: S,
    strategy: o
  }) : b);
  return {
    top: (g.top - I.top + c.top) / E.y,
    bottom: (I.bottom - g.bottom + c.bottom) / E.y,
    left: (g.left - I.left + c.left) / E.x,
    right: (I.right - g.right + c.right) / E.x
  };
}
const Kh = 50, Jh = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: s = "absolute",
    middleware: i = [],
    platform: a
  } = n, l = a.detectOverflow ? a : {
    ...a,
    detectOverflow: Gh
  }, o = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let h = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: v,
    y: u
  } = Fl(h, r, o), f = r, m = 0;
  const c = {};
  for (let w = 0; w < i.length; w++) {
    const _ = i[w];
    if (!_)
      continue;
    const {
      name: g,
      fn: b
    } = _, {
      x: S,
      y: E,
      data: I,
      reset: $
    } = await b({
      x: v,
      y: u,
      initialPlacement: r,
      placement: f,
      strategy: s,
      middlewareData: c,
      rects: h,
      platform: l,
      elements: {
        reference: e,
        floating: t
      }
    });
    v = S ?? v, u = E ?? u, c[g] = {
      ...c[g],
      ...I
    }, $ && m < Kh && (m++, typeof $ == "object" && ($.placement && (f = $.placement), $.rects && (h = $.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }) : $.rects), {
      x: v,
      y: u
    } = Fl(h, f, o)), w = -1);
  }
  return {
    x: v,
    y: u,
    placement: f,
    strategy: s,
    middlewareData: c
  };
}, Qh = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: s,
        middlewareData: i,
        rects: a,
        initialPlacement: l,
        platform: o,
        elements: h
      } = t, {
        mainAxis: v = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: c = "none",
        flipAlignment: w = !0,
        ..._
      } = vi(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const g = qn(s), b = yn(l), S = qn(l) === l, E = await (o.isRTL == null ? void 0 : o.isRTL(h.floating)), I = f || (S || !w ? [qa(l)] : Uh(l)), $ = c !== "none";
      !f && $ && I.push(...Wh(l, w, c, E));
      const C = [l, ...I], F = await o.detectOverflow(t, _), V = [];
      let K = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (v && V.push(F[g]), u) {
        const T = Hh(s, a, E);
        V.push(F[T[0]], F[T[1]]);
      }
      if (K = [...K, {
        placement: s,
        overflows: V
      }], !V.every((T) => T <= 0)) {
        var O, G;
        const T = (((O = i.flip) == null ? void 0 : O.index) || 0) + 1, A = C[T];
        if (A && (!(u === "alignment" ? b !== yn(A) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        K.every((X) => yn(X.placement) === b ? X.overflows[0] > 0 : !0)))
          return {
            data: {
              index: T,
              overflows: K
            },
            reset: {
              placement: A
            }
          };
        let z = (G = K.filter((U) => U.overflows[0] <= 0).sort((U, X) => U.overflows[1] - X.overflows[1])[0]) == null ? void 0 : G.placement;
        if (!z)
          switch (m) {
            case "bestFit": {
              var P;
              const U = (P = K.filter((X) => {
                if ($) {
                  const B = yn(X.placement);
                  return B === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  B === "y";
                }
                return !0;
              }).map((X) => [X.placement, X.overflows.filter((B) => B > 0).reduce((B, ie) => B + ie, 0)]).sort((X, B) => X[1] - B[1])[0]) == null ? void 0 : P[0];
              U && (z = U);
              break;
            }
            case "initialPlacement":
              z = l;
              break;
          }
        if (s !== z)
          return {
            reset: {
              placement: z
            }
          };
      }
      return {};
    }
  };
}, ev = /* @__PURE__ */ new Set(["left", "top"]);
async function tv(e, t) {
  const {
    placement: n,
    platform: r,
    elements: s
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(s.floating)), a = qn(n), l = nr(n), o = yn(n) === "y", h = ev.has(a) ? -1 : 1, v = i && o ? -1 : 1, u = vi(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: c
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return l && typeof c == "number" && (m = l === "end" ? c * -1 : c), o ? {
    x: m * v,
    y: f * h
  } : {
    x: f * h,
    y: m * v
  };
}
const nv = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: s,
        y: i,
        placement: a,
        middlewareData: l
      } = t, o = await tv(t, e);
      return a === ((n = l.offset) == null ? void 0 : n.placement) && (r = l.arrow) != null && r.alignmentOffset ? {} : {
        x: s + o.x,
        y: i + o.y,
        data: {
          ...o,
          placement: a
        }
      };
    }
  };
};
function ar() {
  return typeof window < "u";
}
function Ln(e) {
  return mi(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function It(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function tn(e) {
  var t;
  return (t = (mi(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function mi(e) {
  return ar() ? e instanceof Node || e instanceof It(e).Node : !1;
}
function Zt(e) {
  return ar() ? e instanceof Element || e instanceof It(e).Element : !1;
}
function dn(e) {
  return ar() ? e instanceof HTMLElement || e instanceof It(e).HTMLElement : !1;
}
function Nl(e) {
  return !ar() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof It(e).ShadowRoot;
}
function rr(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: s
  } = Wt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && s !== "inline" && s !== "contents";
}
function av(e) {
  return /^(table|td|th)$/.test(Ln(e));
}
function ir(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const rv = /transform|translate|scale|rotate|perspective|filter/, iv = /paint|layout|strict|content/, bn = (e) => !!e && e !== "none";
let Or;
function gi(e) {
  const t = Zt(e) ? Wt(e) : e;
  return bn(t.transform) || bn(t.translate) || bn(t.scale) || bn(t.rotate) || bn(t.perspective) || !bi() && (bn(t.backdropFilter) || bn(t.filter)) || rv.test(t.willChange || "") || iv.test(t.contain || "");
}
function lv(e) {
  let t = Sn(e);
  for (; dn(t) && !va(t); ) {
    if (gi(t))
      return t;
    if (ir(t))
      return null;
    t = Sn(t);
  }
  return null;
}
function bi() {
  return Or == null && (Or = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Or;
}
function va(e) {
  return /^(html|body|#document)$/.test(Ln(e));
}
function Wt(e) {
  return It(e).getComputedStyle(e);
}
function lr(e) {
  return Zt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Sn(e) {
  if (Ln(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Nl(e) && e.host || // Fallback.
    tn(e)
  );
  return Nl(t) ? t.host : t;
}
function Xo(e) {
  const t = Sn(e);
  return va(t) ? (e.ownerDocument || e).body : dn(t) && rr(t) ? t : Xo(t);
}
function ma(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const s = Xo(e), i = s === ((r = e.ownerDocument) == null ? void 0 : r.body), a = It(s);
  if (i) {
    const l = Yr(a);
    return t.concat(a, a.visualViewport || [], rr(s) ? s : [], l && n ? ma(l) : []);
  } else
    return t.concat(s, ma(s, [], n));
}
function Yr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Yo(e) {
  const t = Wt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const s = dn(e), i = s ? e.offsetWidth : n, a = s ? e.offsetHeight : r, l = Ua(n) !== i || Ua(r) !== a;
  return l && (n = i, r = a), {
    width: n,
    height: r,
    $: l
  };
}
function pi(e) {
  return Zt(e) ? e : e.contextElement;
}
function Bn(e) {
  const t = pi(e);
  if (!dn(t))
    return Kt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: s,
    $: i
  } = Yo(t);
  let a = (i ? Ua(n.width) : n.width) / r, l = (i ? Ua(n.height) : n.height) / s;
  return (!a || !Number.isFinite(a)) && (a = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: a,
    y: l
  };
}
const ov = /* @__PURE__ */ Kt(0);
function Go(e) {
  const t = It(e);
  return !bi() || !t.visualViewport ? ov : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function sv(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === It(e);
}
function Cn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(), i = pi(e);
  let a = Kt(1);
  t && (r ? Zt(r) && (a = Bn(r)) : a = Bn(e));
  const l = sv(i, n, r) ? Go(i) : Kt(0);
  let o = (s.left + l.x) / a.x, h = (s.top + l.y) / a.y, v = s.width / a.x, u = s.height / a.y;
  if (i && r) {
    const f = It(i), m = Zt(r) ? It(r) : r;
    let c = f, w = Yr(c);
    for (; w && m !== c; ) {
      const _ = Bn(w), g = w.getBoundingClientRect(), b = Wt(w), S = g.left + (w.clientLeft + parseFloat(b.paddingLeft)) * _.x, E = g.top + (w.clientTop + parseFloat(b.paddingTop)) * _.y;
      o *= _.x, h *= _.y, v *= _.x, u *= _.y, o += S, h += E, c = It(w), w = Yr(c);
    }
  }
  return ja({
    width: v,
    height: u,
    x: o,
    y: h
  });
}
function or(e, t) {
  const n = lr(e).scrollLeft;
  return t ? t.left + n : Cn(tn(e)).left + n;
}
function Ko(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - or(e, n), s = n.top + t.scrollTop;
  return {
    x: r,
    y: s
  };
}
function cv(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: s
  } = e;
  const i = s === "fixed", a = tn(r), l = t ? ir(t.floating) : !1;
  if (r === a || l && i)
    return n;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = Kt(1);
  const v = Kt(0), u = dn(r);
  if ((u || !i) && ((Ln(r) !== "body" || rr(a)) && (o = lr(r)), u)) {
    const m = Cn(r);
    h = Bn(r), v.x = m.x + r.clientLeft, v.y = m.y + r.clientTop;
  }
  const f = a && !u && !i ? Ko(a, o) : Kt(0);
  return {
    width: n.width * h.x,
    height: n.height * h.y,
    x: n.x * h.x - o.scrollLeft * h.x + v.x + f.x,
    y: n.y * h.y - o.scrollTop * h.y + v.y + f.y
  };
}
function uv(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function dv(e) {
  const t = lr(e), n = e.ownerDocument.body, r = Nn(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), s = Nn(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -t.scrollLeft + or(e);
  const a = -t.scrollTop;
  return Wt(n).direction === "rtl" && (i += Nn(e.clientWidth, n.clientWidth) - r), {
    width: r,
    height: s,
    x: i,
    y: a
  };
}
const fv = 25;
function hv(e, t, n) {
  n === void 0 && (n = "viewport");
  const r = n === "layoutViewport", s = It(e), i = tn(e), a = s.visualViewport;
  let l = i.clientWidth, o = i.clientHeight, h = 0, v = 0;
  if (a) {
    const f = !bi() || t === "fixed";
    r ? f || (h = -a.offsetLeft, v = -a.offsetTop) : (l = a.width, o = a.height, f && (h = a.offsetLeft, v = a.offsetTop));
  }
  if (or(i) <= 0) {
    const f = i.ownerDocument, m = f.body, c = getComputedStyle(m), w = f.compatMode === "CSS1Compat" && parseFloat(c.marginLeft) + parseFloat(c.marginRight) || 0, _ = Math.abs(i.clientWidth - m.clientWidth - w), g = getComputedStyle(i).scrollbarGutter === "stable both-edges" ? _ / 2 : _;
    g <= fv && (l -= g);
  }
  return {
    width: l,
    height: o,
    x: h,
    y: v
  };
}
function vv(e, t) {
  const n = Cn(e, !0, t === "fixed"), r = n.top + e.clientTop, s = n.left + e.clientLeft, i = Bn(e), a = e.clientWidth * i.x, l = e.clientHeight * i.y, o = s * i.x, h = r * i.y;
  return {
    width: a,
    height: l,
    x: o,
    y: h
  };
}
function Bl(e, t, n) {
  let r;
  if (t === "viewport" || t === "layoutViewport")
    r = hv(e, n, t);
  else if (t === "document")
    r = dv(tn(e));
  else if (Zt(t))
    r = vv(t, n);
  else {
    const s = Go(e);
    r = {
      x: t.x - s.x,
      y: t.y - s.y,
      width: t.width,
      height: t.height
    };
  }
  return ja(r);
}
function mv(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ma(e, [], !1).filter((l) => Zt(l) && Ln(l) !== "body"), s = null;
  const i = Wt(e).position === "fixed";
  let a = i ? Sn(e) : e;
  for (; Zt(a) && !va(a); ) {
    const l = Wt(a), o = gi(a), h = s ? s.position : i ? "fixed" : "";
    !o && (h === "fixed" || h === "absolute" && l.position === "static") ? r = r.filter((u) => u !== a) : s = l, a = Sn(a);
  }
  return t.set(e, r), r;
}
function gv(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: s
  } = e;
  const a = [...n === "clippingAncestors" ? ir(t) ? [] : mv(t, this._c) : [].concat(n), r], l = Bl(t, a[0], s);
  let o = l.top, h = l.right, v = l.bottom, u = l.left;
  for (let f = 1; f < a.length; f++) {
    const m = Bl(t, a[f], s);
    o = Nn(m.top, o), h = Wr(m.right, h), v = Wr(m.bottom, v), u = Nn(m.left, u);
  }
  return {
    width: h - u,
    height: v - o,
    x: u,
    y: o
  };
}
function bv(e) {
  const {
    width: t,
    height: n
  } = Yo(e);
  return {
    width: t,
    height: n
  };
}
function pv(e, t, n) {
  const r = dn(t), s = tn(t), i = n === "fixed", a = Cn(e, !0, i, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const o = Kt(0);
  if ((r || !i) && ((Ln(t) !== "body" || rr(s)) && (l = lr(t)), r)) {
    const f = Cn(t, !0, i, t);
    o.x = f.x + t.clientLeft, o.y = f.y + t.clientTop;
  }
  !r && s && (o.x = or(s));
  const h = s && !r && !i ? Ko(s, l) : Kt(0), v = a.left + l.scrollLeft - o.x - h.x, u = a.top + l.scrollTop - o.y - h.y;
  return {
    x: v,
    y: u,
    width: a.width,
    height: a.height
  };
}
function Rr(e) {
  return Wt(e).position === "static";
}
function Pl(e, t) {
  if (!dn(e) || Wt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return tn(e) === n && (n = n.ownerDocument.body), n;
}
function Jo(e, t) {
  const n = It(e);
  if (ir(e))
    return n;
  if (!dn(e)) {
    let s = Sn(e);
    for (; s && !va(s); ) {
      if (Zt(s) && !Rr(s))
        return s;
      s = Sn(s);
    }
    return n;
  }
  let r = Pl(e, t);
  for (; r && av(r) && Rr(r); )
    r = Pl(r, t);
  return r && va(r) && Rr(r) && !gi(r) ? n : r || lv(e) || n;
}
const yv = async function(e) {
  const t = this.getOffsetParent || Jo, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: pv(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function wv(e) {
  return Wt(e).direction === "rtl";
}
const xv = {
  convertOffsetParentRelativeRectToViewportRelativeRect: cv,
  getDocumentElement: tn,
  getClippingRect: gv,
  getOffsetParent: Jo,
  getElementRects: yv,
  getClientRects: uv,
  getDimensions: bv,
  getScale: Bn,
  isElement: Zt,
  isRTL: wv
};
function Qo(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function kv(e, t, n) {
  let r = null, s;
  const i = tn(e);
  function a() {
    var v;
    clearTimeout(s), (v = r) == null || v.disconnect(), r = null;
  }
  function l(v, u) {
    v === void 0 && (v = !1), u === void 0 && (u = 1), a();
    const f = e.getBoundingClientRect(), {
      left: m,
      top: c,
      width: w,
      height: _
    } = f;
    if (v || t(), !w || !_)
      return;
    const g = Ia(c), b = Ia(i.clientWidth - (m + w)), S = Ia(i.clientHeight - (c + _)), E = Ia(m), $ = {
      rootMargin: -g + "px " + -b + "px " + -S + "px " + -E + "px",
      threshold: Nn(0, Wr(1, u)) || 1
    };
    let C = !0;
    function F(V) {
      const K = V[0].intersectionRatio;
      if (!Qo(f, e.getBoundingClientRect()))
        return l();
      if (K !== u) {
        if (!C)
          return l();
        K ? l(!1, K) : s = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      C = !1;
    }
    try {
      r = new IntersectionObserver(F, {
        ...$,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(F, $);
    }
    r.observe(e);
  }
  const o = It(e), h = () => l(n);
  return o.addEventListener("resize", h), l(!0), () => {
    o.removeEventListener("resize", h), a();
  };
}
function es(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: o = !1
  } = r, h = pi(e), v = s || i ? [...h ? ma(h) : [], ...t ? ma(t) : []] : [];
  v.forEach((g) => {
    s && g.addEventListener("scroll", n), i && g.addEventListener("resize", n);
  });
  const u = h && l ? kv(h, n, i) : null;
  let f = -1, m = null;
  a && (m = new ResizeObserver((g) => {
    let [b] = g;
    b && b.target === h && m && t && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var S;
      (S = m) == null || S.observe(t);
    })), n();
  }), h && !o && m.observe(h), t && m.observe(t));
  let c, w = o ? Cn(e) : null;
  o && _();
  function _() {
    const g = Cn(e);
    w && !Qo(w, g) && n(), w = g, c = requestAnimationFrame(_);
  }
  return n(), () => {
    var g;
    v.forEach((b) => {
      s && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), u?.(), (g = m) == null || g.disconnect(), m = null, o && cancelAnimationFrame(c);
  };
}
const ts = nv, ns = Qh, _v = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), s = n ?? {}, i = {
    ...xv,
    ...s.platform,
    _c: r
  };
  return Jh(e, t, {
    ...s,
    platform: i
  });
};
function Sv(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function zl(e) {
  if (Sv(e)) {
    const t = e.$el;
    return mi(t) && Ln(t) === "#comment" ? null : t;
  }
  return e;
}
function as(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Vl(e, t) {
  const n = as(e);
  return Math.round(t * n) / n;
}
function rs(e, t, n) {
  n === void 0 && (n = {});
  const r = n.whileElementsMounted, s = J(() => {
    var C;
    return (C = Ke(n.open)) != null ? C : !0;
  }), i = J(() => Ke(n.middleware)), a = J(() => {
    var C;
    return (C = Ke(n.placement)) != null ? C : "bottom";
  }), l = J(() => {
    var C;
    return (C = Ke(n.strategy)) != null ? C : "absolute";
  }), o = J(() => {
    var C;
    return (C = Ke(n.transform)) != null ? C : !0;
  }), h = J(() => zl(e.value)), v = J(() => zl(t.value)), u = we(0), f = we(0), m = we(l.value), c = we(a.value), w = Hn({}), _ = we(!1), g = J(() => {
    const C = {
      position: m.value,
      left: "0",
      top: "0"
    };
    if (!v.value)
      return C;
    const F = Vl(v.value, u.value), V = Vl(v.value, f.value);
    return o.value ? {
      ...C,
      transform: "translate(" + F + "px, " + V + "px)",
      ...as(v.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: m.value,
      left: F + "px",
      top: V + "px"
    };
  });
  let b;
  function S() {
    if (h.value == null || v.value == null)
      return;
    const C = s.value;
    _v(h.value, v.value, {
      middleware: i.value,
      placement: a.value,
      strategy: l.value
    }).then((F) => {
      u.value = F.x, f.value = F.y, m.value = F.strategy, c.value = F.placement, w.value = F.middlewareData, _.value = C !== !1;
    });
  }
  function E() {
    typeof b == "function" && (b(), b = void 0);
  }
  function I() {
    if (E(), r === void 0) {
      S();
      return;
    }
    if (h.value != null && v.value != null) {
      b = r(h.value, v.value, S);
      return;
    }
  }
  function $() {
    s.value || (_.value = !1);
  }
  return Ve([i, a, l, s], S, {
    flush: "sync"
  }), Ve([h, v], I, {
    flush: "sync"
  }), Ve(s, $, {
    flush: "sync"
  }), $s() && Is(E), {
    x: In(u),
    y: In(f),
    strategy: In(m),
    placement: In(c),
    middlewareData: In(w),
    isPositioned: In(_),
    floatingStyles: g,
    update: S
  };
}
const Oa = we(!1);
let Pn, zn, Vn, Gr = 0;
const yi = () => (wt(() => {
  Gr += 1, Cv();
}), Tn(() => {
  Gr -= 1, Ev();
}), Oa), Cv = () => {
  typeof window > "u" || (Pn || (Pn = () => Oa.value = !0, window.addEventListener("keydown", Pn, !0)), zn || (zn = () => Oa.value = !1, window.addEventListener("mousedown", zn, !0)), Vn || (Vn = () => Oa.value = !1, window.addEventListener("pointerdown", Vn, !0)));
}, Ev = () => {
  typeof window > "u" || Gr || (Pn && (window.removeEventListener("keydown", Pn, !0), Pn = null), zn && (window.removeEventListener("mousedown", zn, !0), zn = null), Vn && (window.removeEventListener("pointerdown", Vn, !0), Vn = null));
}, is = {
  fn: (e) => ({ x: e.x < 0 ? e.rects.reference.x : e.x }),
  name: "positionHelper"
}, Eg = [
  "top-start",
  "top-end",
  "bottom-start",
  "bottom-end"
];
var Vt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Escape = "Escape", e.Home = "Home", e.Space = " ", e.Tab = "Tab", e))(Vt || {});
const Tv = {
  ref: "container",
  class: "lc-menu-button"
}, Av = ["id", "aria-activedescendant"], Lv = ["id", "aria-selected", "onClick"], Tg = /* @__PURE__ */ Se({
  __name: "LcMenuButton",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    icon: { default: "more-horizontal" },
    id: {},
    options: {},
    placement: { default: "bottom-end" },
    value: {},
    zIndex: { default: 99 }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = dt("button"), i = dt("menu"), a = we(null), l = we(!1), { floatingStyles: o } = rs(s, i, {
      middleware: [
        ts({
          alignmentAxis: 4
        }),
        ns(),
        is
      ],
      placement: () => e.placement,
      whileElementsMounted: es
    }), h = Ct(e.id), v = yi(), u = J(() => {
      if (!(!l.value || !_t(a.value)))
        return `${h}-menuitem-${a.value}`;
    }), f = J(
      () => e.options.findIndex((b) => "value" in b && b.value === e.value)
    ), m = () => {
      l.value && (a.value = null, l.value = !1);
    }, c = () => {
      if (l.value) {
        m();
        return;
      }
      g();
    }, w = (b) => {
      if (m(), b?.onClick) {
        b.onClick();
        return;
      }
      r("update:value", b.value);
    }, _ = (b) => {
      if (!en(b.key, Vt)) return;
      b.key !== Vt.Tab && (b.preventDefault(), b.stopPropagation());
      const S = e.options.length - 1;
      switch (b.key) {
        case Vt.ArrowDown:
          if (l.value && _t(a.value)) {
            a.value = Math.min(S, a.value + 1);
            break;
          }
          a.value = 0, g();
          break;
        case Vt.ArrowUp:
          if (l.value && _t(a.value)) {
            a.value = Math.max(0, a.value - 1);
            break;
          }
          a.value = S, g();
          break;
        case Vt.End:
          if (!l.value) return;
          a.value = S;
          break;
        case Vt.Enter:
        case Vt.Space:
          if (l.value && _t(a.value)) {
            w(e.options[a.value]);
            break;
          }
          a.value = 0, g();
          break;
        case Vt.Escape:
        case Vt.Tab:
          m();
          break;
        case Vt.Home:
          if (!l.value) return;
          a.value = 0;
          break;
      }
    }, g = () => {
      l.value || (l.value = !0, e.value && (a.value = f.value));
    };
    return Ya(i, m, {
      ignore: [s, ...Ke(e.ignoreOutsideClickOn)]
    }), t({ menuRef: i }), wt(() => {
      e.value && (a.value = f.value);
    }), (b, S) => (L(), j("div", Tv, [
      Oe(q(St), Ee({
        id: q(h),
        ref: "button"
      }, { icon: e.icon }, {
        "aria-controls": `${q(h)}-menu`,
        "aria-expanded": l.value,
        "aria-haspopup": "menu",
        size: "small",
        variant: "tertiary",
        onClickPassive: c,
        onKeydown: _
      }), null, 16, ["id", "aria-controls", "aria-expanded"]),
      (L(), Ce(ba, { to: "body" }, [
        l.value ? (L(), Ce(q(ya), {
          key: 0,
          ref: "menu",
          "body-class": "lc-menu-button__menu-wrap-body",
          class: "lc-menu-button__menu-wrap",
          style: Lt({ ...q(o), zIndex: e.zIndex })
        }, {
          default: Ie(() => [
            ae("ul", {
              id: `${q(h)}-menu`,
              "aria-activedescendant": u.value,
              class: "lc-menu-button__menu",
              role: "menu"
            }, [
              (L(!0), j(Ge, null, vt(e.options, (E, I) => (L(), j("li", {
                key: `${E.label}-${"value" in E ? E.value : "action"}`,
                class: pe(["lc-menu-button__menu-item", {
                  "lc-menu-button__menu-item--focused": a.value === I && q(v),
                  "lc-menu-button__menu-item--selected": "value" in E && E.value === e.value
                }])
              }, [
                ae("button", {
                  id: `${q(h)}-menuitem-${I}`,
                  "aria-selected": "value" in E && E.value === e.value,
                  class: "lc-menu-button__menu-item-button",
                  role: "menuitem",
                  tabindex: "-1",
                  type: "button",
                  onClick: ($) => w(E)
                }, [
                  Oe(q(Qe), {
                    name: E.icon
                  }, null, 8, ["name"]),
                  ae("span", null, $e(E.label), 1),
                  "value" in E && E.value === e.value ? (L(), Ce(q(Qe), {
                    key: 0,
                    class: "lc-menu-button__menu-item-checkmark",
                    name: "checkmark"
                  })) : ce("", !0)
                ], 8, Lv)
              ], 2))), 128))
            ], 8, Av)
          ]),
          _: 1
        }, 8, ["style"])) : ce("", !0)
      ]))
    ], 512));
  }
}), $v = { class: "lc-message-box__headline" }, Iv = {
  key: 0,
  class: "lc-message-box__text"
}, Ag = /* @__PURE__ */ Se({
  __name: "LcMessageBox",
  props: /* @__PURE__ */ sa({
    id: {},
    modelValue: { type: Boolean },
    headline: {},
    size: { default: "medium" },
    text: {},
    variant: { default: "default" }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = {
      default: "info",
      info: "info",
      warning: "alert-circle"
    }, n = Za(e, "modelValue"), r = J(() => [
      "lc-message-box",
      `lc-message-box--size-${e.size}`,
      `lc-message-box--variant-${e.variant}`
    ]);
    return (s, i) => (L(), Ce(q(mf), {
      modelValue: n.value,
      "onUpdate:modelValue": i[0] || (i[0] = (a) => n.value = a),
      class: pe(r.value),
      "content-class": "lc-message-box__content",
      "header-class": "lc-message-box__header"
    }, {
      header: Ie(() => [
        ae("span", $v, [
          Oe(q(Qe), {
            name: t[e.variant]
          }, null, 8, ["name"]),
          ae("span", null, $e(e.headline), 1)
        ])
      ]),
      default: Ie(() => [
        me(s.$slots, "default", {}, () => [
          e.text ? (L(), j("p", Iv, $e(e.text), 1)) : ce("", !0)
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "class"]));
  }
}), Lg = ["medium", "small"], $g = ["default", "info", "warning"];
var sn;
(function(e) {
  e.symbol = "symbol", e.narrowSymbol = "narrowSymbol", e.code = "code", e.name = "name", e.hidden = "hidden";
})(sn || (sn = {}));
var ln;
(function(e) {
  e.precision = "precision", e.thousands = "thousands", e.tenThousands = "tenThousands", e.millions = "millions", e.billions = "billions";
})(ln || (ln = {}));
const Ra = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), ls = (e) => e.replace(/^0+(0$|[^0])/, "$1"), Fr = (e, t) => (e.match(new RegExp(Ra(t), "g")) || []).length, Dv = (e, t) => e.substring(0, e.indexOf(t)), os = [
  ",",
  ".",
  "٫",
  "。"
], Hl = "(0|[1-9]\\d*)";
class Mv {
  constructor(t) {
    var n, r, s, i, a, l;
    const { currency: o, currencyDisplay: h, locale: v, precision: u, accountingSign: f, useGrouping: m } = t;
    this.locale = v, this.options = {
      currency: o,
      useGrouping: m,
      style: "currency",
      currencySign: f ? "accounting" : void 0,
      currencyDisplay: h !== sn.hidden ? h : void 0
    };
    const c = new Intl.NumberFormat(v, this.options), w = c.formatToParts(123456);
    this.currency = (n = w.find(({ type: b }) => b === "currency")) === null || n === void 0 ? void 0 : n.value, this.digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((b) => b.toLocaleString(v)), this.decimalSymbol = (r = w.find(({ type: b }) => b === "decimal")) === null || r === void 0 ? void 0 : r.value, this.groupingSymbol = (s = w.find(({ type: b }) => b === "group")) === null || s === void 0 ? void 0 : s.value, this.minusSign = (i = c.formatToParts(-1).find(({ type: b }) => b === "minusSign")) === null || i === void 0 ? void 0 : i.value, this.decimalSymbol === void 0 ? this.minimumFractionDigits = this.maximumFractionDigits = 0 : typeof u == "number" ? this.minimumFractionDigits = this.maximumFractionDigits = u : (this.minimumFractionDigits = (a = u?.min) !== null && a !== void 0 ? a : c.resolvedOptions().minimumFractionDigits, this.maximumFractionDigits = (l = u?.max) !== null && l !== void 0 ? l : c.resolvedOptions().maximumFractionDigits);
    const _ = (b) => Dv(b, this.digits[1]), g = (b) => b.substring(b.lastIndexOf(this.decimalSymbol ? this.digits[0] : this.digits[1]) + 1);
    this.prefix = _(c.format(1)), this.suffix = g(c.format(1)), this.negativePrefix = _(c.format(-1)), this.negativeSuffix = g(c.format(-1));
  }
  parse(t) {
    if (t) {
      const n = this.isNegative(t);
      t = this.normalizeDigits(t), t = this.stripCurrency(t, n), t = this.stripSignLiterals(t);
      const r = this.decimalSymbol ? `(?:${Ra(this.decimalSymbol)}(\\d*))?` : "", s = this.stripGroupingSeparator(t).match(new RegExp(`^${Hl}${r}$`));
      if (s && this.isValidIntegerFormat(this.decimalSymbol ? t.split(this.decimalSymbol)[0] : t, Number(s[1])))
        return +`${n ? "-" : ""}${this.onlyDigits(s[1])}.${this.onlyDigits(s[2] || "")}`;
    }
    return null;
  }
  isValidIntegerFormat(t, n) {
    const r = { ...this.options, minimumFractionDigits: 0 };
    return [
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !0 })), !1),
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !1 })), !1)
    ].includes(t);
  }
  format(t, n = {
    minimumFractionDigits: this.minimumFractionDigits,
    maximumFractionDigits: this.maximumFractionDigits
  }) {
    return t != null ? t.toLocaleString(this.locale, { ...this.options, ...n }) : "";
  }
  toFraction(t) {
    return `${this.digits[0]}${this.decimalSymbol}${this.onlyLocaleDigits(t.substring(1)).substring(0, this.maximumFractionDigits)}`;
  }
  isFractionIncomplete(t) {
    return !!this.normalizeDigits(this.stripGroupingSeparator(t)).match(new RegExp(`^${Hl}${Ra(this.decimalSymbol)}$`));
  }
  isNegative(t) {
    return t.startsWith(this.negativePrefix) || this.minusSign === void 0 && (t.startsWith("(") || t.startsWith("-")) || this.minusSign !== void 0 && t.replace("-", this.minusSign).startsWith(this.minusSign);
  }
  insertCurrency(t, n) {
    return `${n ? this.negativePrefix : this.prefix}${t}${n ? this.negativeSuffix : this.suffix}`;
  }
  stripGroupingSeparator(t) {
    return this.groupingSymbol !== void 0 ? t.replace(new RegExp(Ra(this.groupingSymbol), "g"), "") : t;
  }
  stripSignLiterals(t) {
    return this.minusSign !== void 0 ? t.replace("-", this.minusSign).replace(this.minusSign, "") : t.replace(/[-()]/g, "");
  }
  stripCurrency(t, n) {
    return t.replace(n ? this.negativePrefix : this.prefix, "").replace(n ? this.negativeSuffix : this.suffix, "");
  }
  normalizeDecimalSeparator(t, n) {
    return os.forEach((r) => {
      t = t.substring(0, n) + t.substring(n).replace(r, this.decimalSymbol);
    }), t;
  }
  normalizeDigits(t) {
    return this.digits[0] !== "0" && this.digits.forEach((n, r) => {
      t = t.replace(new RegExp(n, "g"), String(r));
    }), t;
  }
  onlyDigits(t) {
    return this.normalizeDigits(t).replace(/\D+/g, "");
  }
  onlyLocaleDigits(t) {
    return t.replace(new RegExp(`[^${this.digits.join("")}]*`, "g"), "");
  }
}
class ss {
  constructor(t) {
    this.currencyFormat = t;
  }
}
class Ov extends ss {
  conformToMask(t, n = "") {
    const r = this.currencyFormat.isNegative(t), s = (c) => c === "" && r && !(this.currencyFormat.minusSign === void 0 ? n === this.currencyFormat.negativePrefix + this.currencyFormat.negativeSuffix : n === this.currencyFormat.negativePrefix), i = (c) => {
      if (s(c))
        return "";
      if (this.currencyFormat.maximumFractionDigits > 0) {
        if (this.currencyFormat.isFractionIncomplete(c))
          return c;
        if (c.startsWith(this.currencyFormat.decimalSymbol))
          return this.currencyFormat.toFraction(c);
      }
      return null;
    };
    let a = t;
    a = this.currencyFormat.stripCurrency(a, r), a = this.currencyFormat.stripSignLiterals(a);
    const l = i(a);
    if (l != null)
      return this.currencyFormat.insertCurrency(l, r);
    const [o, ...h] = a.split(this.currencyFormat.decimalSymbol), v = ls(this.currencyFormat.onlyDigits(o)), u = this.currencyFormat.onlyDigits(h.join("")).substring(0, this.currencyFormat.maximumFractionDigits), f = h.length > 0 && u.length === 0, m = v === "" && r && (this.currencyFormat.minusSign === void 0 ? n === t.slice(0, -2) + this.currencyFormat.negativeSuffix : n === t.slice(0, -1));
    return f || m || s(v) ? n : v.match(/\d+/) ? {
      numberValue: +`${r ? "-" : ""}${v}.${u}`,
      fractionDigits: u
    } : "";
  }
}
class Rv extends ss {
  conformToMask(t, n = "") {
    if (t === "" || t === this.currencyFormat.decimalSymbol || this.currencyFormat.parse(n) === 0 && this.currencyFormat.stripCurrency(n, !0).slice(0, -1) === this.currencyFormat.stripCurrency(t, !0))
      return "";
    const r = this.currencyFormat.isNegative(t), s = this.currencyFormat.stripSignLiterals(t) === "" ? -0 : +`${r ? "-" : ""}${ls(this.currencyFormat.onlyDigits(t))}` / Math.pow(10, this.currencyFormat.maximumFractionDigits);
    return {
      numberValue: s,
      fractionDigits: s.toFixed(this.currencyFormat.maximumFractionDigits).slice(-this.currencyFormat.maximumFractionDigits)
    };
  }
}
const Fv = {
  locale: void 0,
  currency: void 0,
  currencyDisplay: void 0,
  hideGroupingSeparatorOnFocus: !0,
  hideCurrencySymbolOnFocus: !0,
  hideNegligibleDecimalDigitsOnFocus: !0,
  precision: void 0,
  autoDecimalDigits: !1,
  valueRange: void 0,
  useGrouping: void 0,
  valueScaling: void 0
};
class Nv {
  constructor(t) {
    this.el = t.el, this.onInput = t.onInput, this.onChange = t.onChange, this.addEventListener(), this.init(t.options);
  }
  setOptions(t) {
    this.init(t), this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.onChange(this.getValue());
  }
  getValue() {
    return { number: this.valueScaling && this.numberValue != null ? this.toInteger(this.numberValue, this.valueScaling) : this.numberValue, formatted: this.formattedValue };
  }
  setValue(t) {
    const n = this.valueScaling !== void 0 && t != null ? this.toFloat(t, this.valueScaling) : t;
    n !== this.numberValue && (this.format(this.currencyFormat.format(this.validateValueRange(n))), this.onChange(this.getValue()));
  }
  init(t) {
    this.options = {
      ...Fv,
      ...t
    }, this.options.autoDecimalDigits && (this.options.hideNegligibleDecimalDigitsOnFocus = !1), this.el.getAttribute("inputmode") || this.el.setAttribute("inputmode", this.options.autoDecimalDigits ? "numeric" : "decimal"), this.currencyFormat = new Mv(this.options), this.numberMask = this.options.autoDecimalDigits ? new Rv(this.currencyFormat) : new Ov(this.currencyFormat);
    const n = {
      [ln.precision]: this.currencyFormat.maximumFractionDigits,
      [ln.thousands]: 3,
      [ln.tenThousands]: 4,
      [ln.millions]: 6,
      [ln.billions]: 9
    };
    this.valueScaling = this.options.valueScaling ? n[this.options.valueScaling] : void 0, this.valueScalingFractionDigits = this.valueScaling !== void 0 && this.options.valueScaling !== ln.precision ? this.valueScaling + this.currencyFormat.maximumFractionDigits : this.currencyFormat.maximumFractionDigits, this.minValue = this.getMinValue(), this.maxValue = this.getMaxValue();
  }
  getMinValue() {
    var t, n;
    let r = this.toFloat(-Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.min) !== void 0 && (r = Math.max((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.min, this.toFloat(-Number.MAX_SAFE_INTEGER))), r;
  }
  getMaxValue() {
    var t, n;
    let r = this.toFloat(Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.max) !== void 0 && (r = Math.min((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.max, this.toFloat(Number.MAX_SAFE_INTEGER))), r;
  }
  toFloat(t, n) {
    return t / Math.pow(10, n ?? this.valueScalingFractionDigits);
  }
  toInteger(t, n) {
    return Number(t.toFixed(n ?? this.valueScalingFractionDigits).split(".").join(""));
  }
  validateValueRange(t) {
    return t != null ? Math.min(Math.max(t, this.minValue), this.maxValue) : t;
  }
  format(t, n = !1) {
    if (t != null) {
      this.decimalSymbolInsertedAt !== void 0 && (t = this.currencyFormat.normalizeDecimalSeparator(t, this.decimalSymbolInsertedAt), this.decimalSymbolInsertedAt = void 0);
      const r = this.numberMask.conformToMask(t, this.formattedValue);
      let s;
      if (typeof r == "object") {
        const { numberValue: i, fractionDigits: a } = r;
        let { maximumFractionDigits: l, minimumFractionDigits: o } = this.currencyFormat;
        this.focus ? o = n ? a.replace(/0+$/, "").length : Math.min(l, a.length) : Number.isInteger(i) && !this.options.autoDecimalDigits && (this.options.precision === void 0 || o === 0) && (o = l = 0), s = this.toInteger(Math.abs(i)) > Number.MAX_SAFE_INTEGER ? this.formattedValue : this.currencyFormat.format(i, {
          useGrouping: this.options.useGrouping !== !1 && !(this.focus && this.options.hideGroupingSeparatorOnFocus),
          minimumFractionDigits: o,
          maximumFractionDigits: l
        });
      } else
        s = r;
      this.maxValue <= 0 && !this.currencyFormat.isNegative(s) && this.currencyFormat.parse(s) !== 0 && (s = s.replace(this.currencyFormat.prefix, this.currencyFormat.negativePrefix)), this.minValue >= 0 && (s = s.replace(this.currencyFormat.negativePrefix, this.currencyFormat.prefix)), (this.options.currencyDisplay === sn.hidden || this.focus && this.options.hideCurrencySymbolOnFocus) && (s = s.replace(this.currencyFormat.negativePrefix, this.currencyFormat.minusSign !== void 0 ? this.currencyFormat.minusSign : "(").replace(this.currencyFormat.negativeSuffix, this.currencyFormat.minusSign !== void 0 ? "" : ")").replace(this.currencyFormat.prefix, "").replace(this.currencyFormat.suffix, "")), this.el.value = s, this.numberValue = this.currencyFormat.parse(s);
    } else
      this.el.value = "", this.numberValue = null;
    this.formattedValue = this.el.value, this.onInput(this.getValue());
  }
  addEventListener() {
    this.el.addEventListener("input", (t) => {
      const { value: n, selectionStart: r } = this.el, s = t;
      if (r && s.data && os.includes(s.data) && (this.decimalSymbolInsertedAt = r - 1), this.format(n), this.focus && r != null) {
        const i = () => {
          const { prefix: a, suffix: l, decimalSymbol: o, maximumFractionDigits: h, groupingSymbol: v } = this.currencyFormat;
          let u = n.length - r;
          const f = this.formattedValue.length;
          if (this.currencyFormat.minusSign === void 0 && (n.startsWith("(") || n.startsWith("-")) && !n.endsWith(")"))
            return f - this.currencyFormat.negativeSuffix.length > 1 ? this.formattedValue.substring(r).length : 1;
          if (this.formattedValue.substring(r, 1) === v && Fr(this.formattedValue, v) === Fr(n, v) + 1)
            return f - u - 1;
          if (f < u)
            return r;
          if (o !== void 0 && n.indexOf(o) !== -1) {
            const m = n.indexOf(o) + 1;
            if (Math.abs(f - n.length) > 1 && r <= m)
              return this.formattedValue.indexOf(o) + 1;
            !this.options.autoDecimalDigits && r > m && this.currencyFormat.onlyDigits(n.substring(m)).length - 1 === h && (u -= 1);
          }
          return this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden ? f - u : Math.max(f - Math.max(u, l.length), a.length);
        };
        this.setCaretPosition(i());
      }
    }), this.el.addEventListener("focus", () => {
      this.focus = !0, this.numberValueOnFocus = this.numberValue, setTimeout(() => {
        const { value: t, selectionStart: n, selectionEnd: r } = this.el;
        if (this.format(t, this.options.hideNegligibleDecimalDigitsOnFocus), n != null && r != null && Math.abs(n - r) > 0)
          this.setCaretPosition(0, this.el.value.length);
        else if (n != null) {
          const s = this.getCaretPositionOnFocus(t, n);
          this.setCaretPosition(s);
        }
      });
    }), this.el.addEventListener("blur", () => {
      this.focus = !1, this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.numberValueOnFocus !== this.numberValue && this.onChange(this.getValue());
    });
  }
  getCaretPositionOnFocus(t, n) {
    if (this.numberValue == null)
      return n;
    const { prefix: r, negativePrefix: s, suffix: i, negativeSuffix: a, groupingSymbol: l, currency: o } = this.currencyFormat, h = this.numberValue < 0, v = h ? s : r, u = v.length;
    if (this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden) {
      if (h) {
        if (n <= 1)
          return 1;
        if (t.endsWith(")") && n > t.indexOf(")"))
          return this.formattedValue.length - 1;
      }
    } else {
      const m = h ? a.length : i.length;
      if (n >= t.length - m)
        return this.formattedValue.length - m;
      if (n < u)
        return u;
    }
    let f = n;
    return this.options.hideCurrencySymbolOnFocus && this.options.currencyDisplay !== sn.hidden && n >= u && o !== void 0 && v.includes(o) && (f -= u, h && (f += 1)), this.options.hideGroupingSeparatorOnFocus && l !== void 0 && (f -= Fr(t.substring(0, n), l)), f;
  }
  setCaretPosition(t, n = t) {
    this.el.setSelectionRange(t, n);
  }
}
const Bv = (e) => e?.matches("input") ? e : e?.querySelector("input");
function Pv(e, t) {
  var n, r, s, i;
  let a;
  const l = we(null), o = we(null), h = we(null), v = Qr();
  v?.emit || ((r = (n = v?.proxy) === null || n === void 0 ? void 0 : n.$emit) === null || r === void 0 || r.bind(v?.proxy));
  const u = v?.props || ((s = v?.proxy) === null || s === void 0 ? void 0 : s.$props), f = Ds.startsWith("3");
  f && ((i = v?.attrs.modelModifiers) === null || i === void 0 || i.lazy);
  const m = J(() => u?.[f ? "modelValue" : "value"]);
  return Ve(l, (c) => {
    var w;
    if (c) {
      const _ = Bv((w = c?.$el) !== null && w !== void 0 ? w : c);
      _ ? (a = new Nv({
        el: _,
        options: e,
        onInput: (g) => {
          h.value = g.number, o.value = g.formatted;
        },
        onChange: (g) => {
        }
      }), a.setValue(m.value)) : console.error('No input element found. Please make sure that the "inputRef" template ref is properly assigned.');
    } else
      a = null;
  }), {
    inputRef: l,
    numberValue: h,
    formattedValue: o,
    setValue: (c) => a?.setValue(c),
    setOptions: (c) => a?.setOptions(c)
  };
}
const Ul = 2, Ig = /* @__PURE__ */ Se({
  __name: "LcMoneyInput",
  props: {
    autocomplete: { default: "off" },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: { default: "0.00" },
    prefixClass: {},
    suffixClass: {},
    valueRange: { default: () => ({
      max: 1e6,
      min: 0
    }) },
    currency: { default: () => je.general.currency },
    locale: { default: () => je.general.locale },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ga(e, ["autocomplete", "currency", "locale", "placeholder", "value", "valueRange"]), { formattedValue: s, inputRef: i, numberValue: a, setValue: l } = Pv(
      {
        currency: e.currency,
        currencyDisplay: sn.hidden,
        locale: e.locale,
        precision: Ul,
        valueRange: e.valueRange
      }
    ), o = J(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: u }) => u === "currency")?.value ?? e.currency
    ), h = J(
      () => _t(a.value) ? parseFloat((a.value * 100).toFixed()) : null
    ), v = (u) => {
      l(_t(u) ? parseFloat((u / 100).toFixed(Ul)) : null);
    };
    return wt(async () => {
      _t(e.value) && (await Wa(), v(e.value));
    }), Ve(h, (u) => {
      n("update:value", u);
    }), Ve(
      () => e.value,
      (u) => {
        u !== h.value && v(u);
      }
    ), (u, f) => (L(), Ce(q(er), Ee({
      ref_key: "inputRef",
      ref: i
    }, { ...u.$attrs, ...r, autocomplete: e.autocomplete, placeholder: e.placeholder, value: e.value }, {
      class: "lc-money-input",
      spellcheck: !1,
      value: q(s)
    }), Xa({
      prefix: Ie(() => [
        yt($e(o.value), 1)
      ]),
      _: 2
    }, [
      u.$slots.suffix ? {
        name: "suffix",
        fn: Ie(() => [
          me(u.$slots, "suffix")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["value"]));
  }
}), zv = ["aria-checked", "aria-label"], Dg = /* @__PURE__ */ Se({
  __name: "LcPasswordInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {},
    toggleAriaLabel: { default: () => je.lcPasswordInput.toggleAriaLabel }
  },
  setup(e) {
    const t = ga(e, ["toggleAriaLabel"]), n = we("password"), r = J(() => s.value ? "eye-off" : "eye"), s = J(() => n.value === "text"), i = () => {
      n.value = s.value ? "password" : "text";
    };
    return (a, l) => (L(), Ce(q(er), Ee({ ...a.$attrs, ...t }, {
      class: "lc-password-input",
      spellcheck: !1,
      type: n.value
    }), {
      suffix: Ie(() => [
        ae("button", {
          "aria-checked": s.value,
          "aria-label": e.toggleAriaLabel,
          class: "lc-password-input__toggle",
          role: "switch",
          type: "button",
          onClickPassive: i
        }, [
          Oe(q(Qe), { name: r.value }, null, 8, ["name"])
        ], 40, zv),
        me(a.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), Mg = ["password", "text"], Vv = ["aria-valuenow"], Og = /* @__PURE__ */ Se({
  __name: "LcProgressIndicator",
  props: {
    icon: {},
    progress: { default: 0 },
    size: { default: "medium" },
    variant: { default: "info" }
  },
  setup(e) {
    const t = J(() => e.size === "medium" ? 36 : 24);
    return (n, r) => (L(), j("div", {
      "aria-live": "polite",
      "aria-valuenow": e.progress,
      class: pe([
        "lc-progress-indicator",
        `lc-progress-indicator--size-${e.size}`,
        `lc-progress-indicator--variant-${e.variant}`
      ]),
      role: "progressbar"
    }, [
      Oe(q(xo), Ee({ progress: e.progress, radius: t.value }, { "progress-class": "lc-progress-indicator__progress" }), null, 16),
      Oe(wn, {
        mode: "out-in",
        name: "lc-progress-indicator__transition"
      }, {
        default: Ie(() => [
          (L(), Ce(q(Qe), {
            key: e.icon,
            class: "lc-progress-indicator__icon",
            name: e.icon,
            size: e.size === "medium" ? "large" : "medium"
          }, null, 8, ["name", "size"]))
        ]),
        _: 1
      })
    ], 10, Vv));
  }
}), Rg = ["medium", "small"], Fg = ["info", "success"], wi = /* @__PURE__ */ Symbol(), Hv = ["for"], Uv = { class: "lc-radio__control" }, qv = ["id", "aria-labelledby", "data-click-name", "name"], jv = ["id"], Zv = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcRadio",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = t, r = Zn(wi), s = Ct(e.id), i = J(() => [
      "lc-radio",
      {
        "lc-radio--checked": a.value,
        "lc-radio--disabled": !!Ke(r?.disabled) || e.disabled,
        "lc-radio--error": !!Ke(r?.hasError)
      }
    ]), a = J(() => e.value === Ke(r?.value) || e.checked), l = J({
      get: () => a.value,
      set: () => {
        if (r) {
          r.updateValue(e.value);
          return;
        }
        n("change");
      }
    }), o = J(() => {
      if (Ke(r?.value))
        return a.value ? 0 : -1;
    }), h = J(() => Ke(r?.name) ?? e.name);
    return (v, u) => (L(), j("label", {
      class: pe([i.value, v.$attrs.class]),
      for: q(s)
    }, [
      ae("div", Uv, [
        Jt(ae("input", Ee({ id: q(s) }, {
          ...Qt(v.$attrs, ["class"]),
          disabled: e.disabled,
          tabindex: o.value
        }, {
          "onUpdate:modelValue": u[0] || (u[0] = (f) => l.value = f),
          "aria-labelledby": e.label ? `${q(s)}-label` : void 0,
          class: "lc-radio__input",
          "data-click-name": e.dataClickName || `${h.value?.toLowerCase()}_radio`,
          name: h.value,
          type: "radio"
        }), null, 16, qv), [
          [Ms, l.value]
        ])
      ]),
      e.label ? (L(), j("span", {
        key: 0,
        id: `${q(s)}-label`,
        class: pe(["lc-radio__label", e.labelClass])
      }, $e(e.label), 11, jv)) : ce("", !0)
    ], 10, Hv));
  }
}), Wv = { class: "lc-radio-card__main" }, Ng = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcRadioCard",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] },
    bodyClass: {}
  },
  setup(e) {
    const t = dt("radio"), n = Zn(wi), r = J(() => [
      "lc-radio-card",
      {
        "lc-radio-card--disabled": i.value
      }
    ]), s = J(() => e.value === Ke(n?.value) || e.checked), i = J(() => e.disabled || Ke(n?.disabled)), a = () => {
      if (i.value) return;
      n?.updateValue(e.value);
      const l = t.value?.$el?.querySelector("input");
      if (!l) return;
      const o = new Event("focusin", { bubbles: !0 }), h = new Event("focusout", { bubbles: !0 });
      l.dispatchEvent(o), l.dispatchEvent(h);
    };
    return (l, o) => (L(), Ce(q(ya), {
      "body-class": ["lc-radio-card__body", e.bodyClass],
      class: pe([r.value, l.$attrs.class]),
      onClick: a
    }, {
      default: Ie(() => [
        ae("div", Wv, [
          Oe(q(Zv), Ee({ ref: "radio" }, {
            ...Qt(l.$attrs, ["class"]),
            ...l.$props
          }), null, 16),
          me(l.$slots, "default", {
            checked: s.value,
            disabled: i.value
          })
        ]),
        Jt(ae("div", {
          class: "lc-radio-card__underneath",
          onClick: o[0] || (o[0] = oa(() => {
          }, ["stop"]))
        }, [
          me(l.$slots, "underneath", { disabled: i.value })
        ], 512), [
          [ni, s.value && l.$slots.underneath]
        ]),
        me(l.$slots, "bottom")
      ]),
      _: 3
    }, 8, ["body-class", "class"]));
  }
}), Xv = ["id", "aria-labelledby"], Yv = ["id"], Bg = /* @__PURE__ */ Se({
  __name: "LcRadioGroup",
  props: {
    contentWrapClass: {},
    defaultValue: { type: [Boolean, Number, String] },
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    layout: { default: "horizontal" },
    name: { default: "radio-group" },
    noFeedback: { type: Boolean },
    value: { type: [Boolean, null, Number, String], default: null }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = Ct(e.id), s = J(() => [
      "lc-radio-group",
      `lc-radio-group--${e.layout}`,
      {
        "lc-radio-group--disabled": e.disabled,
        "lc-radio-group--error": i.value
      }
    ]), i = J(() => !!e.errorMessage);
    return wt(() => {
      e.defaultValue && n("update:value", e.defaultValue);
    }), ei(wi, {
      disabled: () => e.disabled,
      hasError: to(i),
      name: () => e.name,
      updateValue: (a) => {
        n("update:value", a);
      },
      value: () => e.value
    }), (a, l) => (L(), j("fieldset", Ee({
      ...a.$attrs,
      disabled: e.disabled,
      name: e.name
    }, {
      id: q(r),
      "aria-labelledby": e.label ? `${q(r)}-label` : void 0,
      class: s.value,
      role: "radiogroup"
    }), [
      e.label ? (L(), j("legend", {
        key: 0,
        id: `${q(r)}-label`,
        class: "lc-radio-group__label"
      }, $e(e.label), 9, Yv)) : ce("", !0),
      ae("div", {
        class: pe(["lc-radio-group__wrap", e.contentWrapClass])
      }, [
        me(a.$slots, "default")
      ], 2),
      e.noFeedback ? ce("", !0) : (L(), Ce(q(An), Ee({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 16, Xv));
  }
}), Pg = ["horizontal", "vertical"], Gv = { class: "lc-rating" }, zg = /* @__PURE__ */ Se({
  __name: "LcRating",
  props: {
    max: { default: 5 },
    rating: { default: 0 }
  },
  setup(e) {
    return (t, n) => (L(), j("div", Gv, [
      (L(!0), j(Ge, null, vt(new Array(e.max), (r, s) => (L(), j("svg", {
        key: s,
        class: pe(["lc-rating__star", s < e.rating ? "lc-rating__star--active" : "lc-rating__star--inactive"]),
        fill: "none",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
      }, [...n[0] || (n[0] = [
        ae("path", { d: "M7.639.68c.148-.299.574-.299.722 0l2.16 4.377c.059.119.172.201.303.22l4.831.702c.33.048.462.454.223.686l-3.496 3.407c-.095.092-.138.226-.116.356l.825 4.811c.056.329-.289.579-.584.424l-4.321-2.271c-.117-.062-.257-.062-.374 0l-4.321 2.271c-.295.155-.64-.095-.584-.424l.825-4.811c.022-.131-.021-.264-.116-.356L.122 6.665c-.239-.233-.107-.638.223-.686l4.831-.702c.131-.019.244-.101.303-.22L7.639.68z" }, null, -1),
        ae("path", {
          d: "M.262 6.522l-.14.143.14-.143c-.12-.117-.054-.321.112-.345l4.831-.702a.6.6 0 0 0 .454-.33L7.819.768c.074-.15.289-.15.363 0l2.16 4.377c.088.178.257.301.454.33l4.831.702c.166.024.232.228.112.345l-3.496 3.407c-.142.138-.207.338-.173.533l.825 4.811c.028.165-.145.291-.294.213l-4.321-2.271a.6.6 0 0 0-.561 0l-4.321 2.271.093.177-.093-.177c-.148.078-.322-.048-.294-.213l.825-4.811a.6.6 0 0 0-.173-.533L.262 6.522z",
          "stroke-width": ".4"
        }, null, -1)
      ])], 2))), 128))
    ]));
  }
}), Kv = /* @__PURE__ */ Se({
  __name: "LcSkeleton",
  props: {
    height: { default: "1rem" },
    opacity: { default: 0.4 },
    radius: { default: "large" },
    width: { default: "100%" }
  },
  setup(e) {
    return (t, n) => (L(), j("div", {
      "aria-hidden": "true",
      class: pe(["lc-skeleton", `lc-skeleton--radius-${e.radius}`]),
      style: Lt({
        "--skeleton-height": e.height,
        "--skeleton-radius": e.radius,
        "--skeleton-width": e.width,
        "--skeleton-opacity": e.opacity
      })
    }, null, 6));
  }
}), Vg = ["full", "half", "large", "medium", "none", "small"], Jv = { class: "lc-remote-list__content" }, Qv = {
  key: 0,
  class: "lc-remote-list__cta-wrap"
}, Hg = /* @__PURE__ */ Se({
  __name: "LcRemoteList",
  props: {
    buttonText: {},
    count: {},
    hideSeparator: { type: Boolean },
    loading: { type: Boolean },
    numberOfSkeletons: { default: 3 },
    skeletonHeight: { default: "10.75rem" },
    total: {}
  },
  emits: ["fetch-more"],
  setup(e, { emit: t }) {
    const n = t, r = J(() => [
      "lc-remote-list",
      {
        "lc-remote-list--separator": !e.hideSeparator
      }
    ]), s = J(() => e.count < e.total), i = () => {
      s.value && n("fetch-more");
    };
    return (a, l) => (L(), j("section", {
      class: pe(r.value)
    }, [
      ae("ul", Jv, [
        me(a.$slots, "default"),
        e.loading ? me(a.$slots, "loading", {}, () => [
          (L(!0), j(Ge, null, vt(e.numberOfSkeletons, (o) => (L(), Ce(q(Kv), {
            key: o,
            height: e.skeletonHeight,
            radius: "medium"
          }, null, 8, ["height"]))), 128))
        ], void 0, 0) : ce("", !0)
      ]),
      !e.loading && s.value ? (L(), j("div", Qv, [
        me(a.$slots, "load-more", At(Rt({ fetchMore: i })), () => [
          Oe(q(St), {
            class: "lc-remote-list__cta",
            size: "medium",
            variant: "secondary",
            onClickPassive: i
          }, {
            default: Ie(() => [
              yt($e(e.buttonText), 1)
            ]),
            _: 1
          })
        ]),
        e.hideSeparator ? ce("", !0) : (L(), Ce(q(li), { key: 0 }))
      ])) : ce("", !0)
    ], 2));
  }
}), em = { class: "lc-scratchcard-teaser__button-wrap" }, Ug = /* @__PURE__ */ Se({
  __name: "LcScratchcardTeaser",
  props: {
    href: {},
    target: {},
    to: {},
    backgroundPattern: {},
    badge: {},
    buttonAriaLabel: {},
    buttonText: {},
    variant: { default: "default" }
  },
  emits: ["primary-button-click"],
  setup(e) {
    return (t, n) => (L(), Ce(q(tr), Ee({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-scratchcard-teaser__body",
      class: ["lc-scratchcard-teaser", `lc-scratchcard-teaser--variant-${e.variant}`],
      style: {
        "--teaser-frame-color": "var(--scratchcard-teaser-frame-color)"
      }
    }), {
      default: Ie(() => [
        Oe(q(ii), Ee({ href: e.href, target: e.target, to: e.to }, {
          class: "lc-scratchcard-teaser__link",
          tabindex: "-1"
        }), {
          default: Ie(() => [
            me(t.$slots, "image")
          ]),
          _: 3
        }, 16),
        ae("div", em, [
          Oe(q(St), Ee({ "aria-label": e.buttonAriaLabel }, { href: e.href, target: e.target, to: e.to }, {
            class: "lc-scratchcard-teaser__button",
            "no-padding": "",
            onClick: n[0] || (n[0] = (r) => t.$emit("primary-button-click"))
          }), {
            default: Ie(() => [
              yt($e(e.buttonText), 1)
            ]),
            _: 1
          }, 16, ["aria-label"])
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), qg = [...Po];
var Yt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.Enter = "Enter", e.Escape = "Escape", e.Space = " ", e.Tab = "Tab", e))(Yt || {});
const tm = ["id", "aria-controls", "aria-expanded", "aria-haspopup", "aria-labelledby", "data-click-name", "disabled", "role"], nm = ["id"], am = { class: "lc-select__input" }, rm = ["id", "aria-activedescendant", "aria-labelledby"], im = ["id", "aria-selected", "onClickPassive"], jg = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcSelect",
  props: {
    ignoreOutsideClickOn: { default: () => [je.lcModal.to] },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "select" },
    noFeedback: { type: Boolean },
    noTeleport: { type: Boolean },
    notNullable: { type: Boolean },
    onBlur: {},
    options: {},
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = dt("button"), s = dt("container"), i = dt("menu"), a = dt("options"), l = we(null), o = we(!1), h = Jr({
      focusin: !1,
      focusout: !1
    }), { floatingStyles: v } = rs(r, i, {
      middleware: [ns(), is, ts(2)],
      whileElementsMounted: es
    }), { width: u } = js(s), f = Ct(e.id), m = yi(), c = J(() => {
      if (!(!o.value || !_t(l.value)))
        return `${f}-option-${l.value}`;
    }), w = J(() => [
      "lc-select",
      {
        "lc-select--disabled": e.disabled,
        "lc-select--fixed-value": b.value,
        "lc-select--error": !!e.errorMessage,
        "lc-select--expanded": o.value,
        "lc-select--has-label": !b.value && !!e.label
      }
    ]), _ = J(
      () => b.value || e.value ? e.options[g.value].label : ""
    ), g = J(() => e.options.findIndex((A) => A.value === e.value)), b = J(() => e.notNullable && e.options.length === 1 && !!e.value), S = J(() => [
      "lc-select__label",
      {
        "lc-select__label--floating": !!e.value
      }
    ]), E = J(() => [
      "lc-select__menu",
      {
        "lc-select__menu--scrollable": e.options.length > 6
      }
    ]), I = J(() => ({
      ...v.value,
      minWidth: `${u.value}px`
    })), $ = () => {
      o.value && (l.value = null, o.value = !1, e.onBlur?.(), C("focusout"));
    }, C = (A) => {
      const z = r.value;
      if (!z) return;
      h[A] = !0;
      const U = new Event(A, { bubbles: !0 });
      z.dispatchEvent(U);
    }, F = async () => {
      o.value || await P();
    }, V = (A) => {
      const z = A.type;
      if (!G(z)) return;
      h[z] ? h[z] = !1 : A.stopPropagation();
    }, K = async (A) => {
      if (!en(A.key, Yt)) return;
      A.key !== Yt.Tab && (A.preventDefault(), A.stopPropagation());
      const z = e.options.length - 1;
      switch (A.key) {
        case Yt.ArrowDown:
          if (o.value && _t(l.value)) {
            l.value = Math.min(z, l.value + 1), T();
            break;
          }
          l.value = 0, await P();
          break;
        case Yt.ArrowUp:
          if (o.value && _t(l.value)) {
            l.value = Math.max(0, l.value - 1), T();
            break;
          }
          l.value = z, await P();
          break;
        case Yt.Enter:
        case Yt.Space:
          if (o.value && _t(l.value)) {
            O(e.options[l.value].value);
            break;
          }
          await P();
          break;
        case Yt.Escape:
          $();
          break;
        case Yt.Tab:
          if (!o.value || !_t(l.value)) break;
          O(e.options[l.value].value);
          break;
      }
    }, O = (A) => {
      const z = e.value === A ? null : A;
      e.notNullable && z === null || (n("update:value", z), $());
    }, G = (A) => A === "focusin" || A === "focusout", P = async () => {
      o.value || (o.value = !0, e.value && (l.value = g.value), C("focusin"), await Wa(), T());
    }, T = () => {
      if (!_t(l.value)) return;
      a.value?.[l.value]?.scrollIntoView({ block: "center" });
    };
    return Ya(i, $, {
      ignore: [r, ...Ke(e.ignoreOutsideClickOn)]
    }), wt(() => {
      e.autofocus && r.value?.focus(), e.value && (l.value = g.value);
    }), (A, z) => (L(), j("div", {
      ref: "container",
      class: pe([w.value, A.$attrs.class])
    }, [
      ae("button", Ee({
        id: q(f),
        ref: "button"
      }, Qt(A.$attrs, ["class"]), {
        "aria-controls": b.value ? void 0 : `${q(f)}-listbox`,
        "aria-expanded": b.value ? void 0 : o.value,
        "aria-haspopup": b.value ? void 0 : "listbox",
        "aria-labelledby": e.label ? `${q(f)}-label` : void 0,
        class: "lc-select__wrap",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_select`,
        disabled: b.value || e.disabled,
        role: b.value ? void 0 : "combobox",
        type: "button",
        onClickPassive: F,
        onFocusin: V,
        onFocusout: V,
        onKeydown: K
      }), [
        !b.value && e.label ? (L(), j("span", {
          key: 0,
          id: `${q(f)}-label`,
          class: pe(S.value)
        }, $e(e.label), 11, nm)) : ce("", !0),
        ae("div", am, $e(_.value), 1),
        b.value ? ce("", !0) : (L(), Ce(q(Qe), {
          key: 1,
          class: "lc-select__icon",
          name: "chevron-down"
        }))
      ], 16, tm),
      b.value ? ce("", !0) : (L(), Ce(q(lu), {
        key: 0,
        to: e.noTeleport ? void 0 : "body"
      }, {
        default: Ie(() => [
          o.value ? (L(), j("div", {
            key: 0,
            ref: "menu",
            class: pe(E.value),
            style: Lt(I.value)
          }, [
            ae("ul", {
              id: `${q(f)}-listbox`,
              "aria-activedescendant": c.value,
              "aria-labelledby": e.label ? `${q(f)}-label` : void 0,
              class: "lc-select__menu-list",
              role: "listbox"
            }, [
              (L(!0), j(Ge, null, vt(e.options, (U, X) => (L(), j("li", {
                key: `${U.label}-${U.value}`,
                class: pe(["lc-select__menu-item", {
                  "lc-select__menu-item--focused": l.value === X && q(m),
                  "lc-select__menu-item--selected": U.value === e.value
                }])
              }, [
                ae("button", {
                  id: `${q(f)}-option-${X}`,
                  ref_for: !0,
                  ref: "options",
                  "aria-selected": U.value === e.value,
                  class: "lc-select__menu-item-button",
                  role: "option",
                  tabindex: "-1",
                  type: "button",
                  onClickPassive: (B) => O(U.value)
                }, [
                  ae("span", null, $e(U.label), 1),
                  U.value === e.value ? (L(), Ce(q(Qe), {
                    key: 0,
                    class: "lc-select__menu-item-checkmark",
                    name: "checkmark"
                  })) : ce("", !0)
                ], 40, im)
              ], 2))), 128))
            ], 8, rm)
          ], 6)) : ce("", !0)
        ]),
        _: 1
      }, 8, ["to"])),
      e.noFeedback ? ce("", !0) : (L(), Ce(q(An), Ee({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), Zg = ["default", "discreet"];
var jt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Home = "Home", e.Space = " ", e))(jt || {});
const lm = ["id", "aria-activedescendant"], Wg = /* @__PURE__ */ Se({
  __name: "LcSelectList",
  props: {
    horizontal: { type: Boolean },
    id: {},
    multiple: { type: Boolean },
    optionComponent: {},
    options: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = dt("list"), s = we(null), i = Ct(e.id), a = yi(), l = J(() => {
      if (_t(s.value))
        return `${i}-option-${s.value}`;
    }), o = J(() => !r.value || !_t(s.value) ? null : r.value.querySelectorAll('[role="option"]')[s.value]), h = J(() => [
      "lc-select-list",
      `lc-select-list--variant-${e.variant}`,
      {
        "lc-select-list--focus-hidden": e.options.length <= 1,
        "lc-select-list--horizontal": e.horizontal
      }
    ]), v = J(
      () => e.options.findIndex((E) => E.value === (Array.isArray(e.value) ? e.value[0] : e.value))
    ), u = (E) => e.optionComponent ? g(E) ? "span" : e.optionComponent : _(E) ? g(E) ? "span" : Wn(E.to) : "button", f = () => {
      a.value && (s.value = Math.max(0, v.value));
    }, m = () => {
      a.value && (s.value = null);
    }, c = (E) => {
      if (!en(E.key, jt) || !_t(s.value))
        return;
      E.preventDefault(), E.stopPropagation();
      const I = e.options.length - 1;
      switch (E.key) {
        case jt.ArrowDown:
        case jt.ArrowRight:
          s.value = Math.min(I, s.value + 1);
          break;
        case jt.ArrowLeft:
        case jt.ArrowUp:
          s.value = Math.max(0, s.value - 1);
          break;
        case jt.End:
          s.value = I;
          break;
        case jt.Enter:
        case jt.Space:
          o.value?.dispatchEvent(new MouseEvent("click"));
          break;
        case jt.Home:
          s.value = 0;
          break;
      }
    }, w = (E) => {
      let I;
      if (e.multiple) {
        const $ = Array.isArray(e.value) ? e.value : [];
        I = $.includes(E) ? $.filter((C) => C !== E) : S([...$, E]);
      } else
        I = e.value === E ? void 0 : E;
      n("update:value", I);
    }, _ = ({ href: E, to: I }) => !!(E || I), g = (E) => Array.isArray(e.value) ? e.value.includes(E.value) : e.value === E.value, b = () => {
      o.value?.scrollIntoView(
        e.horizontal ? { block: "nearest", inline: "center" } : { block: "center", inline: "nearest" }
      );
    }, S = (E) => {
      const I = new Map(e.options.map(($, C) => [$.value, C]));
      return [...E].sort(
        ($, C) => (I.get($) ?? 1 / 0) - (I.get(C) ?? 1 / 0)
      );
    };
    return wt(() => {
      if (e.value) {
        if (e.multiple && !Array.isArray(e.value))
          throw Error('LcSelectList: "value" must be an array when "multiple" is true.');
        if (!e.multiple && Array.isArray(e.value))
          throw Error('LcSelectList: "value" must not be an array when "multiple" is false.');
      }
    }), Ve(s, (E) => {
      E !== null && b();
    }), (E, I) => (L(), j("div", {
      class: pe(h.value)
    }, [
      ae("ul", {
        id: q(i),
        ref: "list",
        "aria-activedescendant": l.value,
        class: "lc-select-list__list",
        role: "listbox",
        tabindex: "0",
        onFocusin: f,
        onFocusout: m,
        onKeydown: c
      }, [
        (L(!0), j(Ge, null, vt(e.options, ($, C) => (L(), j("li", {
          key: `${$.label}-${$.value}`,
          class: pe(["lc-select-list__item", {
            "lc-select-list__item--focused": s.value === C && q(a),
            "lc-select-list__item--selected": g($)
          }])
        }, [
          (L(), Ce(Xt(u($)), Ee({
            id: `${q(i)}-option-${C}`
          }, { ref_for: !0 }, {
            ...tu($, ["href", "target", "to"]),
            ...$?.additionalProps ?? {}
          }, {
            "aria-label": $.ariaLabelText,
            "aria-selected": g($),
            class: "lc-select-list__item-button",
            role: "option",
            tabindex: "-1",
            type: _($) && !g($) ? void 0 : "button",
            onClickPassive: (F) => w($.value)
          }), {
            default: Ie(() => [
              ae("span", null, $e($.label), 1),
              g($) ? (L(), Ce(q(Qe), {
                key: 0,
                class: "lc-select-list__item-checkmark",
                name: e.variant === "discreet" ? "checkmark-small" : "checkmark"
              }, null, 8, ["name"])) : ce("", !0)
            ]),
            _: 2
          }, 1040, ["id", "aria-label", "aria-selected", "type", "onClickPassive"]))
        ], 2))), 128))
      ], 40, lm)
    ], 2));
  }
});
function Da(e) {
  return [null, void 0, !1].indexOf(e) !== -1;
}
function om(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function cs(e) {
  var t = { exports: {} };
  return e(t, t.exports), t.exports;
}
var ql = cs((function(e, t) {
  e.exports = /* @__PURE__ */ (function() {
    var n = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
    function r(c) {
      return c.split("").reverse().join("");
    }
    function s(c, w) {
      return c.substring(0, w.length) === w;
    }
    function i(c, w) {
      return c.slice(-1 * w.length) === w;
    }
    function a(c, w, _) {
      if ((c[w] || c[_]) && c[w] === c[_]) throw new Error(w);
    }
    function l(c) {
      return typeof c == "number" && isFinite(c);
    }
    function o(c, w) {
      return c = c.toString().split("e"), (+((c = (c = Math.round(+(c[0] + "e" + (c[1] ? +c[1] + w : w)))).toString().split("e"))[0] + "e" + (c[1] ? +c[1] - w : -w))).toFixed(w);
    }
    function h(c, w, _, g, b, S, E, I, $, C, F, V) {
      var K, O, G, P = V, T = "", A = "";
      return S && (V = S(V)), !!l(V) && (c !== !1 && parseFloat(V.toFixed(c)) === 0 && (V = 0), V < 0 && (K = !0, V = Math.abs(V)), c !== !1 && (V = o(V, c)), (V = V.toString()).indexOf(".") !== -1 ? (G = (O = V.split("."))[0], _ && (T = _ + O[1])) : G = V, w && (G = r(G).match(/.{1,3}/g), G = r(G.join(r(w)))), K && I && (A += I), g && (A += g), K && $ && (A += $), A += G, A += T, b && (A += b), C && (A = C(A, P)), A);
    }
    function v(c, w, _, g, b, S, E, I, $, C, F, V) {
      var K, O = "";
      return F && (V = F(V)), !(!V || typeof V != "string") && (I && s(V, I) && (V = V.replace(I, ""), K = !0), g && s(V, g) && (V = V.replace(g, "")), $ && s(V, $) && (V = V.replace($, ""), K = !0), b && i(V, b) && (V = V.slice(0, -1 * b.length)), w && (V = V.split(w).join("")), _ && (V = V.replace(_, ".")), K && (O += "-"), (O = (O += V).replace(/[^0-9\.\-.]/g, "")) !== "" && (O = Number(O), E && (O = E(O)), !!l(O) && O));
    }
    function u(c) {
      var w, _, g, b = {};
      for (c.suffix === void 0 && (c.suffix = c.postfix), w = 0; w < n.length; w += 1) if ((g = c[_ = n[w]]) === void 0) _ !== "negative" || b.negativeBefore ? _ === "mark" && b.thousand !== "." ? b[_] = "." : b[_] = !1 : b[_] = "-";
      else if (_ === "decimals") {
        if (!(g >= 0 && g < 8)) throw new Error(_);
        b[_] = g;
      } else if (_ === "encoder" || _ === "decoder" || _ === "edit" || _ === "undo") {
        if (typeof g != "function") throw new Error(_);
        b[_] = g;
      } else {
        if (typeof g != "string") throw new Error(_);
        b[_] = g;
      }
      return a(b, "mark", "thousand"), a(b, "prefix", "negative"), a(b, "prefix", "negativeBefore"), b;
    }
    function f(c, w, _) {
      var g, b = [];
      for (g = 0; g < n.length; g += 1) b.push(c[n[g]]);
      return b.push(_), w.apply("", b);
    }
    function m(c) {
      if (!(this instanceof m)) return new m(c);
      typeof c == "object" && (c = u(c), this.to = function(w) {
        return f(c, h, w);
      }, this.from = function(w) {
        return f(c, v, w);
      });
    }
    return m;
  })();
})), sm = om(cs((function(e, t) {
  (function(n) {
    function r(D) {
      return s(D) && typeof D.from == "function";
    }
    function s(D) {
      return typeof D == "object" && typeof D.to == "function";
    }
    function i(D) {
      D.parentElement.removeChild(D);
    }
    function a(D) {
      return D != null;
    }
    function l(D) {
      D.preventDefault();
    }
    function o(D) {
      return D.filter((function(k) {
        return !this[k] && (this[k] = !0);
      }), {});
    }
    function h(D, k) {
      return Math.round(D / k) * k;
    }
    function v(D, k) {
      var y = D.getBoundingClientRect(), Y = D.ownerDocument, W = Y.documentElement, se = S(Y);
      return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (se.x = 0), k ? y.top + se.y - W.clientTop : y.left + se.x - W.clientLeft;
    }
    function u(D) {
      return typeof D == "number" && !isNaN(D) && isFinite(D);
    }
    function f(D, k, y) {
      y > 0 && (_(D, k), setTimeout((function() {
        g(D, k);
      }), y));
    }
    function m(D) {
      return Math.max(Math.min(D, 100), 0);
    }
    function c(D) {
      return Array.isArray(D) ? D : [D];
    }
    function w(D) {
      var k = (D = String(D)).split(".");
      return k.length > 1 ? k[1].length : 0;
    }
    function _(D, k) {
      D.classList && !/\s/.test(k) ? D.classList.add(k) : D.className += " " + k;
    }
    function g(D, k) {
      D.classList && !/\s/.test(k) ? D.classList.remove(k) : D.className = D.className.replace(new RegExp("(^|\\b)" + k.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function b(D, k) {
      return D.classList ? D.classList.contains(k) : new RegExp("\\b" + k + "\\b").test(D.className);
    }
    function S(D) {
      var k = window.pageXOffset !== void 0, y = (D.compatMode || "") === "CSS1Compat";
      return { x: k ? window.pageXOffset : y ? D.documentElement.scrollLeft : D.body.scrollLeft, y: k ? window.pageYOffset : y ? D.documentElement.scrollTop : D.body.scrollTop };
    }
    function E() {
      return window.navigator.pointerEnabled ? { start: "pointerdown", move: "pointermove", end: "pointerup" } : window.navigator.msPointerEnabled ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" } : { start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend" };
    }
    function I() {
      var D = !1;
      try {
        var k = Object.defineProperty({}, "passive", { get: function() {
          D = !0;
        } });
        window.addEventListener("test", null, k);
      } catch {
      }
      return D;
    }
    function $() {
      return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
    }
    function C(D, k) {
      return 100 / (k - D);
    }
    function F(D, k, y) {
      return 100 * k / (D[y + 1] - D[y]);
    }
    function V(D, k) {
      return F(D, D[0] < 0 ? k + Math.abs(D[0]) : k - D[0], 0);
    }
    function K(D, k) {
      return k * (D[1] - D[0]) / 100 + D[0];
    }
    function O(D, k) {
      for (var y = 1; D >= k[y]; ) y += 1;
      return y;
    }
    function G(D, k, y) {
      if (y >= D.slice(-1)[0]) return 100;
      var Y = O(y, D), W = D[Y - 1], se = D[Y], R = k[Y - 1], le = k[Y];
      return R + V([W, se], y) / C(R, le);
    }
    function P(D, k, y) {
      if (y >= 100) return D.slice(-1)[0];
      var Y = O(y, k), W = D[Y - 1], se = D[Y], R = k[Y - 1];
      return K([W, se], (y - R) * C(R, k[Y]));
    }
    function T(D, k, y, Y) {
      if (Y === 100) return Y;
      var W = O(Y, D), se = D[W - 1], R = D[W];
      return y ? Y - se > (R - se) / 2 ? R : se : k[W - 1] ? D[W - 1] + h(Y - D[W - 1], k[W - 1]) : Y;
    }
    var A, z;
    n.PipsMode = void 0, (z = n.PipsMode || (n.PipsMode = {})).Range = "range", z.Steps = "steps", z.Positions = "positions", z.Count = "count", z.Values = "values", n.PipsType = void 0, (A = n.PipsType || (n.PipsType = {}))[A.None = -1] = "None", A[A.NoValue = 0] = "NoValue", A[A.LargeValue = 1] = "LargeValue", A[A.SmallValue = 2] = "SmallValue";
    var U = (function() {
      function D(k, y, Y) {
        var W;
        this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [Y || !1], this.xNumSteps = [!1], this.snap = y;
        var se = [];
        for (Object.keys(k).forEach((function(R) {
          se.push([c(k[R]), R]);
        })), se.sort((function(R, le) {
          return R[0][0] - le[0][0];
        })), W = 0; W < se.length; W++) this.handleEntryPoint(se[W][1], se[W][0]);
        for (this.xNumSteps = this.xSteps.slice(0), W = 0; W < this.xNumSteps.length; W++) this.handleStepPoint(W, this.xNumSteps[W]);
      }
      return D.prototype.getDistance = function(k) {
        for (var y = [], Y = 0; Y < this.xNumSteps.length - 1; Y++) y[Y] = F(this.xVal, k, Y);
        return y;
      }, D.prototype.getAbsoluteDistance = function(k, y, Y) {
        var W, se = 0;
        if (k < this.xPct[this.xPct.length - 1]) for (; k > this.xPct[se + 1]; ) se++;
        else k === this.xPct[this.xPct.length - 1] && (se = this.xPct.length - 2);
        Y || k !== this.xPct[se + 1] || se++, y === null && (y = []);
        var R = 1, le = y[se], p = 0, fe = 0, Le = 0, d = 0;
        for (W = Y ? (k - this.xPct[se]) / (this.xPct[se + 1] - this.xPct[se]) : (this.xPct[se + 1] - k) / (this.xPct[se + 1] - this.xPct[se]); le > 0; ) p = this.xPct[se + 1 + d] - this.xPct[se + d], y[se + d] * R + 100 - 100 * W > 100 ? (fe = p * W, R = (le - 100 * W) / y[se + d], W = 1) : (fe = y[se + d] * p / 100 * R, R = 0), Y ? (Le -= fe, this.xPct.length + d >= 1 && d--) : (Le += fe, this.xPct.length - d >= 1 && d++), le = y[se + d] * R;
        return k + Le;
      }, D.prototype.toStepping = function(k) {
        return k = G(this.xVal, this.xPct, k);
      }, D.prototype.fromStepping = function(k) {
        return P(this.xVal, this.xPct, k);
      }, D.prototype.getStep = function(k) {
        return k = T(this.xPct, this.xSteps, this.snap, k);
      }, D.prototype.getDefaultStep = function(k, y, Y) {
        var W = O(k, this.xPct);
        return (k === 100 || y && k === this.xPct[W - 1]) && (W = Math.max(W - 1, 1)), (this.xVal[W] - this.xVal[W - 1]) / Y;
      }, D.prototype.getNearbySteps = function(k) {
        var y = O(k, this.xPct);
        return { stepBefore: { startValue: this.xVal[y - 2], step: this.xNumSteps[y - 2], highestStep: this.xHighestCompleteStep[y - 2] }, thisStep: { startValue: this.xVal[y - 1], step: this.xNumSteps[y - 1], highestStep: this.xHighestCompleteStep[y - 1] }, stepAfter: { startValue: this.xVal[y], step: this.xNumSteps[y], highestStep: this.xHighestCompleteStep[y] } };
      }, D.prototype.countStepDecimals = function() {
        var k = this.xNumSteps.map(w);
        return Math.max.apply(null, k);
      }, D.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
      }, D.prototype.convert = function(k) {
        return this.getStep(this.toStepping(k));
      }, D.prototype.handleEntryPoint = function(k, y) {
        var Y;
        if (!u(Y = k === "min" ? 0 : k === "max" ? 100 : parseFloat(k)) || !u(y[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
        this.xPct.push(Y), this.xVal.push(y[0]);
        var W = Number(y[1]);
        Y ? this.xSteps.push(!isNaN(W) && W) : isNaN(W) || (this.xSteps[0] = W), this.xHighestCompleteStep.push(0);
      }, D.prototype.handleStepPoint = function(k, y) {
        if (y) if (this.xVal[k] !== this.xVal[k + 1]) {
          this.xSteps[k] = F([this.xVal[k], this.xVal[k + 1]], y, 0) / C(this.xPct[k], this.xPct[k + 1]);
          var Y = (this.xVal[k + 1] - this.xVal[k]) / this.xNumSteps[k], W = Math.ceil(Number(Y.toFixed(3)) - 1), se = this.xVal[k] + this.xNumSteps[k] * W;
          this.xHighestCompleteStep[k] = se;
        } else this.xSteps[k] = this.xHighestCompleteStep[k] = this.xVal[k];
      }, D;
    })(), X = { to: function(D) {
      return D === void 0 ? "" : D.toFixed(2);
    }, from: Number }, B = { target: "target", base: "base", origin: "origin", handle: "handle", handleLower: "handle-lower", handleUpper: "handle-upper", touchArea: "touch-area", horizontal: "horizontal", vertical: "vertical", background: "background", connect: "connect", connects: "connects", ltr: "ltr", rtl: "rtl", textDirectionLtr: "txt-dir-ltr", textDirectionRtl: "txt-dir-rtl", draggable: "draggable", drag: "state-drag", tap: "state-tap", active: "active", tooltip: "tooltip", pips: "pips", pipsHorizontal: "pips-horizontal", pipsVertical: "pips-vertical", marker: "marker", markerHorizontal: "marker-horizontal", markerVertical: "marker-vertical", markerNormal: "marker-normal", markerLarge: "marker-large", markerSub: "marker-sub", value: "value", valueHorizontal: "value-horizontal", valueVertical: "value-vertical", valueNormal: "value-normal", valueLarge: "value-large", valueSub: "value-sub" }, ie = { tooltips: ".__tooltips", aria: ".__aria" };
    function H(D, k) {
      if (!u(k)) throw new Error("noUiSlider: 'step' is not numeric.");
      D.singleStep = k;
    }
    function ee(D, k) {
      if (!u(k)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
      D.keyboardPageMultiplier = k;
    }
    function ue(D, k) {
      if (!u(k)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
      D.keyboardMultiplier = k;
    }
    function ye(D, k) {
      if (!u(k)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
      D.keyboardDefaultStep = k;
    }
    function xe(D, k) {
      if (typeof k != "object" || Array.isArray(k)) throw new Error("noUiSlider: 'range' is not an object.");
      if (k.min === void 0 || k.max === void 0) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
      D.spectrum = new U(k, D.snap || !1, D.singleStep);
    }
    function te(D, k) {
      if (k = c(k), !Array.isArray(k) || !k.length) throw new Error("noUiSlider: 'start' option is incorrect.");
      D.handles = k.length, D.start = k;
    }
    function he(D, k) {
      if (typeof k != "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
      D.snap = k;
    }
    function ge(D, k) {
      if (typeof k != "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
      D.animate = k;
    }
    function be(D, k) {
      if (typeof k != "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
      D.animationDuration = k;
    }
    function Pe(D, k) {
      var y, Y = [!1];
      if (k === "lower" ? k = [!0, !1] : k === "upper" && (k = [!1, !0]), k === !0 || k === !1) {
        for (y = 1; y < D.handles; y++) Y.push(k);
        Y.push(!1);
      } else {
        if (!Array.isArray(k) || !k.length || k.length !== D.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
        Y = k;
      }
      D.connect = Y;
    }
    function Ne(D, k) {
      switch (k) {
        case "horizontal":
          D.ort = 0;
          break;
        case "vertical":
          D.ort = 1;
          break;
        default:
          throw new Error("noUiSlider: 'orientation' option is invalid.");
      }
    }
    function de(D, k) {
      if (!u(k)) throw new Error("noUiSlider: 'margin' option must be numeric.");
      k !== 0 && (D.margin = D.spectrum.getDistance(k));
    }
    function Re(D, k) {
      if (!u(k)) throw new Error("noUiSlider: 'limit' option must be numeric.");
      if (D.limit = D.spectrum.getDistance(k), !D.limit || D.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
    function He(D, k) {
      var y;
      if (!u(k) && !Array.isArray(k)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (Array.isArray(k) && k.length !== 2 && !u(k[0]) && !u(k[1])) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (k !== 0) {
        for (Array.isArray(k) || (k = [k, k]), D.padding = [D.spectrum.getDistance(k[0]), D.spectrum.getDistance(k[1])], y = 0; y < D.spectrum.xNumSteps.length - 1; y++) if (D.padding[0][y] < 0 || D.padding[1][y] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
        var Y = k[0] + k[1], W = D.spectrum.xVal[0];
        if (Y / (D.spectrum.xVal[D.spectrum.xVal.length - 1] - W) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
      }
    }
    function Ze(D, k) {
      switch (k) {
        case "ltr":
          D.dir = 0;
          break;
        case "rtl":
          D.dir = 1;
          break;
        default:
          throw new Error("noUiSlider: 'direction' option was not recognized.");
      }
    }
    function We(D, k) {
      if (typeof k != "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
      var y = k.indexOf("tap") >= 0, Y = k.indexOf("drag") >= 0, W = k.indexOf("fixed") >= 0, se = k.indexOf("snap") >= 0, R = k.indexOf("hover") >= 0, le = k.indexOf("unconstrained") >= 0, p = k.indexOf("drag-all") >= 0, fe = k.indexOf("smooth-steps") >= 0;
      if (W) {
        if (D.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        de(D, D.start[1] - D.start[0]);
      }
      if (le && (D.margin || D.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
      D.events = { tap: y || se, drag: Y, dragAll: p, smoothSteps: fe, fixed: W, snap: se, hover: R, unconstrained: le };
    }
    function Be(D, k) {
      if (k !== !1) if (k === !0 || s(k)) {
        D.tooltips = [];
        for (var y = 0; y < D.handles; y++) D.tooltips.push(k);
      } else {
        if ((k = c(k)).length !== D.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
        k.forEach((function(Y) {
          if (typeof Y != "boolean" && !s(Y)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        })), D.tooltips = k;
      }
    }
    function Fe(D, k) {
      if (k.length !== D.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
      D.handleAttributes = k;
    }
    function Ye(D, k) {
      if (!s(k)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
      D.ariaFormat = k;
    }
    function st(D, k) {
      if (!r(k)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
      D.format = k;
    }
    function mt(D, k) {
      if (typeof k != "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
      D.keyboardSupport = k;
    }
    function gt(D, k) {
      D.documentElement = k;
    }
    function Ft(D, k) {
      if (typeof k != "string" && k !== !1) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
      D.cssPrefix = k;
    }
    function Mt(D, k) {
      if (typeof k != "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
      typeof D.cssPrefix == "string" ? (D.cssClasses = {}, Object.keys(k).forEach((function(y) {
        D.cssClasses[y] = D.cssPrefix + k[y];
      }))) : D.cssClasses = k;
    }
    function xt(D) {
      var k = { margin: null, limit: null, padding: null, animate: !0, animationDuration: 300, ariaFormat: X, format: X }, y = { step: { r: !1, t: H }, keyboardPageMultiplier: { r: !1, t: ee }, keyboardMultiplier: { r: !1, t: ue }, keyboardDefaultStep: { r: !1, t: ye }, start: { r: !0, t: te }, connect: { r: !0, t: Pe }, direction: { r: !0, t: Ze }, snap: { r: !1, t: he }, animate: { r: !1, t: ge }, animationDuration: { r: !1, t: be }, range: { r: !0, t: xe }, orientation: { r: !1, t: Ne }, margin: { r: !1, t: de }, limit: { r: !1, t: Re }, padding: { r: !1, t: He }, behaviour: { r: !0, t: We }, ariaFormat: { r: !1, t: Ye }, format: { r: !1, t: st }, tooltips: { r: !1, t: Be }, keyboardSupport: { r: !0, t: mt }, documentElement: { r: !1, t: gt }, cssPrefix: { r: !0, t: Ft }, cssClasses: { r: !0, t: Mt }, handleAttributes: { r: !1, t: Fe } }, Y = { connect: !1, direction: "ltr", behaviour: "tap", orientation: "horizontal", keyboardSupport: !0, cssPrefix: "noUi-", cssClasses: B, keyboardPageMultiplier: 5, keyboardMultiplier: 1, keyboardDefaultStep: 10 };
      D.format && !D.ariaFormat && (D.ariaFormat = D.format), Object.keys(y).forEach((function(p) {
        if (a(D[p]) || Y[p] !== void 0) y[p].t(k, a(D[p]) ? D[p] : Y[p]);
        else if (y[p].r) throw new Error("noUiSlider: '" + p + "' is required.");
      })), k.pips = D.pips;
      var W = document.createElement("div"), se = W.style.msTransform !== void 0, R = W.style.transform !== void 0;
      k.transformRule = R ? "transform" : se ? "msTransform" : "webkitTransform";
      var le = [["left", "top"], ["right", "bottom"]];
      return k.style = le[k.dir][k.ort], k;
    }
    function Ut(D, k, y) {
      var Y, W, se, R, le, p = E(), fe = $() && I(), Le = D, d = k.spectrum, re = [], ne = [], x = [], N = 0, Q = {}, De = D.ownerDocument, ke = k.documentElement || De.documentElement, Te = De.body, Ue = De.dir === "rtl" || k.ort === 1 ? 0 : 100;
      function ft(M, Z) {
        var oe = De.createElement("div");
        return Z && _(oe, Z), M.appendChild(oe), oe;
      }
      function et(M, Z) {
        var oe = ft(M, k.cssClasses.origin), ve = ft(oe, k.cssClasses.handle);
        if (ft(ve, k.cssClasses.touchArea), ve.setAttribute("data-handle", String(Z)), k.keyboardSupport && (ve.setAttribute("tabindex", "0"), ve.addEventListener("keydown", (function(_e) {
          return bs(_e, Z);
        }))), k.handleAttributes !== void 0) {
          var Ae = k.handleAttributes[Z];
          Object.keys(Ae).forEach((function(_e) {
            ve.setAttribute(_e, Ae[_e]);
          }));
        }
        return ve.setAttribute("role", "slider"), ve.setAttribute("aria-orientation", k.ort ? "vertical" : "horizontal"), Z === 0 ? _(ve, k.cssClasses.handleLower) : Z === k.handles - 1 && _(ve, k.cssClasses.handleUpper), oe;
      }
      function qe(M, Z) {
        return !!Z && ft(M, k.cssClasses.connect);
      }
      function it(M, Z) {
        var oe = ft(Z, k.cssClasses.connects);
        W = [], (se = []).push(qe(oe, M[0]));
        for (var ve = 0; ve < k.handles; ve++) W.push(et(Z, ve)), x[ve] = ve, se.push(qe(oe, M[ve + 1]));
      }
      function bt(M) {
        return _(M, k.cssClasses.target), k.dir === 0 ? _(M, k.cssClasses.ltr) : _(M, k.cssClasses.rtl), k.ort === 0 ? _(M, k.cssClasses.horizontal) : _(M, k.cssClasses.vertical), _(M, getComputedStyle(M).direction === "rtl" ? k.cssClasses.textDirectionRtl : k.cssClasses.textDirectionLtr), ft(M, k.cssClasses.base);
      }
      function kt(M, Z) {
        return !(!k.tooltips || !k.tooltips[Z]) && ft(M.firstChild, k.cssClasses.tooltip);
      }
      function fn() {
        return Le.hasAttribute("disabled");
      }
      function nn(M) {
        return W[M].hasAttribute("disabled");
      }
      function tt() {
        le && (Xn("update" + ie.tooltips), le.forEach((function(M) {
          M && i(M);
        })), le = null);
      }
      function Et() {
        tt(), le = W.map(kt), fr("update" + ie.tooltips, (function(M, Z, oe) {
          if (le && k.tooltips && le[Z] !== !1) {
            var ve = M[Z];
            k.tooltips[Z] !== !0 && (ve = k.tooltips[Z].to(oe[Z])), le[Z].innerHTML = ve;
          }
        }));
      }
      function ht() {
        Xn("update" + ie.aria), fr("update" + ie.aria, (function(M, Z, oe, ve, Ae) {
          x.forEach((function(_e) {
            var ze = W[_e], Me = ka(ne, _e, 0, !0, !0, !0), ot = ka(ne, _e, 100, !0, !0, !0), rt = Ae[_e], Je = String(k.ariaFormat.to(oe[_e]));
            Me = d.fromStepping(Me).toFixed(1), ot = d.fromStepping(ot).toFixed(1), rt = d.fromStepping(rt).toFixed(1), ze.children[0].setAttribute("aria-valuemin", Me), ze.children[0].setAttribute("aria-valuemax", ot), ze.children[0].setAttribute("aria-valuenow", rt), ze.children[0].setAttribute("aria-valuetext", Je);
          }));
        }));
      }
      function Pt(M) {
        if (M.mode === n.PipsMode.Range || M.mode === n.PipsMode.Steps) return d.xVal;
        if (M.mode === n.PipsMode.Count) {
          if (M.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
          for (var Z = M.values - 1, oe = 100 / Z, ve = []; Z--; ) ve[Z] = Z * oe;
          return ve.push(100), Ot(ve, M.stepped);
        }
        return M.mode === n.PipsMode.Positions ? Ot(M.values, M.stepped) : M.mode === n.PipsMode.Values ? M.stepped ? M.values.map((function(Ae) {
          return d.fromStepping(d.getStep(d.toStepping(Ae)));
        })) : M.values : [];
      }
      function Ot(M, Z) {
        return M.map((function(oe) {
          return d.fromStepping(Z ? d.getStep(oe) : oe);
        }));
      }
      function xa(M) {
        function Z(rt, Je) {
          return Number((rt + Je).toFixed(7));
        }
        var oe = Pt(M), ve = {}, Ae = d.xVal[0], _e = d.xVal[d.xVal.length - 1], ze = !1, Me = !1, ot = 0;
        return (oe = o(oe.slice().sort((function(rt, Je) {
          return rt - Je;
        }))))[0] !== Ae && (oe.unshift(Ae), ze = !0), oe[oe.length - 1] !== _e && (oe.push(_e), Me = !0), oe.forEach((function(rt, Je) {
          var nt, Xe, pt, Tt, ut, $i, mr, Ii, Di, Mi, gr = rt, $n = oe[Je + 1], Oi = M.mode === n.PipsMode.Steps;
          for (Oi && (nt = d.xNumSteps[Je]), nt || (nt = $n - gr), $n === void 0 && ($n = gr), nt = Math.max(nt, 1e-7), Xe = gr; Xe <= $n; Xe = Z(Xe, nt)) {
            for (Ii = (ut = (Tt = d.toStepping(Xe)) - ot) / (M.density || 1), Mi = ut / (Di = Math.round(Ii)), pt = 1; pt <= Di; pt += 1) ve[($i = ot + pt * Mi).toFixed(5)] = [d.fromStepping($i), 0];
            mr = oe.indexOf(Xe) > -1 ? n.PipsType.LargeValue : Oi ? n.PipsType.SmallValue : n.PipsType.NoValue, !Je && ze && Xe !== $n && (mr = 0), Xe === $n && Me || (ve[Tt.toFixed(5)] = [Xe, mr]), ot = Tt;
          }
        })), ve;
      }
      function us(M, Z, oe) {
        var ve, Ae, _e = De.createElement("div"), ze = ((ve = {})[n.PipsType.None] = "", ve[n.PipsType.NoValue] = k.cssClasses.valueNormal, ve[n.PipsType.LargeValue] = k.cssClasses.valueLarge, ve[n.PipsType.SmallValue] = k.cssClasses.valueSub, ve), Me = ((Ae = {})[n.PipsType.None] = "", Ae[n.PipsType.NoValue] = k.cssClasses.markerNormal, Ae[n.PipsType.LargeValue] = k.cssClasses.markerLarge, Ae[n.PipsType.SmallValue] = k.cssClasses.markerSub, Ae), ot = [k.cssClasses.valueHorizontal, k.cssClasses.valueVertical], rt = [k.cssClasses.markerHorizontal, k.cssClasses.markerVertical];
        function Je(Xe, pt) {
          var Tt = pt === k.cssClasses.value, ut = Tt ? ze : Me;
          return pt + " " + (Tt ? ot : rt)[k.ort] + " " + ut[Xe];
        }
        function nt(Xe, pt, Tt) {
          if ((Tt = Z ? Z(pt, Tt) : Tt) !== n.PipsType.None) {
            var ut = ft(_e, !1);
            ut.className = Je(Tt, k.cssClasses.marker), ut.style[k.style] = Xe + "%", Tt > n.PipsType.NoValue && ((ut = ft(_e, !1)).className = Je(Tt, k.cssClasses.value), ut.setAttribute("data-value", String(pt)), ut.style[k.style] = Xe + "%", ut.innerHTML = String(oe.to(pt)));
          }
        }
        return _(_e, k.cssClasses.pips), _(_e, k.ort === 0 ? k.cssClasses.pipsHorizontal : k.cssClasses.pipsVertical), Object.keys(M).forEach((function(Xe) {
          nt(Xe, M[Xe][0], M[Xe][1]);
        })), _e;
      }
      function sr() {
        R && (i(R), R = null);
      }
      function cr(M) {
        sr();
        var Z = xa(M), oe = M.filter, ve = M.format || { to: function(Ae) {
          return String(Math.round(Ae));
        } };
        return R = Le.appendChild(us(Z, oe, ve));
      }
      function ki() {
        var M = Y.getBoundingClientRect(), Z = "offset" + ["Width", "Height"][k.ort];
        return k.ort === 0 ? M.width || Y[Z] : M.height || Y[Z];
      }
      function hn(M, Z, oe, ve) {
        var Ae = function(ze) {
          var Me = ds(ze, ve.pageOffset, ve.target || Z);
          return !!Me && !(fn() && !ve.doNotReject) && !(b(Le, k.cssClasses.tap) && !ve.doNotReject) && !(M === p.start && Me.buttons !== void 0 && Me.buttons > 1) && (!ve.hover || !Me.buttons) && (fe || Me.preventDefault(), Me.calcPoint = Me.points[k.ort], void oe(Me, ve));
        }, _e = [];
        return M.split(" ").forEach((function(ze) {
          Z.addEventListener(ze, Ae, !!fe && { passive: !0 }), _e.push([ze, Ae]);
        })), _e;
      }
      function ds(M, Z, oe) {
        var ve = M.type.indexOf("touch") === 0, Ae = M.type.indexOf("mouse") === 0, _e = M.type.indexOf("pointer") === 0, ze = 0, Me = 0;
        if (M.type.indexOf("MSPointer") === 0 && (_e = !0), M.type === "mousedown" && !M.buttons && !M.touches) return !1;
        if (ve) {
          var ot = function(nt) {
            var Xe = nt.target;
            return Xe === oe || oe.contains(Xe) || M.composed && M.composedPath().shift() === oe;
          };
          if (M.type === "touchstart") {
            var rt = Array.prototype.filter.call(M.touches, ot);
            if (rt.length > 1) return !1;
            ze = rt[0].pageX, Me = rt[0].pageY;
          } else {
            var Je = Array.prototype.find.call(M.changedTouches, ot);
            if (!Je) return !1;
            ze = Je.pageX, Me = Je.pageY;
          }
        }
        return Z = Z || S(De), (Ae || _e) && (ze = M.clientX + Z.x, Me = M.clientY + Z.y), M.pageOffset = Z, M.points = [ze, Me], M.cursor = Ae || _e, M;
      }
      function _i(M) {
        var Z = 100 * (M - v(Y, k.ort)) / ki();
        return Z = m(Z), k.dir ? 100 - Z : Z;
      }
      function fs(M) {
        var Z = 100, oe = !1;
        return W.forEach((function(ve, Ae) {
          if (!nn(Ae)) {
            var _e = ne[Ae], ze = Math.abs(_e - M);
            (ze < Z || ze <= Z && M > _e || ze === 100 && Z === 100) && (oe = Ae, Z = ze);
          }
        })), oe;
      }
      function hs(M, Z) {
        M.type === "mouseout" && M.target.nodeName === "HTML" && M.relatedTarget === null && ur(M, Z);
      }
      function vs(M, Z) {
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && M.buttons === 0 && Z.buttonsProperty !== 0) return ur(M, Z);
        var oe = (k.dir ? -1 : 1) * (M.calcPoint - Z.startCalcPoint);
        Si(oe > 0, 100 * oe / Z.baseSize, Z.locations, Z.handleNumbers, Z.connect);
      }
      function ur(M, Z) {
        Z.handle && (g(Z.handle, k.cssClasses.active), N -= 1), Z.listeners.forEach((function(oe) {
          ke.removeEventListener(oe[0], oe[1]);
        })), N === 0 && (g(Le, k.cssClasses.drag), vr(), M.cursor && (Te.style.cursor = "", Te.removeEventListener("selectstart", l))), k.events.smoothSteps && (Z.handleNumbers.forEach((function(oe) {
          vn(oe, ne[oe], !0, !0, !1, !1);
        })), Z.handleNumbers.forEach((function(oe) {
          lt("update", oe);
        }))), Z.handleNumbers.forEach((function(oe) {
          lt("change", oe), lt("set", oe), lt("end", oe);
        }));
      }
      function dr(M, Z) {
        if (!Z.handleNumbers.some(nn)) {
          var oe;
          Z.handleNumbers.length === 1 && (oe = W[Z.handleNumbers[0]].children[0], N += 1, _(oe, k.cssClasses.active)), M.stopPropagation();
          var ve = [], Ae = hn(p.move, ke, vs, { target: M.target, handle: oe, connect: Z.connect, listeners: ve, startCalcPoint: M.calcPoint, baseSize: ki(), pageOffset: M.pageOffset, handleNumbers: Z.handleNumbers, buttonsProperty: M.buttons, locations: ne.slice() }), _e = hn(p.end, ke, ur, { target: M.target, handle: oe, listeners: ve, doNotReject: !0, handleNumbers: Z.handleNumbers }), ze = hn("mouseout", ke, hs, { target: M.target, handle: oe, listeners: ve, doNotReject: !0, handleNumbers: Z.handleNumbers });
          ve.push.apply(ve, Ae.concat(_e, ze)), M.cursor && (Te.style.cursor = getComputedStyle(M.target).cursor, W.length > 1 && _(Le, k.cssClasses.drag), Te.addEventListener("selectstart", l, !1)), Z.handleNumbers.forEach((function(Me) {
            lt("start", Me);
          }));
        }
      }
      function ms(M) {
        M.stopPropagation();
        var Z = _i(M.calcPoint), oe = fs(Z);
        oe !== !1 && (k.events.snap || f(Le, k.cssClasses.tap, k.animationDuration), vn(oe, Z, !0, !0), vr(), lt("slide", oe, !0), lt("update", oe, !0), k.events.snap ? dr(M, { handleNumbers: [oe] }) : (lt("change", oe, !0), lt("set", oe, !0)));
      }
      function gs(M) {
        var Z = _i(M.calcPoint), oe = d.getStep(Z), ve = d.fromStepping(oe);
        Object.keys(Q).forEach((function(Ae) {
          Ae.split(".")[0] === "hover" && Q[Ae].forEach((function(_e) {
            _e.call(Sa, ve);
          }));
        }));
      }
      function bs(M, Z) {
        if (fn() || nn(Z)) return !1;
        var oe = ["Left", "Right"], ve = ["Down", "Up"], Ae = ["PageDown", "PageUp"], _e = ["Home", "End"];
        k.dir && !k.ort ? oe.reverse() : k.ort && !k.dir && (ve.reverse(), Ae.reverse());
        var ze, Me = M.key.replace("Arrow", ""), ot = Me === Ae[0], rt = Me === Ae[1], Je = Me === ve[0] || Me === oe[0] || ot, nt = Me === ve[1] || Me === oe[1] || rt, Xe = Me === _e[0], pt = Me === _e[1];
        if (!(Je || nt || Xe || pt)) return !0;
        if (M.preventDefault(), nt || Je) {
          var Tt = Je ? 0 : 1, ut = Li(Z)[Tt];
          if (ut === null) return !1;
          ut === !1 && (ut = d.getDefaultStep(ne[Z], Je, k.keyboardDefaultStep)), ut *= rt || ot ? k.keyboardPageMultiplier : k.keyboardMultiplier, ut = Math.max(ut, 1e-7), ut *= Je ? -1 : 1, ze = re[Z] + ut;
        } else ze = pt ? k.spectrum.xVal[k.spectrum.xVal.length - 1] : k.spectrum.xVal[0];
        return vn(Z, d.toStepping(ze), !0, !0), lt("slide", Z), lt("update", Z), lt("change", Z), lt("set", Z), !1;
      }
      function ps(M) {
        M.fixed || W.forEach((function(Z, oe) {
          hn(p.start, Z.children[0], dr, { handleNumbers: [oe] });
        })), M.tap && hn(p.start, Y, ms, {}), M.hover && hn(p.move, Y, gs, { hover: !0 }), M.drag && se.forEach((function(Z, oe) {
          if (Z !== !1 && oe !== 0 && oe !== se.length - 1) {
            var ve = W[oe - 1], Ae = W[oe], _e = [Z], ze = [ve, Ae], Me = [oe - 1, oe];
            _(Z, k.cssClasses.draggable), M.fixed && (_e.push(ve.children[0]), _e.push(Ae.children[0])), M.dragAll && (ze = W, Me = x), _e.forEach((function(ot) {
              hn(p.start, ot, dr, { handles: ze, handleNumbers: Me, connect: Z });
            }));
          }
        }));
      }
      function fr(M, Z) {
        Q[M] = Q[M] || [], Q[M].push(Z), M.split(".")[0] === "update" && W.forEach((function(oe, ve) {
          lt("update", ve);
        }));
      }
      function ys(M) {
        return M === ie.aria || M === ie.tooltips;
      }
      function Xn(M) {
        var Z = M && M.split(".")[0], oe = Z ? M.substring(Z.length) : M;
        Object.keys(Q).forEach((function(ve) {
          var Ae = ve.split(".")[0], _e = ve.substring(Ae.length);
          Z && Z !== Ae || oe && oe !== _e || ys(_e) && oe !== _e || delete Q[ve];
        }));
      }
      function lt(M, Z, oe) {
        Object.keys(Q).forEach((function(ve) {
          var Ae = ve.split(".")[0];
          M === Ae && Q[ve].forEach((function(_e) {
            _e.call(Sa, re.map(k.format.to), Z, re.slice(), oe || !1, ne.slice(), Sa);
          }));
        }));
      }
      function ka(M, Z, oe, ve, Ae, _e, ze) {
        var Me;
        return W.length > 1 && !k.events.unconstrained && (ve && Z > 0 && (Me = d.getAbsoluteDistance(M[Z - 1], k.margin, !1), oe = Math.max(oe, Me)), Ae && Z < W.length - 1 && (Me = d.getAbsoluteDistance(M[Z + 1], k.margin, !0), oe = Math.min(oe, Me))), W.length > 1 && k.limit && (ve && Z > 0 && (Me = d.getAbsoluteDistance(M[Z - 1], k.limit, !1), oe = Math.min(oe, Me)), Ae && Z < W.length - 1 && (Me = d.getAbsoluteDistance(M[Z + 1], k.limit, !0), oe = Math.max(oe, Me))), k.padding && (Z === 0 && (Me = d.getAbsoluteDistance(0, k.padding[0], !1), oe = Math.max(oe, Me)), Z === W.length - 1 && (Me = d.getAbsoluteDistance(100, k.padding[1], !0), oe = Math.min(oe, Me))), ze || (oe = d.getStep(oe)), !((oe = m(oe)) === M[Z] && !_e) && oe;
      }
      function hr(M, Z) {
        var oe = k.ort;
        return (oe ? Z : M) + ", " + (oe ? M : Z);
      }
      function Si(M, Z, oe, ve, Ae) {
        var _e = oe.slice(), ze = ve[0], Me = k.events.smoothSteps, ot = [!M, M], rt = [M, !M];
        ve = ve.slice(), M && ve.reverse(), ve.length > 1 ? ve.forEach((function(nt, Xe) {
          var pt = ka(_e, nt, _e[nt] + Z, ot[Xe], rt[Xe], !1, Me);
          pt === !1 ? Z = 0 : (Z = pt - _e[nt], _e[nt] = pt);
        })) : ot = rt = [!0];
        var Je = !1;
        ve.forEach((function(nt, Xe) {
          Je = vn(nt, oe[nt] + Z, ot[Xe], rt[Xe], !1, Me) || Je;
        })), Je && (ve.forEach((function(nt) {
          lt("update", nt), lt("slide", nt);
        })), Ae != null && lt("drag", ze));
      }
      function Ci(M, Z) {
        return k.dir ? 100 - M - Z : M;
      }
      function ws(M, Z) {
        ne[M] = Z, re[M] = d.fromStepping(Z);
        var oe = "translate(" + hr(Ci(Z, 0) - Ue + "%", "0") + ")";
        W[M].style[k.transformRule] = oe, Ei(M), Ei(M + 1);
      }
      function vr() {
        x.forEach((function(M) {
          var Z = ne[M] > 50 ? -1 : 1, oe = 3 + (W.length + Z * M);
          W[M].style.zIndex = String(oe);
        }));
      }
      function vn(M, Z, oe, ve, Ae, _e) {
        return Ae || (Z = ka(ne, M, Z, oe, ve, !1, _e)), Z !== !1 && (ws(M, Z), !0);
      }
      function Ei(M) {
        if (se[M]) {
          var Z = 0, oe = 100;
          M !== 0 && (Z = ne[M - 1]), M !== se.length - 1 && (oe = ne[M]);
          var ve = oe - Z, Ae = "translate(" + hr(Ci(Z, ve) + "%", "0") + ")", _e = "scale(" + hr(ve / 100, "1") + ")";
          se[M].style[k.transformRule] = Ae + " " + _e;
        }
      }
      function Ti(M, Z) {
        return M === null || M === !1 || M === void 0 ? ne[Z] : (typeof M == "number" && (M = String(M)), (M = k.format.from(M)) !== !1 && (M = d.toStepping(M)), M === !1 || isNaN(M) ? ne[Z] : M);
      }
      function _a(M, Z, oe) {
        var ve = c(M), Ae = ne[0] === void 0;
        Z = Z === void 0 || Z, k.animate && !Ae && f(Le, k.cssClasses.tap, k.animationDuration), x.forEach((function(Me) {
          vn(Me, Ti(ve[Me], Me), !0, !1, oe);
        }));
        var _e = x.length === 1 ? 0 : 1;
        if (Ae && d.hasNoSize() && (oe = !0, ne[0] = 0, x.length > 1)) {
          var ze = 100 / (x.length - 1);
          x.forEach((function(Me) {
            ne[Me] = Me * ze;
          }));
        }
        for (; _e < x.length; ++_e) x.forEach((function(Me) {
          vn(Me, ne[Me], !0, !0, oe);
        }));
        vr(), x.forEach((function(Me) {
          lt("update", Me), ve[Me] !== null && Z && lt("set", Me);
        }));
      }
      function xs(M) {
        _a(k.start, M);
      }
      function ks(M, Z, oe, ve) {
        if (!((M = Number(M)) >= 0 && M < x.length)) throw new Error("noUiSlider: invalid handle number, got: " + M);
        vn(M, Ti(Z, M), !0, !0, ve), lt("update", M), oe && lt("set", M);
      }
      function Ai(M) {
        if (M === void 0 && (M = !1), M) return re.length === 1 ? re[0] : re.slice(0);
        var Z = re.map(k.format.to);
        return Z.length === 1 ? Z[0] : Z;
      }
      function _s() {
        for (Xn(ie.aria), Xn(ie.tooltips), Object.keys(k.cssClasses).forEach((function(M) {
          g(Le, k.cssClasses[M]);
        })); Le.firstChild; ) Le.removeChild(Le.firstChild);
        delete Le.noUiSlider;
      }
      function Li(M) {
        var Z = ne[M], oe = d.getNearbySteps(Z), ve = re[M], Ae = oe.thisStep.step, _e = null;
        if (k.snap) return [ve - oe.stepBefore.startValue || null, oe.stepAfter.startValue - ve || null];
        Ae !== !1 && ve + Ae > oe.stepAfter.startValue && (Ae = oe.stepAfter.startValue - ve), _e = ve > oe.thisStep.startValue ? oe.thisStep.step : oe.stepBefore.step !== !1 && ve - oe.stepBefore.highestStep, Z === 100 ? Ae = null : Z === 0 && (_e = null);
        var ze = d.countStepDecimals();
        return Ae !== null && Ae !== !1 && (Ae = Number(Ae.toFixed(ze))), _e !== null && _e !== !1 && (_e = Number(_e.toFixed(ze))), [_e, Ae];
      }
      function Ss() {
        return x.map(Li);
      }
      function Cs(M, Z) {
        var oe = Ai(), ve = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format", "pips", "tooltips"];
        ve.forEach((function(_e) {
          M[_e] !== void 0 && (y[_e] = M[_e]);
        }));
        var Ae = xt(y);
        ve.forEach((function(_e) {
          M[_e] !== void 0 && (k[_e] = Ae[_e]);
        })), d = Ae.spectrum, k.margin = Ae.margin, k.limit = Ae.limit, k.padding = Ae.padding, k.pips ? cr(k.pips) : sr(), k.tooltips ? Et() : tt(), ne = [], _a(a(M.start) ? M.start : oe, Z);
      }
      function Es() {
        Y = bt(Le), it(k.connect, Y), ps(k.events), _a(k.start), k.pips && cr(k.pips), k.tooltips && Et(), ht();
      }
      Es();
      var Sa = { destroy: _s, steps: Ss, on: fr, off: Xn, get: Ai, set: _a, setHandle: ks, reset: xs, __moveHandles: function(M, Z, oe) {
        Si(M, Z, ne, oe);
      }, options: y, updateOptions: Cs, target: Le, removePips: sr, removeTooltips: tt, getPositions: function() {
        return ne.slice();
      }, getTooltips: function() {
        return le;
      }, getOrigins: function() {
        return W;
      }, pips: cr };
      return Sa;
    }
    function $t(D, k) {
      if (!D || !D.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + D);
      if (D.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
      var y = Ut(D, xt(k), k);
      return D.noUiSlider = y, y;
    }
    var ct = { __spectrum: U, cssClasses: B, create: $t };
    n.create = $t, n.cssClasses = B, n.default = ct, Object.defineProperty(n, "__esModule", { value: !0 });
  })(t);
})));
function jl(e, t) {
  if (!Array.isArray(e) || !Array.isArray(t)) return !1;
  const n = t.slice().sort();
  return e.length === t.length && e.slice().sort().every((function(r, s) {
    return r === n[s];
  }));
}
var Kr = { name: "Slider", emits: ["input", "update:modelValue", "start", "slide", "drag", "update", "change", "set", "end"], props: { value: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, modelValue: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, id: { type: [String, Number], required: !1 }, disabled: { type: Boolean, required: !1, default: !1 }, min: { type: Number, required: !1, default: 0 }, max: { type: Number, required: !1, default: 100 }, step: { type: Number, required: !1, default: 1 }, orientation: { type: String, required: !1, default: "horizontal" }, direction: { type: String, required: !1, default: "ltr" }, tooltips: { type: Boolean, required: !1, default: !0 }, options: { type: Object, required: !1, default: () => ({}) }, merge: { type: Number, required: !1, default: -1 }, format: { type: [Object, Function, Boolean], required: !1, default: null }, classes: { type: Object, required: !1, default: () => ({}) }, showTooltip: { type: String, required: !1, default: "always" }, tooltipPosition: { type: String, required: !1, default: null }, lazy: { type: Boolean, required: !1, default: !0 }, ariaLabelledby: { type: String, required: !1, default: void 0 }, aria: { required: !1, type: Object, default: () => ({}) } }, setup(e, t) {
  const n = (function(a, l, o) {
    const { value: h, modelValue: v, min: u } = Ca(a);
    let f = v && v.value !== void 0 ? v : h;
    const m = we(f.value);
    if (Da(f.value) && (f = we(u.value)), Array.isArray(f.value) && f.value.length == 0) throw new Error("Slider v-model must not be an empty array");
    return { value: f, initialValue: m };
  })(e), r = (function(a, l, o) {
    const { classes: h, showTooltip: v, tooltipPosition: u, orientation: f } = Ca(a), m = J((() => ({ target: "slider-target", focused: "slider-focused", tooltipFocus: "slider-tooltip-focus", tooltipDrag: "slider-tooltip-drag", ltr: "slider-ltr", rtl: "slider-rtl", horizontal: "slider-horizontal", vertical: "slider-vertical", textDirectionRtl: "slider-txt-dir-rtl", textDirectionLtr: "slider-txt-dir-ltr", base: "slider-base", connects: "slider-connects", connect: "slider-connect", origin: "slider-origin", handle: "slider-handle", handleLower: "slider-handle-lower", handleUpper: "slider-handle-upper", touchArea: "slider-touch-area", tooltip: "slider-tooltip", tooltipTop: "slider-tooltip-top", tooltipBottom: "slider-tooltip-bottom", tooltipLeft: "slider-tooltip-left", tooltipRight: "slider-tooltip-right", tooltipHidden: "slider-tooltip-hidden", active: "slider-active", draggable: "slider-draggable", tap: "slider-state-tap", drag: "slider-state-drag", pips: "slider-pips", pipsHorizontal: "slider-pips-horizontal", pipsVertical: "slider-pips-vertical", marker: "slider-marker", markerHorizontal: "slider-marker-horizontal", markerVertical: "slider-marker-vertical", markerNormal: "slider-marker-normal", markerLarge: "slider-marker-large", markerSub: "slider-marker-sub", value: "slider-value", valueHorizontal: "slider-value-horizontal", valueVertical: "slider-value-vertical", valueNormal: "slider-value-normal", valueLarge: "slider-value-large", valueSub: "slider-value-sub", ...h.value })));
    return { classList: J((() => {
      const c = { ...m.value };
      return Object.keys(c).forEach(((w) => {
        c[w] = Array.isArray(c[w]) ? c[w].filter(((_) => _ !== null)).join(" ") : c[w];
      })), v.value !== "always" && (c.target += ` ${v.value === "drag" ? c.tooltipDrag : c.tooltipFocus}`), f.value === "horizontal" && (c.tooltip += u.value === "bottom" ? ` ${c.tooltipBottom}` : ` ${c.tooltipTop}`), f.value === "vertical" && (c.tooltip += u.value === "right" ? ` ${c.tooltipRight}` : ` ${c.tooltipLeft}`), c;
    })) };
  })(e), s = (function(a, l, o) {
    const { format: h, step: v } = Ca(a), u = o.value, f = o.classList, m = J((() => h && h.value ? typeof h.value == "function" ? { to: h.value } : ql({ ...h.value }) : ql({ decimals: v.value >= 0 ? 0 : 2 }))), c = J((() => Array.isArray(u.value) ? u.value.map(((w) => m.value)) : m.value));
    return { tooltipFormat: m, tooltipsFormat: c, tooltipsMerge: (w, _, g) => {
      var b = getComputedStyle(w).direction === "rtl", S = w.noUiSlider.options.direction === "rtl", E = w.noUiSlider.options.orientation === "vertical", I = w.noUiSlider.getTooltips(), $ = w.noUiSlider.getOrigins();
      I.forEach((function(C, F) {
        C && $[F].appendChild(C);
      })), w.noUiSlider.on("update", (function(C, F, V, K, O) {
        var G = [[]], P = [[]], T = [[]], A = 0;
        I[0] && (G[0][0] = 0, P[0][0] = O[0], T[0][0] = m.value.to(parseFloat(C[0])));
        for (var z = 1; z < C.length; z++) (!I[z] || C[z] - C[z - 1] > _) && (G[++A] = [], T[A] = [], P[A] = []), I[z] && (G[A].push(z), T[A].push(m.value.to(parseFloat(C[z]))), P[A].push(O[z]));
        G.forEach((function(U, X) {
          for (var B = U.length, ie = 0; ie < B; ie++) {
            var H = U[ie];
            if (ie === B - 1) {
              var ee = 0;
              P[X].forEach((function(te) {
                ee += 1e3 - te;
              }));
              var ue = E ? "bottom" : "right", ye = S ? 0 : B - 1, xe = 1e3 - P[X][ye];
              ee = (b && !E ? 100 : 0) + ee / B - xe, I[H].innerHTML = T[X].join(g), I[H].style.display = "block", I[H].style[ue] = ee + "%", f.value.tooltipHidden.split(" ").forEach(((te) => {
                I[H].classList.contains(te) && I[H].classList.remove(te);
              }));
            } else I[H].style.display = "none", f.value.tooltipHidden.split(" ").forEach(((te) => {
              I[H].classList.add(te);
            }));
          }
        }));
      }));
    } };
  })(e, 0, { value: n.value, classList: r.classList }), i = (function(a, l, o) {
    const { orientation: h, direction: v, tooltips: u, step: f, min: m, max: c, merge: w, id: _, disabled: g, options: b, classes: S, format: E, lazy: I, ariaLabelledby: $, aria: C } = Ca(a), F = o.value, V = o.initialValue, K = o.tooltipsFormat, O = o.tooltipsMerge, G = o.tooltipFormat, P = o.classList, T = we(null), A = we(null), z = we(!1), U = J((() => {
      let te = { cssPrefix: "", cssClasses: P.value, orientation: h.value, direction: v.value, tooltips: !!u.value && K.value, connect: "lower", start: Da(F.value) ? m.value : F.value, range: { min: m.value, max: c.value } };
      if (f.value > 0 && (te.step = f.value), Array.isArray(F.value) && (te.connect = !0), $ && $.value || C && Object.keys(C.value).length) {
        let he = Array.isArray(F.value) ? F.value : [F.value];
        te.handleAttributes = he.map(((ge) => Object.assign({}, C.value, $ && $.value ? { "aria-labelledby": $.value } : {})));
      }
      return E.value && (te.ariaFormat = G.value), te;
    })), X = J((() => {
      let te = { id: _ && _.value ? _.value : void 0 };
      return g.value && (te.disabled = !0), te;
    })), B = J((() => Array.isArray(F.value))), ie = () => {
      let te = A.value.get();
      return Array.isArray(te) ? te.map(((he) => parseFloat(he))) : parseFloat(te);
    }, H = function(te) {
      let he = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
      A.value.set(te, he);
    }, ee = (te) => {
      l.emit("input", te), l.emit("update:modelValue", te), l.emit("update", te);
    }, ue = () => {
      A.value = sm.create(T.value, Object.assign({}, U.value, b.value)), u.value && B.value && w.value >= 0 && O(T.value, w.value, " - "), A.value.on("set", (() => {
        const te = ie();
        l.emit("change", te), l.emit("set", te), I.value && ee(te);
      })), A.value.on("update", (() => {
        if (!z.value) return;
        const te = ie();
        B.value && jl(F.value, te) || !B.value && F.value == te ? l.emit("update", te) : I.value || ee(te);
      })), A.value.on("start", (() => {
        l.emit("start", ie());
      })), A.value.on("end", (() => {
        l.emit("end", ie());
      })), A.value.on("slide", (() => {
        l.emit("slide", ie());
      })), A.value.on("drag", (() => {
        l.emit("drag", ie());
      })), T.value.querySelectorAll("[data-handle]").forEach(((te) => {
        te.onblur = () => {
          T.value && P.value.focused.split(" ").forEach(((he) => {
            T.value.classList.remove(he);
          }));
        }, te.onfocus = () => {
          P.value.focused.split(" ").forEach(((he) => {
            T.value.classList.add(he);
          }));
        };
      })), z.value = !0;
    }, ye = () => {
      A.value.off(), A.value.destroy(), A.value = null;
    }, xe = (te, he) => {
      z.value = !1, ye(), ue();
    };
    return wt(ue), Tn(ye), Ve(B, xe, { immediate: !1 }), Ve(m, xe, { immediate: !1 }), Ve(c, xe, { immediate: !1 }), Ve(f, xe, { immediate: !1 }), Ve(h, xe, { immediate: !1 }), Ve(v, xe, { immediate: !1 }), Ve(u, xe, { immediate: !1 }), Ve(w, xe, { immediate: !1 }), Ve(E, xe, { immediate: !1, deep: !0 }), Ve(b, xe, { immediate: !1, deep: !0 }), Ve(S, xe, { immediate: !1, deep: !0 }), Ve(F, ((te, he) => {
      he && (typeof he == "object" && typeof te == "object" && te && Object.keys(he) > Object.keys(te) || typeof he == "object" && typeof te != "object" || Da(te)) && xe();
    }), { immediate: !1 }), Ve(F, ((te) => {
      if (Da(te)) return void H(m.value, !1);
      let he = ie();
      B.value && !Array.isArray(he) && (he = [he]), (B.value && !jl(te, he) || !B.value && te != he) && H(te, !1);
    }), { deep: !0 }), { slider: T, slider$: A, isRange: B, sliderProps: X, init: ue, destroy: ye, refresh: xe, update: H, reset: () => {
      ee(V.value);
    } };
  })(e, t, { value: n.value, initialValue: n.initialValue, tooltipFormat: s.tooltipFormat, tooltipsFormat: s.tooltipsFormat, tooltipsMerge: s.tooltipsMerge, classList: r.classList });
  return { ...r, ...s, ...i };
} };
Kr.render = function(e, t, n, r, s, i) {
  return L(), j("div", Ee(e.sliderProps, { ref: "slider" }), null, 16);
}, Kr.__file = "src/Slider.vue";
const cm = ["data-click-name"], um = { class: "lc-slider__wrap" }, dm = {
  key: 0,
  class: "lc-slider__min"
}, fm = {
  key: 0,
  class: "lc-slider__slider-marks"
}, hm = ["data-testid"], vm = {
  key: 1,
  class: "lc-slider__max"
}, mm = 1, Xg = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcSlider",
  props: {
    containerClass: {},
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    format: { type: Function, default: (e) => String(e) },
    helpMessage: {},
    hideMax: { type: Boolean },
    hideMin: { type: Boolean },
    hideStepMarkers: { type: Boolean },
    lazy: { type: Boolean, default: !0 },
    marker: {},
    max: {},
    min: {},
    name: {},
    noFeedback: { type: Boolean },
    step: { default: 1 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = we(!1), r = dt("slider"), s = t, i = J({
      get: () => e.value,
      set: (f) => s("update:value", f)
    }), a = J(() => {
      if (!e.marker) return;
      const { snap: f, steps: m } = e.marker;
      return {
        range: {
          min: e.min,
          ...m,
          max: e.max
        },
        snap: f
      };
    }), l = J(() => {
      if (a.value) return Object.keys(a.value.range);
      const f = (e.max - e.min) / e.step + mm;
      return Array.from({ length: f }, (m, c) => c);
    }), o = (f) => {
      const m = r.value;
      if (!m) return;
      const c = new Event(f, { bubbles: !0 });
      m.dispatchEvent(c);
    }, h = () => {
      n.value || (o("focusin"), o("focusout"));
    }, v = (f) => {
      n.value = f === "focusin", o(f);
    }, u = (f) => ["max", "min"].includes(String(f));
    return (f, m) => (L(), j("div", {
      ref: "slider",
      class: pe(["lc-slider", [
        {
          "lc-slider--disabled": e.disabled,
          "lc-slider--fixed-steps": !!a.value
        },
        e.containerClass,
        f.$attrs.class
      ]]),
      "data-click-name": e.dataClickName || `${e.name?.toLowerCase()}_slider`
    }, [
      ae("div", um, [
        e.hideMin ? ce("", !0) : (L(), j("span", dm, [
          me(f.$slots, "min", At(Rt({ min: e.min })), () => [
            yt($e(e.format(e.min)), 1)
          ])
        ])),
        ae("div", {
          class: "lc-slider__slider-container",
          onFocusin: m[1] || (m[1] = oa(() => v("focusin"), ["stop"])),
          onFocusout: m[2] || (m[2] = oa(() => v("focusout"), ["stop"]))
        }, [
          Oe(q(Kr), Ee({
            ...Qt(f.$attrs, ["class"]),
            ...f.$props,
            lazy: e.lazy
          }, {
            modelValue: i.value,
            "onUpdate:modelValue": m[0] || (m[0] = (c) => i.value = c),
            class: "lc-slider__slider",
            options: a.value,
            onChange: h
          }), null, 16, ["modelValue", "options"]),
          e.hideStepMarkers ? ce("", !0) : (L(), j("div", fm, [
            (L(!0), j(Ge, null, vt(l.value, (c) => (L(), j("span", {
              key: c,
              class: pe(["lc-slider__slider-mark", {
                [`lc-slider__slider-mark--${c}`]: u(c)
              }]),
              "data-testid": `lc-slider-mark-${c}`,
              style: Lt(
                typeof c == "string" && !u(c) ? `left:${c}%` : null
              )
            }, null, 14, hm))), 128))
          ]))
        ], 32),
        e.hideMax ? ce("", !0) : (L(), j("span", vm, [
          me(f.$slots, "max", At(Rt({ max: e.max })), () => [
            yt($e(e.format(e.max)), 1)
          ])
        ]))
      ]),
      e.noFeedback ? ce("", !0) : (L(), Ce(q(An), Ee({
        key: 0,
        class: "lc-slider__feedback"
      }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 10, cm));
  }
});
function xn() {
  return xn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xn.apply(this, arguments);
}
var gm = 0.996, bm = function(t, n) {
  return n === void 0 && (n = gm), t * n / (1 - n);
};
function pm(e) {
  return e[e.length - 1];
}
function ym(e) {
  return e.reduce(function(t, n) {
    return t + n;
  }) / e.length;
}
var wm = function(t, n, r) {
  return Math.min(Math.max(n, t), r);
};
function Nr(e, t) {
  if (e.length !== t.length)
    throw new Error("vectors must be same length");
  return e.map(function(n, r) {
    return n + t[r];
  });
}
function Zl(e) {
  return Math.max.apply(Math, e.map(Math.abs));
}
function jn(e) {
  return Object.freeze(e), Object.values(e).forEach(function(t) {
    t !== null && typeof t == "object" && !Object.isFrozen(t) && jn(t);
  }), e;
}
function xm() {
  var e = {};
  function t(s, i) {
    return e[s] = (e[s] || []).concat(i), function() {
      return n(s, i);
    };
  }
  function n(s, i) {
    e[s] = (e[s] || []).filter(function(a) {
      return a !== i;
    });
  }
  function r(s, i) {
    s in e && e[s].forEach(function(a) {
      return a(i);
    });
  }
  return jn({
    on: t,
    off: n,
    dispatch: r
  });
}
function km(e) {
  var t = [], n = function(a) {
    return a.addEventListener("wheel", e, {
      passive: !1
    }), t.push(a), function() {
      return r(a);
    };
  }, r = function(a) {
    a.removeEventListener("wheel", e), t = t.filter(function(l) {
      return l !== a;
    });
  }, s = function() {
    t.forEach(r);
  };
  return jn({
    observe: n,
    unobserve: r,
    disconnect: s
  });
}
var _m = 16 * 1.125, Sm = typeof window < "u" && window.innerHeight || 800, Br = [1, _m, Sm];
function Cm(e) {
  var t = e.deltaX * Br[e.deltaMode], n = e.deltaY * Br[e.deltaMode], r = (e.deltaZ || 0) * Br[e.deltaMode];
  return {
    timeStamp: e.timeStamp,
    axisDelta: [t, n, r]
  };
}
var Em = [-1, -1, -1];
function Tm(e, t) {
  if (!t)
    return e;
  var n = t === !0 ? Em : t.map(function(r) {
    return r ? -1 : 1;
  });
  return xn({}, e, {
    axisDelta: e.axisDelta.map(function(r, s) {
      return r * n[s];
    })
  });
}
var Wl = 700, Am = function(t) {
  return xn({}, t, {
    axisDelta: t.axisDelta.map(function(n) {
      return wm(n, -Wl, Wl);
    })
  });
}, Pr = process.env.NODE_ENV !== "production", Lm = 0.6, $m = 0.96, Im = 2, Xl = 5, Yl = /* @__PURE__ */ jn({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), Dm = 400;
function Gl() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: Dm
  };
}
function Mm(e) {
  e === void 0 && (e = {});
  var t = xm(), n = t.on, r = t.off, s = t.dispatch, i = Yl, a = Gl(), l, o = !1, h, v = function(T) {
    Array.isArray(T) ? T.forEach(function(A) {
      return c(A);
    }) : c(T);
  }, u = function(T) {
    return T === void 0 && (T = {}), Object.values(T).some(function(A) {
      return A == null;
    }) ? (Pr && console.error("updateOptions ignored! undefined & null options not allowed"), i) : i = jn(xn({}, Yl, i, T));
  }, f = function(T) {
    var A = xn({
      event: l,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: a.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: a.axisVelocity,
      axisMovement: a.axisMovement,
      get axisMovementProjection() {
        return Nr(A.axisMovement, A.axisVelocity.map(function(z) {
          return bm(z);
        }));
      }
    }, T);
    s("wheel", xn({}, A, {
      previous: h
    })), h = A;
  }, m = function(T, A) {
    var z = i, U = z.preventWheelAction, X = A[0], B = A[1], ie = A[2];
    if (typeof U == "boolean") return U;
    switch (U) {
      case "x":
        return Math.abs(X) >= T;
      case "y":
        return Math.abs(B) >= T;
      case "z":
        return Math.abs(ie) >= T;
      default:
        return Pr && console.warn("unsupported preventWheelAction value: " + U, "warn"), !1;
    }
  }, c = function(T) {
    var A = Am(Tm(Cm(T), i.reverseSign)), z = A.axisDelta, U = A.timeStamp, X = Zl(z);
    if (T.preventDefault && m(X, z) && T.preventDefault(), a.isStarted ? a.isMomentum && X > Math.max(2, a.lastAbsDelta * 2) && (F(!0), $()) : $(), X === 0 && Object.is && Object.is(T.deltaX, -0)) {
      o = !0;
      return;
    }
    l = T, a.axisMovement = Nr(a.axisMovement, z), a.lastAbsDelta = X, a.scrollPointsToMerge.push({
      axisDelta: z,
      timeStamp: U
    }), w(), f({
      axisDelta: z,
      isStart: !a.isStartPublished
    }), a.isStartPublished = !0, C();
  }, w = function() {
    a.scrollPointsToMerge.length === Im ? (a.scrollPoints.unshift({
      axisDeltaSum: a.scrollPointsToMerge.map(function(T) {
        return T.axisDelta;
      }).reduce(Nr),
      timeStamp: ym(a.scrollPointsToMerge.map(function(T) {
        return T.timeStamp;
      }))
    }), g(), a.scrollPointsToMerge.length = 0, a.scrollPoints.length = 1, a.isMomentum || E()) : a.isStartPublished || _();
  }, _ = function() {
    a.axisVelocity = pm(a.scrollPointsToMerge).axisDelta.map(function(T) {
      return T / a.willEndTimeout;
    });
  }, g = function() {
    var T = a.scrollPoints, A = T[0], z = T[1];
    if (!(!z || !A)) {
      var U = A.timeStamp - z.timeStamp;
      if (U <= 0) {
        Pr && console.warn("invalid deltaTime");
        return;
      }
      var X = A.axisDeltaSum.map(function(ie) {
        return ie / U;
      }), B = X.map(function(ie, H) {
        return ie / (a.axisVelocity[H] || 1);
      });
      a.axisVelocity = X, a.accelerationFactors.push(B), b(U);
    }
  }, b = function(T) {
    var A = Math.ceil(T / 10) * 10 * 1.2;
    a.isMomentum || (A = Math.max(100, A * 2)), a.willEndTimeout = Math.min(1e3, Math.round(A));
  }, S = function(T) {
    return T === 0 ? !0 : T <= $m && T >= Lm;
  }, E = function() {
    if (a.accelerationFactors.length >= Xl) {
      if (o && (o = !1, Zl(a.axisVelocity) >= 0.2)) {
        I();
        return;
      }
      var T = a.accelerationFactors.slice(Xl * -1), A = T.every(function(z) {
        var U = !!z.reduce(function(B, ie) {
          return B && B < 1 && B === ie ? 1 : 0;
        }), X = z.filter(S).length === z.length;
        return U || X;
      });
      A && I(), a.accelerationFactors = T;
    }
  }, I = function() {
    a.isMomentum = !0;
  }, $ = function() {
    a = Gl(), a.isStarted = !0, a.startTime = Date.now(), h = void 0, o = !1;
  }, C = /* @__PURE__ */ (function() {
    var P;
    return function() {
      clearTimeout(P), P = setTimeout(F, a.willEndTimeout);
    };
  })(), F = function(T) {
    T === void 0 && (T = !1), a.isStarted && (a.isMomentum && T ? f({
      isEnding: !0,
      isMomentumCancel: !0
    }) : f({
      isEnding: !0
    }), a.isMomentum = !1, a.isStarted = !1);
  }, V = km(v), K = V.observe, O = V.unobserve, G = V.disconnect;
  return u(e), jn({
    on: n,
    off: r,
    observe: K,
    unobserve: O,
    disconnect: G,
    feedWheel: v,
    updateOptions: u
  });
}
var Om = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
xi.globalOptions = void 0;
var Rm = process.env.NODE_ENV !== "production";
function xi(e) {
  e === void 0 && (e = {});
  var t, n = function() {
  };
  function r(i, a) {
    var l, o, h = a.mergeOptions, v = a.optionsAtMedia, u = h(Om, xi.globalOptions), f = h(u, e);
    t = v(f);
    var m = i.internalEngine(), c = (l = t.target) != null ? l : i.containerNode().parentNode, w = (o = t.forceWheelAxis) != null ? o : m.options.axis, _ = Mm({
      preventWheelAction: w,
      reverseSign: [!0, !0, !1]
    });
    function g() {
      C = (w === "x" ? m.containerRect.width : m.containerRect.height) / 2;
    }
    var b = _.observe(c), S = _.on("wheel", X), E = !1, I, $ = 0, C = 0, F = !1;
    g(), i.on("resize", g);
    function V(B) {
      try {
        I = new MouseEvent("mousedown", B.event), A(I);
      } catch {
        return Rm && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), n();
      }
      E = !0, $ = 0, O(), t.wheelDraggingClass && c.classList.add(t.wheelDraggingClass);
    }
    function K(B) {
      E = !1, A(T("mouseup", B)), G(), t.wheelDraggingClass && c.classList.remove(t.wheelDraggingClass);
    }
    function O() {
      document.documentElement.addEventListener("mousemove", P, !0), document.documentElement.addEventListener("mouseup", P, !0), document.documentElement.addEventListener("mousedown", P, !0);
    }
    function G() {
      document.documentElement.removeEventListener("mousemove", P, !0), document.documentElement.removeEventListener("mouseup", P, !0), document.documentElement.removeEventListener("mousedown", P, !0);
    }
    function P(B) {
      E && B.isTrusted && B.stopImmediatePropagation();
    }
    function T(B, ie) {
      var H, ee;
      if (w === m.options.axis) {
        var ue = ie.axisMovement;
        H = ue[0], ee = ue[1];
      } else {
        var ye = ie.axisMovement;
        ee = ye[0], H = ye[1];
      }
      var xe = z(ie), te = xe.isAtBoundary;
      if (te) {
        var he = Math.min($ / C, 1), ge = 0.25 + he * 0.5, be = H > 0 ? -1 : 1, Pe = $ * be, Ne = Pe * ge;
        H += Ne, ee += Ne;
      }
      if (!m.options.skipSnaps && !m.options.dragFree) {
        var de = m.containerRect.width, Re = m.containerRect.height;
        H = H < 0 ? Math.max(H, -de) : Math.min(H, de), ee = ee < 0 ? Math.max(ee, -Re) : Math.min(ee, Re);
      }
      return new MouseEvent(B, {
        clientX: I.clientX + H,
        clientY: I.clientY + ee,
        screenX: I.screenX + H,
        screenY: I.screenY + ee,
        movementX: H,
        movementY: ee,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function A(B) {
      i.containerNode().dispatchEvent(B);
    }
    function z(B) {
      var ie = B.axisDelta, H = ie[0], ee = ie[1], ue = i.scrollProgress(), ye = ue < 1, xe = ue > 0, te = w === "x" ? H : ee, he = te < 0, ge = te > 0, be = he && !ye || ge && !xe;
      return {
        isAtBoundary: be,
        primaryAxisDelta: te
      };
    }
    function U(B) {
      var ie = z(B), H = ie.isAtBoundary, ee = ie.primaryAxisDelta;
      if (H && !B.isMomentum) {
        if ($ += Math.abs(ee), $ > C)
          return F = !0, K(B), !0;
      } else
        $ = 0;
      return !1;
    }
    function X(B) {
      var ie = B.axisDelta, H = ie[0], ee = ie[1], ue = w === "x" ? H : ee, ye = w === "x" ? ee : H, xe = B.isMomentum && B.previous && !B.previous.isMomentum, te = B.isEnding && !B.isMomentum || xe, he = Math.abs(ue) > Math.abs(ye);
      he && !E && !B.isMomentum && !F && V(B), F && B.isEnding && (F = !1), E && (U(B) || (te ? K(B) : A(T("mousemove", B))));
    }
    n = function() {
      b(), S(), i.off("resize", g), G();
    };
  }
  var s = {
    name: "wheelGestures",
    options: e,
    init: r,
    destroy: function() {
      return n();
    }
  };
  return s;
}
const Fm = { class: "lc-slot-wheel__wrap" }, Yg = /* @__PURE__ */ Se({
  __name: "LcSlotWheel",
  props: {
    options: {},
    value: {}
  },
  emits: ["optionsChanged", "ready", "reInit", "update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = {
      axis: "y",
      loop: !0,
      skipSnaps: !0
    }, i = [
      Ka({
        draggable: "lc-slot-wheel--draggable",
        dragging: "lc-slot-wheel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-slot-wheel__slide--snapped"
      }),
      xi()
    ], [a, l] = Qa(
      {
        ...s,
        startIndex: Math.max(
          0,
          e.options.findIndex(($) => $.value === e.value)
        )
      },
      i
    ), o = Zn(Zr, () => null, !0), h = io(), v = () => {
      l.value?.reInit({
        ...s,
        watchDrag: !1
      });
    }, u = () => {
      l.value?.reInit({
        ...s,
        watchDrag: !0
      });
    }, f = ($) => Math.max(
      0,
      e.options.findIndex((C) => C.value === $)
    ), m = ($) => !$ || h.value === "reduce", c = ($, C = !0) => {
      l.value?.scrollTo(f($), m(C));
    }, w = () => {
      I(), r("ready");
    }, _ = () => {
      o?.disable();
    }, g = () => {
      o?.enable();
    }, b = () => {
      I(), r("reInit");
    }, S = () => {
      const $ = l.value?.selectedScrollSnap() ?? 0;
      r("update:value", e.options[$].value);
    }, E = () => {
      r("optionsChanged");
    }, I = () => {
      if (!l.value) return;
      const { rootNode: $, slideNodes: C } = l.value, V = $().getBoundingClientRect(), K = V.top + V.height / 2;
      C().forEach((O) => {
        const G = O.getBoundingClientRect(), A = (G.top + G.height / 2 - K) / (V.height / 2), z = Math.max(-1, Math.min(1, A)), U = 1 - Math.abs(z) * 0.3, X = O.style.transform.split(" ").filter((B) => !B.startsWith("scale("));
        X.push(`scale(${U})`), O.style.transform = X.join(" ");
      });
    };
    return wt(() => {
      l.value && l.value.on("init", w).on("pointerDown", _).on("pointerUp", g).on("reInit", b).on("scroll", I).on("select", S).on("slidesChanged", E);
    }), Ve(
      () => e.value,
      ($) => c($)
    ), t({
      disable: v,
      enable: u,
      moveToOption: c
    }), ($, C) => (L(), j("div", {
      ref_key: "emblaRef",
      ref: a,
      class: "lc-slot-wheel"
    }, [
      ae("div", Fm, [
        (L(!0), j(Ge, null, vt(e.options, (F, V) => (L(), j("div", {
          key: `${F.label}-${F.value}`,
          className: "lc-slot-wheel__option"
        }, [
          me($.$slots, "option", Ee({ ref_for: !0 }, { index: V, option: F }), () => [
            yt($e(F.label), 1)
          ])
        ]))), 128))
      ])
    ], 512));
  }
}), Nm = ["for"], Bm = ["id", "aria-label", "data-click-name"], Pm = { class: "lc-switch__toggle" }, Gg = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcSwitch",
  props: {
    ariaLabelText: {},
    dataClickName: {},
    disabled: { type: Boolean },
    icon: { default: "checkmark" },
    id: {},
    name: { default: "switch" },
    value: { type: Boolean },
    variant: { default: "success" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = Ct(e.id), { vibrate: s } = lo(), i = J(() => [
      "lc-switch",
      `lc-switch--variant-${e.variant}`,
      {
        "lc-switch--checked": e.value,
        "lc-switch--disabled": e.disabled
      }
    ]), a = J({
      get: () => e.value,
      set: (l) => {
        n("update:value", l), s();
      }
    });
    return (l, o) => (L(), j("label", {
      class: pe([i.value, l.$attrs.class]),
      for: q(r)
    }, [
      Jt(ae("input", Ee({
        ...Qt(l.$attrs, ["class"]),
        disabled: e.disabled,
        name: e.name
      }, {
        id: q(r),
        "onUpdate:modelValue": o[0] || (o[0] = (h) => a.value = h),
        "aria-label": e.ariaLabelText,
        class: "lc-switch__input",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_switch`,
        role: "switch",
        type: "checkbox",
        onKeydown: o[1] || (o[1] = ti((h) => a.value = !a.value, ["enter"]))
      }), null, 16, Bm), [
        [eo, a.value]
      ]),
      o[2] || (o[2] = ae("div", { class: "lc-switch__track" }, null, -1)),
      ae("div", Pm, [
        Oe(q(Qe), {
          class: "lc-switch__icon",
          name: e.icon
        }, null, 8, ["name"])
      ])
    ], 10, Nm));
  }
}), Kg = ["info", "success"], Jg = /* @__PURE__ */ Se({
  __name: "LcTable",
  props: {
    bordered: { type: Boolean },
    padding: { default: "medium" }
  },
  setup(e) {
    const t = J(() => [
      "lc-table",
      `lc-table--padding-${e.padding}`,
      {
        "lc-table--bordered": e.bordered
      }
    ]);
    return (n, r) => (L(), j("table", {
      class: pe(t.value)
    }, [
      me(n.$slots, "default")
    ], 2));
  }
}), Qg = ["medium", "small"], e2 = ["column", "row"], t2 = ["bottom", "top"], n2 = ["automatic", "manual"], a2 = ["default", "divider"], r2 = /* @__PURE__ */ Symbol();
var Rn = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.End = "End", e.Home = "Home", e))(Rn || {});
const zm = ["id"], Vm = ["id"], Hm = { class: "lc-tabs__tablist-inner" }, Um = ["id", "aria-controls", "aria-selected", "disabled", "tabindex", "onClickPassive"], qm = {
  key: 1,
  class: "lc-tabs__header"
}, jm = ["aria-labelledby"], Zm = ["id", "aria-labelledby"], i2 = /* @__PURE__ */ Se({
  __name: "LcTabs",
  props: {
    adaptiveHeight: { type: Boolean },
    disableSwipe: { type: Boolean },
    id: {},
    navigationPosition: { default: "top" },
    renderOnlyVisible: { type: Boolean },
    containerClass: {},
    tabFlexDirection: { default: "column" },
    tabs: {},
    trigger: { default: "automatic" },
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = dt("carousel"), i = dt("container"), a = dt("tabs"), l = Ct(e.id), o = we(0), h = we(0), v = we(null), u = we(null), f = we(!1), m = we(!1);
    let c = null;
    const w = J(() => [
      "lc-tabs",
      `lc-tabs--navigation-${e.navigationPosition}`,
      `lc-tabs--variant-${e.variant}`,
      {
        "lc-tabs--tablist-hidden": b.value
      }
    ]), _ = () => {
      m.value = !0, c && clearTimeout(c), c = setTimeout(() => m.value = !1, 250);
    }, g = () => {
      const O = a.value?.[o.value];
      O && (v.value = `${O.offsetWidth}px`, u.value = `${O.offsetLeft}px`);
    };
    on(window, "resize", [g, _]), Zs(i, g);
    const b = J(() => e.tabs.length <= 1), S = (O, G) => {
      O !== o.value && (o.value = O, G?.skipCarousel || s.value?.moveToIndex(O), G?.skipUpdateEvent || r("update:value", e.tabs[O].name));
    }, E = (O) => {
      a.value?.[O].focus();
    }, I = (O) => {
      if (O !== o.value)
        return {
          "aria-hidden": "true",
          inert: "true"
        };
    }, $ = () => h.value === e.tabs.length - 1 ? 0 : h.value + 1, C = () => h.value === 0 ? e.tabs.length - 1 : h.value - 1, F = (O) => e.tabs.findIndex((G) => G.name === O), V = (O) => {
      if (!en(O.key, Rn)) return;
      O.preventDefault(), O.stopPropagation();
      let G;
      switch (O.key) {
        case Rn.ArrowLeft:
          G = C();
          break;
        case Rn.ArrowRight:
          G = $();
          break;
        case Rn.End:
          G = e.tabs.length - 1;
          break;
        case Rn.Home:
          G = 0;
          break;
      }
      h.value = G, e.trigger === "automatic" && S(G);
    }, K = () => {
      const O = F(e.value);
      O !== -1 && (o.value = O, h.value = O);
    };
    return Os(K), Rs(K), wt(() => {
      g(), b.value || (f.value = !0);
    }), Ve(o, g), Ve(h, E), Ve(
      () => e.value,
      (O) => {
        if (!O) return;
        const G = F(O);
        G !== -1 && S(G, { skipUpdateEvent: !0 });
      }
    ), t({
      containerRef: i
    }), (O, G) => (L(), j("section", {
      id: q(l),
      class: pe(w.value)
    }, [
      me(O.$slots, "top"),
      b.value ? ce("", !0) : (L(), j("div", {
        key: 0,
        ref: "container",
        class: pe(["lc-tabs__nav_container", e.containerClass])
      }, [
        ae("nav", {
          id: q(l),
          class: pe(["lc-tabs__tablist", {
            "lc-tabs__tablist--no-transition": m.value
          }]),
          role: "tablist",
          style: Lt({
            "--active-tab-index": o.value,
            ...u.value && { "--indicator-offset": u.value },
            ...v.value && { "--indicator-size": v.value },
            "--tab-count": e.tabs.length
          })
        }, [
          ae("div", Hm, [
            (L(!0), j(Ge, null, vt(e.tabs, (P, T) => (L(), j("button", {
              id: `${q(l)}-tab-${T}`,
              key: P.name,
              ref_for: !0,
              ref: "tabs",
              "aria-controls": `${q(l)}-tabpanel-${T}`,
              "aria-selected": o.value === T,
              class: pe(["lc-tabs__tab", `lc-tabs__tab--flex-${e.tabFlexDirection}`]),
              disabled: !f.value,
              role: "tab",
              tabindex: o.value !== T ? -1 : void 0,
              type: "button",
              onClickPassive: (A) => S(T),
              onKeydown: V
            }, [
              O.$slots.tab ? me(O.$slots, "tab", Ee({ ref_for: !0 }, { tab: P, index: T }), void 0, void 0, 0) : (L(), j(Ge, { key: 1 }, [
                P.icon ? (L(), Ce(q(Qe), {
                  key: 0,
                  name: P.icon,
                  size: e.variant === "divider" ? "small" : "medium"
                }, null, 8, ["name", "size"])) : ce("", !0),
                yt(" " + $e(P.title ?? P.name), 1)
              ], 64))
            ], 42, Um))), 128))
          ])
        ], 14, Vm),
        me(O.$slots, "subnav")
      ], 2)),
      O.$slots.header ? (L(), j("header", qm, [
        me(O.$slots, "header")
      ])) : ce("", !0),
      !f.value && e.tabs.length > 0 ? (L(), j("div", {
        key: 2,
        "aria-labelledby": `${q(l)}-tab-${o.value}`,
        class: pe(["lc-tabs__tabpanel", "lc-tabs__tabpanel--single-tab"]),
        role: "tabpanel"
      }, [
        me(O.$slots, "tab-panel", {
          index: o.value,
          tab: e.tabs[o.value]
        })
      ], 8, jm)) : ce("", !0),
      b.value ? ce("", !0) : (L(), Ce(q(Dd), {
        key: 3,
        ref: "carousel",
        "adaptive-height": e.renderOnlyVisible ? !1 : e.adaptiveHeight,
        class: pe(["lc-tabs__carousel", {
          "lc-tabs__carousel--unmounted": !f.value
        }]),
        "default-index": o.value,
        "disable-swipe": e.disableSwipe || b.value,
        duration: 15,
        "key-prop": "name",
        slides: e.tabs,
        onChanged: G[0] || (G[0] = (P) => S(P, { skipCarousel: !0 })),
        onReady: G[1] || (G[1] = (P) => f.value = !0)
      }, {
        slide: Ie(({ index: P, isVisible: T, slide: A }) => [
          ae("div", Ee({
            id: `${q(l)}-tabpanel-${P}`
          }, I(P), {
            "aria-labelledby": `${q(l)}-tab-${P}`,
            class: "lc-tabs__tabpanel",
            role: "tabpanel"
          }), [
            !e.renderOnlyVisible || T || P === o.value ? me(O.$slots, "tab-panel", At(Rt({ tab: A, index: P })), void 0, void 0, 0) : ce("", !0)
          ], 16, Zm)
        ]),
        _: 3
      }, 8, ["adaptive-height", "class", "default-index", "disable-swipe", "slides"]))
    ], 10, zm));
  }
}), Wm = ["for"], Xm = ["id"], Ym = ["id", "aria-labelledby", "data-click-error", "data-click-name"], Gm = { class: "lc-textarea__feedback-wrap" }, Km = { class: "lc-textarea__counter" }, l2 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcTextarea",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    maxlength: { default: 82 },
    name: { default: "textarea" },
    noFeedback: { type: Boolean },
    placeholder: {},
    resizeable: { type: Boolean },
    rows: { default: 2 },
    spellcheck: { type: Boolean },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = dt("textarea"), s = Ct(e.id), i = we(!1), a = J(() => [
      "lc-textarea",
      {
        "lc-textarea--disabled": e.disabled,
        "lc-textarea--error": !!e.errorMessage,
        "lc-textarea--has-label": !!e.label
      }
    ]), l = J(() => typeof h.value == "number" ? String(h.value).length : h.value?.length ?? 0), o = J(() => [
      "lc-textarea__label",
      {
        "lc-textarea__label--floating": i.value || !!e.value || typeof e.value == "number"
      }
    ]), h = J({
      get: () => e.value,
      set: (v) => n("update:value", v)
    });
    return wt(() => {
      e.autofocus && r.value?.focus();
    }), (v, u) => (L(), j("div", {
      class: pe([a.value, v.$attrs.class])
    }, [
      ae("label", {
        class: "lc-textarea__wrap",
        for: q(s)
      }, [
        e.label ? (L(), j("span", {
          key: 0,
          id: `${q(s)}-label`,
          class: pe(o.value)
        }, $e(e.label), 11, Xm)) : ce("", !0),
        Jt(ae("textarea", Ee({
          id: q(s),
          ref: "textarea"
        }, {
          ...Qt(v.$attrs, ["class"]),
          disabled: e.disabled,
          maxlength: e.maxlength,
          name: e.name,
          placeholder: e.placeholder,
          resizeable: e.resizeable,
          rows: e.rows,
          spellcheck: e.spellcheck
        }, {
          "onUpdate:modelValue": u[0] || (u[0] = (f) => h.value = f),
          "aria-labelledby": e.label ? `${q(s)}-label` : void 0,
          class: "lc-textarea__input",
          "data-click-error": e.errorMessage ?? "",
          "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_textarea`,
          onFocusin: u[1] || (u[1] = (f) => i.value = !0),
          onFocusout: u[2] || (u[2] = (f) => i.value = !1)
        }), null, 16, Ym), [
          [Fs, h.value]
        ])
      ], 8, Wm),
      ae("div", Gm, [
        e.noFeedback ? ce("", !0) : (L(), Ce(q(An), Ee({ key: 0 }, { disabled: e.disabled }, {
          content: e.errorMessage || e.helpMessage,
          variant: e.errorMessage ? "error" : "default"
        }), null, 16, ["content", "variant"])),
        ae("span", Km, [
          ae("span", null, $e(l.value) + "/" + $e(e.maxlength), 1)
        ])
      ])
    ], 2));
  }
}), Jm = { class: "lc-toast__indicator" }, Qm = { class: "lc-toast__content" }, e1 = {
  key: 0,
  class: "lc-toast__title"
}, t1 = {
  key: 0,
  class: "lc-toast__text"
}, o2 = /* @__PURE__ */ Se({
  __name: "LcToast",
  props: {
    closable: { type: Boolean, default: !0 },
    headline: {},
    text: {},
    variant: { default: "info" }
  },
  emits: ["close"],
  setup(e) {
    const t = {
      danger: "alert-triangle",
      info: "info",
      success: "checkmark",
      warning: "bell",
      win: "winning"
    };
    return (n, r) => (L(), j("article", {
      class: pe(["lc-toast", `lc-toast--variant-${e.variant}`]),
      role: "alert"
    }, [
      ae("aside", Jm, [
        Oe(q(Qe), {
          name: t[e.variant]
        }, null, 8, ["name"])
      ]),
      ae("section", Qm, [
        e.headline ? (L(), j("span", e1, $e(e.headline), 1)) : ce("", !0),
        me(n.$slots, "default", {}, () => [
          e.text ? (L(), j("p", t1, $e(e.text), 1)) : ce("", !0)
        ])
      ]),
      e.closable ? (L(), Ce(q(St), {
        key: 0,
        "aria-label": q(je).lcToast.closeButtonAriaLabel,
        class: "lc-toast__button-close",
        icon: "close",
        size: "small",
        variant: "tertiary",
        onClickPassive: r[0] || (r[0] = (s) => n.$emit("close"))
      }, null, 8, ["aria-label"])) : ce("", !0)
    ], 2));
  }
}), s2 = ["danger", "info", "success", "warning", "win"], n1 = ["left", "right"], a1 = 0.4, r1 = 0.75, Kl = 0.85, i1 = 0.2, l1 = 150, o1 = 8, s1 = {
  key: 1,
  class: "lc-swipeable__action-label"
}, c2 = /* @__PURE__ */ Se({
  __name: "LcSwipeable",
  props: {
    disabled: { type: Boolean },
    leftAction: {},
    pointerTypes: {},
    rightAction: {}
  },
  emits: ["swipe-end", "swipe-start", "trigger"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = dt("lcSwipeableRef"), i = En(), a = we(null), l = we(0), o = we(0), h = we(0), v = we(!1), u = we(!1), f = we(!1), m = we(!1), c = we(!1);
    let w = 0;
    const { distanceX: _ } = Ws(s, {
      pointerTypes: e.pointerTypes,
      threshold: o1,
      onSwipe: () => {
        if (e.disabled || !s.value) return;
        v.value || P();
        const H = s.value.clientWidth, ee = o.value - _.value, ue = K(ee);
        if (ue && !I(ue)) {
          l.value = 0;
          return;
        }
        const ye = C(ue), xe = V(ee, H, $(ue));
        m.value = O(H, ye), h.value = Math.min(1, Math.abs(_.value) / (H * ye));
        const te = !!(ue && E(ue)?.fullSwipe && m.value);
        T(te), A(ue), l.value = te && ue ? G(ue, H) : xe, ue && ue !== a.value && z(ue);
      },
      onSwipeEnd: (H, ee) => {
        U();
        const ue = f.value;
        if (X(), m.value = !1, !(!e.disabled && (ee === "left" || ee === "right") && I(ee) && s.value !== null && O(s.value.clientWidth, C(ee)))) {
          l.value = 0;
          return;
        }
        ue || (l.value = 0), r("trigger", ee);
      }
    }), g = J(() => n1.map((H) => ({ side: H, action: E(H) }))), b = J(() => [
      "lc-swipeable__content",
      { "lc-swipeable__content--dragging": v.value && !u.value }
    ]), S = J(() => Kl + (1 - Kl) * h.value), E = (H) => H === "left" ? e.leftAction : H === "right" ? e.rightAction : void 0, I = (H) => !!(E(H) || i[`${H}-action`]), $ = (H) => E(H)?.resistanceThreshold ?? r1, C = (H) => {
      const ee = E(H);
      return ee?.fullSwipe ? $(H) : ee?.activationThreshold ?? a1;
    }, F = () => {
      if (!s.value) return 0;
      const H = s.value.querySelector(
        ".lc-swipeable__content"
      );
      if (!H) return 0;
      const ee = getComputedStyle(H).transform;
      if (!ee || ee === "none") return 0;
      const ue = new DOMMatrix(ee).m41;
      return Number.isFinite(ue) ? ue : 0;
    }, V = (H, ee, ue) => {
      const ye = ee * ue, xe = Math.abs(H);
      if (xe <= ye) return H;
      const te = ee * i1, ge = (1 - 1 / ((xe - ye) / te + 1)) * te;
      return Math.sign(H) * (ye + ge);
    }, K = (H) => H < 0 ? "left" : H > 0 ? "right" : null, O = (H, ee) => Math.abs(_.value) >= H * ee, G = (H, ee) => H === "left" ? -ee : ee, P = () => {
      o.value = F(), v.value = !0;
    }, T = (H) => {
      H !== f.value && (f.value = H, u.value = !0, w = performance.now());
    }, A = (H) => {
      !u.value || f.value || !(performance.now() - w >= l1) && H === a.value || (u.value = !1);
    }, z = (H) => {
      a.value = H, c.value = !0, r("swipe-start", H);
    }, U = () => {
      !c.value || !a.value || (c.value = !1, r("swipe-end", a.value));
    }, X = () => {
      o.value = 0, h.value = 0, v.value = !1, f.value = !1, u.value = !1;
    }, B = () => {
      u.value = !1, !v.value && l.value === 0 && (a.value = null);
    }, ie = () => {
      const H = a.value, ee = c.value;
      X(), l.value = 0, m.value = !1, c.value = !1, ee && H && r("swipe-end", H);
    };
    return on(s, "pointercancel", ie), Ve(
      () => e.disabled,
      (H) => {
        H && ie();
      }
    ), t({ close: ie }), (H, ee) => (L(), j("div", {
      ref_key: "lcSwipeableRef",
      ref: s,
      class: "lc-swipeable"
    }, [
      (L(!0), j(Ge, null, vt(g.value, ({ side: ue, action: ye }) => (L(), j(Ge, { key: ue }, [
        ye || H.$slots[`${ue}-action`] ? (L(), j("div", {
          key: 0,
          class: pe([
            "lc-swipeable__action",
            `lc-swipeable__action--${ue}`,
            {
              "lc-swipeable__action--hidden": a.value !== ue,
              "lc-swipeable__action--dragging": v.value && !u.value,
              "lc-swipeable__action--past-threshold": m.value && a.value === ue
            }
          ])
        }, [
          me(H.$slots, `${ue}-action`, {}, () => [
            ye ? (L(), j("span", {
              key: 0,
              class: "lc-swipeable__action-icon",
              style: Lt(a.value === ue ? { transform: `scale(${S.value})` } : void 0)
            }, [
              Oe(q(Qe), {
                name: ye.icon
              }, null, 8, ["name"])
            ], 4)) : ce("", !0),
            ye?.label ? (L(), j("span", s1, $e(ye.label), 1)) : ce("", !0)
          ])
        ], 2)) : ce("", !0)
      ], 64))), 128)),
      ae("div", {
        class: pe(b.value),
        style: Lt({ transform: `translateX(${l.value}px)` }),
        onTransitionend: oa(B, ["self"])
      }, [
        me(H.$slots, "default")
      ], 38)
    ], 512));
  }
}), c1 = { class: "lc-lottery-remaining-picks__headline" }, u1 = { class: "lc-lottery-remaining-picks__done" }, d1 = {
  "aria-hidden": "true",
  class: "lc-lottery-remaining-picks__check"
}, f1 = {
  key: 0,
  class: "lc-lottery-remaining-picks__label"
}, h1 = /* @__PURE__ */ Se({
  __name: "LcLotteryRemainingPicks",
  props: {
    complete: { type: Boolean, default: !1 },
    doneLabel: { default: () => je.lcLotteryRemainingPicks.doneLabel }
  },
  setup(e) {
    const t = we(!1);
    Ve(
      () => e.complete,
      (r, s) => {
        r && !s ? t.value = !0 : r || (t.value = !1);
      }
    );
    const n = (r) => {
      const s = e.doneLabel ? "lc-lottery-remaining-picks-label" : "lc-lottery-remaining-picks-pop";
      r.animationName === s && (t.value = !1);
    };
    return (r, s) => (L(), j("div", {
      class: pe([
        "lc-lottery-remaining-picks",
        {
          "lc-lottery-remaining-picks--complete": e.complete,
          "lc-lottery-remaining-picks--playing": t.value
        }
      ]),
      onAnimationend: n
    }, [
      ae("div", c1, [
        me(r.$slots, "default", { countClass: "lc-lottery-remaining-picks__count" })
      ]),
      ae("div", u1, [
        ae("span", d1, [
          Oe(q(Qe), {
            name: "checkmark-small",
            size: "medium"
          })
        ]),
        e.doneLabel ? (L(), j("span", f1, $e(e.doneLabel), 1)) : ce("", !0)
      ])
    ], 34));
  }
}), v1 = ["aria-hidden"], m1 = ["aria-hidden"], g1 = {
  key: 1,
  class: "lc-lottery-editor-card__labels"
}, b1 = {
  key: 0,
  class: "lc-lottery-editor-card__label"
}, p1 = {
  key: 1,
  class: "lc-lottery-editor-card__label"
}, y1 = { class: "lc-lottery-editor-card__footer" }, u2 = /* @__PURE__ */ Se({
  __name: "LcLotteryEditorCard",
  props: /* @__PURE__ */ sa({
    id: {},
    radius: { default: "large" },
    shadow: { default: "small" },
    betType: {},
    clearDisabled: { type: Boolean },
    clearLabel: { default: () => je.lcLotteryEditorCard.clearLabel },
    complete: { type: Boolean },
    doneLabel: {},
    expanded: { type: Boolean },
    fields: {},
    quickPickLabel: { default: () => je.lcLotteryEditorCard.quickPickLabel },
    remaining: {},
    toggleAriaLabel: { default: () => je.lcLotteryEditorCard.toggleAriaLabel },
    wager: {},
    separated: { type: Boolean, default: !1 }
  }, {
    expanded: { type: Boolean, default: !0 },
    expandedModifiers: {}
  }),
  emits: /* @__PURE__ */ sa(["clear", "quick-pick", "update:expanded"], ["update:expanded"]),
  setup(e, { emit: t }) {
    const n = t, r = Za(e, "expanded");
    return (s, i) => (L(), Ce(q(ya), Ee({
      modelValue: r.value,
      "onUpdate:modelValue": i[2] || (i[2] = (a) => r.value = a),
      "body-class": "lc-lottery-editor-card__body",
      class: ["lc-lottery-editor-card", { "lc-lottery-editor-card--separated": e.separated }],
      expandable: "",
      "footer-class": "lc-lottery-editor-card__footer-slot",
      "header-class": r.value ? "lc-lottery-editor-card__header--expanded" : "lc-lottery-editor-card__header"
    }, { id: e.id, radius: e.radius, shadow: e.shadow, toggleAriaLabel: e.toggleAriaLabel }), {
      header: Ie(() => [
        ae("div", {
          class: pe([
            "lc-lottery-editor-card__header-content",
            { "lc-lottery-editor-card__header-content--collapsed": !r.value }
          ])
        }, [
          ae("div", {
            "aria-hidden": !r.value,
            class: "lc-lottery-editor-card__expanded"
          }, [
            Oe(q(h1), At(Rt({ complete: e.complete, doneLabel: e.doneLabel, remaining: e.remaining })), {
              default: Ie(({ countClass: a }) => [
                me(s.$slots, "headline", At(Rt({ countClass: a })))
              ]),
              _: 3
            }, 16)
          ], 8, v1),
          ae("div", {
            "aria-hidden": r.value,
            class: "lc-lottery-editor-card__summary"
          }, [
            e.fields ? (L(), Ce(q(Eh), Ee({ key: 0 }, { fields: e.fields }, { size: "medium" }), null, 16)) : ce("", !0),
            e.wager || e.betType ? (L(), j("div", g1, [
              e.wager ? (L(), j("span", b1, $e(e.wager), 1)) : ce("", !0),
              e.betType ? (L(), j("span", p1, $e(e.betType), 1)) : ce("", !0)
            ])) : ce("", !0)
          ], 8, m1)
        ], 2)
      ]),
      footer: Ie(() => [
        ae("div", y1, [
          Oe(q(St), {
            class: "lc-lottery-editor-card__clear",
            disabled: e.clearDisabled,
            icon: "trash-full",
            size: "medium",
            variant: e.clearDisabled ? "tertiary" : "raised",
            onClick: i[0] || (i[0] = (a) => n("clear"))
          }, {
            default: Ie(() => [
              yt($e(e.clearLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "variant"]),
          Oe(q(St), {
            class: "lc-lottery-editor-card__quick-pick",
            icon: "flash",
            size: "medium",
            variant: "raised",
            onClick: i[1] || (i[1] = (a) => n("quick-pick"))
          }, {
            default: Ie(() => [
              yt($e(e.quickPickLabel), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: Ie(() => [
        e.separated ? (L(), Ce(q(li), {
          key: 0,
          class: "lc-lottery-editor-card__divider"
        })) : ce("", !0),
        me(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["modelValue", "class", "header-class"]));
  }
});
export {
  Oo as AmplitudeEvents,
  Nt as FORM_FIELD_EVENTS,
  P1 as LC_BOTTOM_SHEET_CLOSE_TRIGGERS,
  T1 as LC_BUTTON_ICON_POSITIONS,
  A1 as LC_BUTTON_SIZES,
  $1 as LC_BUTTON_TRIGGERS,
  L1 as LC_BUTTON_TYPES,
  I1 as LC_BUTTON_VARIANTS,
  M1 as LC_CARD_RADII,
  O1 as LC_CARD_SHADOWS,
  R1 as LC_CARD_VARIANTS,
  V1 as LC_CAROUSEL_MOVE_TRIGGERS,
  z1 as LC_CAROUSEL_VARIANTS,
  U1 as LC_COUNTDOWN_VARIANTS,
  tg as LC_FORM_FIELD_INTERACTION_MODES,
  S1 as LC_ICON_NAMES,
  _1 as LC_ICON_SIZES,
  ig as LC_INFO_BUTTON_VARIANTS,
  vg as LC_INFO_TEXT_ICON_ALIGNMENTS,
  mg as LC_INFO_TEXT_SIZES,
  Z1 as LC_INPUT_MODES,
  W1 as LC_INPUT_TYPES,
  pg as LC_LOTTERY_CUTOFF_TIME_VARIANTS,
  rg as LC_LOTTERY_JACPOT_SIZES,
  xg as LC_LOTTERY_NUMBER_SELECTOR_VARIANTS,
  yg as LC_LOTTERY_NUMBER_SIZES,
  wg as LC_LOTTERY_NUMBER_SPACINGS,
  Sg as LC_LOTTERY_TEASER_VARIANTS,
  Eg as LC_MENU_BUTTON_PLACEMENTS,
  Lg as LC_MESSAGE_BOX_SIZES,
  $g as LC_MESSAGE_BOX_VARIANTS,
  F1 as LC_MODAL_CLOSE_TRIGGERS,
  N1 as LC_MODAL_SPACINGS,
  Mg as LC_PASSWORD_INPUT_TYPES,
  Rg as LC_PROGRESS_INDICATOR_SIZES,
  Fg as LC_PROGRESS_INDICATOR_VARIANTS,
  Pg as LC_RADIO_GROUP_LAYOUTS,
  qg as LC_SCRATCHCARD_TEASER_VARIANTS,
  Zg as LC_SELECT_LIST_VARIANTS,
  D1 as LC_SEPARATOR_VARIANTS,
  Vg as LC_SKELETON_RADII,
  Kg as LC_SWITCH_VARIANTS,
  Qg as LC_TABLE_PADDINGS,
  e2 as LC_TABS_FLEX_DIRECTIONS,
  t2 as LC_TABS_NAVIGATION_POSITIONS,
  n2 as LC_TABS_TRIGGERS,
  a2 as LC_TABS_VARIANTS,
  lg as LC_TEASER_BACKGROUND_PATTERNS,
  og as LC_TEASER_BADGE_VARIANTS,
  sg as LC_TEASER_HERO_BADGE_VARIANTS,
  Po as LC_TEASER_VARIANTS,
  s2 as LC_TOAST_VARIANTS,
  C1 as LcBadge,
  B1 as LcBottomSheet,
  St as LcButton,
  Ur as LcButtonActiveKeys,
  ya as LcCard,
  Dd as LcCarousel,
  Ma as LcCarouselActiveKeys,
  H1 as LcCheckbox,
  zr as LcCountBubble,
  Bd as LcCountdown,
  q1 as LcDataList,
  j1 as LcDataListItem,
  X1 as LcDateInput,
  Y1 as LcDescriptionList,
  G1 as LcDigitInput,
  rn as LcDigitInputActiveKeys,
  K1 as LcDigitInputGroup,
  mf as LcExpandable,
  J1 as LcExpandableList,
  Q1 as LcFlyOut,
  eg as LcForm,
  ng as LcFormField,
  ag as LcHeader,
  Rf as LcHighFrequencyBall,
  Ro as LcHighFrequencyBallBackground,
  cg as LcHighFrequencyTeaser,
  ug as LcHighFrequencyTeaserWatch,
  Qe as LcIcon,
  fg as LcImage,
  Bo as LcInfoButton,
  hg as LcInfoText,
  er as LcInput,
  gg as LcLinkList,
  bg as LcLinkListItem,
  Ml as LcLotteryCutoffTime,
  u2 as LcLotteryEditorCard,
  Fo as LcLotteryJackpot,
  kg as LcLotteryNumberSelector,
  qt as LcLotteryNumberSelectorActiveKeys,
  Eh as LcLotteryNumbers,
  h1 as LcLotteryRemainingPicks,
  _g as LcLotteryTeaser,
  Cg as LcMaskedValueDisplay,
  Tg as LcMenuButton,
  Vt as LcMenuButtonActiveKeys,
  Ag as LcMessageBox,
  ko as LcModal,
  Ig as LcMoneyInput,
  Dg as LcPasswordInput,
  Og as LcProgressIndicator,
  Zv as LcRadio,
  Ng as LcRadioCard,
  Bg as LcRadioGroup,
  zg as LcRating,
  Hg as LcRemoteList,
  Ug as LcScratchcardTeaser,
  jg as LcSelect,
  Yt as LcSelectActiveKeys,
  Wg as LcSelectList,
  jt as LcSelectListActiveKeys,
  li as LcSeparator,
  Kv as LcSkeleton,
  Xg as LcSlider,
  Yg as LcSlotWheel,
  c2 as LcSwipeable,
  Gg as LcSwitch,
  Jg as LcTable,
  i2 as LcTabs,
  Rn as LcTabsActiveKeys,
  tr as LcTeaser,
  a0 as LcTeaserBadge,
  i0 as LcTeaserHeroBadge,
  zo as LcTeaserHeroBadgeColor,
  l2 as LcTextarea,
  o2 as LcToast,
  Zr as carouselContext,
  je as globalConfig,
  l0 as isHeroBadge,
  au as nuxtAppContext,
  E1 as setGlobalConfig,
  r2 as tabContext
};
